const mapData = {
  "title": "World, Robinson projection, high resolution",
  "version": "1.1.3",
  "type": "FeatureCollection",
  "copyright": "Copyright (c) 2020 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG:54030"
    }
  },
  "features": [{
    "type": "Feature",
    "id": "FO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.08,
      "hc-key": "fo",
      "hc-a2": "FO",
      "name": "Faroe Islands",
      "labelrank": "6",
      "country-abbrev": "Faeroe Is.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "FRO",
      "iso-a2": "FO",
      "woe-id": "23424816",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3834, 9232],
          [3840, 9229],
          [3832, 9221],
          [3831, 9200],
          [3827, 9203],
          [3828, 9217],
          [3824, 9224],
          [3814, 9224],
          [3820, 9231],
          [3834, 9232]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "US",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.66,
      "hc-middle-y": 0.69,
      "hc-key": "us",
      "hc-a2": "US",
      "name": "United States of America",
      "labelrank": "2",
      "country-abbrev": "U.S.A.",
      "subregion": "Northern America",
      "region-wb": "North America",
      "iso-a3": "USA",
      "iso-a2": "US",
      "woe-id": "23424977",
      "continent": "North America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [374, 9014],
            [357, 9011],
            [377, 9027],
            [388, 9026],
            [382, 9016],
            [391, 9012],
            [384, 8997],
            [382, 8983],
            [370, 8968],
            [363, 8972],
            [369, 8983],
            [365, 8989],
            [354, 8989],
            [372, 9002],
            [363, 9000],
            [357, 9006],
            [369, 9007],
            [374, 9014]
          ]
        ],
        [
          [
            [-950, 8875],
            [-953, 8867],
            [-984, 8859],
            [-999, 8864],
            [-983, 8870],
            [-975, 8865],
            [-963, 8873],
            [-956, 8869],
            [-950, 8875]
          ]
        ],
        [
          [
            [-879, 8878],
            [-887, 8878],
            [-919, 8873],
            [-888, 8882],
            [-879, 8878]
          ]
        ],
        [
          [
            [-664, 8929],
            [-667, 8922],
            [-684, 8917],
            [-696, 8911],
            [-717, 8904],
            [-678, 8925],
            [-664, 8929]
          ]
        ],
        [
          [
            [-486, 8962],
            [-491, 8971],
            [-504, 8966],
            [-518, 8966],
            [-532, 8959],
            [-545, 8959],
            [-542, 8965],
            [-519, 8975],
            [-486, 8981],
            [-490, 8971],
            [-486, 8962]
          ]
        ],
        [
          [
            [346, 8990],
            [350, 8999],
            [360, 8999],
            [349, 8990],
            [359, 8975],
            [348, 8970],
            [346, 8990]
          ]
        ],
        [
          [
            [-384, 8986],
            [-368, 8988],
            [-374, 8982],
            [-391, 8981],
            [-395, 8990],
            [-384, 8993],
            [-384, 8986]
          ]
        ],
        [
          [
            [398, 8990],
            [394, 8992],
            [415, 9005],
            [418, 9011],
            [430, 9012],
            [428, 9002],
            [407, 8986],
            [403, 8988],
            [398, 8976],
            [390, 8980],
            [398, 8990]
          ]
        ],
        [
          [
            [395, 9023],
            [398, 9030],
            [406, 9030],
            [401, 9023],
            [415, 9032],
            [418, 9022],
            [404, 9013],
            [395, 9023]
          ]
        ],
        [
          [
            [-61, 9101],
            [-51, 9098],
            [-60, 9089],
            [-90, 9083],
            [-98, 9086],
            [-82, 9093],
            [-73, 9094],
            [-61, 9101]
          ]
        ],
        [
          [
            [-342, 9166],
            [-335, 9163],
            [-344, 9152],
            [-367, 9147],
            [-378, 9148],
            [-386, 9153],
            [-385, 9160],
            [-370, 9160],
            [-342, 9166]
          ]
        ],
        [
          [
            [1457, 8708],
            [1438, 8699],
            [1430, 8692],
            [1428, 8701],
            [1448, 8710],
            [1457, 8708]
          ]
        ],
        [
          [
            [-591, 8948],
            [-571, 8954],
            [-569, 8951],
            [-598, 8944],
            [-619, 8934],
            [-626, 8928],
            [-658, 8920],
            [-628, 8934],
            [-630, 8939],
            [-610, 8944],
            [-616, 8938],
            [-591, 8948]
          ]
        ],
        [
          [
            [417, 9086],
            [406, 9078],
            [408, 9071],
            [398, 9060],
            [371, 9049],
            [385, 9060],
            [406, 9097],
            [406, 9090],
            [417, 9086]
          ]
        ],
        [
          [
            [-303, 9266],
            [-286, 9264],
            [-294, 9259],
            [-308, 9260],
            [-326, 9252],
            [-325, 9263],
            [-340, 9268],
            [-354, 9264],
            [-356, 9271],
            [-341, 9280],
            [-343, 9274],
            [-331, 9273],
            [-309, 9277],
            [-313, 9270],
            [-303, 9266]
          ]
        ],
        [
          [
            [842, 7936],
            [844, 7950],
            [837, 7954],
            [840, 7974],
            [831, 7982],
            [822, 8000],
            [817, 8031],
            [809, 8044],
            [806, 8046],
            [802, 8050],
            [800, 8055],
            [778, 8056],
            [773, 8060],
            [759, 8054],
            [748, 8036],
            [737, 8026],
            [712, 8039],
            [700, 8052],
            [701, 8071],
            [698, 8084],
            [686, 8096],
            [661, 8129],
            [608, 8130],
            [602, 8113],
            [513, 8113],
            [410, 8156],
            [416, 8164],
            [338, 8158],
            [340, 8179],
            [337, 8187],
            [324, 8203],
            [311, 8190],
            [307, 8193],
            [317, 8206],
            [315, 8214],
            [306, 8212],
            [295, 8218],
            [264, 8208],
            [259, 8213],
            [275, 8215],
            [279, 8227],
            [261, 8229],
            [257, 8234],
            [266, 8255],
            [260, 8258],
            [262, 8267],
            [254, 8275],
            [250, 8294],
            [245, 8299],
            [247, 8310],
            [257, 8318],
            [255, 8325],
            [245, 8330],
            [251, 8355],
            [258, 8343],
            [257, 8368],
            [251, 8357],
            [244, 8380],
            [234, 8398],
            [247, 8432],
            [240, 8445],
            [242, 8452],
            [262, 8473],
            [272, 8488],
            [279, 8507],
            [277, 8513],
            [287, 8532],
            [286, 8538],
            [311, 8564],
            [363, 8637],
            [376, 8663],
            [375, 8666],
            [391, 8683],
            [388, 8688],
            [398, 8719],
            [399, 8735],
            [409, 8742],
            [419, 8735],
            [456, 8732],
            [450, 8710],
            [468, 8728],
            [467, 8740],
            [453, 8747],
            [466, 8754],
            [471, 8745],
            [476, 8751],
            [476, 8765],
            [1269, 8765],
            [1276, 8778],
            [1284, 8776],
            [1279, 8758],
            [1300, 8752],
            [1300, 8747],
            [1317, 8751],
            [1333, 8748],
            [1336, 8737],
            [1347, 8741],
            [1360, 8730],
            [1379, 8737],
            [1380, 8732],
            [1399, 8733],
            [1413, 8728],
            [1380, 8718],
            [1363, 8710],
            [1342, 8697],
            [1319, 8685],
            [1321, 8681],
            [1355, 8690],
            [1366, 8689],
            [1357, 8681],
            [1364, 8677],
            [1387, 8686],
            [1399, 8687],
            [1427, 8701],
            [1429, 8691],
            [1450, 8686],
            [1453, 8674],
            [1475, 8673],
            [1491, 8681],
            [1509, 8681],
            [1527, 8684],
            [1521, 8675],
            [1536, 8672],
            [1548, 8675],
            [1545, 8668],
            [1539, 8663],
            [1546, 8659],
            [1547, 8659],
            [1556, 8653],
            [1525, 8658],
            [1520, 8651],
            [1514, 8657],
            [1500, 8659],
            [1494, 8655],
            [1494, 8631],
            [1505, 8633],
            [1506, 8642],
            [1523, 8649],
            [1533, 8638],
            [1548, 8632],
            [1550, 8622],
            [1544, 8620],
            [1545, 8606],
            [1538, 8592],
            [1527, 8583],
            [1518, 8580],
            [1512, 8569],
            [1518, 8566],
            [1536, 8580],
            [1547, 8583],
            [1551, 8578],
            [1547, 8545],
            [1539, 8532],
            [1533, 8529],
            [1530, 8532],
            [1518, 8520],
            [1517, 8519],
            [1517, 8519],
            [1498, 8498],
            [1522, 8487],
            [1549, 8491],
            [1561, 8499],
            [1594, 8509],
            [1638, 8529],
            [1650, 8542],
            [1648, 8545],
            [1648, 8548],
            [1649, 8551],
            [1650, 8554],
            [1680, 8559],
            [1695, 8554],
            [1721, 8557],
            [1740, 8566],
            [1742, 8585],
            [1749, 8589],
            [1760, 8594],
            [1764, 8598],
            [1784, 8612],
            [1802, 8616],
            [1802, 8616],
            [1817, 8619],
            [1897, 8620],
            [1907, 8630],
            [1921, 8634],
            [1944, 8652],
            [1945, 8659],
            [1962, 8681],
            [1994, 8709],
            [2000, 8699],
            [2019, 8705],
            [2031, 8695],
            [2015, 8647],
            [2018, 8642],
            [2024, 8641],
            [2019, 8629],
            [2026, 8626],
            [2028, 8610],
            [2017, 8602],
            [1998, 8600],
            [1981, 8589],
            [1975, 8591],
            [1971, 8584],
            [1964, 8592],
            [1952, 8579],
            [1947, 8579],
            [1930, 8570],
            [1931, 8574],
            [1918, 8570],
            [1917, 8565],
            [1903, 8555],
            [1892, 8541],
            [1895, 8531],
            [1877, 8520],
            [1886, 8516],
            [1887, 8502],
            [1894, 8498],
            [1905, 8503],
            [1903, 8497],
            [1889, 8495],
            [1873, 8489],
            [1872, 8492],
            [1856, 8489],
            [1836, 8481],
            [1809, 8481],
            [1785, 8473],
            [1773, 8464],
            [1788, 8470],
            [1815, 8472],
            [1825, 8477],
            [1828, 8472],
            [1804, 8463],
            [1759, 8454],
            [1766, 8450],
            [1746, 8419],
            [1726, 8401],
            [1709, 8419],
            [1708, 8403],
            [1715, 8393],
            [1712, 8380],
            [1697, 8359],
            [1692, 8357],
            [1675, 8339],
            [1676, 8347],
            [1689, 8362],
            [1675, 8381],
            [1684, 8385],
            [1677, 8392],
            [1685, 8397],
            [1683, 8407],
            [1698, 8424],
            [1680, 8410],
            [1670, 8391],
            [1667, 8377],
            [1669, 8365],
            [1655, 8373],
            [1670, 8360],
            [1665, 8343],
            [1655, 8335],
            [1661, 8329],
            [1652, 8322],
            [1667, 8323],
            [1664, 8307],
            [1665, 8291],
            [1657, 8294],
            [1635, 8286],
            [1662, 8287],
            [1662, 8274],
            [1643, 8263],
            [1646, 8253],
            [1628, 8235],
            [1611, 8237],
            [1595, 8230],
            [1584, 8220],
            [1576, 8207],
            [1558, 8207],
            [1544, 8199],
            [1532, 8182],
            [1501, 8161],
            [1489, 8156],
            [1468, 8140],
            [1444, 8106],
            [1438, 8091],
            [1437, 8055],
            [1441, 8032],
            [1448, 8012],
            [1444, 8000],
            [1454, 7945],
            [1445, 7911],
            [1438, 7900],
            [1434, 7886],
            [1410, 7882],
            [1407, 7904],
            [1393, 7918],
            [1394, 7931],
            [1386, 7934],
            [1390, 7947],
            [1383, 7942],
            [1373, 7971],
            [1386, 7982],
            [1372, 7985],
            [1382, 8006],
            [1386, 8022],
            [1382, 8032],
            [1376, 8033],
            [1362, 8061],
            [1352, 8068],
            [1340, 8065],
            [1340, 8060],
            [1318, 8049],
            [1307, 8052],
            [1309, 8056],
            [1302, 8067],
            [1290, 8075],
            [1287, 8082],
            [1276, 8079],
            [1239, 8073],
            [1217, 8078],
            [1214, 8072],
            [1203, 8079],
            [1180, 8063],
            [1182, 8057],
            [1167, 8050],
            [1172, 8041],
            [1182, 8040],
            [1181, 8026],
            [1172, 8036],
            [1158, 8043],
            [1147, 8030],
            [1141, 8038],
            [1132, 8029],
            [1114, 8037],
            [1121, 8039],
            [1109, 8054],
            [1085, 8046],
            [1060, 8055],
            [1030, 8051],
            [1011, 8043],
            [1008, 8055],
            [1000, 8047],
            [1007, 8039],
            [974, 8018],
            [917, 7992],
            [924, 7990],
            [905, 7960],
            [902, 7949],
            [903, 7913],
            [893, 7909],
            [886, 7916],
            [869, 7918],
            [842, 7936]
          ]
        ],
        [
          [
            [468, 8765],
            [466, 8764],
            [466, 8765],
            [468, 8765]
          ]
        ],
        [
          [
            [373, 9119],
            [373, 9121],
            [374, 9120],
            [374, 9120],
            [374, 9120],
            [373, 9119],
            [373, 9119],
            [373, 9119]
          ]
        ],
        [
          [
            [382, 9035],
            [353, 9016],
            [359, 9027],
            [369, 9031],
            [368, 9040],
            [379, 9047],
            [382, 9036],
            [392, 9052],
            [412, 9047],
            [409, 9042],
            [414, 9035],
            [393, 9030],
            [379, 9030],
            [382, 9035]
          ]
        ],
        [
          [
            [353, 9063],
            [354, 9071],
            [348, 9079],
            [356, 9087],
            [380, 9093],
            [383, 9087],
            [395, 9085],
            [380, 9066],
            [373, 9065],
            [364, 9075],
            [361, 9066],
            [357, 9064],
            [367, 9068],
            [373, 9058],
            [362, 9040],
            [346, 9023],
            [341, 9022],
            [346, 9042],
            [359, 9058],
            [352, 9058],
            [343, 9049],
            [348, 9060],
            [353, 9063]
          ]
        ],
        [
          [
            [461, 9011],
            [452, 9006],
            [443, 8989],
            [436, 8985],
            [421, 8976],
            [419, 8975],
            [403, 8972],
            [410, 8986],
            [420, 8990],
            [431, 9004],
            [431, 9013],
            [413, 9010],
            [395, 8997],
            [395, 9006],
            [402, 9007],
            [419, 9022],
            [415, 9036],
            [414, 9052],
            [405, 9055],
            [417, 9063],
            [420, 9086],
            [426, 9094],
            [411, 9092],
            [424, 9129],
            [413, 9117],
            [409, 9106],
            [397, 9092],
            [380, 9097],
            [388, 9103],
            [374, 9120],
            [374, 9120],
            [374, 9120],
            [387, 9124],
            [409, 9139],
            [439, 9145],
            [443, 9137],
            [436, 9128],
            [443, 9122],
            [441, 9113],
            [447, 9109],
            [448, 9098],
            [442, 9066],
            [441, 9050],
            [434, 9044],
            [433, 9035],
            [440, 9035],
            [465, 9018],
            [461, 9011]
          ]
        ],
        [
          [
            [373, 9119],
            [372, 9116],
            [380, 9107],
            [374, 9094],
            [367, 9098],
            [355, 9092],
            [342, 9105],
            [341, 9121],
            [315, 9137],
            [331, 9143],
            [333, 9149],
            [301, 9143],
            [282, 9151],
            [258, 9156],
            [224, 9152],
            [208, 9163],
            [227, 9176],
            [201, 9163],
            [184, 9169],
            [163, 9161],
            [165, 9166],
            [191, 9172],
            [186, 9174],
            [198, 9181],
            [182, 9181],
            [172, 9186],
            [143, 9180],
            [171, 9196],
            [152, 9189],
            [129, 9174],
            [141, 9178],
            [128, 9161],
            [119, 9160],
            [125, 9152],
            [157, 9163],
            [125, 9148],
            [113, 9145],
            [114, 9158],
            [103, 9151],
            [80, 9152],
            [59, 9141],
            [58, 9145],
            [35, 9133],
            [-0, 9127],
            [-13, 9123],
            [-13, 9129],
            [19, 9139],
            [7, 9145],
            [35, 9160],
            [51, 9171],
            [54, 9176],
            [94, 9188],
            [120, 9183],
            [102, 9192],
            [100, 9197],
            [63, 9187],
            [32, 9173],
            [34, 9169],
            [4, 9160],
            [-11, 9149],
            [-34, 9140],
            [-47, 9140],
            [-67, 9130],
            [-82, 9119],
            [-68, 9121],
            [-63, 9116],
            [-73, 9109],
            [-90, 9105],
            [-102, 9097],
            [-116, 9093],
            [-123, 9087],
            [-143, 9085],
            [-164, 9074],
            [-167, 9077],
            [-180, 9068],
            [-186, 9069],
            [-223, 9049],
            [-226, 9051],
            [-248, 9041],
            [-280, 9034],
            [-282, 9025],
            [-290, 9031],
            [-293, 9024],
            [-308, 9018],
            [-342, 9009],
            [-356, 9002],
            [-354, 9009],
            [-387, 8996],
            [-396, 8997],
            [-418, 8992],
            [-412, 9001],
            [-439, 8984],
            [-451, 8982],
            [-458, 8974],
            [-462, 8980],
            [-488, 8973],
            [-477, 8983],
            [-447, 8994],
            [-406, 9010],
            [-392, 9013],
            [-365, 9009],
            [-369, 9014],
            [-352, 9024],
            [-324, 9034],
            [-293, 9044],
            [-287, 9041],
            [-279, 9050],
            [-258, 9060],
            [-233, 9069],
            [-198, 9096],
            [-170, 9109],
            [-165, 9114],
            [-204, 9105],
            [-207, 9111],
            [-193, 9121],
            [-218, 9109],
            [-230, 9098],
            [-235, 9098],
            [-230, 9115],
            [-244, 9110],
            [-244, 9121],
            [-262, 9115],
            [-278, 9103],
            [-287, 9107],
            [-302, 9103],
            [-291, 9112],
            [-282, 9126],
            [-263, 9135],
            [-255, 9156],
            [-246, 9166],
            [-265, 9152],
            [-301, 9146],
            [-313, 9147],
            [-306, 9153],
            [-318, 9171],
            [-287, 9181],
            [-274, 9172],
            [-257, 9178],
            [-267, 9182],
            [-283, 9182],
            [-296, 9204],
            [-279, 9210],
            [-283, 9214],
            [-268, 9216],
            [-260, 9224],
            [-236, 9234],
            [-216, 9241],
            [-208, 9248],
            [-189, 9258],
            [-171, 9262],
            [-153, 9256],
            [-114, 9270],
            [-86, 9270],
            [-66, 9278],
            [-49, 9295],
            [-54, 9301],
            [-29, 9308],
            [-27, 9318],
            [-80, 9304],
            [-97, 9300],
            [-101, 9305],
            [-122, 9306],
            [-143, 9302],
            [-166, 9306],
            [-158, 9316],
            [-161, 9325],
            [-151, 9324],
            [-135, 9329],
            [-161, 9333],
            [-167, 9342],
            [-99, 9359],
            [-81, 9357],
            [-86, 9362],
            [-44, 9370],
            [-17, 9372],
            [-34, 9362],
            [-47, 9359],
            [-39, 9355],
            [-15, 9356],
            [1, 9352],
            [21, 9361],
            [34, 9360],
            [29, 9366],
            [15, 9364],
            [25, 9369],
            [22, 9381],
            [33, 9383],
            [28, 9367],
            [42, 9370],
            [45, 9364],
            [66, 9370],
            [56, 9374],
            [35, 9370],
            [33, 9375],
            [49, 9386],
            [31, 9384],
            [5, 9388],
            [17, 9405],
            [6, 9419],
            [-11, 9428],
            [10, 9435],
            [23, 9444],
            [71, 9446],
            [97, 9452],
            [119, 9460],
            [143, 9474],
            [170, 9481],
            [194, 9490],
            [203, 9488],
            [251, 9498],
            [234, 9490],
            [252, 9495],
            [251, 9499],
            [267, 9504],
            [281, 9504],
            [312, 9506],
            [356, 9520],
            [378, 9516],
            [358, 9509],
            [364, 9506],
            [388, 9515],
            [395, 9511],
            [387, 9505],
            [423, 9508],
            [441, 9506],
            [428, 9499],
            [442, 9497],
            [431, 9493],
            [483, 9495],
            [506, 9495],
            [510, 9489],
            [534, 9485],
            [564, 9485],
            [570, 9479],
            [586, 9479],
            [622, 9483],
            [658, 9469],
            [574, 9400],
            [486, 9324],
            [395, 9242],
            [312, 9163],
            [333, 9159],
            [347, 9164],
            [363, 9164],
            [351, 9155],
            [364, 9126],
            [358, 9115],
            [373, 9119],
            [373, 9119],
            [373, 9119]
          ]
        ],
        [
          [
            [-162, 9060],
            [-139, 9072],
            [-130, 9072],
            [-112, 9080],
            [-102, 9077],
            [-103, 9083],
            [-75, 9081],
            [-88, 9074],
            [-80, 9071],
            [-92, 9064],
            [-106, 9067],
            [-102, 9062],
            [-137, 9052],
            [-161, 9040],
            [-170, 9032],
            [-189, 9033],
            [-170, 9035],
            [-142, 9054],
            [-165, 9045],
            [-162, 9060]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "JP",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.68,
      "hc-middle-y": 0.49,
      "hc-key": "jp",
      "hc-a2": "JP",
      "name": "Japan",
      "labelrank": "2",
      "country-abbrev": "Japan",
      "subregion": "Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "JPN",
      "iso-a2": "JP",
      "woe-id": "23424856",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8078, 7941],
            [8089, 7940],
            [8080, 7918],
            [8079, 7931],
            [8084, 7937],
            [8078, 7941]
          ]
        ],
        [
          [
            [8106, 7981],
            [8100, 7985],
            [8108, 7993],
            [8104, 7999],
            [8117, 8007],
            [8106, 7981]
          ]
        ],
        [
          [
            [8125, 8072],
            [8116, 8078],
            [8131, 8081],
            [8132, 8095],
            [8135, 8077],
            [8125, 8072]
          ]
        ],
        [
          [
            [8045, 8203],
            [8049, 8203],
            [8048, 8189],
            [8038, 8162],
            [8029, 8161],
            [8038, 8176],
            [8036, 8184],
            [8047, 8189],
            [8045, 8203]
          ]
        ],
        [
          [
            [8192, 8223],
            [8197, 8235],
            [8202, 8222],
            [8195, 8213],
            [8202, 8206],
            [8194, 8199],
            [8194, 8184],
            [8176, 8195],
            [8164, 8188],
            [8163, 8170],
            [8152, 8165],
            [8143, 8183],
            [8132, 8192],
            [8140, 8202],
            [8141, 8218],
            [8150, 8210],
            [8162, 8211],
            [8162, 8219],
            [8179, 8233],
            [8177, 8224],
            [8192, 8223]
          ]
        ],
        [
          [
            [8133, 8115],
            [8117, 8101],
            [8116, 8113],
            [8106, 8126],
            [8106, 8118],
            [8113, 8111],
            [8100, 8110],
            [8097, 8125],
            [8082, 8131],
            [8077, 8125],
            [8084, 8143],
            [8090, 8142],
            [8093, 8157],
            [8089, 8157],
            [8079, 8145],
            [8076, 8167],
            [8067, 8165],
            [8057, 8172],
            [8070, 8169],
            [8065, 8176],
            [8050, 8183],
            [8057, 8187],
            [8064, 8199],
            [8070, 8197],
            [8069, 8207],
            [8081, 8208],
            [8092, 8198],
            [8109, 8200],
            [8114, 8190],
            [8110, 8185],
            [8123, 8185],
            [8122, 8180],
            [8132, 8173],
            [8127, 8157],
            [8133, 8115]
          ]
        ],
        [
          [
            [8212, 8313],
            [8212, 8321],
            [8203, 8339],
            [8216, 8346],
            [8219, 8321],
            [8232, 8317],
            [8232, 8323],
            [8252, 8333],
            [8257, 8340],
            [8258, 8356],
            [8269, 8369],
            [8266, 8379],
            [8267, 8394],
            [8261, 8420],
            [8253, 8432],
            [8240, 8437],
            [8242, 8448],
            [8231, 8457],
            [8239, 8465],
            [8231, 8482],
            [8241, 8479],
            [8251, 8467],
            [8253, 8473],
            [8263, 8467],
            [8257, 8482],
            [8248, 8477],
            [8242, 8492],
            [8265, 8478],
            [8277, 8460],
            [8309, 8436],
            [8326, 8405],
            [8320, 8401],
            [8321, 8388],
            [8331, 8374],
            [8322, 8379],
            [8316, 8370],
            [8321, 8359],
            [8334, 8340],
            [8339, 8324],
            [8336, 8321],
            [8340, 8298],
            [8360, 8277],
            [8351, 8271],
            [8354, 8257],
            [8345, 8246],
            [8334, 8262],
            [8337, 8273],
            [8330, 8270],
            [8332, 8255],
            [8326, 8261],
            [8315, 8259],
            [8320, 8248],
            [8314, 8237],
            [8307, 8254],
            [8299, 8253],
            [8295, 8239],
            [8291, 8237],
            [8253, 8240],
            [8244, 8251],
            [8246, 8235],
            [8256, 8230],
            [8260, 8223],
            [8250, 8222],
            [8244, 8215],
            [8244, 8197],
            [8240, 8193],
            [8229, 8195],
            [8211, 8208],
            [8205, 8224],
            [8209, 8238],
            [8196, 8236],
            [8187, 8241],
            [8173, 8238],
            [8163, 8229],
            [8135, 8224],
            [8134, 8218],
            [8124, 8226],
            [8117, 8221],
            [8122, 8210],
            [8122, 8206],
            [8105, 8214],
            [8090, 8210],
            [8077, 8216],
            [8075, 8227],
            [8089, 8228],
            [8091, 8237],
            [8098, 8239],
            [8110, 8266],
            [8121, 8273],
            [8134, 8267],
            [8158, 8270],
            [8165, 8275],
            [8177, 8274],
            [8184, 8279],
            [8187, 8271],
            [8205, 8268],
            [8211, 8279],
            [8203, 8287],
            [8204, 8296],
            [8212, 8313]
          ]
        ],
        [
          [
            [8297, 8520],
            [8303, 8506],
            [8241, 8531],
            [8225, 8521],
            [8213, 8529],
            [8203, 8527],
            [8206, 8518],
            [8222, 8513],
            [8244, 8501],
            [8225, 8497],
            [8224, 8487],
            [8213, 8493],
            [8209, 8508],
            [8192, 8517],
            [8185, 8532],
            [8194, 8536],
            [8196, 8544],
            [8185, 8552],
            [8185, 8558],
            [8212, 8550],
            [8214, 8557],
            [8202, 8573],
            [8206, 8578],
            [8190, 8608],
            [8173, 8627],
            [8166, 8626],
            [8161, 8626],
            [8176, 8638],
            [8206, 8620],
            [8211, 8613],
            [8249, 8592],
            [8278, 8584],
            [8299, 8577],
            [8309, 8588],
            [8312, 8572],
            [8334, 8551],
            [8324, 8542],
            [8306, 8544],
            [8297, 8530],
            [8297, 8520]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.33,
      "hc-middle-y": 0.42,
      "hc-key": "in",
      "hc-a2": "IN",
      "name": "India",
      "labelrank": "2",
      "country-abbrev": "India",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "IND",
      "iso-a2": "IN",
      "woe-id": "23424848",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [7038, 7455],
            [7042, 7445],
            [7040, 7401],
            [7047, 7400],
            [7038, 7390],
            [7034, 7370],
            [7030, 7387],
            [7035, 7418],
            [7034, 7443],
            [7038, 7455]
          ]
        ],
        [
          [
            [6860, 7802],
            [6872, 7764],
            [6872, 7763],
            [6872, 7763],
            [6875, 7751],
            [6858, 7749],
            [6856, 7759],
            [6848, 7749],
            [6841, 7753],
            [6841, 7764],
            [6830, 7753],
            [6814, 7749],
            [6806, 7741],
            [6805, 7732],
            [6812, 7716],
            [6796, 7691],
            [6772, 7681],
            [6765, 7687],
            [6756, 7674],
            [6764, 7675],
            [6750, 7662],
            [6729, 7627],
            [6715, 7618],
            [6705, 7602],
            [6682, 7587],
            [6676, 7576],
            [6679, 7564],
            [6660, 7554],
            [6645, 7554],
            [6644, 7541],
            [6633, 7532],
            [6628, 7539],
            [6616, 7531],
            [6611, 7506],
            [6618, 7489],
            [6616, 7477],
            [6622, 7460],
            [6616, 7454],
            [6627, 7444],
            [6623, 7413],
            [6615, 7394],
            [6612, 7378],
            [6615, 7369],
            [6619, 7330],
            [6604, 7331],
            [6591, 7307],
            [6592, 7292],
            [6574, 7285],
            [6568, 7280],
            [6563, 7258],
            [6546, 7247],
            [6529, 7258],
            [6513, 7278],
            [6504, 7300],
            [6503, 7314],
            [6499, 7323],
            [6485, 7360],
            [6474, 7382],
            [6462, 7394],
            [6448, 7425],
            [6438, 7462],
            [6427, 7489],
            [6411, 7508],
            [6410, 7518],
            [6393, 7545],
            [6386, 7562],
            [6384, 7579],
            [6367, 7630],
            [6361, 7663],
            [6352, 7686],
            [6357, 7711],
            [6355, 7725],
            [6343, 7743],
            [6360, 7756],
            [6341, 7754],
            [6339, 7771],
            [6348, 7774],
            [6333, 7778],
            [6329, 7758],
            [6334, 7752],
            [6329, 7736],
            [6295, 7718],
            [6280, 7721],
            [6264, 7734],
            [6233, 7765],
            [6223, 7777],
            [6232, 7776],
            [6262, 7787],
            [6267, 7801],
            [6249, 7798],
            [6246, 7794],
            [6229, 7797],
            [6210, 7809],
            [6200, 7826],
            [6212, 7836],
            [6192, 7826],
            [6192, 7834],
            [6209, 7839],
            [6211, 7849],
            [6234, 7850],
            [6248, 7846],
            [6251, 7851],
            [6266, 7856],
            [6273, 7849],
            [6282, 7856],
            [6281, 7866],
            [6264, 7892],
            [6262, 7903],
            [6249, 7904],
            [6242, 7914],
            [6242, 7934],
            [6231, 7936],
            [6218, 7945],
            [6220, 7959],
            [6231, 7974],
            [6233, 7982],
            [6242, 7991],
            [6257, 7978],
            [6288, 7988],
            [6298, 8018],
            [6314, 8027],
            [6320, 8046],
            [6322, 8061],
            [6338, 8071],
            [6334, 8077],
            [6350, 8105],
            [6349, 8118],
            [6343, 8127],
            [6351, 8139],
            [6365, 8143],
            [6366, 8148],
            [6354, 8155],
            [6344, 8155],
            [6340, 8169],
            [6330, 8166],
            [6327, 8175],
            [6316, 8182],
            [6317, 8195],
            [6311, 8199],
            [6315, 8213],
            [6307, 8213],
            [6304, 8224],
            [6298, 8226],
            [6300, 8236],
            [6312, 8241],
            [6359, 8231],
            [6365, 8238],
            [6384, 8240],
            [6393, 8254],
            [6412, 8269],
            [6420, 8267],
            [6421, 8260],
            [6436, 8236],
            [6458, 8226],
            [6455, 8215],
            [6463, 8193],
            [6470, 8186],
            [6484, 8181],
            [6491, 8166],
            [6487, 8156],
            [6477, 8151],
            [6468, 8161],
            [6458, 8157],
            [6463, 8146],
            [6475, 8136],
            [6480, 8123],
            [6480, 8113],
            [6494, 8113],
            [6510, 8098],
            [6518, 8099],
            [6532, 8091],
            [6532, 8084],
            [6546, 8081],
            [6561, 8071],
            [6544, 8055],
            [6545, 8038],
            [6541, 8020],
            [6557, 8010],
            [6559, 8015],
            [6586, 7995],
            [6607, 7984],
            [6611, 7986],
            [6626, 7977],
            [6632, 7978],
            [6637, 7970],
            [6657, 7970],
            [6673, 7965],
            [6679, 7971],
            [6696, 7964],
            [6700, 7953],
            [6723, 7942],
            [6732, 7946],
            [6741, 7936],
            [6756, 7938],
            [6771, 7930],
            [6780, 7936],
            [6791, 7928],
            [6807, 7932],
            [6812, 7929],
            [6815, 7942],
            [6806, 7956],
            [6805, 7984],
            [6818, 7993],
            [6826, 7989],
            [6827, 7972],
            [6834, 7964],
            [6830, 7958],
            [6844, 7945],
            [6851, 7947],
            [6868, 7941],
            [6884, 7948],
            [6892, 7944],
            [6927, 7945],
            [6938, 7950],
            [6931, 7970],
            [6924, 7968],
            [6917, 7980],
            [6929, 7979],
            [6948, 7986],
            [6948, 7994],
            [6967, 8014],
            [6973, 8014],
            [6993, 8027],
            [6999, 8038],
            [7005, 8033],
            [7022, 8028],
            [7034, 8039],
            [7046, 8040],
            [7067, 8016],
            [7082, 8002],
            [7094, 7997],
            [7097, 7985],
            [7085, 7974],
            [7096, 7959],
            [7095, 7955],
            [7082, 7965],
            [7065, 7962],
            [7036, 7932],
            [7040, 7919],
            [7040, 7905],
            [7030, 7892],
            [7036, 7878],
            [7027, 7853],
            [7024, 7834],
            [7007, 7841],
            [6997, 7840],
            [7003, 7828],
            [7005, 7808],
            [6998, 7803],
            [7002, 7780],
            [6995, 7764],
            [6988, 7771],
            [6985, 7765],
            [6979, 7792],
            [6973, 7800],
            [6971, 7813],
            [6962, 7830],
            [6951, 7813],
            [6954, 7806],
            [6948, 7801],
            [6943, 7810],
            [6938, 7807],
            [6930, 7826],
            [6934, 7844],
            [6956, 7855],
            [6958, 7869],
            [6965, 7875],
            [6949, 7884],
            [6930, 7883],
            [6923, 7885],
            [6896, 7883],
            [6876, 7891],
            [6874, 7912],
            [6866, 7923],
            [6864, 7913],
            [6846, 7924],
            [6839, 7923],
            [6826, 7932],
            [6818, 7911],
            [6835, 7896],
            [6843, 7896],
            [6850, 7884],
            [6834, 7885],
            [6832, 7873],
            [6828, 7875],
            [6824, 7864],
            [6840, 7852],
            [6849, 7851],
            [6850, 7837],
            [6846, 7827],
            [6854, 7812],
            [6862, 7810],
            [6860, 7802]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.39,
      "hc-key": "kr",
      "hc-a2": "KR",
      "name": "South Korea",
      "labelrank": "2",
      "country-abbrev": "S.K.",
      "subregion": "Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "KOR",
      "iso-a2": "KR",
      "woe-id": "23424868",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [7960, 8196],
            [7965, 8191],
            [7956, 8184],
            [7944, 8185],
            [7945, 8192],
            [7960, 8196]
          ]
        ],
        [
          [
            [7885, 8357],
            [7891, 8375],
            [7921, 8377],
            [7922, 8387],
            [7940, 8368],
            [7961, 8351],
            [7976, 8336],
            [7990, 8315],
            [7997, 8295],
            [8004, 8291],
            [8010, 8269],
            [8008, 8256],
            [8000, 8250],
            [7997, 8239],
            [7971, 8248],
            [7969, 8235],
            [7961, 8246],
            [7957, 8241],
            [7965, 8234],
            [7961, 8229],
            [7941, 8219],
            [7935, 8233],
            [7923, 8224],
            [7914, 8238],
            [7923, 8250],
            [7912, 8252],
            [7920, 8257],
            [7916, 8274],
            [7923, 8280],
            [7912, 8287],
            [7909, 8299],
            [7898, 8311],
            [7887, 8317],
            [7896, 8320],
            [7894, 8327],
            [7901, 8327],
            [7889, 8343],
            [7872, 8356],
            [7885, 8357]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "FR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.29,
      "hc-middle-y": 0.06,
      "hc-key": "fr",
      "hc-a2": "FR",
      "name": "France",
      "labelrank": "2",
      "country-abbrev": "Fr.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "FRA",
      "iso-a2": "FR",
      "woe-id": "-90",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5795, 6169],
            [5805, 6159],
            [5804, 6152],
            [5789, 6154],
            [5786, 6163],
            [5795, 6169]
          ]
        ],
        [
          [
            [2004, 7551],
            [2008, 7561],
            [2016, 7552],
            [2003, 7546],
            [2015, 7540],
            [2000, 7538],
            [1996, 7546],
            [1998, 7556],
            [2004, 7551]
          ]
        ],
        [
          [
            [4287, 8532],
            [4291, 8513],
            [4282, 8485],
            [4269, 8493],
            [4269, 8505],
            [4261, 8517],
            [4268, 8530],
            [4282, 8533],
            [4287, 8544],
            [4287, 8532]
          ]
        ],
        [
          [
            [9395, 6175],
            [9403, 6175],
            [9402, 6158],
            [9380, 6176],
            [9383, 6180],
            [9395, 6175]
          ]
        ],
        [
          [
            [9326, 6151],
            [9308, 6173],
            [9305, 6189],
            [9300, 6192],
            [9308, 6200],
            [9331, 6174],
            [9335, 6173],
            [9344, 6155],
            [9364, 6140],
            [9371, 6128],
            [9378, 6124],
            [9375, 6113],
            [9355, 6122],
            [9349, 6129],
            [9330, 6143],
            [9326, 6151]
          ]
        ],
        [
          [
            [1959, 7619],
            [1962, 7621],
            [1962, 7618],
            [1959, 7619]
          ]
        ],
        [
          [
            [4227, 8573],
            [4227, 8572],
            [4225, 8571],
            [4225, 8572],
            [4223, 8570],
            [4201, 8554],
            [4187, 8548],
            [4164, 8552],
            [4159, 8560],
            [4148, 8557],
            [4122, 8564],
            [4105, 8555],
            [4095, 8542],
            [4100, 8524],
            [4092, 8525],
            [4080, 8520],
            [4063, 8522],
            [4056, 8527],
            [4056, 8530],
            [4047, 8530],
            [4045, 8534],
            [4024, 8539],
            [4024, 8533],
            [4003, 8533],
            [3995, 8539],
            [3988, 8536],
            [3982, 8543],
            [3964, 8548],
            [3963, 8553],
            [3951, 8558],
            [3961, 8565],
            [3970, 8604],
            [3967, 8603],
            [3971, 8637],
            [3982, 8631],
            [3981, 8637],
            [3968, 8645],
            [3974, 8657],
            [3969, 8666],
            [3952, 8674],
            [3943, 8688],
            [3947, 8693],
            [3923, 8710],
            [3890, 8725],
            [3878, 8721],
            [3869, 8731],
            [3880, 8736],
            [3867, 8741],
            [3868, 8749],
            [3890, 8755],
            [3902, 8754],
            [3903, 8759],
            [3914, 8760],
            [3927, 8747],
            [3938, 8754],
            [3941, 8750],
            [3960, 8756],
            [3960, 8766],
            [3949, 8791],
            [3968, 8790],
            [3971, 8780],
            [3998, 8775],
            [4009, 8780],
            [4010, 8790],
            [4039, 8800],
            [4049, 8809],
            [4049, 8832],
            [4076, 8840],
            [4078, 8832],
            [4087, 8826],
            [4093, 8829],
            [4098, 8820],
            [4109, 8813],
            [4124, 8810],
            [4123, 8800],
            [4131, 8799],
            [4143, 8806],
            [4141, 8800],
            [4161, 8783],
            [4170, 8784],
            [4175, 8781],
            [4186, 8781],
            [4198, 8771],
            [4201, 8773],
            [4240, 8763],
            [4230, 8751],
            [4224, 8733],
            [4225, 8713],
            [4219, 8708],
            [4208, 8710],
            [4209, 8704],
            [4192, 8683],
            [4183, 8677],
            [4187, 8666],
            [4189, 8669],
            [4191, 8670],
            [4203, 8671],
            [4203, 8661],
            [4210, 8653],
            [4205, 8645],
            [4215, 8634],
            [4212, 8627],
            [4199, 8623],
            [4203, 8614],
            [4211, 8610],
            [4207, 8600],
            [4211, 8589],
            [4222, 8585],
            [4231, 8587],
            [4227, 8573]
          ],
          [
            [4063, 8524],
            [4064, 8524],
            [4063, 8526],
            [4063, 8525],
            [4063, 8524]
          ]
        ],
        [
          [
            [2226, 7146],
            [2233, 7160],
            [2265, 7149],
            [2306, 7110],
            [2306, 7097],
            [2296, 7084],
            [2284, 7064],
            [2275, 7040],
            [2262, 7027],
            [2251, 7034],
            [2235, 7033],
            [2224, 7025],
            [2209, 7033],
            [2217, 7039],
            [2224, 7053],
            [2224, 7066],
            [2230, 7075],
            [2218, 7097],
            [2215, 7129],
            [2226, 7146]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.45,
      "hc-middle-y": 0.50,
      "hc-key": "cn",
      "hc-a2": "CN",
      "name": "China",
      "labelrank": "2",
      "country-abbrev": "China",
      "subregion": "Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "CHN",
      "iso-a2": "CN",
      "woe-id": "23424781",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [7581, 7654],
            [7580, 7643],
            [7570, 7631],
            [7560, 7632],
            [7555, 7623],
            [7524, 7637],
            [7518, 7664],
            [7529, 7676],
            [7549, 7692],
            [7563, 7694],
            [7577, 7691],
            [7579, 7697],
            [7589, 7691],
            [7592, 7680],
            [7585, 7670],
            [7581, 7654]
          ]
        ],
        [
          [
            [6834, 7964],
            [6827, 7972],
            [6826, 7989],
            [6818, 7993],
            [6805, 7984],
            [6775, 7983],
            [6753, 7993],
            [6751, 7986],
            [6737, 7985],
            [6724, 8002],
            [6722, 7999],
            [6705, 8001],
            [6705, 8011],
            [6690, 8012],
            [6674, 8023],
            [6666, 8036],
            [6649, 8033],
            [6634, 8050],
            [6623, 8051],
            [6612, 8061],
            [6598, 8066],
            [6594, 8076],
            [6572, 8077],
            [6568, 8064],
            [6561, 8071],
            [6546, 8081],
            [6532, 8084],
            [6532, 8091],
            [6518, 8099],
            [6510, 8098],
            [6494, 8113],
            [6480, 8113],
            [6480, 8123],
            [6475, 8136],
            [6463, 8146],
            [6458, 8157],
            [6468, 8161],
            [6477, 8151],
            [6487, 8156],
            [6491, 8166],
            [6484, 8181],
            [6470, 8186],
            [6463, 8193],
            [6455, 8215],
            [6458, 8226],
            [6436, 8236],
            [6421, 8260],
            [6420, 8267],
            [6412, 8269],
            [6400, 8268],
            [6379, 8274],
            [6369, 8284],
            [6359, 8280],
            [6347, 8292],
            [6346, 8305],
            [6338, 8314],
            [6326, 8316],
            [6314, 8325],
            [6308, 8322],
            [6296, 8326],
            [6290, 8330],
            [6299, 8337],
            [6299, 8337],
            [6299, 8337],
            [6299, 8337],
            [6300, 8337],
            [6305, 8334],
            [6312, 8341],
            [6301, 8348],
            [6302, 8355],
            [6293, 8367],
            [6287, 8383],
            [6266, 8389],
            [6258, 8386],
            [6251, 8396],
            [6254, 8400],
            [6244, 8410],
            [6243, 8418],
            [6250, 8423],
            [6246, 8437],
            [6246, 8437],
            [6246, 8437],
            [6252, 8439],
            [6257, 8439],
            [6267, 8454],
            [6279, 8452],
            [6287, 8459],
            [6295, 8446],
            [6320, 8458],
            [6320, 8470],
            [6326, 8474],
            [6342, 8471],
            [6359, 8474],
            [6363, 8486],
            [6385, 8501],
            [6409, 8509],
            [6408, 8515],
            [6400, 8532],
            [6409, 8540],
            [6401, 8545],
            [6412, 8550],
            [6388, 8582],
            [6378, 8604],
            [6381, 8607],
            [6360, 8613],
            [6364, 8620],
            [6386, 8624],
            [6407, 8632],
            [6418, 8625],
            [6426, 8628],
            [6434, 8624],
            [6434, 8635],
            [6423, 8639],
            [6423, 8652],
            [6419, 8700],
            [6448, 8691],
            [6470, 8691],
            [6475, 8685],
            [6486, 8694],
            [6494, 8694],
            [6493, 8706],
            [6480, 8726],
            [6480, 8743],
            [6501, 8748],
            [6500, 8769],
            [6513, 8768],
            [6518, 8769],
            [6526, 8771],
            [6529, 8760],
            [6541, 8749],
            [6562, 8741],
            [6565, 8736],
            [6581, 8728],
            [6596, 8729],
            [6605, 8722],
            [6612, 8724],
            [6625, 8716],
            [6634, 8703],
            [6652, 8690],
            [6663, 8676],
            [6663, 8667],
            [6671, 8656],
            [6667, 8647],
            [6669, 8637],
            [6680, 8626],
            [6702, 8622],
            [6751, 8620],
            [6768, 8613],
            [6779, 8605],
            [6819, 8590],
            [6828, 8591],
            [6831, 8581],
            [6838, 8579],
            [6860, 8553],
            [6879, 8541],
            [6883, 8535],
            [6907, 8537],
            [6979, 8529],
            [6993, 8533],
            [7044, 8527],
            [7062, 8515],
            [7096, 8509],
            [7120, 8500],
            [7141, 8504],
            [7145, 8496],
            [7161, 8494],
            [7164, 8499],
            [7202, 8519],
            [7241, 8525],
            [7261, 8523],
            [7280, 8525],
            [7302, 8536],
            [7308, 8555],
            [7330, 8570],
            [7300, 8597],
            [7300, 8620],
            [7317, 8622],
            [7326, 8613],
            [7359, 8607],
            [7369, 8615],
            [7373, 8633],
            [7405, 8636],
            [7415, 8645],
            [7412, 8652],
            [7415, 8667],
            [7435, 8669],
            [7432, 8676],
            [7442, 8674],
            [7455, 8682],
            [7499, 8677],
            [7498, 8688],
            [7484, 8700],
            [7447, 8720],
            [7435, 8727],
            [7412, 8728],
            [7411, 8727],
            [7410, 8720],
            [7407, 8716],
            [7389, 8724],
            [7371, 8724],
            [7363, 8718],
            [7344, 8733],
            [7350, 8737],
            [7344, 8747],
            [7340, 8795],
            [7378, 8784],
            [7393, 8800],
            [7407, 8802],
            [7404, 8813],
            [7398, 8814],
            [7395, 8834],
            [7397, 8840],
            [7392, 8861],
            [7399, 8877],
            [7387, 8892],
            [7370, 8894],
            [7362, 8900],
            [7371, 8918],
            [7381, 8918],
            [7406, 8926],
            [7421, 8925],
            [7430, 8929],
            [7463, 8922],
            [7487, 8912],
            [7492, 8916],
            [7515, 8908],
            [7560, 8878],
            [7562, 8873],
            [7580, 8858],
            [7596, 8848],
            [7601, 8839],
            [7619, 8828],
            [7633, 8812],
            [7642, 8809],
            [7651, 8794],
            [7672, 8785],
            [7693, 8785],
            [7707, 8778],
            [7713, 8780],
            [7752, 8760],
            [7764, 8760],
            [7766, 8751],
            [7783, 8739],
            [7784, 8731],
            [7804, 8717],
            [7846, 8718],
            [7846, 8727],
            [7853, 8732],
            [7866, 8732],
            [7868, 8738],
            [7883, 8742],
            [7896, 8738],
            [7898, 8729],
            [7911, 8719],
            [7910, 8708],
            [7905, 8701],
            [7922, 8665],
            [7918, 8661],
            [7924, 8640],
            [7919, 8635],
            [7926, 8624],
            [7919, 8622],
            [7905, 8631],
            [7890, 8628],
            [7884, 8632],
            [7880, 8615],
            [7868, 8610],
            [7876, 8605],
            [7896, 8582],
            [7905, 8564],
            [7910, 8561],
            [7915, 8539],
            [7900, 8535],
            [7908, 8528],
            [7886, 8544],
            [7878, 8543],
            [7885, 8524],
            [7874, 8525],
            [7870, 8509],
            [7845, 8508],
            [7862, 8493],
            [7861, 8486],
            [7832, 8490],
            [7816, 8501],
            [7809, 8496],
            [7811, 8488],
            [7807, 8468],
            [7799, 8468],
            [7794, 8459],
            [7781, 8453],
            [7773, 8439],
            [7770, 8432],
            [7751, 8428],
            [7744, 8431],
            [7742, 8420],
            [7736, 8424],
            [7733, 8411],
            [7721, 8409],
            [7715, 8396],
            [7700, 8391],
            [7695, 8399],
            [7710, 8404],
            [7708, 8415],
            [7693, 8416],
            [7688, 8421],
            [7695, 8426],
            [7691, 8433],
            [7699, 8436],
            [7703, 8454],
            [7683, 8466],
            [7660, 8469],
            [7655, 8460],
            [7652, 8443],
            [7630, 8434],
            [7632, 8417],
            [7627, 8408],
            [7606, 8403],
            [7597, 8409],
            [7590, 8405],
            [7592, 8387],
            [7617, 8369],
            [7632, 8366],
            [7640, 8369],
            [7660, 8351],
            [7653, 8353],
            [7658, 8336],
            [7675, 8330],
            [7685, 8331],
            [7684, 8339],
            [7703, 8357],
            [7726, 8349],
            [7736, 8342],
            [7750, 8347],
            [7754, 8341],
            [7770, 8341],
            [7769, 8319],
            [7757, 8325],
            [7726, 8305],
            [7729, 8293],
            [7720, 8289],
            [7711, 8296],
            [7717, 8286],
            [7713, 8273],
            [7706, 8272],
            [7704, 8253],
            [7700, 8252],
            [7705, 8239],
            [7709, 8242],
            [7721, 8233],
            [7744, 8224],
            [7761, 8199],
            [7783, 8175],
            [7786, 8163],
            [7807, 8152],
            [7812, 8142],
            [7826, 8136],
            [7834, 8117],
            [7802, 8131],
            [7794, 8139],
            [7795, 8130],
            [7809, 8126],
            [7832, 8111],
            [7845, 8098],
            [7829, 8092],
            [7818, 8084],
            [7814, 8072],
            [7820, 8070],
            [7833, 8076],
            [7851, 8062],
            [7856, 8074],
            [7865, 8066],
            [7850, 8044],
            [7859, 8050],
            [7866, 8029],
            [7853, 8037],
            [7860, 8020],
            [7857, 8014],
            [7865, 8002],
            [7854, 7998],
            [7850, 8003],
            [7847, 7989],
            [7840, 7973],
            [7841, 7960],
            [7833, 7953],
            [7826, 7939],
            [7822, 7946],
            [7815, 7943],
            [7830, 7926],
            [7823, 7925],
            [7820, 7915],
            [7827, 7914],
            [7826, 7903],
            [7836, 7898],
            [7825, 7886],
            [7808, 7887],
            [7813, 7876],
            [7805, 7872],
            [7805, 7861],
            [7798, 7864],
            [7788, 7855],
            [7791, 7850],
            [7781, 7843],
            [7778, 7830],
            [7774, 7832],
            [7759, 7823],
            [7750, 7812],
            [7749, 7801],
            [7742, 7802],
            [7729, 7794],
            [7704, 7795],
            [7699, 7787],
            [7695, 7796],
            [7688, 7793],
            [7688, 7783],
            [7682, 7773],
            [7669, 7781],
            [7656, 7804],
            [7650, 7800],
            [7659, 7788],
            [7659, 7770],
            [7644, 7764],
            [7637, 7754],
            [7620, 7755],
            [7612, 7758],
            [7602, 7748],
            [7573, 7741],
            [7569, 7727],
            [7561, 7727],
            [7564, 7716],
            [7573, 7709],
            [7570, 7702],
            [7554, 7701],
            [7546, 7722],
            [7542, 7726],
            [7541, 7746],
            [7522, 7743],
            [7521, 7751],
            [7508, 7753],
            [7497, 7761],
            [7485, 7747],
            [7479, 7752],
            [7463, 7751],
            [7441, 7766],
            [7432, 7788],
            [7437, 7793],
            [7427, 7800],
            [7407, 7799],
            [7387, 7817],
            [7372, 7806],
            [7374, 7800],
            [7360, 7791],
            [7351, 7795],
            [7349, 7785],
            [7337, 7795],
            [7333, 7787],
            [7326, 7795],
            [7318, 7782],
            [7299, 7794],
            [7290, 7781],
            [7275, 7782],
            [7271, 7775],
            [7282, 7759],
            [7284, 7734],
            [7269, 7735],
            [7264, 7749],
            [7262, 7757],
            [7250, 7748],
            [7233, 7744],
            [7224, 7755],
            [7222, 7767],
            [7196, 7771],
            [7201, 7784],
            [7197, 7793],
            [7202, 7805],
            [7180, 7810],
            [7180, 7818],
            [7166, 7843],
            [7153, 7845],
            [7137, 7835],
            [7134, 7856],
            [7128, 7868],
            [7135, 7871],
            [7131, 7880],
            [7157, 7911],
            [7150, 7919],
            [7153, 7938],
            [7143, 7973],
            [7133, 7977],
            [7131, 7972],
            [7120, 7994],
            [7099, 8009],
            [7094, 7997],
            [7082, 8002],
            [7067, 8016],
            [7046, 8040],
            [7034, 8039],
            [7022, 8028],
            [7005, 8033],
            [6999, 8038],
            [6993, 8027],
            [6973, 8014],
            [6967, 8014],
            [6948, 7994],
            [6948, 7986],
            [6929, 7979],
            [6917, 7980],
            [6917, 7986],
            [6904, 7993],
            [6898, 7988],
            [6884, 7993],
            [6868, 8003],
            [6849, 7995],
            [6834, 7964]
          ]
        ],
        [
          [
            [7774, 8438],
            [7774, 8438],
            [7774, 8437],
            [7774, 8436],
            [7774, 8438]
          ]
        ],
        [
          [
            [6246, 8438],
            [6247, 8437],
            [6246, 8437],
            [6246, 8437],
            [6246, 8438]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.83,
      "hc-middle-y": 0.54,
      "hc-key": "sw",
      "hc-a2": "SW",
      "name": "Serranilla Bank",
      "labelrank": "5",
      "country-abbrev": "S.B.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "-99",
      "iso-a2": "SW",
      "woe-id": "-99",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1447, 7537],
          [1447, 7537],
          [1447, 7537],
          [1447, 7537]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.50,
      "hc-key": "sh",
      "hc-a2": "SH",
      "name": "Scarborough Reef",
      "labelrank": "6",
      "country-abbrev": "S.R.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "-99",
      "iso-a2": "SH",
      "woe-id": "-99",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7838, 7511],
          [7838, 7511],
          [7838, 7511],
          [7838, 7511],
          [7838, 7511]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "EC",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.72,
      "hc-middle-y": 0.44,
      "hc-key": "ec",
      "hc-a2": "EC",
      "name": "Ecuador",
      "labelrank": "3",
      "country-abbrev": "Ecu.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "ECU",
      "iso-a2": "EC",
      "woe-id": "23424801",
      "continent": "South America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1036, 6929],
            [1038, 6921],
            [1026, 6921],
            [1025, 6933],
            [1017, 6934],
            [1019, 6941],
            [1036, 6929]
          ]
        ],
        [
          [
            [998, 6930],
            [989, 6936],
            [1000, 6935],
            [1000, 6952],
            [1005, 6939],
            [1018, 6919],
            [1014, 6910],
            [998, 6909],
            [997, 6918],
            [1008, 6925],
            [998, 6930]
          ]
        ],
        [
          [
            [1364, 6820],
            [1376, 6827],
            [1382, 6848],
            [1378, 6868],
            [1378, 6845],
            [1366, 6834],
            [1366, 6845],
            [1344, 6860],
            [1350, 6875],
            [1345, 6887],
            [1349, 6897],
            [1343, 6907],
            [1355, 6913],
            [1357, 6932],
            [1371, 6948],
            [1373, 6967],
            [1370, 6974],
            [1392, 6987],
            [1401, 6987],
            [1412, 7000],
            [1420, 6991],
            [1457, 6971],
            [1459, 6961],
            [1476, 6955],
            [1491, 6956],
            [1495, 6964],
            [1506, 6954],
            [1528, 6943],
            [1517, 6943],
            [1529, 6926],
            [1530, 6911],
            [1524, 6912],
            [1519, 6889],
            [1502, 6867],
            [1483, 6851],
            [1445, 6835],
            [1434, 6821],
            [1429, 6820],
            [1427, 6805],
            [1419, 6785],
            [1420, 6777],
            [1408, 6760],
            [1395, 6767],
            [1392, 6778],
            [1382, 6780],
            [1371, 6787],
            [1364, 6780],
            [1365, 6790],
            [1359, 6794],
            [1370, 6802],
            [1364, 6820]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.42,
      "hc-key": "au",
      "hc-a2": "AU",
      "name": "Australia",
      "labelrank": "2",
      "country-abbrev": "Auz.",
      "subregion": "Australia and New Zealand",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "AUS",
      "iso-a2": "AU",
      "woe-id": "-90",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8262, 5621],
            [8258, 5616],
            [8272, 5615],
            [8269, 5609],
            [8256, 5609],
            [8248, 5602],
            [8225, 5603],
            [8226, 5614],
            [8253, 5621],
            [8262, 5621]
          ]
        ],
        [
          [
            [8913, 6025],
            [8913, 6015],
            [8894, 5986],
            [8894, 5995],
            [8900, 6008],
            [8913, 6025]
          ]
        ],
        [
          [
            [8467, 6432],
            [8462, 6423],
            [8469, 6415],
            [8452, 6418],
            [8453, 6432],
            [8463, 6438],
            [8467, 6432]
          ]
        ],
        [
          [
            [8494, 5446],
            [8496, 5442],
            [8483, 5436],
            [8483, 5444],
            [8496, 5465],
            [8499, 5455],
            [8494, 5446]
          ]
        ],
        [
          [
            [8271, 6515],
            [8268, 6528],
            [8273, 6527],
            [8279, 6523],
            [8297, 6529],
            [8306, 6523],
            [8303, 6515],
            [8285, 6502],
            [8272, 6512],
            [8275, 6507],
            [8255, 6507],
            [8267, 6525],
            [8268, 6519],
            [8271, 6515]
          ]
        ],
        [
          [
            [8385, 5339],
            [8368, 5326],
            [8355, 5331],
            [8346, 5329],
            [8349, 5338],
            [8346, 5350],
            [8347, 5363],
            [8355, 5378],
            [8358, 5370],
            [8361, 5386],
            [8358, 5395],
            [8366, 5418],
            [8379, 5436],
            [8382, 5431],
            [8401, 5423],
            [8410, 5415],
            [8421, 5415],
            [8439, 5422],
            [8451, 5421],
            [8474, 5431],
            [8478, 5421],
            [8456, 5392],
            [8452, 5381],
            [8444, 5381],
            [8431, 5366],
            [8433, 5361],
            [8422, 5357],
            [8412, 5341],
            [8408, 5354],
            [8390, 5339],
            [8385, 5339]
          ]
        ],
        [
          [
            [8732, 6372],
            [8734, 6349],
            [8731, 6338],
            [8741, 6311],
            [8745, 6290],
            [8736, 6267],
            [8746, 6261],
            [8739, 6244],
            [8744, 6236],
            [8772, 6224],
            [8775, 6212],
            [8795, 6203],
            [8799, 6194],
            [8804, 6200],
            [8809, 6192],
            [8815, 6199],
            [8817, 6191],
            [8803, 6181],
            [8807, 6171],
            [8817, 6161],
            [8819, 6138],
            [8819, 6118],
            [8830, 6103],
            [8828, 6121],
            [8834, 6122],
            [8837, 6113],
            [8848, 6105],
            [8848, 6119],
            [8854, 6101],
            [8848, 6084],
            [8848, 6069],
            [8854, 6073],
            [8863, 6053],
            [8872, 6052],
            [8878, 6031],
            [8887, 6021],
            [8889, 6006],
            [8895, 6005],
            [8891, 5988],
            [8897, 5981],
            [8889, 5967],
            [8884, 5938],
            [8892, 5940],
            [8890, 5926],
            [8878, 5901],
            [8880, 5894],
            [8872, 5872],
            [8857, 5855],
            [8851, 5841],
            [8824, 5802],
            [8824, 5796],
            [8810, 5774],
            [8785, 5749],
            [8781, 5739],
            [8762, 5726],
            [8750, 5722],
            [8727, 5698],
            [8709, 5677],
            [8698, 5669],
            [8676, 5637],
            [8669, 5635],
            [8643, 5609],
            [8635, 5593],
            [8615, 5570],
            [8613, 5557],
            [8606, 5549],
            [8585, 5538],
            [8548, 5536],
            [8520, 5527],
            [8487, 5506],
            [8472, 5501],
            [8461, 5487],
            [8459, 5499],
            [8452, 5495],
            [8452, 5506],
            [8431, 5510],
            [8429, 5515],
            [8443, 5524],
            [8444, 5533],
            [8426, 5525],
            [8418, 5518],
            [8380, 5497],
            [8356, 5516],
            [8339, 5520],
            [8332, 5514],
            [8318, 5528],
            [8310, 5527],
            [8303, 5534],
            [8304, 5542],
            [8298, 5561],
            [8300, 5569],
            [8312, 5581],
            [8314, 5609],
            [8310, 5617],
            [8317, 5631],
            [8305, 5623],
            [8289, 5619],
            [8276, 5620],
            [8291, 5630],
            [8305, 5653],
            [8301, 5676],
            [8270, 5636],
            [8264, 5639],
            [8244, 5632],
            [8255, 5647],
            [8268, 5646],
            [8275, 5658],
            [8271, 5662],
            [8290, 5685],
            [8307, 5698],
            [8307, 5708],
            [8316, 5713],
            [8318, 5736],
            [8311, 5719],
            [8298, 5713],
            [8282, 5694],
            [8259, 5684],
            [8228, 5661],
            [8221, 5650],
            [8211, 5645],
            [8209, 5657],
            [8215, 5685],
            [8208, 5695],
            [8212, 5712],
            [8198, 5712],
            [8199, 5729],
            [8207, 5730],
            [8205, 5738],
            [8195, 5748],
            [8178, 5748],
            [8170, 5757],
            [8152, 5754],
            [8142, 5765],
            [8125, 5775],
            [8113, 5770],
            [8093, 5771],
            [8055, 5767],
            [8019, 5752],
            [7993, 5745],
            [7973, 5744],
            [7959, 5747],
            [7903, 5722],
            [7892, 5720],
            [7880, 5712],
            [7870, 5697],
            [7851, 5683],
            [7839, 5680],
            [7837, 5686],
            [7816, 5684],
            [7810, 5680],
            [7806, 5688],
            [7742, 5684],
            [7728, 5678],
            [7718, 5666],
            [7698, 5664],
            [7681, 5653],
            [7677, 5647],
            [7653, 5642],
            [7616, 5643],
            [7603, 5649],
            [7600, 5661],
            [7591, 5669],
            [7583, 5667],
            [7583, 5678],
            [7591, 5699],
            [7598, 5694],
            [7615, 5707],
            [7622, 5731],
            [7630, 5743],
            [7628, 5756],
            [7634, 5753],
            [7637, 5768],
            [7632, 5799],
            [7633, 5822],
            [7641, 5849],
            [7641, 5863],
            [7636, 5875],
            [7637, 5884],
            [7630, 5900],
            [7634, 5915],
            [7633, 5929],
            [7626, 5953],
            [7619, 5963],
            [7619, 5974],
            [7613, 5987],
            [7629, 5988],
            [7633, 5997],
            [7638, 5986],
            [7634, 5973],
            [7642, 5979],
            [7644, 5962],
            [7654, 5984],
            [7652, 5986],
            [7643, 6026],
            [7639, 6033],
            [7642, 6051],
            [7656, 6071],
            [7662, 6088],
            [7660, 6106],
            [7676, 6133],
            [7681, 6135],
            [7676, 6121],
            [7677, 6108],
            [7683, 6110],
            [7697, 6133],
            [7726, 6146],
            [7753, 6170],
            [7771, 6177],
            [7786, 6180],
            [7791, 6175],
            [7804, 6177],
            [7819, 6189],
            [7841, 6191],
            [7856, 6203],
            [7868, 6199],
            [7890, 6205],
            [7915, 6215],
            [7928, 6226],
            [7953, 6259],
            [7969, 6271],
            [7965, 6277],
            [7970, 6304],
            [8002, 6337],
            [7999, 6329],
            [8013, 6294],
            [8020, 6314],
            [8025, 6306],
            [8023, 6323],
            [8017, 6326],
            [8025, 6338],
            [8048, 6338],
            [8055, 6379],
            [8071, 6375],
            [8071, 6384],
            [8082, 6390],
            [8080, 6402],
            [8112, 6406],
            [8110, 6411],
            [8120, 6424],
            [8134, 6429],
            [8127, 6422],
            [8132, 6417],
            [8146, 6436],
            [8150, 6426],
            [8160, 6427],
            [8180, 6399],
            [8173, 6377],
            [8187, 6395],
            [8192, 6397],
            [8211, 6389],
            [8213, 6393],
            [8226, 6385],
            [8223, 6395],
            [8232, 6393],
            [8220, 6410],
            [8228, 6422],
            [8234, 6425],
            [8243, 6446],
            [8255, 6450],
            [8253, 6465],
            [8269, 6476],
            [8272, 6485],
            [8286, 6486],
            [8286, 6494],
            [8298, 6490],
            [8319, 6488],
            [8326, 6494],
            [8340, 6495],
            [8337, 6519],
            [8324, 6517],
            [8317, 6527],
            [8322, 6532],
            [8328, 6522],
            [8328, 6532],
            [8342, 6535],
            [8343, 6518],
            [8351, 6525],
            [8358, 6511],
            [8371, 6507],
            [8379, 6510],
            [8398, 6498],
            [8409, 6502],
            [8418, 6490],
            [8446, 6505],
            [8449, 6511],
            [8463, 6515],
            [8470, 6489],
            [8476, 6495],
            [8477, 6485],
            [8461, 6471],
            [8463, 6462],
            [8454, 6450],
            [8456, 6460],
            [8447, 6447],
            [8442, 6454],
            [8436, 6440],
            [8438, 6435],
            [8447, 6438],
            [8437, 6427],
            [8420, 6401],
            [8415, 6399],
            [8419, 6387],
            [8446, 6365],
            [8465, 6364],
            [8462, 6354],
            [8482, 6341],
            [8497, 6323],
            [8519, 6317],
            [8531, 6333],
            [8541, 6336],
            [8534, 6326],
            [8527, 6324],
            [8535, 6310],
            [8529, 6300],
            [8545, 6287],
            [8562, 6290],
            [8574, 6297],
            [8587, 6321],
            [8591, 6325],
            [8603, 6348],
            [8602, 6353],
            [8618, 6388],
            [8616, 6407],
            [8621, 6418],
            [8618, 6427],
            [8622, 6441],
            [8629, 6453],
            [8627, 6463],
            [8640, 6478],
            [8629, 6480],
            [8639, 6498],
            [8644, 6498],
            [8653, 6524],
            [8655, 6539],
            [8661, 6541],
            [8658, 6567],
            [8662, 6564],
            [8660, 6548],
            [8671, 6546],
            [8677, 6523],
            [8674, 6506],
            [8685, 6500],
            [8679, 6487],
            [8689, 6477],
            [8690, 6443],
            [8686, 6435],
            [8690, 6413],
            [8695, 6406],
            [8715, 6419],
            [8719, 6405],
            [8738, 6390],
            [8732, 6372]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.33,
      "hc-middle-y": 0.17,
      "hc-key": "ph",
      "hc-a2": "PH",
      "name": "Philippines",
      "labelrank": "2",
      "country-abbrev": "Phil.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "PHL",
      "iso-a2": "PH",
      "woe-id": "23424934",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8081, 7323],
            [8082, 7310],
            [8076, 7304],
            [8061, 7306],
            [8061, 7316],
            [8070, 7324],
            [8081, 7323]
          ]
        ],
        [
          [
            [8056, 7292],
            [8056, 7285],
            [8045, 7291],
            [8036, 7283],
            [8030, 7293],
            [8021, 7298],
            [8013, 7313],
            [8027, 7323],
            [8024, 7338],
            [8027, 7351],
            [8035, 7356],
            [8048, 7350],
            [8037, 7314],
            [8038, 7305],
            [8044, 7294],
            [8056, 7292]
          ]
        ],
        [
          [
            [8061, 7359],
            [8064, 7352],
            [8064, 7333],
            [8053, 7321],
            [8049, 7302],
            [8044, 7301],
            [8048, 7323],
            [8061, 7359]
          ]
        ],
        [
          [
            [8074, 7374],
            [8077, 7381],
            [8080, 7367],
            [8087, 7372],
            [8094, 7365],
            [8095, 7347],
            [8102, 7341],
            [8104, 7323],
            [8098, 7320],
            [8090, 7325],
            [8087, 7350],
            [8081, 7356],
            [8079, 7343],
            [8072, 7341],
            [8074, 7361],
            [8070, 7377],
            [8074, 7374]
          ]
        ],
        [
          [
            [8018, 7347],
            [8004, 7343],
            [7996, 7335],
            [7997, 7381],
            [7988, 7385],
            [7991, 7391],
            [8015, 7376],
            [8017, 7379],
            [8032, 7374],
            [8031, 7362],
            [8018, 7347]
          ]
        ],
        [
          [
            [7930, 7388],
            [7927, 7381],
            [7922, 7392],
            [7926, 7394],
            [7921, 7405],
            [7937, 7396],
            [7936, 7387],
            [7930, 7388]
          ]
        ],
        [
          [
            [8041, 7417],
            [8045, 7416],
            [8050, 7400],
            [8059, 7392],
            [8060, 7383],
            [8037, 7401],
            [8030, 7390],
            [8031, 7409],
            [8041, 7417]
          ]
        ],
        [
          [
            [8005, 7412],
            [8011, 7404],
            [7994, 7414],
            [7992, 7397],
            [7989, 7415],
            [8005, 7412]
          ]
        ],
        [
          [
            [7928, 7456],
            [7938, 7450],
            [7959, 7447],
            [7971, 7436],
            [7974, 7416],
            [7966, 7401],
            [7949, 7421],
            [7947, 7431],
            [7928, 7456]
          ]
        ],
        [
          [
            [8055, 7470],
            [8062, 7463],
            [8061, 7451],
            [8050, 7456],
            [8055, 7470]
          ]
        ],
        [
          [
            [8086, 7376],
            [8087, 7384],
            [8069, 7402],
            [8064, 7414],
            [8077, 7413],
            [8093, 7415],
            [8105, 7403],
            [8107, 7379],
            [8116, 7360],
            [8101, 7360],
            [8086, 7376]
          ]
        ],
        [
          [
            [7849, 7255],
            [7849, 7256],
            [7849, 7256],
            [7849, 7256],
            [7849, 7255],
            [7849, 7255],
            [7849, 7255]
          ]
        ],
        [
          [
            [7849, 7255],
            [7841, 7237],
            [7840, 7247],
            [7849, 7255],
            [7849, 7255],
            [7849, 7255]
          ]
        ],
        [
          [
            [8132, 7220],
            [8123, 7208],
            [8119, 7195],
            [8127, 7186],
            [8131, 7174],
            [8123, 7154],
            [8111, 7165],
            [8083, 7177],
            [8076, 7186],
            [8074, 7211],
            [8080, 7218],
            [8074, 7230],
            [8061, 7237],
            [8053, 7237],
            [8054, 7221],
            [8043, 7229],
            [8038, 7220],
            [8029, 7237],
            [8018, 7224],
            [8010, 7198],
            [8019, 7193],
            [8008, 7185],
            [8005, 7215],
            [8013, 7244],
            [8036, 7250],
            [8039, 7264],
            [8049, 7271],
            [8061, 7267],
            [8066, 7250],
            [8077, 7252],
            [8082, 7267],
            [8094, 7263],
            [8093, 7285],
            [8105, 7275],
            [8108, 7285],
            [8118, 7283],
            [8111, 7307],
            [8116, 7319],
            [8113, 7331],
            [8118, 7334],
            [8118, 7306],
            [8127, 7302],
            [8132, 7321],
            [8137, 7311],
            [8130, 7310],
            [8134, 7291],
            [8145, 7276],
            [8138, 7267],
            [8147, 7265],
            [8151, 7253],
            [8150, 7238],
            [8156, 7234],
            [8158, 7218],
            [8150, 7207],
            [8147, 7181],
            [8142, 7201],
            [8132, 7220]
          ]
        ],
        [
          [
            [7849, 7256],
            [7849, 7268],
            [7860, 7284],
            [7871, 7290],
            [7886, 7310],
            [7894, 7326],
            [7904, 7333],
            [7910, 7346],
            [7905, 7351],
            [7912, 7372],
            [7919, 7357],
            [7914, 7357],
            [7918, 7344],
            [7925, 7339],
            [7929, 7337],
            [7911, 7331],
            [7908, 7322],
            [7893, 7315],
            [7894, 7309],
            [7887, 7293],
            [7875, 7287],
            [7872, 7277],
            [7851, 7262],
            [7849, 7256],
            [7849, 7256]
          ]
        ],
        [
          [
            [8029, 7435],
            [8023, 7447],
            [8000, 7466],
            [8001, 7455],
            [8009, 7439],
            [7991, 7454],
            [7986, 7438],
            [7980, 7443],
            [7987, 7460],
            [7974, 7467],
            [7966, 7455],
            [7957, 7454],
            [7946, 7465],
            [7939, 7461],
            [7935, 7474],
            [7947, 7489],
            [7941, 7496],
            [7931, 7499],
            [7934, 7487],
            [7916, 7498],
            [7906, 7521],
            [7904, 7538],
            [7900, 7539],
            [7898, 7556],
            [7904, 7555],
            [7910, 7544],
            [7919, 7548],
            [7912, 7565],
            [7915, 7579],
            [7908, 7600],
            [7911, 7629],
            [7910, 7635],
            [7926, 7641],
            [7954, 7627],
            [7961, 7636],
            [7967, 7631],
            [7964, 7621],
            [7965, 7607],
            [7972, 7593],
            [7982, 7583],
            [7976, 7559],
            [7976, 7551],
            [7958, 7540],
            [7962, 7530],
            [7955, 7518],
            [7970, 7495],
            [7974, 7501],
            [7977, 7492],
            [7967, 7494],
            [7973, 7475],
            [7992, 7471],
            [7997, 7481],
            [8010, 7478],
            [8018, 7467],
            [8020, 7457],
            [8026, 7461],
            [8022, 7468],
            [8047, 7460],
            [8034, 7453],
            [8046, 7440],
            [8059, 7437],
            [8058, 7414],
            [8034, 7432],
            [8029, 7427],
            [8018, 7435],
            [8029, 7435]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ES",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.72,
      "hc-middle-y": 0.27,
      "hc-key": "es",
      "hc-a2": "ES",
      "name": "Spain",
      "labelrank": "2",
      "country-abbrev": "Sp.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "ESP",
      "iso-a2": "ES",
      "woe-id": "23424950",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3515, 7995],
            [3516, 7984],
            [3509, 7979],
            [3503, 7983],
            [3506, 7995],
            [3515, 7995]
          ]
        ],
        [
          [
            [3462, 7993],
            [3454, 7993],
            [3468, 8002],
            [3493, 8011],
            [3483, 7995],
            [3474, 7989],
            [3462, 7993]
          ]
        ],
        [
          [
            [3565, 8021],
            [3568, 8029],
            [3580, 8034],
            [3578, 8027],
            [3566, 8016],
            [3561, 7998],
            [3549, 7991],
            [3565, 8021]
          ]
        ],
        [
          [
            [4121, 8437],
            [4129, 8438],
            [4110, 8429],
            [4098, 8411],
            [4085, 8422],
            [4076, 8424],
            [4090, 8434],
            [4101, 8437],
            [4102, 8429],
            [4121, 8437]
          ]
        ],
        [
          [
            [4063, 8524],
            [4063, 8525],
            [4063, 8526],
            [4064, 8524],
            [4063, 8524]
          ]
        ],
        [
          [
            [3795, 8437],
            [3795, 8437],
            [3792, 8444],
            [3799, 8449],
            [3795, 8473],
            [3818, 8493],
            [3807, 8499],
            [3807, 8506],
            [3793, 8506],
            [3781, 8501],
            [3773, 8505],
            [3759, 8502],
            [3758, 8514],
            [3742, 8507],
            [3738, 8513],
            [3740, 8533],
            [3728, 8541],
            [3730, 8550],
            [3757, 8559],
            [3757, 8565],
            [3770, 8572],
            [3786, 8569],
            [3788, 8565],
            [3820, 8566],
            [3844, 8564],
            [3864, 8559],
            [3880, 8559],
            [3898, 8563],
            [3915, 8556],
            [3922, 8561],
            [3941, 8555],
            [3951, 8558],
            [3963, 8553],
            [3964, 8548],
            [3982, 8543],
            [3988, 8536],
            [3995, 8539],
            [4003, 8533],
            [4024, 8533],
            [4024, 8539],
            [4045, 8534],
            [4047, 8530],
            [4050, 8524],
            [4056, 8527],
            [4063, 8522],
            [4080, 8520],
            [4092, 8525],
            [4100, 8524],
            [4102, 8507],
            [4093, 8498],
            [4074, 8489],
            [4067, 8482],
            [4034, 8474],
            [4026, 8465],
            [4015, 8446],
            [4005, 8436],
            [3995, 8420],
            [4001, 8399],
            [4012, 8393],
            [3989, 8376],
            [3981, 8356],
            [3983, 8349],
            [3964, 8347],
            [3953, 8339],
            [3941, 8317],
            [3925, 8318],
            [3923, 8314],
            [3905, 8316],
            [3868, 8315],
            [3859, 8306],
            [3845, 8303],
            [3840, 8293],
            [3839, 8293],
            [3831, 8288],
            [3815, 8299],
            [3805, 8324],
            [3793, 8332],
            [3777, 8333],
            [3774, 8347],
            [3782, 8363],
            [3790, 8364],
            [3780, 8380],
            [3783, 8391],
            [3792, 8402],
            [3787, 8405],
            [3782, 8418],
            [3775, 8427],
            [3791, 8427],
            [3795, 8437],
            [3795, 8437],
            [3796, 8436],
            [3795, 8437],
            [3795, 8437],
            [3795, 8437],
            [3795, 8437],
            [3795, 8437],
            [3795, 8437]
          ]
        ],
        [
          [
            [3838, 8285],
            [3841, 8284],
            [3840, 8282],
            [3838, 8283],
            [3838, 8285]
          ]
        ],
        [
          [
            [3913, 8260],
            [3913, 8262],
            [3913, 8262],
            [3913, 8262],
            [3913, 8262],
            [3914, 8260],
            [3913, 8260]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.46,
      "hc-middle-y": 0.67,
      "hc-key": "bu",
      "hc-a2": "BU",
      "name": "Bajo Nuevo Bank (Petrel Is.)",
      "labelrank": "8",
      "country-abbrev": null,
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "-99",
      "iso-a2": "BU",
      "woe-id": "-99",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1403, 7535],
          [1403, 7535],
          [1403, 7535],
          [1403, 7535],
          [1403, 7535]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MV",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.60,
      "hc-middle-y": 0.59,
      "hc-key": "mv",
      "hc-a2": "MV",
      "name": "Maldives",
      "labelrank": "5",
      "country-abbrev": "Mald.",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "MDV",
      "iso-a2": "MV",
      "woe-id": "23424899",
      "continent": "Seven seas (open ocean)"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6422, 7143],
          [6413, 7146],
          [6417, 7153],
          [6423, 7148],
          [6422, 7143]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SP",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.51,
      "hc-key": "sp",
      "hc-a2": "SP",
      "name": "Spratly Islands",
      "labelrank": "6",
      "country-abbrev": "Spratly Is.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "-99",
      "iso-a2": "SP",
      "woe-id": "23424921",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7795, 7350],
          [7794, 7350],
          [7794, 7350],
          [7795, 7350],
          [7795, 7350]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "VE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.53,
      "hc-middle-y": 0.37,
      "hc-key": "ve",
      "hc-a2": "VE",
      "name": "Venezuela",
      "labelrank": "3",
      "country-abbrev": "Ven.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "VEN",
      "iso-a2": "VE",
      "woe-id": "23424982",
      "continent": "South America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [2016, 7273],
            [2018, 7268],
            [2002, 7268],
            [2002, 7273],
            [2015, 7277],
            [2016, 7273]
          ]
        ],
        [
          [
            [2037, 7265],
            [2044, 7255],
            [2036, 7246],
            [2020, 7237],
            [2013, 7227],
            [2016, 7214],
            [2026, 7212],
            [2023, 7205],
            [2012, 7198],
            [1999, 7197],
            [1996, 7190],
            [1998, 7177],
            [1989, 7166],
            [2010, 7140],
            [2014, 7131],
            [2000, 7115],
            [1990, 7115],
            [1982, 7105],
            [1961, 7099],
            [1953, 7102],
            [1942, 7096],
            [1941, 7081],
            [1934, 7081],
            [1920, 7094],
            [1899, 7092],
            [1897, 7100],
            [1882, 7100],
            [1880, 7094],
            [1894, 7080],
            [1893, 7063],
            [1901, 7048],
            [1899, 7039],
            [1921, 7036],
            [1919, 7027],
            [1898, 7017],
            [1896, 7005],
            [1886, 7003],
            [1876, 6993],
            [1862, 6989],
            [1848, 6971],
            [1850, 6979],
            [1842, 6983],
            [1829, 6974],
            [1820, 6976],
            [1805, 6992],
            [1795, 7036],
            [1781, 7051],
            [1774, 7054],
            [1792, 7074],
            [1782, 7087],
            [1775, 7115],
            [1778, 7135],
            [1776, 7144],
            [1784, 7153],
            [1784, 7162],
            [1791, 7169],
            [1789, 7177],
            [1775, 7179],
            [1751, 7175],
            [1738, 7178],
            [1725, 7175],
            [1704, 7206],
            [1689, 7210],
            [1669, 7206],
            [1665, 7208],
            [1639, 7210],
            [1636, 7221],
            [1627, 7225],
            [1627, 7242],
            [1632, 7256],
            [1623, 7269],
            [1619, 7287],
            [1613, 7293],
            [1601, 7288],
            [1615, 7312],
            [1618, 7335],
            [1633, 7361],
            [1641, 7362],
            [1652, 7381],
            [1673, 7388],
            [1654, 7379],
            [1652, 7370],
            [1663, 7346],
            [1660, 7336],
            [1643, 7312],
            [1654, 7295],
            [1653, 7286],
            [1661, 7283],
            [1677, 7295],
            [1678, 7309],
            [1665, 7334],
            [1663, 7349],
            [1687, 7363],
            [1698, 7366],
            [1718, 7375],
            [1722, 7382],
            [1710, 7379],
            [1707, 7388],
            [1717, 7401],
            [1722, 7394],
            [1728, 7374],
            [1740, 7376],
            [1753, 7373],
            [1768, 7361],
            [1770, 7343],
            [1781, 7336],
            [1812, 7342],
            [1836, 7343],
            [1858, 7326],
            [1874, 7321],
            [1884, 7322],
            [1904, 7337],
            [1921, 7337],
            [1911, 7341],
            [1902, 7338],
            [1915, 7363],
            [1918, 7355],
            [1909, 7343],
            [1925, 7342],
            [1953, 7347],
            [1977, 7343],
            [1950, 7337],
            [1959, 7325],
            [1964, 7308],
            [1967, 7319],
            [1980, 7312],
            [1986, 7315],
            [2013, 7293],
            [2007, 7288],
            [2011, 7282],
            [2003, 7282],
            [1998, 7267],
            [1984, 7267],
            [1996, 7259],
            [1999, 7263],
            [2026, 7268],
            [2037, 7265]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GB",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.60,
      "hc-middle-y": 0.07,
      "hc-key": "gb",
      "hc-a2": "GB",
      "name": "United Kingdom",
      "labelrank": "2",
      "country-abbrev": "U.K.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "GBR",
      "iso-a2": "GB",
      "woe-id": "-90",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3836, 9050],
            [3822, 9065],
            [3835, 9074],
            [3840, 9062],
            [3853, 9058],
            [3844, 9050],
            [3836, 9050]
          ]
        ],
        [
          [
            [3814, 9072],
            [3815, 9090],
            [3838, 9101],
            [3840, 9096],
            [3835, 9085],
            [3814, 9072]
          ]
        ],
        [
          [
            [2291, 5044],
            [2311, 5045],
            [2306, 5038],
            [2322, 5046],
            [2331, 5041],
            [2320, 5022],
            [2309, 5020],
            [2303, 5012],
            [2288, 5018],
            [2281, 5026],
            [2302, 5020],
            [2306, 5032],
            [2291, 5044]
          ]
        ],
        [
          [
            [3969, 9166],
            [3963, 9169],
            [3983, 9181],
            [3978, 9172],
            [3971, 9148],
            [3969, 9166]
          ]
        ],
        [
          [
            [2329, 5009],
            [2325, 5021],
            [2335, 5031],
            [2337, 5047],
            [2355, 5043],
            [2352, 5038],
            [2363, 5034],
            [2359, 5042],
            [2368, 5042],
            [2377, 5031],
            [2360, 5024],
            [2344, 5025],
            [2362, 5017],
            [2339, 5020],
            [2345, 5012],
            [2335, 5016],
            [2338, 5009],
            [2329, 5009]
          ]
        ],
        [
          [
            [5056, 8248],
            [5055, 8247],
            [5053, 8249],
            [5052, 8249],
            [5051, 8249],
            [5052, 8249],
            [5050, 8249],
            [5050, 8249],
            [5050, 8250],
            [5049, 8251],
            [5052, 8251],
            [5056, 8252],
            [5055, 8252],
            [5053, 8251],
            [5056, 8248]
          ],
          [
            [5051, 8250],
            [5051, 8250],
            [5051, 8250],
            [5051, 8250],
            [5051, 8250]
          ]
        ],
        [
          [
            [3840, 8293],
            [3840, 8292],
            [3839, 8293],
            [3840, 8293]
          ]
        ],
        [
          [
            [5030, 8236],
            [5027, 8237],
            [5022, 8237],
            [5024, 8239],
            [5030, 8236]
          ]
        ],
        [
          [
            [3806, 8982],
            [3835, 8990],
            [3852, 8967],
            [3837, 8945],
            [3831, 8947],
            [3821, 8945],
            [3811, 8959],
            [3803, 8948],
            [3787, 8951],
            [3779, 8960],
            [3792, 8965],
            [3806, 8982]
          ]
        ],
        [
          [
            [3866, 9043],
            [3851, 9032],
            [3851, 9028],
            [3833, 9024],
            [3838, 9031],
            [3827, 9037],
            [3843, 9042],
            [3855, 9062],
            [3848, 9061],
            [3850, 9079],
            [3865, 9082],
            [3861, 9093],
            [3872, 9105],
            [3881, 9103],
            [3903, 9104],
            [3914, 9106],
            [3917, 9123],
            [3923, 9130],
            [3933, 9126],
            [3919, 9094],
            [3895, 9082],
            [3903, 9078],
            [3890, 9066],
            [3911, 9074],
            [3953, 9073],
            [3957, 9066],
            [3951, 9060],
            [3946, 9046],
            [3936, 9035],
            [3926, 9030],
            [3935, 9024],
            [3919, 9017],
            [3921, 9012],
            [3933, 9016],
            [3946, 9011],
            [3960, 9000],
            [3963, 8985],
            [3971, 8966],
            [3989, 8961],
            [4003, 8948],
            [3999, 8945],
            [4008, 8931],
            [3999, 8931],
            [4009, 8925],
            [4014, 8912],
            [4005, 8905],
            [4015, 8901],
            [4019, 8907],
            [4040, 8906],
            [4051, 8901],
            [4054, 8890],
            [4049, 8876],
            [4034, 8865],
            [4024, 8854],
            [4032, 8850],
            [4045, 8851],
            [4043, 8842],
            [4012, 8828],
            [4000, 8831],
            [3982, 8827],
            [3963, 8834],
            [3974, 8826],
            [3968, 8822],
            [3952, 8827],
            [3949, 8823],
            [3935, 8822],
            [3923, 8828],
            [3907, 8824],
            [3905, 8816],
            [3897, 8809],
            [3884, 8814],
            [3869, 8813],
            [3856, 8800],
            [3850, 8808],
            [3868, 8823],
            [3887, 8845],
            [3918, 8845],
            [3928, 8855],
            [3921, 8857],
            [3912, 8851],
            [3904, 8852],
            [3896, 8860],
            [3882, 8865],
            [3865, 8859],
            [3855, 8868],
            [3887, 8883],
            [3891, 8892],
            [3890, 8906],
            [3871, 8901],
            [3883, 8910],
            [3877, 8923],
            [3886, 8923],
            [3889, 8916],
            [3916, 8923],
            [3924, 8935],
            [3921, 8942],
            [3926, 8951],
            [3915, 8948],
            [3904, 8962],
            [3911, 8975],
            [3907, 8979],
            [3896, 8971],
            [3884, 8976],
            [3885, 8959],
            [3885, 8954],
            [3872, 8946],
            [3880, 8957],
            [3881, 8969],
            [3871, 8975],
            [3871, 8966],
            [3863, 8975],
            [3878, 8997],
            [3870, 9004],
            [3871, 9014],
            [3860, 9009],
            [3865, 8999],
            [3847, 8990],
            [3852, 9006],
            [3848, 9017],
            [3840, 9003],
            [3832, 9009],
            [3851, 9022],
            [3866, 9043]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.30,
      "hc-middle-y": 0.44,
      "hc-key": "gr",
      "hc-a2": "GR",
      "name": "Greece",
      "labelrank": "3",
      "country-abbrev": "Greece",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "GRC",
      "iso-a2": "GR",
      "woe-id": "23424833",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4857, 8296],
            [4874, 8305],
            [4871, 8292],
            [4863, 8283],
            [4857, 8296]
          ]
        ],
        [
          [
            [4780, 8325],
            [4789, 8333],
            [4794, 8321],
            [4773, 8311],
            [4787, 8322],
            [4780, 8325]
          ]
        ],
        [
          [
            [4634, 8381],
            [4641, 8366],
            [4632, 8368],
            [4633, 8393],
            [4634, 8381]
          ]
        ],
        [
          [
            [4749, 8397],
            [4757, 8393],
            [4745, 8383],
            [4749, 8369],
            [4757, 8369],
            [4784, 8341],
            [4771, 8350],
            [4760, 8361],
            [4745, 8367],
            [4739, 8379],
            [4727, 8379],
            [4726, 8385],
            [4705, 8397],
            [4714, 8403],
            [4721, 8395],
            [4742, 8388],
            [4749, 8397]
          ]
        ],
        [
          [
            [4803, 8384],
            [4804, 8375],
            [4794, 8385],
            [4800, 8385],
            [4802, 8402],
            [4791, 8411],
            [4806, 8415],
            [4815, 8402],
            [4810, 8400],
            [4803, 8384]
          ]
        ],
        [
          [
            [4819, 8261],
            [4815, 8250],
            [4772, 8247],
            [4770, 8253],
            [4733, 8261],
            [4735, 8273],
            [4753, 8270],
            [4756, 8264],
            [4770, 8266],
            [4781, 8263],
            [4799, 8263],
            [4805, 8254],
            [4819, 8261]
          ]
        ],
        [
          [
            [4640, 8461],
            [4643, 8463],
            [4639, 8461],
            [4637, 8464],
            [4638, 8465],
            [4639, 8466],
            [4642, 8467],
            [4661, 8469],
            [4665, 8476],
            [4689, 8478],
            [4694, 8484],
            [4715, 8486],
            [4728, 8491],
            [4742, 8493],
            [4750, 8485],
            [4765, 8481],
            [4791, 8485],
            [4787, 8498],
            [4796, 8498],
            [4806, 8487],
            [4797, 8481],
            [4800, 8471],
            [4791, 8463],
            [4781, 8453],
            [4773, 8438],
            [4774, 8431],
            [4765, 8432],
            [4774, 8453],
            [4775, 8467],
            [4760, 8472],
            [4753, 8467],
            [4753, 8458],
            [4745, 8459],
            [4746, 8470],
            [4733, 8462],
            [4721, 8460],
            [4743, 8442],
            [4723, 8449],
            [4731, 8440],
            [4727, 8436],
            [4722, 8443],
            [4710, 8444],
            [4697, 8450],
            [4697, 8459],
            [4690, 8453],
            [4688, 8442],
            [4715, 8408],
            [4702, 8415],
            [4700, 8407],
            [4706, 8403],
            [4699, 8393],
            [4716, 8388],
            [4717, 8382],
            [4737, 8374],
            [4742, 8352],
            [4752, 8352],
            [4766, 8324],
            [4755, 8330],
            [4749, 8346],
            [4739, 8351],
            [4730, 8361],
            [4716, 8362],
            [4715, 8349],
            [4727, 8355],
            [4722, 8347],
            [4729, 8340],
            [4702, 8347],
            [4716, 8317],
            [4720, 8304],
            [4706, 8318],
            [4699, 8317],
            [4698, 8305],
            [4686, 8326],
            [4681, 8318],
            [4672, 8316],
            [4668, 8328],
            [4670, 8336],
            [4666, 8347],
            [4652, 8357],
            [4643, 8350],
            [4636, 8357],
            [4654, 8361],
            [4658, 8372],
            [4666, 8369],
            [4676, 8376],
            [4684, 8371],
            [4704, 8365],
            [4715, 8367],
            [4698, 8375],
            [4675, 8379],
            [4670, 8376],
            [4657, 8378],
            [4651, 8375],
            [4649, 8384],
            [4638, 8392],
            [4644, 8402],
            [4635, 8404],
            [4628, 8412],
            [4617, 8410],
            [4600, 8429],
            [4612, 8427],
            [4624, 8432],
            [4620, 8438],
            [4630, 8439],
            [4640, 8461]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "DK",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.31,
      "hc-middle-y": 0.47,
      "hc-key": "dk",
      "hc-a2": "DK",
      "name": "Denmark",
      "labelrank": "4",
      "country-abbrev": "Den.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "DNK",
      "iso-a2": "DK",
      "woe-id": "23424796",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4314, 8978],
            [4331, 8970],
            [4320, 8966],
            [4308, 8971],
            [4314, 8978]
          ]
        ],
        [
          [
            [4292, 9007],
            [4301, 8987],
            [4305, 8985],
            [4300, 8971],
            [4290, 8973],
            [4283, 8984],
            [4269, 8997],
            [4287, 9001],
            [4292, 9007]
          ]
        ],
        [
          [
            [4338, 8976],
            [4334, 8968],
            [4324, 8986],
            [4313, 8986],
            [4307, 9002],
            [4323, 9011],
            [4327, 9003],
            [4338, 9019],
            [4351, 9000],
            [4339, 8994],
            [4346, 8989],
            [4334, 8985],
            [4338, 8976]
          ]
        ],
        [
          [
            [4264, 8973],
            [4247, 8976],
            [4243, 8976],
            [4240, 8995],
            [4226, 8998],
            [4233, 9011],
            [4225, 9018],
            [4225, 9034],
            [4237, 9034],
            [4252, 9045],
            [4269, 9053],
            [4245, 9049],
            [4245, 9042],
            [4235, 9035],
            [4228, 9043],
            [4237, 9053],
            [4258, 9055],
            [4272, 9070],
            [4287, 9075],
            [4288, 9064],
            [4303, 9059],
            [4289, 9057],
            [4282, 9046],
            [4286, 9034],
            [4302, 9030],
            [4291, 9018],
            [4287, 9025],
            [4284, 9011],
            [4264, 8996],
            [4271, 8988],
            [4265, 8985],
            [4281, 8975],
            [4264, 8973]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.33,
      "hc-key": "gl",
      "hc-a2": "GL",
      "name": "Greenland",
      "labelrank": "3",
      "country-abbrev": "Grlnd.",
      "subregion": "Northern America",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "GRL",
      "iso-a2": "GL",
      "woe-id": "23424828",
      "continent": "North America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3476, 9573],
            [3505, 9568],
            [3504, 9562],
            [3487, 9562],
            [3476, 9567],
            [3445, 9568],
            [3446, 9571],
            [3476, 9573]
          ]
        ],
        [
          [
            [3537, 9613],
            [3546, 9613],
            [3553, 9606],
            [3527, 9603],
            [3513, 9607],
            [3516, 9611],
            [3537, 9613]
          ]
        ],
        [
          [
            [3612, 9639],
            [3603, 9637],
            [3621, 9631],
            [3586, 9630],
            [3587, 9640],
            [3612, 9639]
          ]
        ],
        [
          [
            [3651, 9767],
            [3639, 9761],
            [3625, 9759],
            [3607, 9764],
            [3643, 9770],
            [3651, 9767]
          ]
        ],
        [
          [
            [3450, 9557],
            [3446, 9566],
            [3477, 9566],
            [3485, 9560],
            [3501, 9556],
            [3485, 9555],
            [3498, 9549],
            [3492, 9545],
            [3450, 9557]
          ]
        ],
        [
          [
            [3482, 9574],
            [3448, 9572],
            [3421, 9577],
            [3433, 9583],
            [3451, 9584],
            [3477, 9578],
            [3439, 9581],
            [3482, 9574]
          ]
        ],
        [
          [
            [3077, 9833],
            [3099, 9831],
            [3132, 9824],
            [3110, 9820],
            [3084, 9824],
            [3072, 9830],
            [3077, 9833]
          ]
        ],
        [
          [
            [2712, 9491],
            [2749, 9486],
            [2757, 9477],
            [2773, 9473],
            [2768, 9465],
            [2727, 9456],
            [2715, 9459],
            [2724, 9466],
            [2705, 9467],
            [2700, 9470],
            [2710, 9479],
            [2712, 9491]
          ]
        ],
        [
          [
            [3372, 9494],
            [3345, 9493],
            [3356, 9502],
            [3355, 9506],
            [3390, 9508],
            [3405, 9513],
            [3412, 9500],
            [3385, 9495],
            [3377, 9494],
            [3385, 9491],
            [3370, 9490],
            [3346, 9482],
            [3360, 9479],
            [3372, 9488],
            [3384, 9486],
            [3409, 9492],
            [3448, 9483],
            [3477, 9483],
            [3464, 9478],
            [3453, 9469],
            [3432, 9465],
            [3418, 9457],
            [3374, 9439],
            [3363, 9439],
            [3350, 9434],
            [3331, 9434],
            [3309, 9427],
            [3303, 9429],
            [3296, 9423],
            [3287, 9426],
            [3284, 9421],
            [3255, 9418],
            [3239, 9420],
            [3226, 9436],
            [3231, 9418],
            [3194, 9403],
            [3193, 9394],
            [3175, 9378],
            [3151, 9364],
            [3125, 9356],
            [3104, 9347],
            [3082, 9345],
            [3085, 9344],
            [3067, 9338],
            [3064, 9346],
            [3074, 9349],
            [3082, 9345],
            [3071, 9354],
            [3088, 9364],
            [3068, 9360],
            [3065, 9351],
            [3049, 9342],
            [3025, 9338],
            [3021, 9342],
            [3007, 9335],
            [3021, 9331],
            [3004, 9325],
            [2999, 9320],
            [2990, 9324],
            [2980, 9323],
            [2977, 9316],
            [2991, 9314],
            [2983, 9300],
            [2970, 9294],
            [2982, 9290],
            [2979, 9278],
            [2971, 9271],
            [2961, 9271],
            [2959, 9261],
            [2948, 9259],
            [2944, 9251],
            [2929, 9243],
            [2904, 9244],
            [2911, 9240],
            [2925, 9240],
            [2912, 9218],
            [2917, 9213],
            [2905, 9211],
            [2899, 9193],
            [2884, 9194],
            [2894, 9183],
            [2886, 9179],
            [2886, 9173],
            [2869, 9169],
            [2875, 9161],
            [2869, 9151],
            [2844, 9146],
            [2840, 9152],
            [2824, 9154],
            [2815, 9160],
            [2835, 9172],
            [2822, 9167],
            [2818, 9174],
            [2812, 9169],
            [2805, 9176],
            [2813, 9179],
            [2805, 9186],
            [2817, 9189],
            [2814, 9195],
            [2802, 9183],
            [2785, 9178],
            [2760, 9180],
            [2755, 9176],
            [2748, 9181],
            [2752, 9193],
            [2734, 9195],
            [2731, 9207],
            [2743, 9218],
            [2730, 9212],
            [2736, 9225],
            [2722, 9228],
            [2715, 9237],
            [2725, 9252],
            [2706, 9259],
            [2699, 9276],
            [2716, 9300],
            [2707, 9300],
            [2691, 9291],
            [2697, 9309],
            [2724, 9321],
            [2698, 9313],
            [2705, 9319],
            [2693, 9337],
            [2698, 9343],
            [2684, 9338],
            [2688, 9348],
            [2683, 9354],
            [2724, 9368],
            [2723, 9369],
            [2687, 9356],
            [2680, 9356],
            [2686, 9369],
            [2700, 9377],
            [2725, 9382],
            [2691, 9382],
            [2686, 9387],
            [2734, 9397],
            [2690, 9392],
            [2695, 9398],
            [2736, 9411],
            [2724, 9410],
            [2699, 9401],
            [2703, 9411],
            [2717, 9413],
            [2722, 9423],
            [2735, 9423],
            [2749, 9418],
            [2767, 9419],
            [2787, 9415],
            [2763, 9423],
            [2770, 9426],
            [2739, 9422],
            [2738, 9428],
            [2723, 9430],
            [2743, 9431],
            [2746, 9438],
            [2755, 9434],
            [2775, 9435],
            [2775, 9441],
            [2785, 9452],
            [2796, 9447],
            [2805, 9449],
            [2802, 9458],
            [2790, 9454],
            [2797, 9468],
            [2787, 9465],
            [2788, 9478],
            [2769, 9481],
            [2752, 9490],
            [2738, 9491],
            [2726, 9502],
            [2741, 9505],
            [2753, 9503],
            [2746, 9514],
            [2758, 9520],
            [2751, 9524],
            [2734, 9521],
            [2719, 9522],
            [2710, 9531],
            [2723, 9535],
            [2715, 9537],
            [2743, 9548],
            [2727, 9545],
            [2732, 9561],
            [2726, 9564],
            [2759, 9566],
            [2755, 9570],
            [2737, 9571],
            [2753, 9583],
            [2736, 9588],
            [2748, 9593],
            [2736, 9594],
            [2739, 9603],
            [2749, 9609],
            [2719, 9604],
            [2750, 9611],
            [2737, 9616],
            [2739, 9628],
            [2718, 9632],
            [2724, 9634],
            [2713, 9641],
            [2723, 9643],
            [2724, 9651],
            [2711, 9650],
            [2709, 9655],
            [2694, 9660],
            [2680, 9659],
            [2680, 9663],
            [2653, 9665],
            [2628, 9670],
            [2611, 9663],
            [2600, 9667],
            [2596, 9662],
            [2567, 9667],
            [2558, 9661],
            [2551, 9666],
            [2540, 9664],
            [2553, 9657],
            [2514, 9661],
            [2495, 9670],
            [2502, 9676],
            [2472, 9687],
            [2487, 9693],
            [2488, 9698],
            [2464, 9696],
            [2465, 9700],
            [2482, 9698],
            [2494, 9700],
            [2506, 9698],
            [2509, 9703],
            [2528, 9706],
            [2504, 9707],
            [2521, 9711],
            [2492, 9709],
            [2468, 9719],
            [2484, 9729],
            [2509, 9732],
            [2558, 9736],
            [2570, 9741],
            [2592, 9744],
            [2636, 9744],
            [2668, 9755],
            [2676, 9768],
            [2649, 9770],
            [2636, 9769],
            [2634, 9776],
            [2660, 9782],
            [2691, 9787],
            [2702, 9792],
            [2744, 9798],
            [2769, 9794],
            [2784, 9797],
            [2780, 9801],
            [2793, 9804],
            [2785, 9810],
            [2816, 9814],
            [2846, 9813],
            [2829, 9816],
            [2848, 9818],
            [2935, 9824],
            [2948, 9818],
            [2934, 9805],
            [2956, 9812],
            [2955, 9821],
            [2962, 9823],
            [2992, 9816],
            [2975, 9815],
            [3006, 9809],
            [2995, 9815],
            [3018, 9813],
            [3026, 9814],
            [3007, 9819],
            [3003, 9827],
            [3043, 9826],
            [3047, 9824],
            [3096, 9816],
            [3109, 9811],
            [3128, 9812],
            [3117, 9817],
            [3146, 9825],
            [3112, 9833],
            [3193, 9832],
            [3217, 9828],
            [3224, 9831],
            [3205, 9833],
            [3116, 9835],
            [3094, 9837],
            [3111, 9840],
            [3127, 9837],
            [3139, 9841],
            [3189, 9843],
            [3230, 9841],
            [3229, 9843],
            [3255, 9840],
            [3258, 9847],
            [3297, 9849],
            [3325, 9849],
            [3380, 9851],
            [3415, 9850],
            [3508, 9844],
            [3499, 9842],
            [3408, 9841],
            [3324, 9836],
            [3386, 9838],
            [3421, 9840],
            [3473, 9839],
            [3516, 9841],
            [3523, 9838],
            [3507, 9833],
            [3528, 9836],
            [3563, 9833],
            [3587, 9830],
            [3564, 9823],
            [3535, 9822],
            [3416, 9819],
            [3355, 9812],
            [3366, 9808],
            [3377, 9812],
            [3456, 9817],
            [3518, 9815],
            [3515, 9811],
            [3481, 9807],
            [3478, 9802],
            [3533, 9810],
            [3546, 9816],
            [3582, 9817],
            [3587, 9810],
            [3581, 9804],
            [3540, 9790],
            [3563, 9793],
            [3609, 9805],
            [3625, 9807],
            [3628, 9817],
            [3642, 9809],
            [3651, 9810],
            [3661, 9804],
            [3692, 9812],
            [3729, 9811],
            [3765, 9807],
            [3777, 9803],
            [3736, 9793],
            [3712, 9792],
            [3716, 9787],
            [3693, 9784],
            [3660, 9784],
            [3628, 9782],
            [3639, 9780],
            [3663, 9782],
            [3684, 9778],
            [3670, 9773],
            [3623, 9771],
            [3603, 9768],
            [3608, 9774],
            [3588, 9765],
            [3594, 9759],
            [3610, 9760],
            [3601, 9752],
            [3613, 9749],
            [3600, 9734],
            [3589, 9737],
            [3568, 9736],
            [3568, 9732],
            [3538, 9706],
            [3549, 9705],
            [3554, 9714],
            [3587, 9712],
            [3592, 9724],
            [3623, 9732],
            [3604, 9722],
            [3606, 9716],
            [3595, 9712],
            [3601, 9704],
            [3592, 9702],
            [3579, 9706],
            [3562, 9705],
            [3572, 9703],
            [3568, 9698],
            [3597, 9692],
            [3608, 9695],
            [3625, 9711],
            [3631, 9710],
            [3612, 9693],
            [3612, 9685],
            [3600, 9674],
            [3598, 9658],
            [3591, 9672],
            [3596, 9681],
            [3564, 9686],
            [3535, 9678],
            [3525, 9683],
            [3514, 9679],
            [3536, 9674],
            [3533, 9666],
            [3551, 9668],
            [3571, 9666],
            [3576, 9662],
            [3562, 9659],
            [3528, 9658],
            [3569, 9657],
            [3581, 9651],
            [3576, 9637],
            [3565, 9634],
            [3560, 9640],
            [3549, 9638],
            [3529, 9647],
            [3535, 9641],
            [3551, 9634],
            [3536, 9633],
            [3563, 9630],
            [3567, 9626],
            [3555, 9621],
            [3576, 9618],
            [3591, 9622],
            [3571, 9608],
            [3553, 9609],
            [3550, 9614],
            [3519, 9614],
            [3506, 9604],
            [3539, 9597],
            [3540, 9584],
            [3517, 9586],
            [3498, 9578],
            [3481, 9581],
            [3463, 9589],
            [3463, 9595],
            [3452, 9587],
            [3432, 9585],
            [3411, 9578],
            [3435, 9573],
            [3427, 9568],
            [3442, 9554],
            [3485, 9538],
            [3471, 9532],
            [3498, 9533],
            [3484, 9528],
            [3484, 9519],
            [3491, 9525],
            [3500, 9525],
            [3497, 9519],
            [3500, 9496],
            [3488, 9492],
            [3478, 9493],
            [3480, 9506],
            [3472, 9493],
            [3456, 9493],
            [3443, 9498],
            [3438, 9513],
            [3405, 9528],
            [3383, 9527],
            [3361, 9540],
            [3348, 9539],
            [3372, 9532],
            [3364, 9529],
            [3385, 9525],
            [3407, 9525],
            [3413, 9522],
            [3406, 9515],
            [3378, 9508],
            [3341, 9509],
            [3352, 9507],
            [3340, 9497],
            [3340, 9491],
            [3372, 9494]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.50,
      "hc-key": "pr",
      "hc-a2": "PR",
      "name": "Puerto Rico",
      "labelrank": "5",
      "country-abbrev": "P.R.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "PRI",
      "iso-a2": "PR",
      "woe-id": "23424935",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1885, 7623],
          [1878, 7625],
          [1871, 7618],
          [1858, 7614],
          [1850, 7617],
          [1829, 7615],
          [1825, 7631],
          [1829, 7635],
          [1858, 7635],
          [1879, 7631],
          [1885, 7623]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "UM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.50,
      "hc-key": "um",
      "hc-a2": "UM",
      "name": "United States Minor Outlying Islands",
      "labelrank": "5",
      "country-abbrev": "U.S. MOI",
      "subregion": "Seven seas (open ocean)",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "UMI",
      "iso-a2": "UM",
      "woe-id": "28289407",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1574, 7632],
          [1575, 7632],
          [1575, 7632],
          [1574, 7632],
          [1574, 7632]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "VI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.16,
      "hc-key": "vi",
      "hc-a2": "VI",
      "name": "United States Virgin Islands",
      "labelrank": "6",
      "country-abbrev": "V.I. (U.S.)",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "VIR",
      "iso-a2": "VI",
      "woe-id": "23424985",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1906, 7608],
          [1911, 7608],
          [1900, 7605],
          [1901, 7608],
          [1906, 7608]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.28,
      "hc-middle-y": 0.57,
      "hc-key": "ca",
      "hc-a2": "CA",
      "name": "Canada",
      "labelrank": "2",
      "country-abbrev": "Can.",
      "subregion": "Northern America",
      "region-wb": "North America",
      "iso-a3": "CAN",
      "iso-a2": "CA",
      "woe-id": "23424775",
      "continent": "North America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1764, 8598],
            [1746, 8590],
            [1749, 8589],
            [1736, 8588],
            [1716, 8575],
            [1704, 8582],
            [1657, 8574],
            [1643, 8568],
            [1630, 8556],
            [1641, 8551],
            [1650, 8554],
            [1649, 8551],
            [1648, 8548],
            [1647, 8545],
            [1650, 8542],
            [1610, 8537],
            [1597, 8529],
            [1573, 8532],
            [1553, 8518],
            [1527, 8510],
            [1513, 8510],
            [1517, 8519],
            [1517, 8519],
            [1518, 8520],
            [1537, 8521],
            [1533, 8529],
            [1539, 8532],
            [1547, 8545],
            [1571, 8557],
            [1582, 8584],
            [1604, 8603],
            [1606, 8610],
            [1601, 8627],
            [1612, 8629],
            [1610, 8609],
            [1616, 8610],
            [1636, 8598],
            [1652, 8609],
            [1642, 8633],
            [1637, 8653],
            [1626, 8653],
            [1614, 8660],
            [1576, 8662],
            [1559, 8666],
            [1547, 8659],
            [1546, 8658],
            [1546, 8659],
            [1545, 8668],
            [1548, 8675],
            [1536, 8672],
            [1541, 8688],
            [1536, 8692],
            [1546, 8703],
            [1539, 8715],
            [1547, 8727],
            [1523, 8727],
            [1524, 8719],
            [1514, 8719],
            [1520, 8728],
            [1517, 8734],
            [1516, 8757],
            [1493, 8756],
            [1472, 8765],
            [1482, 8756],
            [1460, 8754],
            [1458, 8759],
            [1444, 8742],
            [1446, 8750],
            [1432, 8746],
            [1422, 8733],
            [1413, 8728],
            [1399, 8733],
            [1380, 8732],
            [1379, 8737],
            [1360, 8730],
            [1347, 8741],
            [1336, 8737],
            [1333, 8748],
            [1317, 8751],
            [1300, 8747],
            [1300, 8752],
            [1279, 8758],
            [1284, 8776],
            [1276, 8778],
            [1269, 8765],
            [476, 8765],
            [474, 8768],
            [468, 8765],
            [466, 8765],
            [469, 8775],
            [454, 8784],
            [442, 8782],
            [441, 8794],
            [446, 8812],
            [440, 8821],
            [427, 8817],
            [404, 8822],
            [425, 8832],
            [406, 8829],
            [391, 8836],
            [389, 8846],
            [403, 8856],
            [400, 8854],
            [398, 8861],
            [413, 8881],
            [415, 8891],
            [397, 8876],
            [420, 8913],
            [418, 8914],
            [415, 8906],
            [392, 8883],
            [390, 8904],
            [395, 8899],
            [403, 8912],
            [407, 8919],
            [417, 8915],
            [409, 8920],
            [417, 8931],
            [428, 8934],
            [444, 8945],
            [415, 8931],
            [405, 8923],
            [400, 8942],
            [408, 8950],
            [391, 8960],
            [393, 8966],
            [405, 8960],
            [413, 8966],
            [410, 8971],
            [419, 8975],
            [436, 8985],
            [444, 8990],
            [448, 8999],
            [461, 9011],
            [465, 9018],
            [440, 9035],
            [433, 9035],
            [434, 9044],
            [441, 9050],
            [442, 9066],
            [448, 9098],
            [447, 9109],
            [441, 9113],
            [443, 9122],
            [436, 9128],
            [443, 9137],
            [439, 9145],
            [409, 9139],
            [387, 9124],
            [374, 9120],
            [374, 9120],
            [374, 9120],
            [374, 9120],
            [373, 9119],
            [373, 9119],
            [373, 9119],
            [373, 9119],
            [358, 9115],
            [364, 9126],
            [351, 9155],
            [363, 9164],
            [347, 9164],
            [333, 9159],
            [312, 9163],
            [395, 9242],
            [486, 9324],
            [574, 9400],
            [658, 9469],
            [683, 9468],
            [697, 9464],
            [706, 9467],
            [707, 9453],
            [730, 9444],
            [752, 9445],
            [768, 9458],
            [790, 9463],
            [803, 9463],
            [820, 9470],
            [822, 9463],
            [805, 9457],
            [833, 9461],
            [851, 9469],
            [872, 9471],
            [929, 9485],
            [929, 9481],
            [949, 9488],
            [944, 9480],
            [894, 9468],
            [868, 9465],
            [858, 9460],
            [839, 9456],
            [809, 9443],
            [826, 9443],
            [829, 9450],
            [861, 9457],
            [874, 9463],
            [883, 9457],
            [912, 9470],
            [947, 9475],
            [946, 9470],
            [970, 9478],
            [974, 9483],
            [998, 9487],
            [989, 9491],
            [999, 9500],
            [1009, 9487],
            [1002, 9471],
            [1007, 9461],
            [1016, 9458],
            [1022, 9464],
            [1055, 9480],
            [1066, 9482],
            [1053, 9471],
            [1062, 9471],
            [1041, 9460],
            [1060, 9460],
            [1076, 9464],
            [1093, 9474],
            [1127, 9472],
            [1142, 9461],
            [1174, 9455],
            [1183, 9449],
            [1225, 9442],
            [1232, 9448],
            [1265, 9438],
            [1254, 9424],
            [1233, 9426],
            [1221, 9417],
            [1208, 9415],
            [1214, 9410],
            [1241, 9407],
            [1298, 9408],
            [1323, 9415],
            [1327, 9413],
            [1360, 9424],
            [1366, 9413],
            [1365, 9401],
            [1372, 9394],
            [1386, 9413],
            [1399, 9415],
            [1398, 9420],
            [1425, 9420],
            [1440, 9428],
            [1462, 9432],
            [1468, 9437],
            [1442, 9433],
            [1421, 9425],
            [1414, 9428],
            [1406, 9422],
            [1386, 9420],
            [1391, 9427],
            [1381, 9425],
            [1404, 9436],
            [1417, 9437],
            [1459, 9445],
            [1471, 9445],
            [1479, 9434],
            [1489, 9435],
            [1474, 9425],
            [1478, 9418],
            [1505, 9417],
            [1524, 9408],
            [1540, 9406],
            [1565, 9412],
            [1594, 9410],
            [1597, 9408],
            [1620, 9410],
            [1610, 9418],
            [1620, 9419],
            [1626, 9409],
            [1634, 9404],
            [1650, 9410],
            [1642, 9417],
            [1630, 9413],
            [1627, 9428],
            [1650, 9428],
            [1649, 9434],
            [1664, 9431],
            [1666, 9424],
            [1679, 9426],
            [1665, 9419],
            [1693, 9426],
            [1658, 9400],
            [1666, 9399],
            [1657, 9393],
            [1676, 9395],
            [1671, 9381],
            [1687, 9402],
            [1682, 9408],
            [1697, 9419],
            [1713, 9418],
            [1735, 9428],
            [1756, 9434],
            [1763, 9443],
            [1759, 9448],
            [1748, 9441],
            [1735, 9441],
            [1758, 9458],
            [1769, 9459],
            [1765, 9454],
            [1782, 9460],
            [1781, 9465],
            [1761, 9462],
            [1760, 9470],
            [1751, 9466],
            [1727, 9475],
            [1732, 9490],
            [1752, 9499],
            [1743, 9505],
            [1760, 9520],
            [1771, 9523],
            [1779, 9519],
            [1781, 9526],
            [1807, 9539],
            [1822, 9541],
            [1809, 9540],
            [1823, 9555],
            [1819, 9565],
            [1833, 9576],
            [1844, 9590],
            [1855, 9594],
            [1880, 9604],
            [1915, 9606],
            [1932, 9600],
            [1949, 9602],
            [1976, 9598],
            [1930, 9577],
            [1909, 9566],
            [1893, 9562],
            [1872, 9565],
            [1854, 9564],
            [1862, 9555],
            [1834, 9542],
            [1824, 9541],
            [1818, 9531],
            [1826, 9535],
            [1842, 9522],
            [1840, 9515],
            [1828, 9506],
            [1838, 9500],
            [1844, 9484],
            [1830, 9485],
            [1837, 9474],
            [1834, 9466],
            [1859, 9462],
            [1843, 9455],
            [1831, 9457],
            [1839, 9444],
            [1824, 9431],
            [1827, 9424],
            [1850, 9437],
            [1858, 9447],
            [1874, 9456],
            [1883, 9456],
            [1895, 9440],
            [1889, 9427],
            [1873, 9426],
            [1865, 9406],
            [1873, 9396],
            [1867, 9388],
            [1898, 9397],
            [1904, 9407],
            [1928, 9418],
            [1949, 9440],
            [1971, 9440],
            [1973, 9449],
            [1968, 9453],
            [1978, 9472],
            [2008, 9475],
            [2019, 9470],
            [2043, 9470],
            [2047, 9458],
            [2065, 9461],
            [2063, 9451],
            [2046, 9446],
            [2056, 9444],
            [2053, 9437],
            [2021, 9428],
            [2024, 9421],
            [2017, 9414],
            [2028, 9399],
            [2011, 9385],
            [2000, 9384],
            [1975, 9371],
            [1965, 9370],
            [1951, 9364],
            [1940, 9375],
            [1940, 9384],
            [1925, 9384],
            [1937, 9377],
            [1940, 9359],
            [1930, 9363],
            [1923, 9359],
            [1903, 9362],
            [1905, 9371],
            [1891, 9367],
            [1883, 9370],
            [1869, 9367],
            [1870, 9363],
            [1886, 9358],
            [1865, 9349],
            [1861, 9344],
            [1829, 9331],
            [1815, 9331],
            [1786, 9351],
            [1776, 9349],
            [1746, 9352],
            [1776, 9346],
            [1791, 9330],
            [1835, 9328],
            [1835, 9324],
            [1799, 9304],
            [1787, 9293],
            [1755, 9285],
            [1737, 9291],
            [1728, 9280],
            [1703, 9273],
            [1680, 9277],
            [1685, 9270],
            [1700, 9266],
            [1694, 9256],
            [1671, 9248],
            [1676, 9242],
            [1651, 9250],
            [1641, 9247],
            [1652, 9242],
            [1647, 9238],
            [1627, 9236],
            [1623, 9226],
            [1608, 9225],
            [1613, 9218],
            [1570, 9202],
            [1572, 9198],
            [1546, 9182],
            [1513, 9151],
            [1503, 9133],
            [1492, 9120],
            [1494, 9109],
            [1515, 9111],
            [1529, 9109],
            [1524, 9102],
            [1518, 9065],
            [1501, 9047],
            [1553, 9058],
            [1564, 9057],
            [1579, 9048],
            [1602, 9044],
            [1618, 9030],
            [1620, 9016],
            [1663, 9000],
            [1666, 8994],
            [1685, 8988],
            [1706, 8991],
            [1731, 8987],
            [1745, 8982],
            [1744, 8974],
            [1728, 8957],
            [1727, 8937],
            [1718, 8919],
            [1707, 8907],
            [1718, 8889],
            [1707, 8882],
            [1716, 8882],
            [1726, 8873],
            [1732, 8863],
            [1731, 8849],
            [1746, 8842],
            [1752, 8851],
            [1767, 8861],
            [1765, 8874],
            [1777, 8865],
            [1795, 8877],
            [1802, 8886],
            [1800, 8910],
            [1811, 8929],
            [1819, 8950],
            [1810, 8951],
            [1808, 8967],
            [1873, 8989],
            [1917, 9016],
            [1929, 9030],
            [1938, 9050],
            [1938, 9064],
            [1942, 9063],
            [1941, 9082],
            [1933, 9093],
            [1911, 9105],
            [1914, 9111],
            [1938, 9125],
            [1953, 9132],
            [1955, 9142],
            [1970, 9146],
            [1976, 9153],
            [1971, 9167],
            [1981, 9178],
            [1963, 9179],
            [1987, 9193],
            [1997, 9203],
            [1990, 9211],
            [1992, 9221],
            [2004, 9240],
            [2020, 9240],
            [2055, 9232],
            [2070, 9231],
            [2081, 9225],
            [2110, 9236],
            [2110, 9243],
            [2126, 9226],
            [2140, 9222],
            [2139, 9212],
            [2152, 9209],
            [2142, 9201],
            [2149, 9194],
            [2164, 9188],
            [2181, 9189],
            [2179, 9183],
            [2196, 9180],
            [2179, 9170],
            [2180, 9160],
            [2171, 9152],
            [2173, 9141],
            [2164, 9136],
            [2175, 9119],
            [2154, 9111],
            [2153, 9120],
            [2147, 9104],
            [2167, 9115],
            [2188, 9112],
            [2191, 9102],
            [2204, 9094],
            [2229, 9102],
            [2242, 9113],
            [2248, 9111],
            [2265, 9121],
            [2265, 9126],
            [2276, 9128],
            [2278, 9143],
            [2295, 9152],
            [2310, 9169],
            [2317, 9161],
            [2312, 9152],
            [2319, 9152],
            [2315, 9142],
            [2323, 9136],
            [2315, 9132],
            [2326, 9130],
            [2324, 9122],
            [2332, 9120],
            [2330, 9104],
            [2317, 9100],
            [2338, 9101],
            [2331, 9090],
            [2336, 9090],
            [2343, 9065],
            [2339, 9055],
            [2349, 9053],
            [2342, 9044],
            [2330, 9042],
            [2340, 9031],
            [2320, 9029],
            [2337, 9027],
            [2321, 9022],
            [2343, 9020],
            [2357, 8995],
            [2345, 8986],
            [2367, 8991],
            [2364, 8983],
            [2386, 8985],
            [2384, 8974],
            [2398, 8970],
            [2412, 8977],
            [2408, 8971],
            [2422, 8967],
            [2425, 8962],
            [2413, 8957],
            [2398, 8957],
            [2382, 8946],
            [2355, 8938],
            [2338, 8936],
            [2325, 8918],
            [2351, 8928],
            [2374, 8942],
            [2396, 8947],
            [2391, 8951],
            [2413, 8951],
            [2419, 8935],
            [2438, 8937],
            [2433, 8933],
            [2449, 8928],
            [2452, 8918],
            [2444, 8895],
            [2430, 8892],
            [2444, 8889],
            [2443, 8881],
            [2431, 8871],
            [2406, 8860],
            [2395, 8852],
            [2375, 8854],
            [2365, 8849],
            [2338, 8840],
            [2334, 8830],
            [2322, 8829],
            [2301, 8813],
            [2290, 8809],
            [2257, 8808],
            [2244, 8805],
            [2241, 8809],
            [2187, 8813],
            [2183, 8809],
            [2169, 8813],
            [2146, 8813],
            [2121, 8808],
            [2111, 8811],
            [2086, 8795],
            [2072, 8777],
            [2052, 8776],
            [2046, 8769],
            [2033, 8766],
            [2017, 8757],
            [1999, 8739],
            [1988, 8733],
            [1978, 8720],
            [1958, 8708],
            [1947, 8696],
            [1923, 8683],
            [1907, 8681],
            [1881, 8667],
            [1869, 8663],
            [1848, 8645],
            [1841, 8635],
            [1839, 8635],
            [1843, 8635],
            [1850, 8647],
            [1862, 8658],
            [1876, 8662],
            [1907, 8680],
            [1925, 8683],
            [1951, 8692],
            [2010, 8737],
            [2039, 8752],
            [2061, 8760],
            [2104, 8772],
            [2123, 8775],
            [2140, 8773],
            [2156, 8763],
            [2156, 8751],
            [2148, 8744],
            [2111, 8729],
            [2102, 8733],
            [2081, 8732],
            [2099, 8725],
            [2102, 8717],
            [2116, 8722],
            [2127, 8718],
            [2111, 8699],
            [2102, 8695],
            [2118, 8694],
            [2113, 8688],
            [2118, 8667],
            [2137, 8660],
            [2127, 8657],
            [2147, 8646],
            [2154, 8649],
            [2170, 8642],
            [2189, 8652],
            [2188, 8645],
            [2199, 8644],
            [2210, 8632],
            [2205, 8627],
            [2183, 8623],
            [2178, 8616],
            [2162, 8613],
            [2120, 8597],
            [2118, 8606],
            [2104, 8601],
            [2100, 8591],
            [2080, 8574],
            [2070, 8569],
            [2068, 8573],
            [2053, 8560],
            [2048, 8574],
            [2043, 8570],
            [2042, 8584],
            [2056, 8601],
            [2045, 8594],
            [2030, 8604],
            [2034, 8609],
            [2033, 8626],
            [2026, 8626],
            [2019, 8629],
            [2024, 8641],
            [2017, 8644],
            [2015, 8647],
            [2031, 8695],
            [2019, 8705],
            [2000, 8699],
            [1994, 8709],
            [1962, 8681],
            [1945, 8659],
            [1944, 8652],
            [1921, 8634],
            [1907, 8630],
            [1897, 8620],
            [1817, 8619],
            [1802, 8616],
            [1805, 8620],
            [1837, 8634],
            [1823, 8631],
            [1805, 8621],
            [1802, 8616],
            [1784, 8612],
            [1764, 8598]
          ],
          [
            [403, 8856],
            [409, 8859],
            [409, 8859],
            [409, 8859],
            [409, 8859],
            [431, 8861],
            [414, 8863],
            [409, 8860],
            [409, 8860],
            [409, 8860],
            [409, 8859],
            [408, 8859],
            [403, 8856]
          ]
        ],
        [
          [
            [312, 8914],
            [308, 8918],
            [318, 8920],
            [310, 8925],
            [314, 8940],
            [327, 8951],
            [345, 8948],
            [343, 8941],
            [346, 8944],
            [363, 8950],
            [340, 8931],
            [327, 8918],
            [319, 8915],
            [333, 8918],
            [332, 8910],
            [316, 8898],
            [321, 8899],
            [318, 8883],
            [324, 8884],
            [318, 8872],
            [309, 8900],
            [308, 8914],
            [312, 8914]
          ],
          [
            [343, 8941],
            [340, 8939],
            [340, 8939],
            [340, 8939],
            [323, 8933],
            [333, 8932],
            [340, 8939],
            [340, 8939],
            [340, 8939],
            [342, 8939],
            [343, 8941]
          ]
        ],
        [
          [
            [2119, 9323],
            [2120, 9325],
            [2113, 9330],
            [2131, 9328],
            [2136, 9333],
            [2148, 9331],
            [2161, 9337],
            [2177, 9335],
            [2178, 9343],
            [2166, 9357],
            [2215, 9376],
            [2225, 9386],
            [2234, 9387],
            [2241, 9395],
            [2244, 9410],
            [2239, 9414],
            [2244, 9424],
            [2226, 9428],
            [2235, 9438],
            [2220, 9433],
            [2215, 9424],
            [2214, 9435],
            [2202, 9428],
            [2191, 9433],
            [2208, 9442],
            [2200, 9449],
            [2194, 9445],
            [2165, 9438],
            [2172, 9445],
            [2170, 9453],
            [2162, 9452],
            [2164, 9461],
            [2180, 9461],
            [2182, 9466],
            [2172, 9469],
            [2183, 9473],
            [2165, 9474],
            [2172, 9485],
            [2156, 9486],
            [2153, 9494],
            [2133, 9492],
            [2145, 9490],
            [2143, 9477],
            [2118, 9475],
            [2116, 9479],
            [2075, 9483],
            [2090, 9473],
            [2085, 9471],
            [2076, 9479],
            [2058, 9473],
            [2042, 9480],
            [2026, 9478],
            [1979, 9483],
            [1977, 9479],
            [1965, 9487],
            [1961, 9480],
            [1943, 9480],
            [1941, 9489],
            [1920, 9494],
            [1913, 9508],
            [1915, 9513],
            [1941, 9509],
            [1966, 9511],
            [1953, 9517],
            [1916, 9520],
            [1917, 9529],
            [1927, 9534],
            [1924, 9539],
            [1938, 9545],
            [1939, 9551],
            [1979, 9576],
            [2006, 9587],
            [2026, 9592],
            [2053, 9596],
            [2085, 9596],
            [2092, 9593],
            [2054, 9580],
            [2027, 9566],
            [2022, 9560],
            [2026, 9554],
            [2012, 9541],
            [2021, 9526],
            [2031, 9523],
            [2005, 9515],
            [2027, 9515],
            [2041, 9524],
            [2043, 9531],
            [2030, 9531],
            [2022, 9542],
            [2033, 9543],
            [2040, 9549],
            [2050, 9549],
            [2044, 9560],
            [2056, 9570],
            [2082, 9565],
            [2066, 9571],
            [2071, 9578],
            [2084, 9583],
            [2137, 9593],
            [2167, 9592],
            [2163, 9579],
            [2173, 9576],
            [2168, 9570],
            [2171, 9563],
            [2157, 9552],
            [2142, 9547],
            [2141, 9540],
            [2172, 9554],
            [2184, 9553],
            [2191, 9548],
            [2200, 9552],
            [2216, 9548],
            [2204, 9556],
            [2232, 9564],
            [2281, 9556],
            [2276, 9545],
            [2294, 9543],
            [2288, 9535],
            [2266, 9532],
            [2255, 9526],
            [2295, 9534],
            [2302, 9534],
            [2294, 9524],
            [2312, 9527],
            [2324, 9531],
            [2344, 9526],
            [2349, 9519],
            [2337, 9512],
            [2352, 9514],
            [2356, 9508],
            [2339, 9499],
            [2370, 9507],
            [2360, 9498],
            [2374, 9503],
            [2400, 9498],
            [2393, 9491],
            [2367, 9487],
            [2360, 9484],
            [2385, 9486],
            [2375, 9478],
            [2391, 9482],
            [2402, 9490],
            [2415, 9478],
            [2413, 9471],
            [2393, 9473],
            [2414, 9459],
            [2410, 9452],
            [2389, 9454],
            [2380, 9458],
            [2361, 9460],
            [2386, 9449],
            [2376, 9447],
            [2375, 9439],
            [2362, 9436],
            [2394, 9430],
            [2381, 9428],
            [2394, 9424],
            [2392, 9417],
            [2407, 9424],
            [2406, 9411],
            [2438, 9417],
            [2427, 9409],
            [2439, 9411],
            [2453, 9401],
            [2446, 9394],
            [2469, 9394],
            [2453, 9381],
            [2467, 9383],
            [2481, 9391],
            [2484, 9382],
            [2493, 9383],
            [2500, 9374],
            [2491, 9364],
            [2462, 9360],
            [2473, 9353],
            [2461, 9352],
            [2463, 9342],
            [2436, 9340],
            [2422, 9335],
            [2426, 9327],
            [2413, 9317],
            [2411, 9325],
            [2403, 9321],
            [2400, 9329],
            [2393, 9323],
            [2381, 9344],
            [2387, 9352],
            [2374, 9351],
            [2376, 9356],
            [2361, 9365],
            [2361, 9371],
            [2349, 9370],
            [2351, 9363],
            [2335, 9367],
            [2334, 9361],
            [2343, 9356],
            [2342, 9350],
            [2323, 9349],
            [2321, 9360],
            [2316, 9358],
            [2315, 9346],
            [2320, 9341],
            [2335, 9341],
            [2330, 9334],
            [2339, 9332],
            [2333, 9323],
            [2355, 9316],
            [2369, 9308],
            [2358, 9297],
            [2364, 9283],
            [2378, 9274],
            [2371, 9265],
            [2368, 9274],
            [2364, 9263],
            [2353, 9272],
            [2355, 9251],
            [2339, 9253],
            [2342, 9241],
            [2355, 9237],
            [2339, 9234],
            [2332, 9243],
            [2337, 9246],
            [2310, 9255],
            [2300, 9251],
            [2302, 9263],
            [2295, 9263],
            [2286, 9275],
            [2275, 9258],
            [2282, 9255],
            [2296, 9243],
            [2298, 9234],
            [2309, 9227],
            [2301, 9221],
            [2309, 9215],
            [2295, 9215],
            [2272, 9225],
            [2243, 9229],
            [2224, 9243],
            [2230, 9246],
            [2202, 9246],
            [2207, 9240],
            [2192, 9239],
            [2196, 9248],
            [2179, 9260],
            [2181, 9267],
            [2197, 9272],
            [2186, 9279],
            [2168, 9277],
            [2172, 9288],
            [2164, 9289],
            [2162, 9298],
            [2157, 9292],
            [2157, 9309],
            [2143, 9298],
            [2149, 9311],
            [2126, 9299],
            [2102, 9307],
            [2100, 9300],
            [2091, 9300],
            [2072, 9293],
            [2046, 9299],
            [2043, 9308],
            [2051, 9318],
            [2077, 9326],
            [2079, 9335],
            [2097, 9333],
            [2116, 9327],
            [2119, 9323]
          ],
          [
            [2119, 9323],
            [2119, 9321],
            [2119, 9321],
            [2119, 9321],
            [2113, 9318],
            [2118, 9311],
            [2119, 9321],
            [2119, 9321],
            [2119, 9321],
            [2121, 9322],
            [2119, 9323]
          ]
        ],
        [
          [
            [2173, 8799],
            [2193, 8795],
            [2214, 8787],
            [2230, 8778],
            [2232, 8768],
            [2216, 8767],
            [2182, 8779],
            [2176, 8789],
            [2164, 8794],
            [2173, 8799]
          ]
        ],
        [
          [
            [406, 8875],
            [398, 8867],
            [393, 8854],
            [387, 8855],
            [395, 8870],
            [413, 8884],
            [406, 8875]
          ]
        ],
        [
          [
            [1736, 8917],
            [1744, 8916],
            [1749, 8906],
            [1747, 8898],
            [1714, 8909],
            [1722, 8915],
            [1736, 8917]
          ]
        ],
        [
          [
            [389, 8911],
            [378, 8923],
            [380, 8931],
            [390, 8924],
            [389, 8911]
          ]
        ],
        [
          [
            [2323, 9213],
            [2324, 9219],
            [2332, 9207],
            [2322, 9198],
            [2311, 9207],
            [2323, 9213]
          ]
        ],
        [
          [
            [1966, 9233],
            [1961, 9220],
            [1941, 9206],
            [1934, 9213],
            [1941, 9225],
            [1953, 9233],
            [1966, 9233]
          ]
        ],
        [
          [
            [1909, 9253],
            [1908, 9244],
            [1866, 9226],
            [1851, 9225],
            [1853, 9237],
            [1879, 9251],
            [1882, 9248],
            [1909, 9253]
          ]
        ],
        [
          [
            [2014, 9270],
            [2032, 9268],
            [2030, 9260],
            [2018, 9257],
            [2009, 9267],
            [2014, 9270]
          ]
        ],
        [
          [
            [2051, 9276],
            [2061, 9269],
            [2055, 9266],
            [2041, 9273],
            [2045, 9277],
            [2037, 9287],
            [2046, 9288],
            [2051, 9276]
          ]
        ],
        [
          [
            [1935, 9348],
            [1935, 9340],
            [1919, 9345],
            [1920, 9357],
            [1935, 9348]
          ]
        ],
        [
          [
            [2210, 9419],
            [2228, 9416],
            [2225, 9410],
            [2200, 9410],
            [2198, 9419],
            [2210, 9419]
          ]
        ],
        [
          [
            [1914, 9415],
            [1904, 9408],
            [1903, 9419],
            [1914, 9426],
            [1919, 9423],
            [1914, 9415]
          ]
        ],
        [
          [
            [2183, 9427],
            [2192, 9424],
            [2180, 9402],
            [2154, 9393],
            [2127, 9392],
            [2128, 9407],
            [2155, 9425],
            [2183, 9427]
          ]
        ],
        [
          [
            [2129, 9462],
            [2140, 9469],
            [2155, 9470],
            [2137, 9463],
            [2140, 9457],
            [2117, 9445],
            [2117, 9434],
            [2097, 9422],
            [2097, 9427],
            [2114, 9436],
            [2104, 9446],
            [2128, 9457],
            [2129, 9462]
          ]
        ],
        [
          [
            [2096, 9462],
            [2097, 9468],
            [2087, 9469],
            [2117, 9474],
            [2123, 9470],
            [2104, 9468],
            [2096, 9462]
          ]
        ],
        [
          [
            [1633, 9580],
            [1603, 9566],
            [1593, 9583],
            [1583, 9585],
            [1601, 9592],
            [1634, 9593],
            [1643, 9588],
            [1633, 9580]
          ]
        ],
        [
          [
            [1814, 9603],
            [1796, 9597],
            [1776, 9595],
            [1770, 9598],
            [1813, 9604],
            [1814, 9603]
          ]
        ],
        [
          [
            [1717, 9638],
            [1717, 9635],
            [1697, 9630],
            [1686, 9634],
            [1698, 9640],
            [1714, 9643],
            [1717, 9638]
          ]
        ],
        [
          [
            [1443, 9662],
            [1446, 9661],
            [1411, 9647],
            [1397, 9645],
            [1384, 9647],
            [1414, 9657],
            [1443, 9662]
          ]
        ],
        [
          [
            [1773, 9661],
            [1772, 9659],
            [1739, 9656],
            [1757, 9660],
            [1731, 9661],
            [1740, 9665],
            [1775, 9668],
            [1773, 9661]
          ]
        ],
        [
          [
            [1759, 9677],
            [1773, 9672],
            [1762, 9668],
            [1739, 9668],
            [1743, 9676],
            [1759, 9677]
          ]
        ],
        [
          [
            [2085, 9705],
            [2090, 9697],
            [2076, 9693],
            [2062, 9696],
            [2066, 9704],
            [2085, 9705]
          ]
        ],
        [
          [
            [1765, 9699],
            [1773, 9696],
            [1759, 9690],
            [1750, 9698],
            [1754, 9708],
            [1765, 9707],
            [1765, 9699]
          ]
        ],
        [
          [
            [1982, 9709],
            [2020, 9709],
            [2027, 9706],
            [2009, 9699],
            [1959, 9701],
            [1962, 9707],
            [1982, 9709]
          ]
        ],
        [
          [
            [1590, 9715],
            [1598, 9710],
            [1581, 9707],
            [1571, 9714],
            [1590, 9715]
          ]
        ],
        [
          [
            [1836, 9712],
            [1852, 9712],
            [1863, 9708],
            [1831, 9708],
            [1828, 9719],
            [1836, 9712]
          ]
        ],
        [
          [
            [1976, 9770],
            [1986, 9767],
            [1974, 9759],
            [1958, 9768],
            [1976, 9770]
          ]
        ],
        [
          [
            [1624, 9722],
            [1629, 9726],
            [1663, 9730],
            [1701, 9735],
            [1714, 9731],
            [1704, 9723],
            [1684, 9723],
            [1671, 9725],
            [1661, 9722],
            [1649, 9725],
            [1624, 9722]
          ]
        ],
        [
          [
            [1563, 8655],
            [1578, 8656],
            [1577, 8650],
            [1595, 8657],
            [1595, 8650],
            [1603, 8655],
            [1600, 8639],
            [1563, 8655]
          ]
        ],
        [
          [
            [2149, 8662],
            [2130, 8671],
            [2125, 8681],
            [2142, 8695],
            [2136, 8684],
            [2156, 8671],
            [2176, 8673],
            [2194, 8672],
            [2181, 8669],
            [2172, 8655],
            [2163, 8655],
            [2163, 8662],
            [2149, 8662]
          ]
        ],
        [
          [
            [1930, 9653],
            [1942, 9638],
            [1933, 9627],
            [1921, 9620],
            [1896, 9619],
            [1888, 9624],
            [1878, 9615],
            [1874, 9627],
            [1865, 9630],
            [1891, 9640],
            [1886, 9645],
            [1871, 9640],
            [1871, 9644],
            [1893, 9649],
            [1899, 9644],
            [1923, 9649],
            [1930, 9653]
          ]
        ],
        [
          [
            [1656, 9708],
            [1670, 9709],
            [1657, 9701],
            [1610, 9696],
            [1596, 9703],
            [1608, 9712],
            [1657, 9717],
            [1691, 9718],
            [1683, 9713],
            [1658, 9711],
            [1656, 9708]
          ]
        ],
        [
          [
            [390, 8938],
            [386, 8943],
            [397, 8947],
            [404, 8921],
            [394, 8916],
            [392, 8926],
            [384, 8933],
            [390, 8938]
          ]
        ],
        [
          [
            [2242, 8688],
            [2243, 8678],
            [2211, 8644],
            [2235, 8656],
            [2223, 8654],
            [2235, 8664],
            [2254, 8662],
            [2255, 8656],
            [2231, 8643],
            [2211, 8636],
            [2201, 8644],
            [2202, 8657],
            [2212, 8665],
            [2240, 8693],
            [2242, 8688]
          ]
        ],
        [
          [
            [1843, 9041],
            [1849, 9043],
            [1860, 9030],
            [1870, 9030],
            [1865, 9021],
            [1857, 9018],
            [1846, 9007],
            [1843, 9010],
            [1853, 9023],
            [1838, 9010],
            [1839, 9018],
            [1825, 9008],
            [1836, 9020],
            [1827, 9021],
            [1837, 9028],
            [1844, 9025],
            [1851, 9034],
            [1843, 9041]
          ]
        ],
        [
          [
            [2180, 9572],
            [2184, 9578],
            [2172, 9582],
            [2183, 9592],
            [2192, 9594],
            [2211, 9590],
            [2241, 9591],
            [2259, 9586],
            [2271, 9574],
            [2263, 9565],
            [2222, 9568],
            [2196, 9564],
            [2180, 9567],
            [2180, 9572]
          ]
        ],
        [
          [
            [1951, 9709],
            [1940, 9716],
            [1963, 9719],
            [1943, 9723],
            [1943, 9729],
            [1959, 9737],
            [1994, 9732],
            [1988, 9729],
            [2010, 9727],
            [1997, 9721],
            [1994, 9714],
            [1956, 9711],
            [1951, 9709]
          ]
        ],
        [
          [
            [1517, 9686],
            [1502, 9685],
            [1504, 9679],
            [1471, 9674],
            [1455, 9666],
            [1446, 9671],
            [1468, 9681],
            [1449, 9679],
            [1446, 9675],
            [1429, 9673],
            [1432, 9669],
            [1411, 9661],
            [1413, 9669],
            [1400, 9660],
            [1384, 9655],
            [1371, 9655],
            [1378, 9663],
            [1365, 9657],
            [1357, 9654],
            [1349, 9660],
            [1331, 9657],
            [1332, 9663],
            [1352, 9671],
            [1371, 9671],
            [1391, 9678],
            [1412, 9682],
            [1426, 9687],
            [1468, 9697],
            [1490, 9698],
            [1499, 9695],
            [1507, 9700],
            [1528, 9703],
            [1539, 9696],
            [1516, 9693],
            [1517, 9686]
          ]
        ],
        [
          [
            [373, 8792],
            [357, 8823],
            [359, 8829],
            [379, 8835],
            [389, 8824],
            [421, 8816],
            [439, 8817],
            [441, 8804],
            [433, 8806],
            [429, 8790],
            [434, 8779],
            [453, 8771],
            [455, 8760],
            [463, 8757],
            [448, 8755],
            [447, 8744],
            [437, 8740],
            [411, 8749],
            [401, 8758],
            [416, 8766],
            [396, 8762],
            [389, 8772],
            [396, 8781],
            [383, 8775],
            [382, 8787],
            [373, 8792]
          ]
        ],
        [
          [
            [2451, 8749],
            [2460, 8746],
            [2478, 8751],
            [2469, 8741],
            [2457, 8736],
            [2443, 8718],
            [2451, 8712],
            [2463, 8729],
            [2474, 8732],
            [2460, 8715],
            [2462, 8708],
            [2475, 8721],
            [2477, 8711],
            [2461, 8684],
            [2441, 8678],
            [2443, 8697],
            [2429, 8685],
            [2426, 8689],
            [2442, 8708],
            [2440, 8722],
            [2436, 8724],
            [2424, 8710],
            [2435, 8716],
            [2431, 8705],
            [2425, 8709],
            [2412, 8706],
            [2394, 8689],
            [2380, 8687],
            [2374, 8690],
            [2382, 8696],
            [2381, 8709],
            [2387, 8714],
            [2361, 8715],
            [2355, 8711],
            [2329, 8715],
            [2322, 8718],
            [2288, 8713],
            [2285, 8724],
            [2320, 8747],
            [2312, 8749],
            [2329, 8770],
            [2335, 8764],
            [2335, 8778],
            [2349, 8792],
            [2374, 8823],
            [2390, 8834],
            [2401, 8849],
            [2430, 8860],
            [2441, 8858],
            [2432, 8848],
            [2421, 8851],
            [2427, 8844],
            [2429, 8830],
            [2412, 8827],
            [2386, 8803],
            [2376, 8785],
            [2403, 8807],
            [2412, 8799],
            [2420, 8799],
            [2401, 8790],
            [2402, 8783],
            [2419, 8781],
            [2420, 8775],
            [2430, 8775],
            [2444, 8789],
            [2451, 8786],
            [2458, 8792],
            [2456, 8782],
            [2471, 8774],
            [2451, 8759],
            [2451, 8749]
          ]
        ],
        [
          [
            [1887, 9279],
            [1868, 9274],
            [1858, 9267],
            [1842, 9260],
            [1826, 9258],
            [1835, 9274],
            [1831, 9277],
            [1810, 9276],
            [1796, 9272],
            [1796, 9277],
            [1809, 9285],
            [1831, 9290],
            [1836, 9307],
            [1850, 9318],
            [1861, 9333],
            [1874, 9345],
            [1889, 9350],
            [1895, 9345],
            [1905, 9355],
            [1905, 9341],
            [1901, 9338],
            [1906, 9329],
            [1924, 9324],
            [1924, 9318],
            [1942, 9312],
            [1951, 9304],
            [1946, 9297],
            [1951, 9290],
            [1971, 9286],
            [1976, 9281],
            [1948, 9269],
            [1926, 9277],
            [1915, 9276],
            [1923, 9284],
            [1906, 9287],
            [1913, 9291],
            [1899, 9291],
            [1887, 9279]
          ]
        ],
        [
          [
            [1659, 9462],
            [1687, 9476],
            [1701, 9464],
            [1708, 9463],
            [1708, 9466],
            [1733, 9467],
            [1733, 9460],
            [1715, 9459],
            [1710, 9450],
            [1712, 9438],
            [1706, 9440],
            [1682, 9431],
            [1672, 9435],
            [1661, 9434],
            [1648, 9441],
            [1612, 9447],
            [1596, 9439],
            [1601, 9449],
            [1624, 9449],
            [1660, 9458],
            [1659, 9462]
          ]
        ],
        [
          [
            [1547, 9468],
            [1556, 9460],
            [1578, 9463],
            [1571, 9459],
            [1580, 9452],
            [1560, 9447],
            [1564, 9438],
            [1557, 9435],
            [1549, 9444],
            [1525, 9441],
            [1505, 9446],
            [1486, 9447],
            [1497, 9450],
            [1465, 9454],
            [1471, 9464],
            [1439, 9449],
            [1407, 9447],
            [1389, 9440],
            [1349, 9436],
            [1342, 9432],
            [1323, 9434],
            [1285, 9432],
            [1281, 9442],
            [1292, 9454],
            [1278, 9457],
            [1258, 9456],
            [1241, 9458],
            [1225, 9472],
            [1228, 9479],
            [1244, 9484],
            [1308, 9489],
            [1351, 9486],
            [1362, 9491],
            [1377, 9489],
            [1369, 9495],
            [1333, 9502],
            [1279, 9497],
            [1278, 9499],
            [1251, 9497],
            [1239, 9505],
            [1241, 9511],
            [1301, 9522],
            [1318, 9527],
            [1272, 9522],
            [1258, 9525],
            [1276, 9528],
            [1270, 9531],
            [1246, 9530],
            [1256, 9539],
            [1276, 9546],
            [1288, 9548],
            [1286, 9555],
            [1329, 9568],
            [1409, 9582],
            [1415, 9575],
            [1403, 9565],
            [1382, 9559],
            [1410, 9562],
            [1432, 9571],
            [1463, 9563],
            [1456, 9558],
            [1436, 9552],
            [1456, 9553],
            [1487, 9563],
            [1484, 9571],
            [1498, 9571],
            [1517, 9558],
            [1510, 9552],
            [1507, 9540],
            [1501, 9535],
            [1508, 9530],
            [1528, 9538],
            [1523, 9545],
            [1533, 9555],
            [1536, 9564],
            [1555, 9581],
            [1564, 9581],
            [1564, 9587],
            [1574, 9590],
            [1578, 9580],
            [1587, 9578],
            [1599, 9565],
            [1585, 9544],
            [1585, 9528],
            [1564, 9513],
            [1569, 9503],
            [1582, 9495],
            [1588, 9495],
            [1608, 9483],
            [1622, 9485],
            [1609, 9469],
            [1600, 9470],
            [1598, 9463],
            [1587, 9476],
            [1569, 9466],
            [1554, 9470],
            [1547, 9468]
          ]
        ],
        [
          [
            [1710, 9563],
            [1718, 9575],
            [1706, 9584],
            [1733, 9596],
            [1751, 9594],
            [1758, 9598],
            [1768, 9593],
            [1816, 9597],
            [1815, 9590],
            [1802, 9587],
            [1803, 9582],
            [1788, 9580],
            [1762, 9571],
            [1794, 9571],
            [1805, 9577],
            [1807, 9573],
            [1795, 9569],
            [1795, 9554],
            [1785, 9548],
            [1773, 9536],
            [1746, 9529],
            [1729, 9530],
            [1730, 9527],
            [1707, 9519],
            [1697, 9521],
            [1700, 9528],
            [1689, 9546],
            [1673, 9548],
            [1658, 9561],
            [1672, 9572],
            [1686, 9574],
            [1689, 9563],
            [1710, 9563]
          ]
        ],
        [
          [
            [1116, 9549],
            [1145, 9559],
            [1153, 9567],
            [1168, 9569],
            [1164, 9573],
            [1187, 9583],
            [1215, 9594],
            [1210, 9596],
            [1216, 9611],
            [1295, 9617],
            [1316, 9609],
            [1336, 9607],
            [1363, 9609],
            [1383, 9603],
            [1396, 9585],
            [1313, 9568],
            [1278, 9560],
            [1264, 9551],
            [1241, 9548],
            [1204, 9525],
            [1182, 9522],
            [1179, 9525],
            [1162, 9519],
            [1133, 9513],
            [1132, 9532],
            [1114, 9540],
            [1099, 9540],
            [1116, 9549]
          ]
        ],
        [
          [
            [1789, 9643],
            [1816, 9649],
            [1778, 9648],
            [1749, 9644],
            [1756, 9652],
            [1742, 9652],
            [1754, 9656],
            [1775, 9659],
            [1786, 9653],
            [1784, 9661],
            [1802, 9666],
            [1785, 9665],
            [1807, 9676],
            [1835, 9680],
            [1853, 9677],
            [1857, 9670],
            [1865, 9676],
            [1879, 9677],
            [1890, 9673],
            [1872, 9655],
            [1860, 9652],
            [1870, 9650],
            [1863, 9644],
            [1849, 9644],
            [1839, 9633],
            [1838, 9618],
            [1835, 9631],
            [1797, 9629],
            [1783, 9631],
            [1789, 9643]
          ]
        ],
        [
          [
            [1643, 9679],
            [1664, 9683],
            [1651, 9671],
            [1657, 9667],
            [1639, 9660],
            [1654, 9661],
            [1651, 9656],
            [1665, 9656],
            [1681, 9661],
            [1697, 9659],
            [1693, 9649],
            [1659, 9632],
            [1601, 9628],
            [1601, 9632],
            [1574, 9626],
            [1547, 9624],
            [1545, 9621],
            [1514, 9615],
            [1480, 9612],
            [1467, 9614],
            [1458, 9620],
            [1474, 9624],
            [1512, 9630],
            [1535, 9630],
            [1557, 9637],
            [1521, 9633],
            [1484, 9632],
            [1493, 9641],
            [1473, 9632],
            [1454, 9630],
            [1459, 9635],
            [1441, 9629],
            [1410, 9636],
            [1428, 9644],
            [1453, 9644],
            [1484, 9651],
            [1455, 9647],
            [1431, 9647],
            [1447, 9653],
            [1495, 9655],
            [1455, 9656],
            [1469, 9663],
            [1488, 9666],
            [1503, 9672],
            [1527, 9673],
            [1529, 9681],
            [1558, 9684],
            [1553, 9679],
            [1537, 9680],
            [1526, 9664],
            [1550, 9667],
            [1555, 9660],
            [1567, 9654],
            [1560, 9645],
            [1578, 9647],
            [1608, 9644],
            [1616, 9652],
            [1600, 9656],
            [1624, 9662],
            [1608, 9667],
            [1643, 9679]
          ]
        ],
        [
          [
            [1997, 9677],
            [2031, 9679],
            [2046, 9675],
            [2044, 9671],
            [2066, 9667],
            [2061, 9664],
            [2019, 9664],
            [2039, 9661],
            [2018, 9660],
            [2019, 9657],
            [2043, 9659],
            [2053, 9653],
            [2047, 9643],
            [2060, 9650],
            [2067, 9645],
            [2093, 9647],
            [2104, 9642],
            [2111, 9645],
            [2158, 9651],
            [2173, 9654],
            [2185, 9651],
            [2204, 9654],
            [2229, 9653],
            [2222, 9649],
            [2239, 9649],
            [2253, 9644],
            [2246, 9635],
            [2224, 9631],
            [2243, 9631],
            [2244, 9627],
            [2221, 9623],
            [2218, 9618],
            [2192, 9617],
            [2179, 9614],
            [2157, 9617],
            [2160, 9625],
            [2144, 9618],
            [2125, 9616],
            [2049, 9614],
            [2030, 9615],
            [2041, 9627],
            [2027, 9620],
            [2000, 9616],
            [1977, 9622],
            [1960, 9623],
            [1963, 9636],
            [1985, 9647],
            [1991, 9655],
            [1985, 9659],
            [1985, 9669],
            [1966, 9667],
            [1932, 9666],
            [1942, 9668],
            [1927, 9670],
            [1923, 9678],
            [1925, 9687],
            [1951, 9689],
            [1990, 9685],
            [1997, 9677]
          ]
        ],
        [
          [
            [1890, 9744],
            [1913, 9737],
            [1922, 9731],
            [1910, 9727],
            [1915, 9717],
            [1904, 9711],
            [1886, 9709],
            [1874, 9711],
            [1877, 9720],
            [1847, 9725],
            [1807, 9722],
            [1804, 9729],
            [1815, 9731],
            [1835, 9728],
            [1846, 9736],
            [1843, 9739],
            [1812, 9743],
            [1826, 9750],
            [1862, 9751],
            [1872, 9749],
            [1877, 9742],
            [1890, 9744]
          ]
        ],
        [
          [
            [2225, 9765],
            [2213, 9759],
            [2244, 9757],
            [2248, 9749],
            [2209, 9743],
            [2172, 9732],
            [2172, 9742],
            [2164, 9730],
            [2150, 9723],
            [2147, 9726],
            [2129, 9720],
            [2122, 9731],
            [2120, 9720],
            [2104, 9723],
            [2100, 9719],
            [2075, 9720],
            [2059, 9724],
            [2059, 9729],
            [2086, 9730],
            [2053, 9731],
            [2044, 9741],
            [2071, 9746],
            [2098, 9747],
            [2095, 9753],
            [2061, 9748],
            [2067, 9752],
            [2035, 9749],
            [2033, 9756],
            [2056, 9758],
            [2070, 9762],
            [2034, 9759],
            [2026, 9764],
            [2030, 9770],
            [2068, 9769],
            [2079, 9773],
            [2059, 9771],
            [2040, 9774],
            [2066, 9777],
            [2061, 9784],
            [2096, 9786],
            [2079, 9788],
            [2099, 9794],
            [2106, 9791],
            [2136, 9794],
            [2138, 9797],
            [2116, 9798],
            [2142, 9801],
            [2165, 9796],
            [2168, 9782],
            [2195, 9781],
            [2190, 9775],
            [2198, 9770],
            [2210, 9778],
            [2225, 9778],
            [2225, 9765]
          ]
        ],
        [
          [
            [2313, 9695],
            [2279, 9697],
            [2291, 9692],
            [2305, 9694],
            [2311, 9690],
            [2298, 9685],
            [2331, 9686],
            [2326, 9678],
            [2304, 9672],
            [2302, 9675],
            [2283, 9667],
            [2288, 9661],
            [2266, 9653],
            [2264, 9665],
            [2240, 9663],
            [2254, 9671],
            [2231, 9673],
            [2221, 9670],
            [2170, 9672],
            [2172, 9668],
            [2154, 9667],
            [2111, 9672],
            [2103, 9668],
            [2078, 9671],
            [2066, 9675],
            [2053, 9673],
            [2051, 9680],
            [2078, 9683],
            [2113, 9691],
            [2127, 9690],
            [2146, 9695],
            [2132, 9697],
            [2130, 9705],
            [2137, 9710],
            [2160, 9712],
            [2180, 9707],
            [2175, 9699],
            [2200, 9710],
            [2192, 9713],
            [2209, 9717],
            [2224, 9724],
            [2202, 9718],
            [2185, 9717],
            [2187, 9720],
            [2160, 9718],
            [2170, 9727],
            [2199, 9737],
            [2231, 9739],
            [2270, 9736],
            [2302, 9738],
            [2296, 9739],
            [2252, 9740],
            [2245, 9743],
            [2258, 9747],
            [2256, 9758],
            [2230, 9761],
            [2246, 9775],
            [2299, 9774],
            [2322, 9764],
            [2325, 9757],
            [2346, 9757],
            [2331, 9760],
            [2339, 9766],
            [2326, 9768],
            [2313, 9775],
            [2426, 9782],
            [2387, 9783],
            [2428, 9787],
            [2463, 9789],
            [2435, 9790],
            [2416, 9789],
            [2419, 9792],
            [2448, 9799],
            [2441, 9799],
            [2400, 9788],
            [2337, 9781],
            [2325, 9784],
            [2346, 9786],
            [2312, 9785],
            [2307, 9781],
            [2280, 9780],
            [2250, 9783],
            [2283, 9792],
            [2354, 9796],
            [2282, 9793],
            [2240, 9783],
            [2205, 9789],
            [2228, 9792],
            [2262, 9792],
            [2310, 9799],
            [2270, 9795],
            [2200, 9792],
            [2194, 9796],
            [2207, 9800],
            [2247, 9806],
            [2199, 9801],
            [2192, 9803],
            [2223, 9807],
            [2202, 9808],
            [2194, 9806],
            [2176, 9807],
            [2201, 9812],
            [2267, 9818],
            [2329, 9815],
            [2294, 9819],
            [2294, 9821],
            [2326, 9822],
            [2323, 9826],
            [2373, 9822],
            [2434, 9811],
            [2427, 9816],
            [2408, 9818],
            [2380, 9824],
            [2401, 9831],
            [2426, 9828],
            [2413, 9833],
            [2445, 9833],
            [2445, 9836],
            [2462, 9837],
            [2474, 9834],
            [2502, 9835],
            [2500, 9837],
            [2526, 9839],
            [2562, 9838],
            [2566, 9835],
            [2596, 9840],
            [2652, 9840],
            [2651, 9837],
            [2714, 9836],
            [2667, 9831],
            [2686, 9830],
            [2745, 9836],
            [2773, 9827],
            [2797, 9827],
            [2797, 9820],
            [2727, 9809],
            [2707, 9810],
            [2678, 9804],
            [2613, 9797],
            [2694, 9804],
            [2719, 9803],
            [2684, 9798],
            [2627, 9786],
            [2581, 9774],
            [2531, 9769],
            [2564, 9771],
            [2546, 9762],
            [2520, 9759],
            [2485, 9765],
            [2471, 9764],
            [2499, 9762],
            [2499, 9756],
            [2478, 9753],
            [2458, 9755],
            [2455, 9751],
            [2434, 9755],
            [2431, 9750],
            [2392, 9751],
            [2405, 9749],
            [2463, 9748],
            [2458, 9743],
            [2430, 9744],
            [2429, 9747],
            [2385, 9747],
            [2426, 9745],
            [2387, 9743],
            [2429, 9741],
            [2448, 9736],
            [2439, 9731],
            [2425, 9729],
            [2403, 9730],
            [2428, 9725],
            [2412, 9720],
            [2385, 9720],
            [2411, 9718],
            [2378, 9712],
            [2352, 9714],
            [2360, 9710],
            [2334, 9698],
            [2313, 9695]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.49,
      "hc-key": "tz",
      "hc-a2": "TZ",
      "name": "United Republic of Tanzania",
      "labelrank": "3",
      "country-abbrev": "Tanz.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "TZA",
      "iso-a2": "TZ",
      "woe-id": "23424973",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5292, 6728],
            [5295, 6734],
            [5302, 6717],
            [5299, 6707],
            [5291, 6717],
            [5292, 6728]
          ]
        ],
        [
          [
            [5148, 6516],
            [5148, 6518],
            [5146, 6521],
            [5146, 6522],
            [5142, 6524],
            [5141, 6527],
            [5141, 6527],
            [5140, 6528],
            [5136, 6536],
            [5139, 6549],
            [5134, 6576],
            [5128, 6585],
            [5124, 6589],
            [5124, 6589],
            [5124, 6589],
            [5121, 6592],
            [5121, 6592],
            [5121, 6592],
            [5116, 6591],
            [5115, 6585],
            [5110, 6590],
            [5099, 6589],
            [5083, 6596],
            [5066, 6606],
            [5052, 6609],
            [5038, 6622],
            [5026, 6627],
            [5018, 6648],
            [5008, 6667],
            [5008, 6688],
            [4994, 6706],
            [4988, 6704],
            [4981, 6721],
            [4988, 6726],
            [4981, 6744],
            [4984, 6755],
            [4977, 6769],
            [4979, 6781],
            [4990, 6787],
            [5005, 6814],
            [5018, 6826],
            [5015, 6835],
            [5005, 6841],
            [5009, 6857],
            [5018, 6859],
            [5019, 6887],
            [5010, 6897],
            [5007, 6907],
            [5019, 6909],
            [5050, 6909],
            [5050, 6907],
            [5051, 6909],
            [5052, 6909],
            [5045, 6859],
            [5051, 6867],
            [5062, 6858],
            [5083, 6854],
            [5090, 6858],
            [5096, 6853],
            [5117, 6864],
            [5095, 6866],
            [5085, 6870],
            [5091, 6873],
            [5106, 6871],
            [5108, 6884],
            [5125, 6907],
            [5242, 6833],
            [5240, 6819],
            [5246, 6810],
            [5292, 6772],
            [5290, 6757],
            [5280, 6730],
            [5280, 6710],
            [5300, 6691],
            [5302, 6681],
            [5295, 6674],
            [5294, 6656],
            [5313, 6658],
            [5307, 6645],
            [5298, 6648],
            [5292, 6637],
            [5294, 6622],
            [5308, 6581],
            [5305, 6576],
            [5322, 6567],
            [5328, 6556],
            [5314, 6544],
            [5297, 6537],
            [5289, 6531],
            [5277, 6531],
            [5263, 6522],
            [5251, 6528],
            [5243, 6525],
            [5241, 6517],
            [5230, 6510],
            [5215, 6516],
            [5206, 6512],
            [5188, 6511],
            [5176, 6522],
            [5168, 6514],
            [5148, 6516]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.62,
      "hc-middle-y": 0.91,
      "hc-key": "cl",
      "hc-a2": "CL",
      "name": "Chile",
      "labelrank": "2",
      "country-abbrev": "Chile",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "CHL",
      "iso-a2": "CL",
      "woe-id": "23424782",
      "continent": "South America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [2178, 4907],
            [2162, 4903],
            [2153, 4908],
            [2138, 4906],
            [2130, 4917],
            [2155, 4916],
            [2178, 4907]
          ]
        ],
        [
          [
            [2022, 4941],
            [2008, 4945],
            [2010, 4954],
            [2039, 4946],
            [2040, 4936],
            [2028, 4943],
            [2022, 4941]
          ]
        ],
        [
          [
            [2058, 4942],
            [2045, 4945],
            [2039, 4954],
            [2047, 4964],
            [2058, 4942]
          ]
        ],
        [
          [
            [1941, 4976],
            [1921, 4987],
            [1915, 4994],
            [1935, 4985],
            [1955, 4980],
            [1970, 4972],
            [1956, 4973],
            [1943, 4982],
            [1941, 4976]
          ]
        ],
        [
          [
            [1898, 5022],
            [1889, 5030],
            [1891, 5034],
            [1903, 5026],
            [1916, 5034],
            [1921, 5028],
            [1918, 5022],
            [1908, 5026],
            [1898, 5022]
          ]
        ],
        [
          [
            [1888, 5066],
            [1877, 5079],
            [1888, 5075],
            [1897, 5066],
            [1894, 5059],
            [1898, 5049],
            [1891, 5049],
            [1891, 5041],
            [1880, 5033],
            [1877, 5045],
            [1885, 5044],
            [1894, 5056],
            [1881, 5050],
            [1883, 5057],
            [1873, 5064],
            [1888, 5066]
          ]
        ],
        [
          [
            [1869, 5082],
            [1871, 5076],
            [1862, 5064],
            [1855, 5086],
            [1871, 5088],
            [1869, 5082]
          ]
        ],
        [
          [
            [1843, 5134],
            [1839, 5127],
            [1830, 5129],
            [1841, 5141],
            [1843, 5134]
          ]
        ],
        [
          [
            [1826, 5170],
            [1820, 5174],
            [1830, 5177],
            [1837, 5171],
            [1855, 5139],
            [1845, 5142],
            [1828, 5162],
            [1826, 5170]
          ]
        ],
        [
          [
            [1834, 5140],
            [1823, 5143],
            [1824, 5164],
            [1841, 5143],
            [1834, 5140]
          ]
        ],
        [
          [
            [1833, 5260],
            [1834, 5248],
            [1826, 5255],
            [1827, 5261],
            [1818, 5268],
            [1819, 5260],
            [1812, 5263],
            [1826, 5277],
            [1834, 5269],
            [1833, 5260]
          ]
        ],
        [
          [
            [1823, 5289],
            [1826, 5293],
            [1832, 5283],
            [1829, 5279],
            [1805, 5288],
            [1796, 5288],
            [1790, 5279],
            [1785, 5283],
            [1793, 5293],
            [1823, 5289]
          ]
        ],
        [
          [
            [1962, 4964],
            [1972, 4971],
            [2004, 4956],
            [1999, 4950],
            [2007, 4944],
            [2004, 4937],
            [1997, 4946],
            [1990, 4944],
            [1981, 4954],
            [1976, 4945],
            [1971, 4960],
            [1962, 4964]
          ]
        ],
        [
          [
            [1800, 5371],
            [1807, 5367],
            [1798, 5363],
            [1809, 5356],
            [1814, 5345],
            [1808, 5344],
            [1810, 5334],
            [1794, 5336],
            [1788, 5340],
            [1790, 5360],
            [1785, 5369],
            [1783, 5387],
            [1795, 5392],
            [1807, 5373],
            [1800, 5371]
          ]
        ],
        [
          [
            [1805, 5301],
            [1817, 5314],
            [1823, 5310],
            [1819, 5293],
            [1802, 5294],
            [1805, 5301]
          ]
        ],
        [
          [
            [1853, 5125],
            [1845, 5136],
            [1858, 5139],
            [1871, 5113],
            [1878, 5094],
            [1868, 5091],
            [1864, 5107],
            [1856, 5109],
            [1857, 5095],
            [1841, 5105],
            [1850, 5105],
            [1840, 5112],
            [1842, 5118],
            [1857, 5115],
            [1853, 5125]
          ]
        ],
        [
          [
            [2085, 4913],
            [2087, 4918],
            [2114, 4915],
            [2124, 4916],
            [2122, 4909],
            [2135, 4905],
            [2147, 4893],
            [2163, 4894],
            [2172, 4884],
            [2156, 4882],
            [2138, 4895],
            [2117, 4899],
            [2114, 4905],
            [2100, 4906],
            [2112, 4897],
            [2094, 4900],
            [2085, 4913]
          ]
        ],
        [
          [
            [2083, 4997],
            [2116, 4921],
            [2114, 4922],
            [2116, 4921],
            [2117, 4918],
            [2105, 4916],
            [2087, 4922],
            [2068, 4913],
            [2055, 4912],
            [2059, 4919],
            [2037, 4931],
            [2020, 4926],
            [2018, 4933],
            [2031, 4930],
            [2034, 4936],
            [2047, 4933],
            [2042, 4945],
            [2062, 4938],
            [2072, 4939],
            [2101, 4934],
            [2066, 4946],
            [2058, 4958],
            [2076, 4966],
            [2074, 4972],
            [2052, 4968],
            [2042, 4974],
            [2039, 4984],
            [2054, 4993],
            [2058, 5004],
            [2070, 4996],
            [2078, 5001],
            [2083, 4997]
          ]
        ],
        [
          [
            [1724, 6264],
            [1737, 6267],
            [1742, 6277],
            [1739, 6286],
            [1750, 6295],
            [1763, 6271],
            [1772, 6241],
            [1791, 6223],
            [1784, 6211],
            [1789, 6200],
            [1783, 6198],
            [1785, 6186],
            [1795, 6179],
            [1793, 6169],
            [1806, 6154],
            [1812, 6129],
            [1822, 6107],
            [1822, 6097],
            [1833, 6094],
            [1845, 6097],
            [1851, 6090],
            [1845, 6053],
            [1818, 6039],
            [1809, 6024],
            [1817, 6012],
            [1811, 5999],
            [1821, 5973],
            [1818, 5958],
            [1828, 5945],
            [1821, 5935],
            [1813, 5937],
            [1806, 5906],
            [1795, 5889],
            [1794, 5863],
            [1788, 5853],
            [1796, 5837],
            [1799, 5817],
            [1792, 5816],
            [1790, 5800],
            [1793, 5791],
            [1786, 5785],
            [1787, 5771],
            [1816, 5723],
            [1819, 5707],
            [1827, 5704],
            [1826, 5693],
            [1833, 5672],
            [1826, 5670],
            [1823, 5659],
            [1824, 5637],
            [1819, 5635],
            [1826, 5624],
            [1832, 5603],
            [1824, 5595],
            [1825, 5590],
            [1815, 5587],
            [1815, 5569],
            [1823, 5541],
            [1832, 5527],
            [1842, 5504],
            [1828, 5494],
            [1832, 5469],
            [1827, 5471],
            [1833, 5458],
            [1832, 5457],
            [1832, 5457],
            [1830, 5450],
            [1835, 5446],
            [1831, 5431],
            [1837, 5423],
            [1843, 5398],
            [1854, 5382],
            [1844, 5375],
            [1853, 5349],
            [1867, 5342],
            [1865, 5332],
            [1873, 5327],
            [1879, 5315],
            [1875, 5309],
            [1880, 5298],
            [1898, 5297],
            [1900, 5284],
            [1878, 5285],
            [1879, 5280],
            [1894, 5277],
            [1906, 5263],
            [1897, 5247],
            [1906, 5238],
            [1899, 5232],
            [1905, 5228],
            [1913, 5212],
            [1907, 5208],
            [1910, 5194],
            [1904, 5168],
            [1917, 5152],
            [1911, 5148],
            [1915, 5136],
            [1906, 5129],
            [1906, 5117],
            [1897, 5117],
            [1897, 5109],
            [1904, 5100],
            [1908, 5087],
            [1914, 5083],
            [1927, 5065],
            [1936, 5070],
            [1950, 5069],
            [1960, 5047],
            [1960, 5036],
            [1981, 5020],
            [2037, 5020],
            [2082, 5010],
            [2082, 5010],
            [2082, 5010],
            [2082, 5010],
            [2083, 5009],
            [2084, 5008],
            [2063, 5013],
            [2054, 5010],
            [2053, 5001],
            [2047, 5003],
            [2026, 4994],
            [2027, 4977],
            [2034, 4956],
            [2029, 4953],
            [2003, 4960],
            [1991, 4968],
            [1991, 4976],
            [2001, 4971],
            [2002, 4976],
            [2014, 4980],
            [2015, 4991],
            [2010, 4991],
            [1996, 4980],
            [1984, 4975],
            [1993, 4965],
            [1961, 4979],
            [1971, 4979],
            [1965, 4990],
            [1976, 4990],
            [1985, 4997],
            [2004, 4997],
            [2000, 5000],
            [1978, 5001],
            [1964, 4990],
            [1963, 4981],
            [1950, 4997],
            [1946, 4993],
            [1943, 5004],
            [1931, 5018],
            [1946, 5012],
            [1954, 5022],
            [1965, 5023],
            [1945, 5030],
            [1951, 5025],
            [1945, 5014],
            [1937, 5018],
            [1928, 5031],
            [1924, 5027],
            [1914, 5045],
            [1928, 5033],
            [1917, 5049],
            [1906, 5049],
            [1899, 5058],
            [1912, 5057],
            [1909, 5067],
            [1917, 5068],
            [1907, 5073],
            [1906, 5062],
            [1900, 5064],
            [1891, 5076],
            [1876, 5084],
            [1883, 5089],
            [1878, 5106],
            [1865, 5127],
            [1860, 5142],
            [1864, 5147],
            [1857, 5157],
            [1845, 5164],
            [1870, 5164],
            [1874, 5172],
            [1845, 5172],
            [1838, 5175],
            [1843, 5193],
            [1852, 5200],
            [1839, 5209],
            [1828, 5205],
            [1817, 5210],
            [1814, 5218],
            [1804, 5203],
            [1795, 5214],
            [1807, 5230],
            [1814, 5232],
            [1814, 5243],
            [1829, 5245],
            [1850, 5226],
            [1843, 5257],
            [1850, 5263],
            [1841, 5278],
            [1844, 5279],
            [1834, 5290],
            [1841, 5290],
            [1837, 5299],
            [1844, 5300],
            [1855, 5294],
            [1854, 5287],
            [1844, 5279],
            [1858, 5285],
            [1855, 5295],
            [1834, 5306],
            [1837, 5327],
            [1830, 5332],
            [1835, 5348],
            [1824, 5376],
            [1831, 5382],
            [1817, 5388],
            [1822, 5395],
            [1810, 5403],
            [1806, 5392],
            [1789, 5394],
            [1774, 5422],
            [1776, 5438],
            [1772, 5457],
            [1779, 5474],
            [1773, 5489],
            [1758, 5515],
            [1757, 5528],
            [1747, 5540],
            [1744, 5561],
            [1755, 5561],
            [1758, 5579],
            [1756, 5606],
            [1761, 5613],
            [1757, 5622],
            [1766, 5639],
            [1767, 5656],
            [1764, 5675],
            [1771, 5698],
            [1763, 5714],
            [1768, 5718],
            [1768, 5742],
            [1762, 5748],
            [1761, 5759],
            [1750, 5786],
            [1745, 5807],
            [1744, 5820],
            [1749, 5819],
            [1753, 5832],
            [1746, 5856],
            [1739, 5869],
            [1746, 5889],
            [1745, 5907],
            [1750, 5918],
            [1745, 5935],
            [1750, 5941],
            [1749, 5979],
            [1745, 5985],
            [1751, 6001],
            [1745, 6026],
            [1743, 6061],
            [1744, 6071],
            [1737, 6071],
            [1737, 6086],
            [1744, 6089],
            [1747, 6148],
            [1742, 6164],
            [1737, 6212],
            [1731, 6228],
            [1724, 6264]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CV",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.64,
      "hc-key": "cv",
      "hc-a2": "CV",
      "name": "Cape Verde",
      "labelrank": "4",
      "country-abbrev": "C.Vd.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "CPV",
      "iso-a2": "CV",
      "woe-id": "23424794",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3241, 7505],
          [3231, 7506],
          [3232, 7517],
          [3239, 7510],
          [3252, 7513],
          [3241, 7505]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "DM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.48,
      "hc-key": "dm",
      "hc-a2": "DM",
      "name": "Dominica",
      "labelrank": "6",
      "country-abbrev": "D'inca",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "DMA",
      "iso-a2": "DM",
      "woe-id": "23424798",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2007, 7527],
          [2011, 7520],
          [2007, 7513],
          [2004, 7523],
          [2007, 7527]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SC",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.59,
      "hc-middle-y": 0.79,
      "hc-key": "sc",
      "hc-a2": "SC",
      "name": "Seychelles",
      "labelrank": "6",
      "country-abbrev": "Syc.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SYC",
      "iso-a2": "SC",
      "woe-id": "23424941",
      "continent": "Seven seas (open ocean)"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5526, 6599],
          [5526, 6596],
          [5519, 6595],
          [5526, 6597],
          [5526, 6599]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.19,
      "hc-middle-y": 0.84,
      "hc-key": "nz",
      "hc-a2": "NZ",
      "name": "New Zealand",
      "labelrank": "2",
      "country-abbrev": "N.Z.",
      "subregion": "Australia and New Zealand",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "NZL",
      "iso-a2": "NZ",
      "woe-id": "23424916",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8894, 5209],
            [8905, 5212],
            [8899, 5197],
            [8886, 5196],
            [8894, 5209]
          ]
        ],
        [
          [
            [9077, 5303],
            [9064, 5292],
            [9046, 5271],
            [9013, 5248],
            [9012, 5242],
            [8996, 5238],
            [8987, 5231],
            [8957, 5216],
            [8937, 5213],
            [8935, 5217],
            [8920, 5215],
            [8923, 5224],
            [8911, 5223],
            [8913, 5230],
            [8884, 5229],
            [8882, 5237],
            [8889, 5244],
            [8901, 5245],
            [8902, 5253],
            [8933, 5277],
            [8961, 5291],
            [8996, 5311],
            [9010, 5313],
            [9029, 5321],
            [9051, 5328],
            [9081, 5345],
            [9097, 5350],
            [9127, 5368],
            [9153, 5391],
            [9169, 5397],
            [9188, 5412],
            [9198, 5425],
            [9227, 5438],
            [9219, 5430],
            [9228, 5428],
            [9216, 5410],
            [9238, 5417],
            [9249, 5424],
            [9241, 5412],
            [9253, 5422],
            [9262, 5421],
            [9250, 5409],
            [9241, 5405],
            [9234, 5390],
            [9196, 5367],
            [9174, 5350],
            [9149, 5339],
            [9141, 5329],
            [9147, 5325],
            [9142, 5318],
            [9125, 5322],
            [9116, 5317],
            [9077, 5303]
          ]
        ],
        [
          [
            [9383, 5467],
            [9367, 5457],
            [9345, 5440],
            [9331, 5432],
            [9310, 5416],
            [9295, 5407],
            [9272, 5398],
            [9276, 5406],
            [9266, 5406],
            [9272, 5412],
            [9262, 5410],
            [9295, 5433],
            [9309, 5447],
            [9312, 5455],
            [9301, 5461],
            [9299, 5469],
            [9289, 5477],
            [9293, 5484],
            [9328, 5499],
            [9350, 5526],
            [9362, 5539],
            [9374, 5582],
            [9379, 5583],
            [9387, 5599],
            [9375, 5601],
            [9372, 5595],
            [9367, 5635],
            [9375, 5645],
            [9370, 5663],
            [9384, 5666],
            [9378, 5649],
            [9381, 5645],
            [9397, 5643],
            [9396, 5635],
            [9403, 5633],
            [9405, 5621],
            [9393, 5606],
            [9397, 5595],
            [9384, 5574],
            [9394, 5570],
            [9392, 5562],
            [9398, 5561],
            [9402, 5573],
            [9409, 5582],
            [9409, 5597],
            [9419, 5594],
            [9411, 5587],
            [9410, 5576],
            [9417, 5578],
            [9409, 5562],
            [9406, 5544],
            [9417, 5534],
            [9436, 5530],
            [9464, 5547],
            [9477, 5540],
            [9464, 5530],
            [9449, 5510],
            [9433, 5503],
            [9421, 5488],
            [9408, 5490],
            [9393, 5484],
            [9383, 5476],
            [9383, 5467]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "YE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.47,
      "hc-key": "ye",
      "hc-a2": "YE",
      "name": "Yemen",
      "labelrank": "3",
      "country-abbrev": "Yem.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "YEM",
      "iso-a2": "YE",
      "woe-id": "23425002",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5754, 7420],
            [5771, 7419],
            [5784, 7414],
            [5773, 7406],
            [5760, 7405],
            [5747, 7413],
            [5754, 7420]
          ]
        ],
        [
          [
            [5687, 7654],
            [5716, 7591],
            [5729, 7566],
            [5712, 7559],
            [5701, 7542],
            [5704, 7528],
            [5677, 7514],
            [5648, 7505],
            [5639, 7499],
            [5620, 7495],
            [5604, 7487],
            [5592, 7469],
            [5570, 7470],
            [5551, 7455],
            [5528, 7447],
            [5500, 7445],
            [5487, 7433],
            [5478, 7429],
            [5476, 7422],
            [5459, 7423],
            [5455, 7418],
            [5440, 7416],
            [5424, 7425],
            [5416, 7439],
            [5415, 7463],
            [5400, 7459],
            [5397, 7468],
            [5410, 7471],
            [5407, 7488],
            [5395, 7526],
            [5398, 7539],
            [5395, 7556],
            [5408, 7572],
            [5405, 7576],
            [5405, 7592],
            [5413, 7599],
            [5424, 7593],
            [5453, 7596],
            [5470, 7596],
            [5479, 7591],
            [5508, 7588],
            [5521, 7590],
            [5530, 7578],
            [5544, 7583],
            [5549, 7597],
            [5565, 7622],
            [5596, 7640],
            [5687, 7654]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "JM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.54,
      "hc-key": "jm",
      "hc-a2": "JM",
      "name": "Jamaica",
      "labelrank": "4",
      "country-abbrev": "Jam.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "JAM",
      "iso-a2": "JM",
      "woe-id": "23424858",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1497, 7634],
          [1514, 7632],
          [1530, 7623],
          [1535, 7614],
          [1521, 7612],
          [1513, 7617],
          [1500, 7606],
          [1494, 7612],
          [1484, 7611],
          [1475, 7624],
          [1465, 7627],
          [1472, 7634],
          [1483, 7636],
          [1497, 7634]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "OM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.83,
      "hc-middle-y": 0.45,
      "hc-key": "om",
      "hc-a2": "OM",
      "name": "Oman",
      "labelrank": "4",
      "country-abbrev": "Oman",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "OMN",
      "iso-a2": "OM",
      "woe-id": "23424898",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5805, 7886],
            [5804, 7885],
            [5803, 7889],
            [5807, 7888],
            [5805, 7886]
          ]
        ],
        [
          [
            [5795, 7917],
            [5803, 7929],
            [5807, 7918],
            [5803, 7901],
            [5799, 7902],
            [5795, 7917]
          ]
        ],
        [
          [
            [5729, 7566],
            [5716, 7591],
            [5687, 7654],
            [5781, 7691],
            [5796, 7765],
            [5779, 7792],
            [5778, 7803],
            [5787, 7832],
            [5783, 7839],
            [5800, 7843],
            [5792, 7849],
            [5791, 7873],
            [5797, 7876],
            [5800, 7867],
            [5809, 7877],
            [5818, 7859],
            [5838, 7838],
            [5876, 7826],
            [5891, 7823],
            [5903, 7805],
            [5920, 7786],
            [5928, 7786],
            [5929, 7775],
            [5917, 7745],
            [5908, 7739],
            [5898, 7722],
            [5907, 7710],
            [5899, 7698],
            [5898, 7705],
            [5884, 7706],
            [5880, 7712],
            [5869, 7681],
            [5876, 7655],
            [5856, 7651],
            [5839, 7639],
            [5838, 7622],
            [5832, 7615],
            [5802, 7611],
            [5797, 7602],
            [5798, 7588],
            [5791, 7580],
            [5761, 7580],
            [5746, 7571],
            [5729, 7566]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "VC",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.50,
      "hc-key": "vc",
      "hc-a2": "VC",
      "name": "Saint Vincent and the Grenadines",
      "labelrank": "6",
      "country-abbrev": "St.V.G.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "VCT",
      "iso-a2": "VC",
      "woe-id": "23424981",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2007, 7432],
          [2005, 7439],
          [2009, 7445],
          [2009, 7438],
          [2007, 7432]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.81,
      "hc-middle-y": 0.67,
      "hc-key": "bd",
      "hc-a2": "BD",
      "name": "Bangladesh",
      "labelrank": "3",
      "country-abbrev": "Bang.",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "BGD",
      "iso-a2": "BD",
      "woe-id": "23424759",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [6921, 7770],
            [6923, 7776],
            [6919, 7795],
            [6927, 7782],
            [6928, 7771],
            [6920, 7761],
            [6921, 7770]
          ]
        ],
        [
          [
            [6872, 7764],
            [6873, 7766],
            [6871, 7771],
            [6860, 7802],
            [6862, 7810],
            [6854, 7812],
            [6846, 7827],
            [6850, 7837],
            [6849, 7851],
            [6840, 7852],
            [6824, 7864],
            [6828, 7875],
            [6832, 7873],
            [6834, 7885],
            [6850, 7884],
            [6843, 7896],
            [6835, 7896],
            [6818, 7911],
            [6826, 7932],
            [6839, 7923],
            [6846, 7924],
            [6864, 7913],
            [6866, 7923],
            [6874, 7912],
            [6876, 7891],
            [6896, 7883],
            [6923, 7885],
            [6930, 7883],
            [6949, 7884],
            [6965, 7875],
            [6958, 7869],
            [6956, 7855],
            [6934, 7844],
            [6930, 7826],
            [6938, 7807],
            [6943, 7810],
            [6948, 7801],
            [6954, 7806],
            [6951, 7813],
            [6962, 7830],
            [6971, 7813],
            [6973, 7800],
            [6979, 7792],
            [6985, 7765],
            [6991, 7740],
            [6981, 7745],
            [6977, 7735],
            [6980, 7731],
            [6984, 7719],
            [6965, 7747],
            [6965, 7761],
            [6956, 7781],
            [6945, 7795],
            [6939, 7790],
            [6939, 7774],
            [6936, 7783],
            [6919, 7801],
            [6914, 7793],
            [6920, 7782],
            [6919, 7773],
            [6909, 7758],
            [6904, 7761],
            [6896, 7776],
            [6899, 7762],
            [6890, 7757],
            [6887, 7764],
            [6879, 7753],
            [6872, 7763],
            [6872, 7764]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SB",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.63,
      "hc-middle-y": 0.67,
      "hc-key": "sb",
      "hc-a2": "SB",
      "name": "Solomon Islands",
      "labelrank": "3",
      "country-abbrev": "S. Is.",
      "subregion": "Melanesia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "SLB",
      "iso-a2": "SB",
      "woe-id": "23424766",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [9299, 6564],
            [9309, 6558],
            [9314, 6544],
            [9299, 6547],
            [9284, 6562],
            [9288, 6567],
            [9299, 6564]
          ]
        ],
        [
          [
            [9222, 6608],
            [9234, 6600],
            [9250, 6611],
            [9260, 6607],
            [9258, 6596],
            [9270, 6584],
            [9265, 6577],
            [9255, 6581],
            [9239, 6582],
            [9233, 6598],
            [9222, 6608]
          ]
        ],
        [
          [
            [9292, 6594],
            [9293, 6586],
            [9275, 6606],
            [9269, 6636],
            [9276, 6635],
            [9281, 6627],
            [9279, 6618],
            [9285, 6613],
            [9292, 6594]
          ]
        ],
        [
          [
            [9147, 6644],
            [9137, 6645],
            [9138, 6662],
            [9141, 6665],
            [9159, 6652],
            [9159, 6641],
            [9169, 6650],
            [9191, 6619],
            [9181, 6621],
            [9180, 6627],
            [9163, 6633],
            [9153, 6645],
            [9147, 6644]
          ]
        ],
        [
          [
            [9201, 6664],
            [9212, 6664],
            [9223, 6652],
            [9232, 6647],
            [9245, 6637],
            [9246, 6628],
            [9235, 6631],
            [9238, 6635],
            [9213, 6650],
            [9201, 6664]
          ]
        ],
        [
          [
            [9178, 6672],
            [9178, 6668],
            [9159, 6673],
            [9139, 6696],
            [9140, 6701],
            [9158, 6690],
            [9162, 6679],
            [9178, 6672]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LC",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.48,
      "hc-key": "lc",
      "hc-a2": "LC",
      "name": "Saint Lucia",
      "labelrank": "6",
      "country-abbrev": "S.L.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "LCA",
      "iso-a2": "LC",
      "woe-id": "23424951",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2017, 7457],
          [2013, 7463],
          [2018, 7472],
          [2019, 7466],
          [2017, 7457]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.12,
      "hc-middle-y": 0.91,
      "hc-key": "no",
      "hc-a2": "NO",
      "name": "Norway",
      "labelrank": "3",
      "country-abbrev": "Nor.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "NOR",
      "iso-a2": "NO",
      "woe-id": "-90",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4343, 9422],
            [4332, 9420],
            [4315, 9411],
            [4320, 9420],
            [4330, 9424],
            [4370, 9431],
            [4363, 9424],
            [4343, 9422]
          ]
        ],
        [
          [
            [4365, 9434],
            [4350, 9438],
            [4371, 9445],
            [4373, 9437],
            [4365, 9434]
          ]
        ],
        [
          [
            [4472, 9482],
            [4465, 9487],
            [4480, 9483],
            [4471, 9475],
            [4458, 9473],
            [4451, 9466],
            [4437, 9465],
            [4440, 9473],
            [4450, 9473],
            [4446, 9483],
            [4472, 9482]
          ]
        ],
        [
          [
            [4454, 9731],
            [4467, 9731],
            [4473, 9722],
            [4448, 9720],
            [4428, 9728],
            [4454, 9731]
          ]
        ],
        [
          [
            [4415, 9463],
            [4429, 9467],
            [4433, 9454],
            [4413, 9451],
            [4408, 9461],
            [4415, 9463]
          ]
        ],
        [
          [
            [4375, 9445],
            [4377, 9452],
            [4388, 9458],
            [4388, 9453],
            [4377, 9447],
            [4390, 9443],
            [4401, 9447],
            [4400, 9430],
            [4379, 9431],
            [4366, 9427],
            [4378, 9436],
            [4375, 9445]
          ]
        ],
        [
          [
            [4497, 9718],
            [4493, 9714],
            [4522, 9710],
            [4501, 9695],
            [4484, 9695],
            [4489, 9703],
            [4449, 9700],
            [4462, 9713],
            [4445, 9717],
            [4461, 9721],
            [4488, 9722],
            [4497, 9718]
          ]
        ],
        [
          [
            [4735, 9473],
            [4738, 9465],
            [4722, 9468],
            [4718, 9460],
            [4705, 9458],
            [4697, 9449],
            [4693, 9455],
            [4703, 9463],
            [4696, 9469],
            [4678, 9473],
            [4664, 9481],
            [4646, 9476],
            [4632, 9477],
            [4622, 9470],
            [4618, 9444],
            [4609, 9442],
            [4603, 9434],
            [4578, 9442],
            [4562, 9436],
            [4542, 9439],
            [4520, 9457],
            [4498, 9449],
            [4492, 9445],
            [4492, 9432],
            [4486, 9428],
            [4462, 9433],
            [4441, 9433],
            [4444, 9423],
            [4438, 9416],
            [4423, 9420],
            [4411, 9413],
            [4408, 9405],
            [4397, 9398],
            [4406, 9386],
            [4384, 9368],
            [4386, 9361],
            [4364, 9356],
            [4368, 9346],
            [4366, 9330],
            [4347, 9306],
            [4359, 9302],
            [4361, 9294],
            [4357, 9287],
            [4338, 9290],
            [4325, 9285],
            [4313, 9274],
            [4310, 9263],
            [4316, 9254],
            [4314, 9240],
            [4321, 9230],
            [4319, 9211],
            [4338, 9199],
            [4335, 9188],
            [4323, 9187],
            [4334, 9169],
            [4333, 9157],
            [4316, 9148],
            [4313, 9137],
            [4317, 9128],
            [4314, 9116],
            [4308, 9118],
            [4301, 9119],
            [4293, 9121],
            [4284, 9133],
            [4269, 9117],
            [4262, 9119],
            [4232, 9093],
            [4208, 9085],
            [4179, 9088],
            [4183, 9092],
            [4165, 9097],
            [4150, 9110],
            [4152, 9123],
            [4164, 9123],
            [4166, 9129],
            [4152, 9129],
            [4143, 9123],
            [4141, 9136],
            [4149, 9146],
            [4142, 9144],
            [4143, 9152],
            [4153, 9155],
            [4153, 9148],
            [4162, 9151],
            [4162, 9162],
            [4156, 9152],
            [4151, 9161],
            [4147, 9157],
            [4134, 9162],
            [4130, 9173],
            [4134, 9190],
            [4125, 9189],
            [4136, 9197],
            [4133, 9201],
            [4145, 9206],
            [4133, 9208],
            [4129, 9215],
            [4141, 9221],
            [4148, 9231],
            [4161, 9224],
            [4154, 9232],
            [4174, 9239],
            [4185, 9253],
            [4211, 9257],
            [4207, 9260],
            [4226, 9264],
            [4229, 9270],
            [4211, 9265],
            [4218, 9272],
            [4214, 9276],
            [4227, 9280],
            [4237, 9271],
            [4250, 9275],
            [4261, 9264],
            [4266, 9269],
            [4279, 9268],
            [4277, 9274],
            [4293, 9282],
            [4279, 9283],
            [4281, 9278],
            [4256, 9271],
            [4246, 9279],
            [4260, 9285],
            [4270, 9301],
            [4288, 9310],
            [4301, 9313],
            [4275, 9315],
            [4300, 9319],
            [4316, 9333],
            [4309, 9353],
            [4320, 9362],
            [4322, 9357],
            [4338, 9360],
            [4325, 9364],
            [4327, 9370],
            [4343, 9379],
            [4337, 9383],
            [4348, 9384],
            [4348, 9389],
            [4363, 9392],
            [4354, 9399],
            [4383, 9409],
            [4365, 9405],
            [4363, 9411],
            [4378, 9421],
            [4400, 9418],
            [4395, 9428],
            [4410, 9427],
            [4425, 9431],
            [4403, 9431],
            [4412, 9444],
            [4422, 9444],
            [4420, 9450],
            [4438, 9453],
            [4440, 9464],
            [4455, 9466],
            [4457, 9471],
            [4473, 9473],
            [4471, 9465],
            [4489, 9487],
            [4506, 9476],
            [4508, 9480],
            [4525, 9473],
            [4520, 9481],
            [4505, 9486],
            [4511, 9489],
            [4533, 9489],
            [4535, 9495],
            [4525, 9494],
            [4529, 9501],
            [4554, 9504],
            [4543, 9493],
            [4559, 9501],
            [4571, 9496],
            [4583, 9509],
            [4598, 9505],
            [4595, 9512],
            [4606, 9515],
            [4611, 9506],
            [4594, 9495],
            [4599, 9482],
            [4603, 9490],
            [4622, 9506],
            [4628, 9509],
            [4628, 9491],
            [4638, 9496],
            [4647, 9507],
            [4641, 9511],
            [4662, 9513],
            [4672, 9510],
            [4659, 9494],
            [4669, 9492],
            [4678, 9506],
            [4708, 9502],
            [4737, 9488],
            [4725, 9487],
            [4717, 9482],
            [4683, 9485],
            [4680, 9483],
            [4707, 9479],
            [4718, 9474],
            [4735, 9473]
          ]
        ],
        [
          [
            [4326, 9707],
            [4362, 9710],
            [4360, 9712],
            [4301, 9707],
            [4291, 9716],
            [4322, 9718],
            [4336, 9724],
            [4360, 9724],
            [4347, 9727],
            [4350, 9734],
            [4340, 9728],
            [4328, 9727],
            [4314, 9735],
            [4306, 9728],
            [4314, 9725],
            [4296, 9721],
            [4276, 9722],
            [4256, 9731],
            [4251, 9727],
            [4261, 9721],
            [4238, 9727],
            [4224, 9739],
            [4238, 9735],
            [4240, 9741],
            [4260, 9739],
            [4247, 9744],
            [4255, 9750],
            [4238, 9744],
            [4229, 9751],
            [4225, 9761],
            [4247, 9764],
            [4254, 9759],
            [4287, 9764],
            [4287, 9760],
            [4261, 9756],
            [4291, 9756],
            [4303, 9763],
            [4319, 9757],
            [4325, 9750],
            [4347, 9739],
            [4335, 9750],
            [4326, 9764],
            [4337, 9769],
            [4349, 9764],
            [4364, 9765],
            [4376, 9761],
            [4371, 9752],
            [4382, 9758],
            [4390, 9756],
            [4397, 9746],
            [4415, 9746],
            [4421, 9743],
            [4453, 9738],
            [4446, 9732],
            [4437, 9734],
            [4403, 9728],
            [4403, 9720],
            [4393, 9712],
            [4392, 9701],
            [4382, 9701],
            [4377, 9687],
            [4368, 9675],
            [4314, 9692],
            [4301, 9702],
            [4326, 9707]
          ]
        ],
        [
          [
            [4477, 9753],
            [4434, 9752],
            [4421, 9754],
            [4412, 9750],
            [4408, 9758],
            [4453, 9760],
            [4453, 9763],
            [4389, 9761],
            [4378, 9765],
            [4389, 9768],
            [4367, 9771],
            [4377, 9777],
            [4398, 9770],
            [4391, 9776],
            [4405, 9773],
            [4409, 9781],
            [4418, 9778],
            [4419, 9784],
            [4429, 9773],
            [4449, 9774],
            [4462, 9768],
            [4466, 9780],
            [4479, 9778],
            [4474, 9772],
            [4485, 9771],
            [4497, 9780],
            [4509, 9774],
            [4551, 9772],
            [4562, 9765],
            [4536, 9758],
            [4540, 9755],
            [4525, 9750],
            [4507, 9750],
            [4503, 9747],
            [4479, 9748],
            [4477, 9753]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.66,
      "hc-middle-y": 0.61,
      "hc-key": "cu",
      "hc-a2": "CU",
      "name": "Cuba",
      "labelrank": "3",
      "country-abbrev": "Cuba",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "CUB",
      "iso-a2": "CU",
      "woe-id": "23424793",
      "continent": "North America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1343, 7764],
            [1345, 7751],
            [1335, 7745],
            [1329, 7760],
            [1343, 7764]
          ]
        ],
        [
          [
            [1582, 7688],
            [1562, 7687],
            [1543, 7691],
            [1507, 7688],
            [1493, 7685],
            [1497, 7692],
            [1513, 7703],
            [1516, 7709],
            [1509, 7718],
            [1486, 7718],
            [1480, 7725],
            [1473, 7714],
            [1472, 7743],
            [1468, 7752],
            [1452, 7749],
            [1431, 7754],
            [1415, 7768],
            [1394, 7769],
            [1391, 7776],
            [1379, 7768],
            [1363, 7782],
            [1377, 7783],
            [1372, 7791],
            [1344, 7792],
            [1320, 7773],
            [1303, 7772],
            [1299, 7763],
            [1282, 7758],
            [1281, 7766],
            [1290, 7767],
            [1289, 7779],
            [1304, 7791],
            [1330, 7803],
            [1351, 7805],
            [1369, 7810],
            [1394, 7809],
            [1396, 7805],
            [1409, 7810],
            [1420, 7809],
            [1432, 7805],
            [1457, 7790],
            [1449, 7785],
            [1455, 7780],
            [1470, 7780],
            [1474, 7786],
            [1492, 7780],
            [1506, 7762],
            [1525, 7746],
            [1550, 7732],
            [1560, 7734],
            [1567, 7729],
            [1570, 7719],
            [1592, 7715],
            [1606, 7694],
            [1588, 7693],
            [1582, 7688]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.59,
      "hc-middle-y": 0.50,
      "hc-key": "kn",
      "hc-a2": "KN",
      "name": "Saint Kitts and Nevis",
      "labelrank": "6",
      "country-abbrev": "St.K.N.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "KNA",
      "iso-a2": "KN",
      "woe-id": "23424940",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1973, 7587],
          [1965, 7593],
          [1966, 7595],
          [1970, 7592],
          [1973, 7587]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.56,
      "hc-middle-y": 0.50,
      "hc-key": "bh",
      "hc-a2": "BH",
      "name": "Bahrain",
      "labelrank": "4",
      "country-abbrev": "Bahr.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "BHR",
      "iso-a2": "BH",
      "woe-id": "23424753",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5616, 7924],
          [5620, 7922],
          [5620, 7907],
          [5616, 7914],
          [5616, 7924]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "FI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.54,
      "hc-key": "fi",
      "hc-a2": "FI",
      "name": "Finland",
      "labelrank": "3",
      "country-abbrev": "Fin.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "FIN",
      "iso-a2": "FI",
      "woe-id": "23424812",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4537, 9157],
            [4536, 9153],
            [4523, 9155],
            [4531, 9165],
            [4537, 9157]
          ]
        ],
        [
          [
            [4603, 9347],
            [4590, 9359],
            [4586, 9366],
            [4593, 9378],
            [4580, 9390],
            [4583, 9398],
            [4575, 9400],
            [4577, 9415],
            [4564, 9421],
            [4554, 9429],
            [4536, 9432],
            [4498, 9449],
            [4520, 9457],
            [4542, 9439],
            [4562, 9436],
            [4578, 9442],
            [4603, 9434],
            [4609, 9442],
            [4618, 9444],
            [4622, 9470],
            [4632, 9477],
            [4646, 9476],
            [4664, 9481],
            [4678, 9473],
            [4696, 9469],
            [4703, 9463],
            [4693, 9455],
            [4697, 9449],
            [4685, 9445],
            [4695, 9443],
            [4689, 9433],
            [4696, 9423],
            [4714, 9419],
            [4733, 9407],
            [4732, 9401],
            [4716, 9384],
            [4717, 9379],
            [4743, 9356],
            [4752, 9341],
            [4742, 9340],
            [4749, 9326],
            [4744, 9319],
            [4762, 9308],
            [4760, 9300],
            [4774, 9294],
            [4776, 9288],
            [4764, 9278],
            [4778, 9269],
            [4799, 9261],
            [4811, 9251],
            [4806, 9237],
            [4793, 9227],
            [4763, 9195],
            [4753, 9190],
            [4731, 9171],
            [4724, 9168],
            [4715, 9172],
            [4683, 9161],
            [4665, 9161],
            [4629, 9151],
            [4604, 9155],
            [4597, 9148],
            [4593, 9158],
            [4575, 9165],
            [4573, 9170],
            [4556, 9169],
            [4564, 9176],
            [4558, 9189],
            [4563, 9189],
            [4561, 9209],
            [4552, 9220],
            [4552, 9232],
            [4547, 9234],
            [4545, 9252],
            [4548, 9261],
            [4573, 9264],
            [4575, 9276],
            [4600, 9290],
            [4624, 9315],
            [4626, 9322],
            [4636, 9314],
            [4641, 9318],
            [4634, 9324],
            [4634, 9336],
            [4603, 9347]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ID",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.39,
      "hc-middle-y": 0.38,
      "hc-key": "id",
      "hc-a2": "ID",
      "name": "Indonesia",
      "labelrank": "2",
      "country-abbrev": "Indo.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "IDN",
      "iso-a2": "ID",
      "woe-id": "23424846",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8042, 6553],
            [8036, 6544],
            [8023, 6540],
            [8043, 6558],
            [8042, 6553]
          ]
        ],
        [
          [
            [7936, 6598],
            [7944, 6587],
            [7950, 6588],
            [7960, 6571],
            [7948, 6563],
            [7938, 6566],
            [7933, 6575],
            [7922, 6583],
            [7903, 6586],
            [7900, 6591],
            [7912, 6598],
            [7936, 6598]
          ]
        ],
        [
          [
            [7832, 6634],
            [7823, 6619],
            [7813, 6614],
            [7801, 6618],
            [7808, 6621],
            [7808, 6632],
            [7821, 6641],
            [7832, 6634]
          ]
        ],
        [
          [
            [8047, 6634],
            [8037, 6630],
            [8042, 6639],
            [8068, 6640],
            [8050, 6627],
            [8047, 6634]
          ]
        ],
        [
          [
            [8077, 6634],
            [8079, 6642],
            [8106, 6643],
            [8106, 6635],
            [8083, 6631],
            [8077, 6634]
          ]
        ],
        [
          [
            [7793, 6624],
            [7784, 6625],
            [7781, 6618],
            [7772, 6631],
            [7763, 6634],
            [7757, 6645],
            [7770, 6641],
            [7782, 6647],
            [7797, 6636],
            [7793, 6624]
          ]
        ],
        [
          [
            [8161, 6661],
            [8152, 6650],
            [8138, 6653],
            [8129, 6648],
            [8136, 6661],
            [8148, 6660],
            [8158, 6665],
            [8161, 6661]
          ]
        ],
        [
          [
            [8555, 6643],
            [8558, 6634],
            [8524, 6635],
            [8517, 6633],
            [8531, 6662],
            [8539, 6669],
            [8558, 6672],
            [8566, 6664],
            [8555, 6643]
          ]
        ],
        [
          [
            [8327, 6682],
            [8322, 6663],
            [8305, 6643],
            [8296, 6639],
            [8304, 6649],
            [8306, 6663],
            [8320, 6680],
            [8327, 6682]
          ]
        ],
        [
          [
            [7754, 6683],
            [7742, 6684],
            [7730, 6677],
            [7703, 6680],
            [7708, 6690],
            [7745, 6690],
            [7754, 6683]
          ]
        ],
        [
          [
            [8414, 6710],
            [8427, 6704],
            [8408, 6689],
            [8404, 6695],
            [8408, 6717],
            [8414, 6710]
          ]
        ],
        [
          [
            [8363, 6725],
            [8359, 6738],
            [8376, 6738],
            [8366, 6723],
            [8363, 6725]
          ]
        ],
        [
          [
            [8013, 6744],
            [8005, 6751],
            [8011, 6758],
            [8020, 6748],
            [8025, 6758],
            [8025, 6770],
            [8037, 6774],
            [8038, 6762],
            [8029, 6744],
            [8013, 6744]
          ]
        ],
        [
          [
            [8052, 6772],
            [8047, 6770],
            [8043, 6754],
            [8051, 6750],
            [8043, 6746],
            [8037, 6735],
            [8030, 6741],
            [8035, 6751],
            [8043, 6780],
            [8047, 6783],
            [8052, 6772]
          ]
        ],
        [
          [
            [7831, 6821],
            [7827, 6802],
            [7821, 6796],
            [7818, 6808],
            [7822, 6823],
            [7831, 6821]
          ]
        ],
        [
          [
            [8175, 6831],
            [8188, 6821],
            [8187, 6812],
            [8170, 6803],
            [8152, 6812],
            [8147, 6828],
            [8161, 6832],
            [8175, 6831]
          ]
        ],
        [
          [
            [7538, 6838],
            [7545, 6851],
            [7558, 6850],
            [7565, 6840],
            [7562, 6830],
            [7543, 6826],
            [7542, 6838],
            [7538, 6838]
          ]
        ],
        [
          [
            [7300, 6843],
            [7307, 6834],
            [7303, 6830],
            [7299, 6843],
            [7293, 6841],
            [7292, 6854],
            [7300, 6843]
          ]
        ],
        [
          [
            [8146, 6873],
            [8150, 6855],
            [8143, 6869],
            [8127, 6879],
            [8160, 6879],
            [8146, 6873]
          ]
        ],
        [
          [
            [8292, 6883],
            [8294, 6878],
            [8284, 6870],
            [8270, 6876],
            [8292, 6883]
          ]
        ],
        [
          [
            [8095, 6872],
            [8095, 6884],
            [8103, 6886],
            [8126, 6880],
            [8126, 6876],
            [8095, 6872]
          ]
        ],
        [
          [
            [8460, 6887],
            [8500, 6882],
            [8506, 6879],
            [8486, 6875],
            [8461, 6884],
            [8460, 6887]
          ]
        ],
        [
          [
            [8068, 6891],
            [8079, 6870],
            [8066, 6883],
            [8066, 6890],
            [8058, 6890],
            [8060, 6880],
            [8052, 6876],
            [8055, 6898],
            [8046, 6888],
            [8047, 6903],
            [8057, 6904],
            [8068, 6899],
            [8068, 6891]
          ]
        ],
        [
          [
            [7258, 6912],
            [7269, 6881],
            [7257, 6884],
            [7247, 6902],
            [7249, 6910],
            [7258, 6912]
          ]
        ],
        [
          [
            [8307, 6914],
            [8311, 6917],
            [8316, 6906],
            [8313, 6897],
            [8303, 6905],
            [8307, 6914]
          ]
        ],
        [
          [
            [8459, 6922],
            [8474, 6920],
            [8484, 6907],
            [8482, 6901],
            [8472, 6905],
            [8459, 6922]
          ]
        ],
        [
          [
            [8192, 6917],
            [8187, 6918],
            [8186, 6936],
            [8192, 6928],
            [8199, 6935],
            [8205, 6929],
            [8202, 6919],
            [8192, 6917]
          ]
        ],
        [
          [
            [8303, 6929],
            [8295, 6943],
            [8308, 6946],
            [8323, 6941],
            [8321, 6932],
            [8303, 6929]
          ]
        ],
        [
          [
            [7445, 6929],
            [7437, 6922],
            [7434, 6929],
            [7443, 6947],
            [7451, 6940],
            [7443, 6936],
            [7445, 6929]
          ]
        ],
        [
          [
            [7434, 6978],
            [7428, 6983],
            [7419, 6980],
            [7426, 6991],
            [7438, 6991],
            [7452, 6985],
            [7434, 6978]
          ]
        ],
        [
          [
            [7207, 7003],
            [7226, 6983],
            [7224, 6970],
            [7218, 6968],
            [7215, 6977],
            [7208, 6982],
            [7197, 6999],
            [7207, 7003]
          ]
        ],
        [
          [
            [8219, 7032],
            [8232, 7045],
            [8236, 7039],
            [8230, 7023],
            [8223, 7022],
            [8219, 7032]
          ]
        ],
        [
          [
            [7158, 7055],
            [7177, 7035],
            [7175, 7034],
            [7151, 7050],
            [7158, 7055]
          ]
        ],
        [
          [
            [7564, 7099],
            [7565, 7084],
            [7553, 7096],
            [7561, 7105],
            [7564, 7099]
          ]
        ],
        [
          [
            [7513, 6836],
            [7525, 6838],
            [7514, 6832],
            [7489, 6841],
            [7483, 6866],
            [7467, 6867],
            [7463, 6874],
            [7469, 6885],
            [7487, 6891],
            [7492, 6888],
            [7502, 6855],
            [7517, 6851],
            [7509, 6838],
            [7513, 6836]
          ]
        ],
        [
          [
            [8414, 6716],
            [8414, 6726],
            [8421, 6744],
            [8430, 6735],
            [8426, 6711],
            [8414, 6711],
            [8414, 6716]
          ]
        ],
        [
          [
            [8195, 6893],
            [8205, 6901],
            [8219, 6886],
            [8199, 6882],
            [8195, 6893]
          ]
        ],
        [
          [
            [7858, 6635],
            [7857, 6642],
            [7878, 6644],
            [7883, 6635],
            [7888, 6639],
            [7896, 6635],
            [7906, 6637],
            [7906, 6625],
            [7887, 6616],
            [7885, 6624],
            [7877, 6616],
            [7862, 6615],
            [7838, 6607],
            [7831, 6611],
            [7834, 6630],
            [7847, 6635],
            [7858, 6635]
          ]
        ],
        [
          [
            [7920, 6621],
            [7919, 6632],
            [7927, 6624],
            [7945, 6638],
            [7971, 6636],
            [7987, 6626],
            [7995, 6635],
            [8005, 6633],
            [8013, 6625],
            [8035, 6641],
            [8030, 6626],
            [8007, 6621],
            [7995, 6616],
            [7983, 6619],
            [7981, 6614],
            [7967, 6614],
            [7956, 6619],
            [7942, 6620],
            [7934, 6616],
            [7920, 6621]
          ]
        ],
        [
          [
            [8101, 6593],
            [8097, 6587],
            [8079, 6569],
            [8068, 6568],
            [8057, 6560],
            [8048, 6562],
            [8055, 6588],
            [8068, 6599],
            [8075, 6593],
            [8082, 6605],
            [8086, 6605],
            [8098, 6613],
            [8105, 6605],
            [8099, 6604],
            [8101, 6593]
          ]
        ],
        [
          [
            [7879, 7101],
            [7869, 7098],
            [7872, 7102],
            [7879, 7101]
          ]
        ],
        [
          [
            [7375, 6986],
            [7375, 6989],
            [7380, 6985],
            [7383, 6990],
            [7394, 6985],
            [7395, 6975],
            [7378, 6976],
            [7373, 6979],
            [7374, 6983],
            [7367, 6987],
            [7366, 6999],
            [7361, 7007],
            [7375, 7002],
            [7375, 6993],
            [7375, 6986]
          ]
        ],
        [
          [
            [8624, 6607],
            [8593, 6645],
            [8575, 6641],
            [8569, 6645],
            [8559, 6638],
            [8567, 6665],
            [8554, 6679],
            [8570, 6677],
            [8552, 6688],
            [8559, 6698],
            [8549, 6708],
            [8544, 6726],
            [8531, 6751],
            [8500, 6763],
            [8471, 6779],
            [8448, 6780],
            [8419, 6802],
            [8418, 6797],
            [8407, 6803],
            [8397, 6817],
            [8383, 6795],
            [8372, 6794],
            [8367, 6809],
            [8374, 6814],
            [8370, 6824],
            [8355, 6837],
            [8344, 6838],
            [8350, 6847],
            [8368, 6842],
            [8383, 6856],
            [8404, 6848],
            [8410, 6857],
            [8404, 6862],
            [8388, 6864],
            [8368, 6861],
            [8356, 6862],
            [8348, 6868],
            [8339, 6887],
            [8325, 6895],
            [8312, 6892],
            [8322, 6906],
            [8321, 6916],
            [8342, 6921],
            [8350, 6929],
            [8370, 6933],
            [8384, 6927],
            [8392, 6920],
            [8411, 6920],
            [8421, 6896],
            [8414, 6884],
            [8415, 6867],
            [8425, 6840],
            [8429, 6855],
            [8433, 6836],
            [8442, 6823],
            [8453, 6820],
            [8473, 6835],
            [8475, 6843],
            [8485, 6851],
            [8489, 6863],
            [8501, 6863],
            [8516, 6868],
            [8514, 6880],
            [8538, 6892],
            [8565, 6880],
            [8570, 6874],
            [8604, 6858],
            [8613, 6860],
            [8640, 6850],
            [8636, 6775],
            [8632, 6711],
            [8627, 6697],
            [8631, 6690],
            [8624, 6607]
          ]
        ],
        [
          [
            [7224, 7116],
            [7234, 7111],
            [7233, 7102],
            [7257, 7083],
            [7284, 7065],
            [7291, 7056],
            [7291, 7047],
            [7299, 7047],
            [7305, 7034],
            [7324, 7017],
            [7319, 7029],
            [7328, 7029],
            [7339, 7018],
            [7347, 7026],
            [7351, 7019],
            [7345, 7008],
            [7351, 7008],
            [7363, 6998],
            [7366, 6985],
            [7378, 6974],
            [7395, 6970],
            [7400, 6965],
            [7406, 6983],
            [7409, 6975],
            [7404, 6967],
            [7418, 6955],
            [7419, 6946],
            [7406, 6938],
            [7417, 6934],
            [7406, 6927],
            [7405, 6919],
            [7418, 6909],
            [7438, 6908],
            [7442, 6877],
            [7453, 6871],
            [7453, 6861],
            [7478, 6857],
            [7483, 6840],
            [7491, 6834],
            [7491, 6825],
            [7483, 6810],
            [7487, 6804],
            [7481, 6789],
            [7484, 6780],
            [7480, 6736],
            [7472, 6730],
            [7463, 6743],
            [7459, 6732],
            [7449, 6735],
            [7443, 6726],
            [7429, 6736],
            [7418, 6755],
            [7386, 6779],
            [7367, 6798],
            [7364, 6811],
            [7345, 6826],
            [7335, 6846],
            [7329, 6850],
            [7320, 6866],
            [7321, 6876],
            [7312, 6897],
            [7306, 6904],
            [7304, 6916],
            [7288, 6935],
            [7286, 6945],
            [7272, 6955],
            [7241, 6946],
            [7245, 6952],
            [7266, 6956],
            [7264, 6969],
            [7245, 7019],
            [7226, 7031],
            [7219, 7031],
            [7205, 7022],
            [7205, 7028],
            [7216, 7036],
            [7213, 7053],
            [7185, 7086],
            [7174, 7089],
            [7139, 7126],
            [7131, 7144],
            [7131, 7154],
            [7138, 7157],
            [7153, 7152],
            [7160, 7144],
            [7171, 7141],
            [7189, 7143],
            [7198, 7138],
            [7207, 7142],
            [7221, 7129],
            [7224, 7116]
          ]
        ],
        [
          [
            [7500, 6684],
            [7482, 6693],
            [7459, 6692],
            [7457, 6703],
            [7466, 6693],
            [7478, 6707],
            [7481, 6720],
            [7487, 6728],
            [7510, 6719],
            [7519, 6726],
            [7529, 6724],
            [7539, 6714],
            [7553, 6711],
            [7562, 6714],
            [7569, 6695],
            [7593, 6691],
            [7630, 6688],
            [7639, 6706],
            [7648, 6707],
            [7652, 6697],
            [7664, 6700],
            [7682, 6689],
            [7694, 6691],
            [7702, 6676],
            [7703, 6666],
            [7721, 6657],
            [7744, 6663],
            [7759, 6655],
            [7753, 6633],
            [7760, 6620],
            [7751, 6626],
            [7741, 6626],
            [7720, 6637],
            [7710, 6637],
            [7698, 6632],
            [7670, 6639],
            [7666, 6635],
            [7644, 6639],
            [7624, 6646],
            [7613, 6653],
            [7592, 6659],
            [7581, 6657],
            [7564, 6660],
            [7557, 6655],
            [7537, 6661],
            [7528, 6667],
            [7499, 6671],
            [7495, 6677],
            [7500, 6684]
          ]
        ],
        [
          [
            [8209, 6806],
            [8213, 6813],
            [8205, 6826],
            [8196, 6823],
            [8212, 6838],
            [8247, 6842],
            [8249, 6837],
            [8264, 6843],
            [8280, 6835],
            [8290, 6836],
            [8297, 6830],
            [8306, 6813],
            [8304, 6802],
            [8278, 6817],
            [8274, 6822],
            [8263, 6824],
            [8261, 6818],
            [8241, 6827],
            [8230, 6813],
            [8225, 6820],
            [8223, 6811],
            [8209, 6806]
          ]
        ],
        [
          [
            [8025, 6808],
            [8036, 6801],
            [8035, 6794],
            [8048, 6799],
            [8041, 6781],
            [8033, 6783],
            [8016, 6778],
            [8015, 6766],
            [8003, 6766],
            [7996, 6773],
            [8001, 6794],
            [7993, 6799],
            [7978, 6815],
            [7984, 6828],
            [7985, 6844],
            [7976, 6849],
            [7956, 6836],
            [7963, 6825],
            [7963, 6808],
            [7960, 6802],
            [7962, 6774],
            [7955, 6755],
            [7962, 6725],
            [7959, 6706],
            [7959, 6729],
            [7956, 6741],
            [7931, 6736],
            [7924, 6746],
            [7935, 6786],
            [7931, 6808],
            [7932, 6817],
            [7926, 6819],
            [7913, 6814],
            [7909, 6831],
            [7911, 6849],
            [7922, 6855],
            [7925, 6872],
            [7929, 6874],
            [7929, 6900],
            [7943, 6923],
            [7945, 6955],
            [7953, 6966],
            [7953, 6974],
            [7963, 6978],
            [7970, 6976],
            [7981, 6997],
            [7997, 6994],
            [8005, 6986],
            [8032, 6985],
            [8045, 6977],
            [8049, 6982],
            [8081, 6978],
            [8102, 6991],
            [8103, 6999],
            [8119, 7013],
            [8124, 6999],
            [8120, 6998],
            [8113, 6983],
            [8094, 6961],
            [8074, 6958],
            [8058, 6959],
            [8053, 6966],
            [8011, 6962],
            [8008, 6966],
            [7981, 6962],
            [7964, 6964],
            [7956, 6954],
            [7952, 6938],
            [7955, 6922],
            [7965, 6913],
            [7973, 6895],
            [7988, 6894],
            [8001, 6915],
            [8006, 6916],
            [8007, 6929],
            [8015, 6935],
            [8022, 6933],
            [8013, 6928],
            [8024, 6918],
            [8049, 6919],
            [8042, 6922],
            [8052, 6926],
            [8064, 6922],
            [8060, 6907],
            [8052, 6914],
            [8044, 6912],
            [8029, 6891],
            [8010, 6883],
            [8002, 6875],
            [7994, 6880],
            [8002, 6866],
            [8010, 6861],
            [8016, 6846],
            [8031, 6829],
            [8023, 6821],
            [8025, 6808]
          ]
        ],
        [
          [
            [8211, 6946],
            [8216, 6931],
            [8227, 6915],
            [8216, 6920],
            [8204, 6938],
            [8204, 6953],
            [8197, 6952],
            [8193, 6960],
            [8201, 6962],
            [8197, 6971],
            [8198, 6980],
            [8195, 6992],
            [8200, 7012],
            [8211, 7027],
            [8209, 7015],
            [8215, 7011],
            [8215, 6995],
            [8203, 6984],
            [8209, 6976],
            [8221, 6991],
            [8217, 6993],
            [8229, 7004],
            [8238, 7005],
            [8238, 6986],
            [8225, 6980],
            [8225, 6971],
            [8237, 6967],
            [8243, 6956],
            [8214, 6964],
            [8211, 6946]
          ]
        ],
        [
          [
            [7868, 7101],
            [7862, 7099],
            [7877, 7089],
            [7877, 7080],
            [7853, 7082],
            [7873, 7074],
            [7872, 7068],
            [7863, 7070],
            [7871, 7061],
            [7869, 7055],
            [7877, 7049],
            [7888, 7031],
            [7880, 7017],
            [7889, 7008],
            [7919, 6985],
            [7912, 6977],
            [7892, 6979],
            [7882, 6987],
            [7887, 6976],
            [7877, 6974],
            [7870, 6957],
            [7868, 6927],
            [7873, 6931],
            [7873, 6917],
            [7862, 6916],
            [7853, 6902],
            [7837, 6891],
            [7833, 6881],
            [7833, 6864],
            [7839, 6865],
            [7817, 6813],
            [7771, 6791],
            [7771, 6809],
            [7760, 6821],
            [7740, 6818],
            [7739, 6828],
            [7731, 6825],
            [7721, 6835],
            [7720, 6829],
            [7704, 6818],
            [7693, 6823],
            [7680, 6815],
            [7681, 6833],
            [7677, 6843],
            [7672, 6834],
            [7664, 6837],
            [7656, 6833],
            [7642, 6832],
            [7639, 6840],
            [7629, 6835],
            [7629, 6852],
            [7624, 6875],
            [7619, 6880],
            [7625, 6893],
            [7620, 6905],
            [7605, 6898],
            [7605, 6910],
            [7599, 6915],
            [7601, 6925],
            [7594, 6927],
            [7595, 6951],
            [7587, 6959],
            [7585, 6977],
            [7592, 7004],
            [7601, 7019],
            [7610, 7024],
            [7607, 7015],
            [7611, 7006],
            [7641, 6978],
            [7662, 6987],
            [7672, 6982],
            [7691, 6989],
            [7693, 7000],
            [7703, 7005],
            [7720, 7005],
            [7724, 7000],
            [7742, 6992],
            [7751, 7000],
            [7770, 7000],
            [7781, 7017],
            [7779, 7030],
            [7792, 7039],
            [7788, 7052],
            [7793, 7060],
            [7800, 7059],
            [7805, 7102],
            [7811, 7110],
            [7829, 7106],
            [7856, 7109],
            [7868, 7101]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.60,
      "hc-middle-y": 0.58,
      "hc-key": "mu",
      "hc-a2": "MU",
      "name": "Mauritius",
      "labelrank": "5",
      "country-abbrev": "Mus.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "MUS",
      "iso-a2": "MU",
      "woe-id": "23424894",
      "continent": "Seven seas (open ocean)"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5869, 6198],
          [5866, 6184],
          [5857, 6183],
          [5863, 6201],
          [5869, 6198]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.46,
      "hc-middle-y": 0.62,
      "hc-key": "se",
      "hc-a2": "SE",
      "name": "Sweden",
      "labelrank": "3",
      "country-abbrev": "Swe.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "SWE",
      "iso-a2": "SE",
      "woe-id": "23424954",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4464, 9061],
            [4453, 9023],
            [4450, 9035],
            [4457, 9046],
            [4464, 9061]
          ]
        ],
        [
          [
            [4514, 9081],
            [4509, 9075],
            [4514, 9063],
            [4501, 9054],
            [4499, 9047],
            [4492, 9058],
            [4492, 9068],
            [4507, 9081],
            [4514, 9081]
          ]
        ],
        [
          [
            [4498, 9449],
            [4536, 9432],
            [4554, 9429],
            [4564, 9421],
            [4577, 9415],
            [4575, 9400],
            [4583, 9398],
            [4580, 9390],
            [4593, 9378],
            [4586, 9366],
            [4590, 9359],
            [4603, 9347],
            [4584, 9347],
            [4578, 9343],
            [4558, 9346],
            [4561, 9334],
            [4539, 9333],
            [4545, 9329],
            [4535, 9309],
            [4548, 9302],
            [4533, 9291],
            [4530, 9283],
            [4514, 9276],
            [4505, 9268],
            [4498, 9272],
            [4490, 9260],
            [4477, 9260],
            [4477, 9250],
            [4467, 9245],
            [4462, 9237],
            [4449, 9237],
            [4456, 9227],
            [4449, 9205],
            [4451, 9187],
            [4466, 9170],
            [4473, 9173],
            [4490, 9158],
            [4506, 9149],
            [4494, 9121],
            [4488, 9122],
            [4455, 9105],
            [4456, 9095],
            [4448, 9091],
            [4454, 9080],
            [4445, 9080],
            [4453, 9066],
            [4450, 9062],
            [4448, 9037],
            [4445, 9037],
            [4436, 9017],
            [4428, 9020],
            [4406, 9020],
            [4392, 9008],
            [4397, 8998],
            [4393, 8993],
            [4371, 8991],
            [4360, 8993],
            [4357, 9006],
            [4344, 9024],
            [4354, 9030],
            [4353, 9037],
            [4338, 9046],
            [4329, 9065],
            [4319, 9074],
            [4320, 9088],
            [4313, 9082],
            [4310, 9089],
            [4316, 9098],
            [4304, 9096],
            [4301, 9119],
            [4301, 9121],
            [4308, 9118],
            [4314, 9116],
            [4317, 9128],
            [4313, 9137],
            [4316, 9148],
            [4333, 9157],
            [4334, 9169],
            [4323, 9187],
            [4335, 9188],
            [4338, 9199],
            [4319, 9211],
            [4321, 9230],
            [4314, 9240],
            [4316, 9254],
            [4310, 9263],
            [4313, 9274],
            [4325, 9285],
            [4338, 9290],
            [4357, 9287],
            [4361, 9294],
            [4359, 9302],
            [4347, 9306],
            [4366, 9330],
            [4368, 9346],
            [4364, 9356],
            [4386, 9361],
            [4384, 9368],
            [4406, 9386],
            [4397, 9398],
            [4408, 9405],
            [4411, 9413],
            [4423, 9420],
            [4438, 9416],
            [4444, 9423],
            [4441, 9433],
            [4462, 9433],
            [4486, 9428],
            [4492, 9432],
            [4492, 9445],
            [4498, 9449]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "RU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.86,
      "hc-middle-y": 0.49,
      "hc-key": "ru",
      "hc-a2": "RU",
      "name": "Russia",
      "labelrank": "2",
      "country-abbrev": "Rus.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "RUS",
      "iso-a2": "RU",
      "woe-id": "23424936",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8333, 8596],
            [8328, 8570],
            [8321, 8575],
            [8325, 8582],
            [8325, 8599],
            [8333, 8596]
          ]
        ],
        [
          [
            [8383, 8632],
            [8369, 8627],
            [8366, 8615],
            [8359, 8613],
            [8352, 8596],
            [8346, 8610],
            [8353, 8615],
            [8351, 8623],
            [8369, 8629],
            [8373, 8637],
            [8383, 8632]
          ]
        ],
        [
          [
            [8410, 8664],
            [8400, 8642],
            [8394, 8650],
            [8405, 8664],
            [8410, 8664]
          ]
        ],
        [
          [
            [8417, 8831],
            [8439, 8829],
            [8449, 8825],
            [8446, 8808],
            [8440, 8806],
            [8438, 8788],
            [8445, 8777],
            [8441, 8760],
            [8433, 8763],
            [8439, 8771],
            [8436, 8788],
            [8439, 8803],
            [8426, 8811],
            [8436, 8815],
            [8433, 8826],
            [8417, 8831]
          ]
        ],
        [
          [
            [7771, 8977],
            [7760, 8978],
            [7777, 8986],
            [7798, 8979],
            [7796, 8967],
            [7785, 8975],
            [7771, 8977]
          ]
        ],
        [
          [
            [8549, 8992],
            [8588, 8974],
            [8594, 8968],
            [8571, 8977],
            [8549, 8992]
          ]
        ],
        [
          [
            [8361, 9125],
            [8375, 9114],
            [8365, 9112],
            [8358, 9104],
            [8351, 9119],
            [8361, 9125]
          ]
        ],
        [
          [
            [5203, 9447],
            [5185, 9441],
            [5170, 9440],
            [5159, 9445],
            [5156, 9456],
            [5165, 9464],
            [5176, 9464],
            [5201, 9456],
            [5203, 9447]
          ]
        ],
        [
          [
            [8020, 9472],
            [8017, 9466],
            [7978, 9474],
            [7981, 9480],
            [8014, 9476],
            [8020, 9472]
          ]
        ],
        [
          [
            [5402, 9490],
            [5408, 9486],
            [5434, 9478],
            [5439, 9471],
            [5417, 9471],
            [5411, 9476],
            [5388, 9482],
            [5382, 9490],
            [5392, 9494],
            [5402, 9490]
          ]
        ],
        [
          [
            [8209, 9510],
            [8190, 9504],
            [8174, 9512],
            [8171, 9518],
            [8181, 9527],
            [8209, 9510]
          ]
        ],
        [
          [
            [-140, 9528],
            [-127, 9518],
            [-149, 9512],
            [-188, 9508],
            [-200, 9510],
            [-171, 9527],
            [-140, 9528]
          ]
        ],
        [
          [
            [5791, 9550],
            [5772, 9550],
            [5780, 9560],
            [5801, 9556],
            [5791, 9550]
          ]
        ],
        [
          [
            [5817, 9569],
            [5823, 9563],
            [5807, 9563],
            [5798, 9568],
            [5805, 9574],
            [5817, 9569]
          ]
        ],
        [
          [
            [5618, 9583],
            [5631, 9578],
            [5595, 9572],
            [5589, 9583],
            [5609, 9586],
            [5618, 9583]
          ]
        ],
        [
          [
            [5745, 9577],
            [5734, 9577],
            [5724, 9587],
            [5741, 9585],
            [5745, 9577]
          ]
        ],
        [
          [
            [7165, 9598],
            [7145, 9607],
            [7157, 9609],
            [7172, 9601],
            [7165, 9598]
          ]
        ],
        [
          [
            [6539, 9611],
            [6535, 9603],
            [6519, 9605],
            [6496, 9611],
            [6501, 9616],
            [6533, 9615],
            [6539, 9611]
          ]
        ],
        [
          [
            [5810, 9645],
            [5821, 9633],
            [5800, 9640],
            [5809, 9641],
            [5802, 9655],
            [5814, 9656],
            [5810, 9645]
          ]
        ],
        [
          [
            [5165, 9776],
            [5167, 9769],
            [5141, 9770],
            [5142, 9776],
            [5165, 9776]
          ]
        ],
        [
          [
            [5205, 9768],
            [5219, 9771],
            [5229, 9767],
            [5196, 9766],
            [5195, 9772],
            [5176, 9771],
            [5159, 9780],
            [5190, 9779],
            [5209, 9776],
            [5205, 9768]
          ]
        ],
        [
          [
            [5110, 9779],
            [5095, 9772],
            [5066, 9774],
            [5078, 9778],
            [5093, 9775],
            [5103, 9782],
            [5110, 9779]
          ]
        ],
        [
          [
            [5166, 9794],
            [5184, 9793],
            [5184, 9786],
            [5130, 9794],
            [5166, 9794]
          ]
        ],
        [
          [
            [5120, 9789],
            [5113, 9785],
            [5095, 9789],
            [5114, 9790],
            [5101, 9795],
            [5130, 9793],
            [5167, 9788],
            [5144, 9783],
            [5124, 9785],
            [5147, 9788],
            [5120, 9789]
          ]
        ],
        [
          [
            [5301, 9797],
            [5322, 9790],
            [5308, 9786],
            [5280, 9784],
            [5264, 9788],
            [5292, 9792],
            [5301, 9797]
          ]
        ],
        [
          [
            [5157, 9808],
            [5154, 9811],
            [5183, 9811],
            [5183, 9802],
            [5159, 9801],
            [5162, 9795],
            [5123, 9797],
            [5113, 9800],
            [5136, 9798],
            [5140, 9805],
            [5157, 9808]
          ]
        ],
        [
          [
            [7182, 9589],
            [7180, 9597],
            [7199, 9598],
            [7246, 9587],
            [7263, 9578],
            [7257, 9576],
            [7214, 9580],
            [7193, 9583],
            [7178, 9581],
            [7170, 9585],
            [7182, 9589]
          ]
        ],
        [
          [
            [5871, 9766],
            [5878, 9769],
            [5922, 9766],
            [5908, 9759],
            [5871, 9766]
          ]
        ],
        [
          [
            [4947, 9779],
            [4916, 9784],
            [4978, 9788],
            [4991, 9783],
            [4967, 9787],
            [4947, 9779]
          ]
        ],
        [
          [
            [7324, 9635],
            [7339, 9634],
            [7345, 9627],
            [7320, 9623],
            [7295, 9624],
            [7228, 9637],
            [7220, 9647],
            [7247, 9640],
            [7247, 9643],
            [7270, 9642],
            [7285, 9636],
            [7294, 9638],
            [7324, 9635]
          ]
        ],
        [
          [
            [6187, 9738],
            [6197, 9737],
            [6212, 9729],
            [6206, 9724],
            [6187, 9722],
            [6136, 9720],
            [6120, 9714],
            [6101, 9716],
            [6105, 9724],
            [6100, 9733],
            [6102, 9748],
            [6117, 9753],
            [6134, 9749],
            [6138, 9737],
            [6141, 9743],
            [6156, 9746],
            [6187, 9738]
          ]
        ],
        [
          [
            [7908, 8528],
            [7900, 8535],
            [7915, 8539],
            [7910, 8561],
            [7905, 8564],
            [7896, 8582],
            [7876, 8605],
            [7868, 8610],
            [7880, 8615],
            [7884, 8632],
            [7890, 8628],
            [7901, 8610],
            [7917, 8599],
            [7921, 8605],
            [7919, 8622],
            [7926, 8624],
            [7919, 8635],
            [7924, 8640],
            [7918, 8661],
            [7922, 8665],
            [7905, 8701],
            [7910, 8708],
            [7911, 8719],
            [7898, 8729],
            [7896, 8738],
            [7883, 8742],
            [7868, 8738],
            [7866, 8732],
            [7853, 8732],
            [7846, 8727],
            [7846, 8718],
            [7804, 8717],
            [7784, 8731],
            [7783, 8739],
            [7766, 8751],
            [7764, 8760],
            [7752, 8760],
            [7713, 8780],
            [7707, 8778],
            [7693, 8785],
            [7672, 8785],
            [7651, 8794],
            [7642, 8809],
            [7633, 8812],
            [7619, 8828],
            [7601, 8839],
            [7596, 8848],
            [7580, 8858],
            [7562, 8873],
            [7560, 8878],
            [7515, 8908],
            [7492, 8916],
            [7487, 8912],
            [7463, 8922],
            [7430, 8929],
            [7421, 8925],
            [7406, 8926],
            [7381, 8918],
            [7371, 8918],
            [7362, 8900],
            [7370, 8894],
            [7387, 8892],
            [7399, 8877],
            [7392, 8861],
            [7397, 8840],
            [7395, 8834],
            [7398, 8814],
            [7404, 8813],
            [7407, 8802],
            [7393, 8800],
            [7378, 8784],
            [7340, 8795],
            [7322, 8802],
            [7301, 8797],
            [7275, 8810],
            [7261, 8811],
            [7240, 8794],
            [7241, 8787],
            [7216, 8780],
            [7197, 8778],
            [7185, 8770],
            [7168, 8771],
            [7135, 8777],
            [7118, 8777],
            [7093, 8789],
            [7088, 8799],
            [7066, 8801],
            [7042, 8813],
            [7031, 8812],
            [7001, 8818],
            [6979, 8812],
            [6976, 8807],
            [6961, 8806],
            [6926, 8816],
            [6911, 8824],
            [6895, 8848],
            [6868, 8853],
            [6838, 8863],
            [6824, 8863],
            [6784, 8878],
            [6785, 8867],
            [6777, 8863],
            [6774, 8854],
            [6777, 8837],
            [6791, 8824],
            [6800, 8820],
            [6804, 8803],
            [6792, 8798],
            [6789, 8792],
            [6775, 8797],
            [6757, 8797],
            [6741, 8802],
            [6733, 8797],
            [6714, 8803],
            [6705, 8802],
            [6694, 8809],
            [6685, 8821],
            [6637, 8825],
            [6625, 8832],
            [6623, 8826],
            [6611, 8826],
            [6606, 8818],
            [6594, 8816],
            [6589, 8809],
            [6565, 8798],
            [6570, 8791],
            [6552, 8781],
            [6532, 8781],
            [6526, 8771],
            [6518, 8769],
            [6513, 8768],
            [6484, 8787],
            [6481, 8794],
            [6474, 8782],
            [6455, 8787],
            [6446, 8786],
            [6430, 8804],
            [6405, 8811],
            [6400, 8820],
            [6383, 8832],
            [6370, 8837],
            [6352, 8834],
            [6351, 8830],
            [6336, 8827],
            [6318, 8827],
            [6313, 8836],
            [6303, 8836],
            [6302, 8844],
            [6286, 8848],
            [6285, 8836],
            [6274, 8830],
            [6249, 8855],
            [6202, 8896],
            [6174, 8918],
            [6125, 8943],
            [6117, 8949],
            [6127, 8954],
            [6120, 8959],
            [6098, 8947],
            [6086, 8937],
            [6067, 8930],
            [6051, 8930],
            [6047, 8924],
            [6038, 8932],
            [6040, 8942],
            [6010, 8949],
            [5994, 8957],
            [5999, 8949],
            [5976, 8951],
            [5974, 8948],
            [5965, 8970],
            [5959, 8971],
            [5945, 8990],
            [5931, 8984],
            [5913, 8991],
            [5876, 8986],
            [5878, 8978],
            [5823, 8966],
            [5808, 8966],
            [5806, 8956],
            [5796, 8958],
            [5772, 8955],
            [5750, 8947],
            [5711, 8943],
            [5705, 8946],
            [5695, 8940],
            [5699, 8931],
            [5709, 8928],
            [5709, 8918],
            [5735, 8913],
            [5735, 8906],
            [5720, 8909],
            [5703, 8897],
            [5717, 8885],
            [5703, 8878],
            [5698, 8869],
            [5712, 8859],
            [5724, 8859],
            [5742, 8852],
            [5746, 8845],
            [5747, 8829],
            [5730, 8825],
            [5706, 8831],
            [5705, 8820],
            [5679, 8826],
            [5666, 8832],
            [5665, 8838],
            [5641, 8841],
            [5635, 8832],
            [5623, 8841],
            [5605, 8840],
            [5588, 8820],
            [5554, 8838],
            [5559, 8823],
            [5550, 8823],
            [5550, 8832],
            [5537, 8841],
            [5523, 8845],
            [5511, 8855],
            [5487, 8855],
            [5480, 8865],
            [5467, 8861],
            [5467, 8855],
            [5454, 8854],
            [5454, 8860],
            [5432, 8860],
            [5428, 8849],
            [5414, 8841],
            [5405, 8841],
            [5406, 8831],
            [5388, 8822],
            [5400, 8802],
            [5389, 8794],
            [5358, 8817],
            [5352, 8811],
            [5355, 8803],
            [5345, 8795],
            [5346, 8777],
            [5355, 8772],
            [5349, 8762],
            [5346, 8743],
            [5365, 8738],
            [5370, 8722],
            [5397, 8720],
            [5414, 8707],
            [5434, 8684],
            [5419, 8680],
            [5444, 8668],
            [5428, 8655],
            [5421, 8645],
            [5409, 8641],
            [5403, 8645],
            [5396, 8615],
            [5385, 8604],
            [5388, 8595],
            [5404, 8588],
            [5418, 8572],
            [5420, 8545],
            [5463, 8503],
            [5459, 8493],
            [5443, 8479],
            [5428, 8483],
            [5408, 8503],
            [5398, 8504],
            [5371, 8517],
            [5373, 8525],
            [5361, 8527],
            [5344, 8535],
            [5327, 8534],
            [5318, 8528],
            [5313, 8535],
            [5292, 8542],
            [5281, 8551],
            [5243, 8552],
            [5213, 8564],
            [5196, 8564],
            [5195, 8558],
            [5159, 8586],
            [5134, 8595],
            [5120, 8607],
            [5112, 8605],
            [5099, 8620],
            [5082, 8626],
            [5108, 8633],
            [5115, 8630],
            [5109, 8642],
            [5116, 8656],
            [5134, 8660],
            [5110, 8673],
            [5124, 8686],
            [5148, 8693],
            [5146, 8702],
            [5117, 8696],
            [5117, 8714],
            [5128, 8717],
            [5129, 8723],
            [5156, 8722],
            [5160, 8737],
            [5148, 8756],
            [5156, 8761],
            [5145, 8766],
            [5156, 8773],
            [5152, 8783],
            [5124, 8796],
            [5118, 8794],
            [5094, 8803],
            [5090, 8798],
            [5070, 8816],
            [5049, 8809],
            [5032, 8816],
            [5021, 8814],
            [4997, 8845],
            [4972, 8846],
            [4966, 8861],
            [4975, 8864],
            [4964, 8871],
            [4953, 8886],
            [4936, 8886],
            [4929, 8882],
            [4913, 8884],
            [4911, 8876],
            [4898, 8877],
            [4877, 8909],
            [4879, 8915],
            [4901, 8911],
            [4915, 8924],
            [4907, 8933],
            [4885, 8937],
            [4887, 8944],
            [4870, 8952],
            [4863, 8966],
            [4851, 8972],
            [4856, 8980],
            [4848, 8989],
            [4849, 9000],
            [4836, 9007],
            [4819, 9008],
            [4810, 9003],
            [4806, 9012],
            [4790, 9012],
            [4770, 9019],
            [4767, 9033],
            [4752, 9044],
            [4754, 9059],
            [4740, 9067],
            [4742, 9077],
            [4744, 9084],
            [4758, 9079],
            [4751, 9090],
            [4739, 9092],
            [4745, 9100],
            [4740, 9118],
            [4742, 9124],
            [4744, 9128],
            [4746, 9129],
            [4747, 9129],
            [4745, 9130],
            [4745, 9130],
            [4747, 9129],
            [4749, 9130],
            [4747, 9133],
            [4744, 9135],
            [4744, 9146],
            [4752, 9141],
            [4755, 9148],
            [4767, 9147],
            [4771, 9153],
            [4798, 9148],
            [4787, 9158],
            [4757, 9161],
            [4753, 9178],
            [4742, 9171],
            [4731, 9171],
            [4753, 9190],
            [4763, 9195],
            [4793, 9227],
            [4806, 9237],
            [4811, 9251],
            [4799, 9261],
            [4778, 9269],
            [4764, 9278],
            [4776, 9288],
            [4774, 9294],
            [4760, 9300],
            [4762, 9308],
            [4744, 9319],
            [4749, 9326],
            [4742, 9340],
            [4752, 9341],
            [4743, 9356],
            [4717, 9379],
            [4716, 9384],
            [4732, 9401],
            [4733, 9407],
            [4714, 9419],
            [4696, 9423],
            [4689, 9433],
            [4695, 9443],
            [4685, 9445],
            [4697, 9449],
            [4705, 9458],
            [4718, 9460],
            [4722, 9468],
            [4738, 9465],
            [4735, 9473],
            [4759, 9470],
            [4763, 9478],
            [4790, 9471],
            [4785, 9467],
            [4765, 9466],
            [4802, 9462],
            [4799, 9455],
            [4819, 9461],
            [4825, 9457],
            [4863, 9454],
            [4909, 9439],
            [4931, 9428],
            [4935, 9429],
            [4960, 9419],
            [4963, 9422],
            [4984, 9412],
            [5001, 9406],
            [5007, 9393],
            [5014, 9391],
            [5014, 9379],
            [5000, 9365],
            [4976, 9357],
            [4957, 9354],
            [4934, 9356],
            [4914, 9362],
            [4875, 9366],
            [4859, 9372],
            [4827, 9376],
            [4802, 9389],
            [4793, 9389],
            [4799, 9381],
            [4819, 9375],
            [4834, 9367],
            [4832, 9363],
            [4858, 9355],
            [4870, 9343],
            [4863, 9332],
            [4882, 9311],
            [4891, 9324],
            [4909, 9325],
            [4916, 9317],
            [4928, 9325],
            [4957, 9315],
            [4980, 9311],
            [4998, 9305],
            [5017, 9313],
            [4994, 9331],
            [4993, 9340],
            [5011, 9351],
            [5026, 9354],
            [5041, 9369],
            [5069, 9367],
            [5086, 9358],
            [5099, 9348],
            [5092, 9361],
            [5097, 9374],
            [5087, 9387],
            [5074, 9390],
            [5075, 9410],
            [5072, 9425],
            [5045, 9436],
            [5094, 9434],
            [5110, 9431],
            [5129, 9421],
            [5137, 9412],
            [5105, 9408],
            [5100, 9395],
            [5118, 9390],
            [5127, 9381],
            [5146, 9379],
            [5172, 9385],
            [5172, 9399],
            [5167, 9403],
            [5188, 9408],
            [5222, 9424],
            [5235, 9433],
            [5241, 9429],
            [5259, 9434],
            [5264, 9427],
            [5273, 9430],
            [5265, 9437],
            [5284, 9446],
            [5304, 9449],
            [5294, 9437],
            [5305, 9426],
            [5295, 9430],
            [5288, 9425],
            [5307, 9424],
            [5318, 9427],
            [5325, 9422],
            [5330, 9432],
            [5349, 9438],
            [5382, 9435],
            [5393, 9443],
            [5413, 9448],
            [5430, 9441],
            [5427, 9430],
            [5443, 9427],
            [5447, 9431],
            [5442, 9439],
            [5455, 9440],
            [5462, 9446],
            [5459, 9452],
            [5433, 9466],
            [5447, 9475],
            [5490, 9471],
            [5528, 9465],
            [5574, 9451],
            [5609, 9444],
            [5645, 9430],
            [5653, 9423],
            [5661, 9447],
            [5642, 9448],
            [5623, 9464],
            [5603, 9468],
            [5598, 9461],
            [5591, 9467],
            [5585, 9480],
            [5582, 9503],
            [5576, 9506],
            [5563, 9501],
            [5562, 9519],
            [5575, 9523],
            [5587, 9536],
            [5581, 9562],
            [5592, 9567],
            [5636, 9568],
            [5669, 9562],
            [5679, 9550],
            [5678, 9529],
            [5671, 9527],
            [5683, 9519],
            [5698, 9514],
            [5708, 9507],
            [5716, 9493],
            [5711, 9488],
            [5726, 9474],
            [5725, 9469],
            [5741, 9446],
            [5775, 9433],
            [5768, 9423],
            [5779, 9408],
            [5768, 9405],
            [5768, 9390],
            [5756, 9381],
            [5762, 9374],
            [5743, 9369],
            [5713, 9371],
            [5705, 9379],
            [5702, 9372],
            [5738, 9363],
            [5757, 9364],
            [5782, 9360],
            [5785, 9372],
            [5806, 9379],
            [5811, 9387],
            [5806, 9394],
            [5819, 9407],
            [5809, 9421],
            [5795, 9429],
            [5791, 9439],
            [5805, 9444],
            [5831, 9448],
            [5843, 9441],
            [5864, 9433],
            [5871, 9424],
            [5873, 9410],
            [5893, 9402],
            [5915, 9404],
            [5883, 9410],
            [5878, 9419],
            [5889, 9425],
            [5875, 9433],
            [5863, 9445],
            [5837, 9452],
            [5805, 9456],
            [5791, 9451],
            [5772, 9451],
            [5763, 9461],
            [5748, 9472],
            [5744, 9485],
            [5750, 9496],
            [5717, 9518],
            [5701, 9523],
            [5704, 9535],
            [5731, 9544],
            [5729, 9551],
            [5705, 9570],
            [5730, 9563],
            [5745, 9550],
            [5747, 9533],
            [5757, 9521],
            [5775, 9518],
            [5820, 9514],
            [5838, 9507],
            [5827, 9518],
            [5813, 9519],
            [5773, 9528],
            [5760, 9538],
            [5777, 9542],
            [5798, 9536],
            [5809, 9537],
            [5802, 9544],
            [5787, 9544],
            [5798, 9552],
            [5827, 9552],
            [5897, 9532],
            [5921, 9534],
            [5932, 9533],
            [5934, 9523],
            [5919, 9519],
            [5924, 9511],
            [5940, 9498],
            [5937, 9509],
            [5960, 9502],
            [5963, 9493],
            [5953, 9488],
            [5969, 9482],
            [5958, 9490],
            [5974, 9494],
            [5941, 9518],
            [5942, 9530],
            [5931, 9536],
            [5915, 9537],
            [5894, 9549],
            [5869, 9552],
            [5853, 9557],
            [5847, 9569],
            [5829, 9577],
            [5824, 9588],
            [5854, 9591],
            [5852, 9603],
            [5869, 9605],
            [5891, 9602],
            [5891, 9615],
            [5906, 9622],
            [5913, 9619],
            [5926, 9629],
            [5946, 9631],
            [5965, 9643],
            [5979, 9647],
            [6014, 9649],
            [6050, 9655],
            [6030, 9661],
            [6059, 9662],
            [6065, 9665],
            [6061, 9688],
            [6074, 9691],
            [6076, 9678],
            [6086, 9679],
            [6085, 9668],
            [6106, 9669],
            [6107, 9679],
            [6113, 9676],
            [6109, 9664],
            [6100, 9667],
            [6099, 9657],
            [6136, 9662],
            [6151, 9666],
            [6179, 9660],
            [6168, 9667],
            [6144, 9674],
            [6159, 9672],
            [6186, 9674],
            [6187, 9681],
            [6176, 9683],
            [6174, 9690],
            [6197, 9706],
            [6229, 9707],
            [6236, 9722],
            [6248, 9719],
            [6273, 9719],
            [6273, 9716],
            [6248, 9718],
            [6247, 9702],
            [6257, 9703],
            [6279, 9696],
            [6283, 9689],
            [6302, 9687],
            [6297, 9697],
            [6308, 9695],
            [6307, 9687],
            [6316, 9685],
            [6310, 9675],
            [6318, 9672],
            [6338, 9674],
            [6332, 9680],
            [6384, 9680],
            [6436, 9676],
            [6461, 9663],
            [6458, 9671],
            [6500, 9647],
            [6510, 9638],
            [6504, 9630],
            [6492, 9626],
            [6463, 9611],
            [6466, 9606],
            [6452, 9601],
            [6444, 9590],
            [6424, 9589],
            [6423, 9580],
            [6411, 9579],
            [6414, 9571],
            [6405, 9564],
            [6425, 9570],
            [6420, 9577],
            [6452, 9576],
            [6479, 9582],
            [6472, 9587],
            [6490, 9585],
            [6506, 9591],
            [6473, 9594],
            [6475, 9601],
            [6534, 9592],
            [6550, 9597],
            [6571, 9586],
            [6607, 9592],
            [6658, 9588],
            [6680, 9588],
            [6689, 9579],
            [6708, 9575],
            [6763, 9569],
            [6812, 9569],
            [6809, 9578],
            [6790, 9587],
            [6801, 9599],
            [6805, 9595],
            [6833, 9588],
            [6901, 9586],
            [6905, 9581],
            [6931, 9577],
            [6951, 9572],
            [6961, 9562],
            [6953, 9555],
            [6964, 9555],
            [6983, 9548],
            [6976, 9543],
            [6953, 9548],
            [7003, 9527],
            [7015, 9520],
            [7046, 9509],
            [7079, 9503],
            [7081, 9507],
            [7066, 9537],
            [7109, 9524],
            [7131, 9522],
            [7137, 9527],
            [7156, 9530],
            [7178, 9526],
            [7197, 9529],
            [7206, 9526],
            [7219, 9530],
            [7239, 9523],
            [7256, 9525],
            [7227, 9539],
            [7224, 9546],
            [7208, 9546],
            [7203, 9556],
            [7226, 9556],
            [7235, 9559],
            [7210, 9568],
            [7237, 9564],
            [7335, 9558],
            [7376, 9551],
            [7342, 9551],
            [7329, 9554],
            [7328, 9546],
            [7339, 9549],
            [7380, 9550],
            [7378, 9536],
            [7375, 9545],
            [7357, 9547],
            [7371, 9539],
            [7357, 9534],
            [7371, 9531],
            [7383, 9535],
            [7385, 9551],
            [7414, 9550],
            [7453, 9545],
            [7469, 9538],
            [7468, 9534],
            [7454, 9538],
            [7457, 9532],
            [7478, 9531],
            [7485, 9525],
            [7500, 9526],
            [7510, 9519],
            [7515, 9522],
            [7531, 9520],
            [7555, 9512],
            [7547, 9510],
            [7585, 9505],
            [7642, 9513],
            [7682, 9513],
            [7708, 9509],
            [7749, 9500],
            [7759, 9507],
            [7768, 9504],
            [7768, 9492],
            [7778, 9487],
            [7783, 9477],
            [7810, 9469],
            [7836, 9463],
            [7838, 9468],
            [7890, 9470],
            [7892, 9472],
            [7921, 9466],
            [7939, 9467],
            [7974, 9464],
            [7981, 9473],
            [8003, 9465],
            [8018, 9456],
            [8049, 9451],
            [8072, 9441],
            [8087, 9443],
            [8091, 9450],
            [8057, 9467],
            [8035, 9471],
            [8041, 9476],
            [8032, 9483],
            [8087, 9479],
            [8114, 9474],
            [8131, 9476],
            [8161, 9475],
            [8189, 9472],
            [8278, 9457],
            [8310, 9448],
            [8499, 9322],
            [8498, 9314],
            [8474, 9309],
            [8456, 9311],
            [8442, 9317],
            [8423, 9321],
            [8443, 9314],
            [8419, 9315],
            [8441, 9306],
            [8451, 9312],
            [8457, 9305],
            [8489, 9294],
            [8490, 9299],
            [8518, 9285],
            [8550, 9265],
            [8573, 9259],
            [8576, 9255],
            [8600, 9244],
            [8598, 9232],
            [8568, 9238],
            [8547, 9240],
            [8537, 9247],
            [8533, 9243],
            [8545, 9239],
            [8517, 9224],
            [8509, 9214],
            [8487, 9212],
            [8494, 9205],
            [8488, 9193],
            [8480, 9194],
            [8486, 9182],
            [8473, 9179],
            [8477, 9172],
            [8467, 9167],
            [8482, 9151],
            [8467, 9155],
            [8445, 9167],
            [8424, 9172],
            [8400, 9173],
            [8377, 9163],
            [8379, 9149],
            [8375, 9147],
            [8356, 9169],
            [8348, 9168],
            [8339, 9155],
            [8343, 9145],
            [8321, 9156],
            [8322, 9152],
            [8301, 9154],
            [8311, 9136],
            [8330, 9121],
            [8325, 9106],
            [8336, 9087],
            [8343, 9081],
            [8363, 9075],
            [8359, 9083],
            [8387, 9074],
            [8386, 9061],
            [8409, 9041],
            [8421, 9040],
            [8447, 9021],
            [8445, 9014],
            [8422, 9024],
            [8415, 9019],
            [8425, 9001],
            [8448, 8982],
            [8463, 8974],
            [8465, 8962],
            [8446, 8965],
            [8437, 8963],
            [8431, 8950],
            [8447, 8928],
            [8469, 8912],
            [8452, 8918],
            [8437, 8905],
            [8459, 8872],
            [8458, 8857],
            [8448, 8837],
            [8433, 8847],
            [8398, 8881],
            [8365, 8906],
            [8331, 8936],
            [8282, 8976],
            [8264, 8992],
            [8247, 9012],
            [8226, 9041],
            [8233, 9051],
            [8227, 9064],
            [8209, 9076],
            [8226, 9077],
            [8224, 9085],
            [8234, 9083],
            [8244, 9098],
            [8244, 9114],
            [8238, 9123],
            [8244, 9139],
            [8245, 9155],
            [8249, 9159],
            [8242, 9167],
            [8253, 9178],
            [8269, 9184],
            [8258, 9187],
            [8258, 9198],
            [8246, 9203],
            [8244, 9210],
            [8222, 9229],
            [8225, 9235],
            [8246, 9233],
            [8217, 9243],
            [8189, 9238],
            [8200, 9231],
            [8212, 9213],
            [8225, 9210],
            [8203, 9209],
            [8204, 9199],
            [8189, 9172],
            [8178, 9188],
            [8165, 9184],
            [8152, 9195],
            [8153, 9205],
            [8138, 9218],
            [8130, 9209],
            [8115, 9217],
            [8070, 9213],
            [8061, 9204],
            [8073, 9193],
            [8066, 9187],
            [8070, 9177],
            [8061, 9165],
            [8061, 9148],
            [8071, 9136],
            [8095, 9135],
            [8113, 9124],
            [8093, 9126],
            [8087, 9120],
            [8062, 9127],
            [8062, 9115],
            [8042, 9120],
            [8040, 9114],
            [8023, 9113],
            [8007, 9122],
            [7994, 9118],
            [7990, 9134],
            [7971, 9139],
            [7943, 9144],
            [7931, 9134],
            [7950, 9124],
            [7912, 9132],
            [7908, 9126],
            [7898, 9130],
            [7870, 9132],
            [7878, 9124],
            [7863, 9127],
            [7860, 9133],
            [7836, 9131],
            [7805, 9133],
            [7788, 9130],
            [7772, 9123],
            [7772, 9105],
            [7762, 9097],
            [7769, 9078],
            [7761, 9072],
            [7763, 9066],
            [7749, 9048],
            [7751, 9019],
            [7747, 9018],
            [7733, 8996],
            [7734, 8990],
            [7722, 8975],
            [7728, 8969],
            [7746, 8964],
            [7777, 8965],
            [7778, 8959],
            [7799, 8936],
            [7807, 8937],
            [7806, 8945],
            [7796, 8949],
            [7807, 8954],
            [7806, 8946],
            [7822, 8942],
            [7822, 8927],
            [7837, 8929],
            [7842, 8944],
            [7854, 8927],
            [7848, 8943],
            [7837, 8955],
            [7858, 8951],
            [7867, 8954],
            [7887, 8946],
            [7909, 8931],
            [7943, 8919],
            [7948, 8914],
            [7942, 8907],
            [7953, 8903],
            [7966, 8885],
            [7980, 8881],
            [7986, 8870],
            [7980, 8860],
            [7983, 8849],
            [7992, 8838],
            [7999, 8820],
            [8019, 8803],
            [8017, 8797],
            [8029, 8786],
            [8033, 8773],
            [8048, 8745],
            [8040, 8721],
            [8043, 8703],
            [8039, 8695],
            [8045, 8664],
            [8044, 8648],
            [8033, 8626],
            [8031, 8598],
            [8025, 8595],
            [8026, 8572],
            [8020, 8561],
            [8002, 8540],
            [7983, 8533],
            [7966, 8541],
            [7953, 8541],
            [7944, 8556],
            [7935, 8544],
            [7929, 8557],
            [7926, 8531],
            [7909, 8532],
            [7918, 8527],
            [7918, 8519],
            [7914, 8523],
            [7908, 8528]
          ]
        ],
        [
          [
            [4550, 8959],
            [4567, 8968],
            [4556, 8969],
            [4546, 8960],
            [4546, 8960],
            [4553, 8968],
            [4552, 8975],
            [4571, 8981],
            [4578, 8989],
            [4580, 8989],
            [4569, 8978],
            [4584, 8976],
            [4588, 8988],
            [4611, 8980],
            [4624, 8982],
            [4632, 8975],
            [4633, 8957],
            [4631, 8956],
            [4550, 8959]
          ]
        ],
        [
          [
            [5242, 9795],
            [5242, 9793],
            [5235, 9788],
            [5254, 9789],
            [5260, 9783],
            [5244, 9778],
            [5205, 9781],
            [5211, 9792],
            [5242, 9795],
            [5242, 9795],
            [5242, 9795]
          ]
        ],
        [
          [
            [5214, 9593],
            [5251, 9610],
            [5241, 9614],
            [5260, 9615],
            [5240, 9620],
            [5258, 9622],
            [5245, 9625],
            [5261, 9628],
            [5242, 9630],
            [5242, 9636],
            [5253, 9632],
            [5260, 9642],
            [5277, 9639],
            [5269, 9645],
            [5288, 9651],
            [5296, 9659],
            [5309, 9657],
            [5317, 9662],
            [5335, 9661],
            [5331, 9667],
            [5343, 9668],
            [5361, 9664],
            [5387, 9669],
            [5396, 9668],
            [5423, 9675],
            [5424, 9679],
            [5443, 9686],
            [5476, 9686],
            [5490, 9681],
            [5495, 9675],
            [5487, 9669],
            [5467, 9662],
            [5403, 9649],
            [5369, 9643],
            [5362, 9636],
            [5348, 9634],
            [5344, 9623],
            [5324, 9620],
            [5325, 9614],
            [5301, 9618],
            [5319, 9608],
            [5310, 9607],
            [5310, 9600],
            [5300, 9585],
            [5286, 9578],
            [5286, 9564],
            [5279, 9564],
            [5277, 9550],
            [5287, 9538],
            [5311, 9518],
            [5339, 9506],
            [5355, 9502],
            [5347, 9495],
            [5339, 9498],
            [5316, 9498],
            [5302, 9503],
            [5300, 9497],
            [5251, 9506],
            [5259, 9515],
            [5235, 9522],
            [5243, 9518],
            [5243, 9509],
            [5219, 9521],
            [5230, 9523],
            [5222, 9530],
            [5209, 9524],
            [5194, 9534],
            [5194, 9544],
            [5211, 9543],
            [5211, 9560],
            [5201, 9563],
            [5220, 9571],
            [5213, 9576],
            [5234, 9579],
            [5230, 9586],
            [5247, 9592],
            [5226, 9589],
            [5214, 9593]
          ]
        ],
        [
          [
            [8108, 8741],
            [8088, 8757],
            [8089, 8760],
            [8073, 8789],
            [8053, 8814],
            [8044, 8821],
            [8032, 8843],
            [8018, 8854],
            [7998, 8864],
            [7978, 8887],
            [7977, 8894],
            [7966, 8909],
            [7951, 8922],
            [7959, 8927],
            [7969, 8922],
            [7969, 8934],
            [7958, 8942],
            [7935, 8955],
            [7943, 8959],
            [7961, 8948],
            [7970, 8936],
            [8000, 8914],
            [8018, 8895],
            [8023, 8884],
            [8036, 8868],
            [8064, 8847],
            [8101, 8812],
            [8115, 8802],
            [8145, 8774],
            [8160, 8763],
            [8138, 8774],
            [8112, 8778],
            [8112, 8772],
            [8129, 8729],
            [8140, 8715],
            [8163, 8701],
            [8180, 8684],
            [8189, 8685],
            [8203, 8669],
            [8205, 8659],
            [8192, 8675],
            [8163, 8679],
            [8170, 8652],
            [8162, 8657],
            [8145, 8678],
            [8140, 8694],
            [8123, 8714],
            [8120, 8727],
            [8108, 8741]
          ]
        ],
        [
          [
            [-408, 9358],
            [-435, 9356],
            [-449, 9345],
            [-446, 9340],
            [-478, 9324],
            [-490, 9322],
            [-301, 9448],
            [-285, 9440],
            [-291, 9434],
            [-277, 9428],
            [-261, 9412],
            [-275, 9407],
            [-270, 9403],
            [-257, 9411],
            [-251, 9406],
            [-255, 9398],
            [-296, 9361],
            [-276, 9368],
            [-287, 9359],
            [-273, 9364],
            [-278, 9371],
            [-265, 9374],
            [-254, 9383],
            [-262, 9387],
            [-220, 9386],
            [-198, 9383],
            [-202, 9374],
            [-191, 9353],
            [-217, 9348],
            [-229, 9340],
            [-241, 9342],
            [-251, 9337],
            [-274, 9336],
            [-309, 9314],
            [-306, 9312],
            [-335, 9309],
            [-321, 9308],
            [-326, 9300],
            [-360, 9296],
            [-372, 9311],
            [-367, 9314],
            [-389, 9312],
            [-390, 9320],
            [-380, 9325],
            [-374, 9335],
            [-389, 9340],
            [-408, 9334],
            [-432, 9337],
            [-418, 9354],
            [-408, 9358]
          ]
        ],
        [
          [
            [7153, 9654],
            [7199, 9645],
            [7189, 9642],
            [7201, 9638],
            [7192, 9631],
            [7162, 9634],
            [7142, 9641],
            [7138, 9650],
            [7123, 9651],
            [7126, 9645],
            [7160, 9633],
            [7189, 9628],
            [7165, 9625],
            [7146, 9630],
            [7114, 9625],
            [7103, 9629],
            [7104, 9621],
            [7071, 9624],
            [7036, 9634],
            [7019, 9640],
            [7028, 9642],
            [7007, 9651],
            [6997, 9643],
            [6987, 9641],
            [6970, 9655],
            [6993, 9648],
            [7007, 9653],
            [7021, 9652],
            [7005, 9658],
            [7024, 9665],
            [7059, 9656],
            [7090, 9651],
            [7078, 9664],
            [7121, 9655],
            [7153, 9654]
          ]
        ],
        [
          [
            [5993, 9772],
            [6007, 9769],
            [6004, 9764],
            [6019, 9764],
            [6017, 9769],
            [6045, 9766],
            [6062, 9758],
            [6063, 9748],
            [6083, 9740],
            [6077, 9737],
            [6043, 9737],
            [6017, 9741],
            [5979, 9743],
            [5957, 9748],
            [5949, 9754],
            [5934, 9756],
            [5912, 9753],
            [5936, 9762],
            [5942, 9770],
            [5993, 9772]
          ]
        ],
        [
          [
            [4984, 9776],
            [4966, 9779],
            [4984, 9782],
            [4994, 9780],
            [5008, 9783],
            [4993, 9787],
            [5017, 9792],
            [5022, 9796],
            [5027, 9786],
            [5049, 9785],
            [5037, 9781],
            [5012, 9780],
            [5020, 9773],
            [5038, 9767],
            [5044, 9770],
            [5057, 9765],
            [5028, 9767],
            [5010, 9777],
            [4996, 9777],
            [4992, 9770],
            [4977, 9769],
            [4980, 9774],
            [4964, 9772],
            [4953, 9775],
            [4984, 9776]
          ]
        ],
        [
          [
            [5926, 9767],
            [5901, 9770],
            [5866, 9775],
            [5868, 9779],
            [5884, 9780],
            [5885, 9787],
            [5872, 9786],
            [5875, 9792],
            [5907, 9796],
            [5920, 9799],
            [5957, 9790],
            [5983, 9785],
            [5969, 9784],
            [5983, 9773],
            [5932, 9771],
            [5926, 9767]
          ]
        ],
        [
          [
            [5242, 9795],
            [5243, 9805],
            [5242, 9795],
            [5242, 9795],
            [5242, 9795],
            [5242, 9795]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.50,
      "hc-key": "tt",
      "hc-a2": "TT",
      "name": "Trinidad and Tobago",
      "labelrank": "5",
      "country-abbrev": "Tr.T.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "TTO",
      "iso-a2": "TT",
      "woe-id": "23424958",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2012, 7350],
          [2007, 7343],
          [2008, 7324],
          [1982, 7322],
          [1993, 7329],
          [1992, 7342],
          [1987, 7345],
          [2012, 7350]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.35,
      "hc-key": "br",
      "hc-a2": "BR",
      "name": "Brazil",
      "labelrank": "2",
      "country-abbrev": "Brazil",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "BRA",
      "iso-a2": "BR",
      "woe-id": "23424768",
      "continent": "South America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [2320, 6926],
            [2318, 6908],
            [2301, 6893],
            [2296, 6894],
            [2304, 6904],
            [2305, 6915],
            [2313, 6926],
            [2320, 6926]
          ]
        ],
        [
          [
            [2338, 6946],
            [2331, 6935],
            [2329, 6946],
            [2341, 6953],
            [2338, 6946]
          ]
        ],
        [
          [
            [2350, 6966],
            [2359, 6966],
            [2350, 6958],
            [2371, 6961],
            [2372, 6949],
            [2381, 6946],
            [2369, 6941],
            [2366, 6947],
            [2350, 6947],
            [2343, 6954],
            [2350, 6966]
          ]
        ],
        [
          [
            [2335, 5697],
            [2335, 5708],
            [2343, 5726],
            [2351, 5721],
            [2359, 5734],
            [2354, 5749],
            [2341, 5731],
            [2324, 5742],
            [2319, 5753],
            [2306, 5759],
            [2289, 5775],
            [2267, 5783],
            [2254, 5798],
            [2242, 5789],
            [2242, 5798],
            [2233, 5808],
            [2211, 5826],
            [2200, 5820],
            [2186, 5823],
            [2194, 5830],
            [2218, 5864],
            [2234, 5895],
            [2247, 5907],
            [2256, 5909],
            [2259, 5918],
            [2290, 5935],
            [2293, 5945],
            [2292, 5969],
            [2282, 5992],
            [2275, 5997],
            [2259, 5994],
            [2259, 5996],
            [2259, 6000],
            [2265, 6008],
            [2267, 6028],
            [2264, 6050],
            [2251, 6060],
            [2235, 6052],
            [2227, 6055],
            [2217, 6090],
            [2216, 6104],
            [2207, 6116],
            [2196, 6117],
            [2189, 6125],
            [2181, 6119],
            [2150, 6121],
            [2138, 6125],
            [2140, 6166],
            [2126, 6196],
            [2135, 6203],
            [2126, 6212],
            [2135, 6237],
            [2140, 6269],
            [2130, 6294],
            [2110, 6304],
            [2104, 6338],
            [2049, 6341],
            [2044, 6370],
            [2032, 6384],
            [2042, 6384],
            [2040, 6402],
            [2033, 6421],
            [2032, 6433],
            [2013, 6445],
            [1987, 6442],
            [1975, 6458],
            [1955, 6462],
            [1945, 6475],
            [1937, 6474],
            [1925, 6482],
            [1917, 6479],
            [1901, 6483],
            [1898, 6491],
            [1880, 6500],
            [1873, 6509],
            [1866, 6531],
            [1868, 6537],
            [1863, 6557],
            [1867, 6566],
            [1866, 6580],
            [1861, 6586],
            [1822, 6578],
            [1805, 6562],
            [1800, 6562],
            [1789, 6548],
            [1776, 6548],
            [1771, 6538],
            [1755, 6532],
            [1755, 6536],
            [1728, 6539],
            [1716, 6540],
            [1705, 6535],
            [1694, 6537],
            [1692, 6580],
            [1694, 6595],
            [1673, 6576],
            [1667, 6574],
            [1641, 6574],
            [1636, 6592],
            [1619, 6596],
            [1606, 6596],
            [1614, 6608],
            [1600, 6631],
            [1594, 6635],
            [1587, 6657],
            [1577, 6666],
            [1586, 6675],
            [1584, 6690],
            [1604, 6709],
            [1600, 6720],
            [1608, 6734],
            [1610, 6755],
            [1619, 6760],
            [1642, 6778],
            [1673, 6783],
            [1679, 6792],
            [1694, 6791],
            [1698, 6785],
            [1706, 6789],
            [1722, 6902],
            [1714, 6919],
            [1715, 6927],
            [1700, 6941],
            [1700, 6968],
            [1719, 6974],
            [1731, 6971],
            [1724, 6986],
            [1707, 6986],
            [1707, 7010],
            [1763, 7011],
            [1774, 7013],
            [1782, 7023],
            [1790, 7024],
            [1797, 7010],
            [1799, 6990],
            [1805, 6992],
            [1820, 6976],
            [1829, 6974],
            [1842, 6983],
            [1850, 6979],
            [1848, 6971],
            [1862, 6989],
            [1876, 6993],
            [1886, 7003],
            [1896, 7005],
            [1898, 7017],
            [1919, 7027],
            [1921, 7036],
            [1899, 7039],
            [1901, 7048],
            [1893, 7063],
            [1894, 7080],
            [1880, 7094],
            [1882, 7100],
            [1897, 7100],
            [1899, 7092],
            [1920, 7094],
            [1934, 7081],
            [1941, 7081],
            [1942, 7096],
            [1953, 7102],
            [1961, 7099],
            [1982, 7105],
            [1990, 7115],
            [2000, 7115],
            [2014, 7131],
            [2010, 7140],
            [2027, 7143],
            [2034, 7136],
            [2029, 7114],
            [2040, 7113],
            [2048, 7093],
            [2038, 7081],
            [2032, 7047],
            [2040, 7031],
            [2040, 7015],
            [2056, 6998],
            [2070, 6991],
            [2080, 6994],
            [2087, 7006],
            [2112, 7010],
            [2116, 7017],
            [2127, 7022],
            [2137, 7016],
            [2147, 7019],
            [2162, 7015],
            [2166, 7023],
            [2161, 7030],
            [2164, 7041],
            [2172, 7036],
            [2197, 7041],
            [2209, 7033],
            [2224, 7025],
            [2235, 7033],
            [2251, 7034],
            [2262, 7027],
            [2275, 7040],
            [2284, 7064],
            [2296, 7084],
            [2306, 7097],
            [2312, 7112],
            [2326, 7091],
            [2327, 7060],
            [2339, 7026],
            [2345, 7028],
            [2350, 7019],
            [2363, 7009],
            [2364, 6990],
            [2357, 6975],
            [2345, 6971],
            [2334, 6953],
            [2324, 6945],
            [2322, 6935],
            [2304, 6919],
            [2304, 6908],
            [2292, 6894],
            [2287, 6896],
            [2271, 6887],
            [2285, 6890],
            [2286, 6883],
            [2318, 6901],
            [2332, 6912],
            [2329, 6919],
            [2334, 6922],
            [2338, 6937],
            [2348, 6943],
            [2371, 6938],
            [2382, 6941],
            [2413, 6936],
            [2408, 6913],
            [2399, 6902],
            [2398, 6893],
            [2386, 6886],
            [2380, 6889],
            [2367, 6879],
            [2352, 6886],
            [2351, 6879],
            [2341, 6880],
            [2334, 6893],
            [2335, 6907],
            [2332, 6912],
            [2329, 6905],
            [2339, 6879],
            [2346, 6874],
            [2360, 6879],
            [2369, 6875],
            [2382, 6883],
            [2375, 6857],
            [2376, 6849],
            [2386, 6874],
            [2394, 6887],
            [2405, 6895],
            [2408, 6888],
            [2411, 6903],
            [2418, 6915],
            [2432, 6925],
            [2452, 6922],
            [2457, 6916],
            [2486, 6912],
            [2498, 6897],
            [2511, 6893],
            [2514, 6882],
            [2525, 6896],
            [2531, 6883],
            [2541, 6876],
            [2546, 6860],
            [2541, 6856],
            [2543, 6835],
            [2546, 6852],
            [2555, 6857],
            [2556, 6851],
            [2547, 6842],
            [2556, 6842],
            [2568, 6862],
            [2576, 6852],
            [2580, 6859],
            [2601, 6851],
            [2609, 6844],
            [2629, 6845],
            [2636, 6839],
            [2662, 6839],
            [2673, 6843],
            [2690, 6840],
            [2714, 6826],
            [2734, 6810],
            [2740, 6809],
            [2752, 6792],
            [2769, 6775],
            [2780, 6771],
            [2783, 6764],
            [2802, 6757],
            [2822, 6759],
            [2836, 6756],
            [2847, 6742],
            [2863, 6679],
            [2863, 6651],
            [2853, 6615],
            [2848, 6604],
            [2813, 6555],
            [2797, 6545],
            [2781, 6516],
            [2774, 6498],
            [2754, 6465],
            [2745, 6463],
            [2734, 6453],
            [2735, 6425],
            [2732, 6400],
            [2741, 6356],
            [2736, 6335],
            [2732, 6307],
            [2735, 6288],
            [2721, 6269],
            [2718, 6257],
            [2721, 6225],
            [2711, 6211],
            [2700, 6179],
            [2690, 6170],
            [2681, 6145],
            [2686, 6129],
            [2664, 6117],
            [2655, 6107],
            [2658, 6098],
            [2653, 6092],
            [2622, 6091],
            [2619, 6103],
            [2613, 6100],
            [2616, 6090],
            [2594, 6088],
            [2581, 6082],
            [2587, 6089],
            [2580, 6093],
            [2568, 6086],
            [2573, 6077],
            [2563, 6077],
            [2547, 6067],
            [2553, 6061],
            [2533, 6062],
            [2500, 6043],
            [2493, 6033],
            [2471, 6014],
            [2463, 5999],
            [2455, 6006],
            [2459, 5994],
            [2453, 5977],
            [2457, 5970],
            [2453, 5951],
            [2459, 5934],
            [2457, 5923],
            [2465, 5919],
            [2461, 5909],
            [2458, 5885],
            [2441, 5869],
            [2429, 5850],
            [2423, 5836],
            [2418, 5812],
            [2408, 5791],
            [2397, 5775],
            [2378, 5758],
            [2396, 5779],
            [2395, 5790],
            [2407, 5800],
            [2405, 5816],
            [2388, 5822],
            [2390, 5816],
            [2386, 5789],
            [2372, 5781],
            [2371, 5768],
            [2365, 5765],
            [2367, 5745],
            [2361, 5714],
            [2341, 5691],
            [2336, 5694],
            [2335, 5697]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BS",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.10,
      "hc-middle-y": 0.37,
      "hc-key": "bs",
      "hc-a2": "BS",
      "name": "The Bahamas",
      "labelrank": "4",
      "country-abbrev": "Bhs.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "BHS",
      "iso-a2": "BS",
      "woe-id": "23424758",
      "continent": "North America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1650, 7747],
            [1646, 7728],
            [1629, 7725],
            [1628, 7729],
            [1639, 7737],
            [1643, 7734],
            [1650, 7747]
          ]
        ],
        [
          [
            [1504, 7849],
            [1516, 7849],
            [1518, 7835],
            [1509, 7835],
            [1504, 7849]
          ]
        ],
        [
          [
            [1522, 7878],
            [1515, 7866],
            [1511, 7853],
            [1503, 7851],
            [1497, 7865],
            [1510, 7883],
            [1511, 7871],
            [1522, 7878]
          ]
        ],
        [
          [
            [1522, 7938],
            [1519, 7939],
            [1493, 7934],
            [1502, 7942],
            [1519, 7942],
            [1522, 7949],
            [1534, 7948],
            [1547, 7934],
            [1539, 7912],
            [1541, 7931],
            [1534, 7947],
            [1522, 7938]
          ]
        ],
        [
          [
            [1567, 7876],
            [1567, 7876],
            [1567, 7877],
            [1567, 7877],
            [1567, 7876],
            [1567, 7876],
            [1567, 7876]
          ]
        ],
        [
          [
            [1567, 7876],
            [1582, 7864],
            [1583, 7859],
            [1567, 7872],
            [1567, 7876],
            [1567, 7876],
            [1567, 7876]
          ]
        ],
        [
          [
            [1567, 7877],
            [1568, 7882],
            [1558, 7892],
            [1569, 7882],
            [1567, 7877],
            [1567, 7877]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.54,
      "hc-key": "pw",
      "hc-a2": "PW",
      "name": "Palau",
      "labelrank": "6",
      "country-abbrev": "Palau",
      "subregion": "Micronesia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "PLW",
      "iso-a2": "PW",
      "woe-id": "23424927",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [8316, 7059],
          [8315, 7059],
          [8316, 7060],
          [8317, 7060],
          [8316, 7059]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.47,
      "hc-key": "ir",
      "hc-a2": "IR",
      "name": "Iran",
      "labelrank": "2",
      "country-abbrev": "Iran",
      "subregion": "Southern Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "IRN",
      "iso-a2": "IR",
      "woe-id": "23424851",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5800, 7948],
            [5795, 7949],
            [5768, 7935],
            [5769, 7939],
            [5794, 7952],
            [5800, 7948]
          ]
        ],
        [
          [
            [5365, 8425],
            [5389, 8401],
            [5411, 8396],
            [5418, 8398],
            [5422, 8397],
            [5431, 8407],
            [5461, 8428],
            [5475, 8415],
            [5469, 8413],
            [5476, 8403],
            [5469, 8394],
            [5482, 8387],
            [5490, 8378],
            [5498, 8380],
            [5507, 8354],
            [5521, 8344],
            [5545, 8340],
            [5556, 8327],
            [5577, 8316],
            [5604, 8310],
            [5649, 8321],
            [5667, 8319],
            [5660, 8339],
            [5669, 8338],
            [5685, 8345],
            [5686, 8354],
            [5701, 8367],
            [5728, 8367],
            [5730, 8373],
            [5749, 8371],
            [5754, 8373],
            [5760, 8362],
            [5787, 8355],
            [5794, 8350],
            [5807, 8352],
            [5826, 8344],
            [5827, 8338],
            [5850, 8327],
            [5863, 8312],
            [5885, 8312],
            [5890, 8309],
            [5900, 8273],
            [5900, 8254],
            [5897, 8236],
            [5890, 8232],
            [5898, 8224],
            [5890, 8224],
            [5887, 8216],
            [5891, 8199],
            [5902, 8196],
            [5897, 8177],
            [5911, 8147],
            [5916, 8119],
            [5944, 8115],
            [5951, 8095],
            [5927, 8058],
            [5943, 8042],
            [5955, 8022],
            [5968, 8009],
            [5997, 7998],
            [6003, 7970],
            [6002, 7962],
            [6016, 7962],
            [6021, 7956],
            [6016, 7939],
            [6005, 7939],
            [5991, 7933],
            [5990, 7928],
            [5979, 7924],
            [5975, 7906],
            [5975, 7885],
            [5970, 7880],
            [5944, 7888],
            [5941, 7894],
            [5920, 7890],
            [5905, 7895],
            [5895, 7892],
            [5885, 7898],
            [5864, 7898],
            [5857, 7903],
            [5836, 7906],
            [5830, 7918],
            [5822, 7946],
            [5813, 7957],
            [5799, 7960],
            [5778, 7952],
            [5774, 7944],
            [5766, 7944],
            [5752, 7933],
            [5736, 7941],
            [5717, 7941],
            [5707, 7951],
            [5693, 7956],
            [5679, 7965],
            [5673, 7976],
            [5658, 7983],
            [5638, 7987],
            [5625, 8009],
            [5623, 8017],
            [5610, 8031],
            [5607, 8043],
            [5588, 8061],
            [5585, 8071],
            [5571, 8065],
            [5559, 8069],
            [5548, 8079],
            [5548, 8065],
            [5537, 8062],
            [5532, 8071],
            [5518, 8081],
            [5516, 8100],
            [5505, 8101],
            [5503, 8116],
            [5506, 8129],
            [5493, 8143],
            [5490, 8152],
            [5479, 8155],
            [5466, 8166],
            [5451, 8173],
            [5435, 8198],
            [5431, 8197],
            [5418, 8211],
            [5422, 8222],
            [5416, 8229],
            [5428, 8253],
            [5435, 8258],
            [5427, 8268],
            [5428, 8276],
            [5436, 8280],
            [5417, 8281],
            [5404, 8287],
            [5399, 8304],
            [5391, 8308],
            [5380, 8331],
            [5372, 8343],
            [5371, 8353],
            [5358, 8363],
            [5363, 8376],
            [5358, 8378],
            [5354, 8395],
            [5343, 8415],
            [5355, 8417],
            [5358, 8430],
            [5365, 8425]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.56,
      "hc-middle-y": 0.49,
      "hc-key": "gw",
      "hc-a2": "GW",
      "name": "Guinea Bissau",
      "labelrank": "6",
      "country-abbrev": "GnB.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "GNB",
      "iso-a2": "GW",
      "woe-id": "23424929",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3486, 7367],
            [3493, 7367],
            [3479, 7358],
            [3473, 7360],
            [3469, 7377],
            [3474, 7373],
            [3483, 7379],
            [3486, 7367]
          ]
        ],
        [
          [
            [3458, 7406],
            [3475, 7410],
            [3493, 7410],
            [3508, 7419],
            [3556, 7418],
            [3557, 7404],
            [3548, 7399],
            [3556, 7393],
            [3556, 7383],
            [3537, 7381],
            [3524, 7375],
            [3513, 7355],
            [3501, 7363],
            [3497, 7379],
            [3503, 7392],
            [3483, 7383],
            [3471, 7393],
            [3471, 7400],
            [3458, 7406]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.50,
      "hc-key": "gd",
      "hc-a2": "GD",
      "name": "Grenada",
      "labelrank": "6",
      "country-abbrev": "Gren.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "GRD",
      "iso-a2": "GD",
      "woe-id": "23424826",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1991, 7395],
          [1987, 7395],
          [1988, 7400],
          [1992, 7402],
          [1991, 7395]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "EE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.32,
      "hc-middle-y": 0.41,
      "hc-key": "ee",
      "hc-a2": "EE",
      "name": "Estonia",
      "labelrank": "6",
      "country-abbrev": "Est.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "EST",
      "iso-a2": "EE",
      "woe-id": "23424805",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4618, 9105],
            [4626, 9100],
            [4612, 9092],
            [4598, 9089],
            [4588, 9093],
            [4586, 9101],
            [4605, 9106],
            [4618, 9105]
          ]
        ],
        [
          [
            [4607, 9119],
            [4616, 9112],
            [4604, 9107],
            [4589, 9116],
            [4607, 9119]
          ]
        ],
        [
          [
            [4742, 9124],
            [4740, 9118],
            [4723, 9117],
            [4720, 9112],
            [4744, 9084],
            [4742, 9077],
            [4740, 9067],
            [4726, 9071],
            [4717, 9067],
            [4681, 9086],
            [4656, 9079],
            [4660, 9095],
            [4648, 9092],
            [4631, 9103],
            [4626, 9126],
            [4642, 9128],
            [4653, 9134],
            [4675, 9135],
            [4681, 9141],
            [4713, 9135],
            [4741, 9132],
            [4744, 9135],
            [4747, 9133],
            [4749, 9130],
            [4748, 9130],
            [4745, 9130],
            [4747, 9129],
            [4747, 9129],
            [4747, 9129],
            [4746, 9129],
            [4744, 9129],
            [4742, 9124]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.51,
      "hc-key": "ag",
      "hc-a2": "AG",
      "name": "Antigua and Barbuda",
      "labelrank": "6",
      "country-abbrev": "Ant.B.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "ATG",
      "iso-a2": "AG",
      "woe-id": "23424737",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1999, 7584],
          [2002, 7581],
          [1997, 7580],
          [1995, 7583],
          [1999, 7584]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "FJ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.23,
      "hc-middle-y": 0.78,
      "hc-key": "fj",
      "hc-a2": "FJ",
      "name": "Fiji",
      "labelrank": "6",
      "country-abbrev": "Fiji",
      "subregion": "Melanesia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "FJI",
      "iso-a2": "FJ",
      "woe-id": "23424813",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [9801, 6287],
            [9797, 6274],
            [9769, 6266],
            [9752, 6272],
            [9752, 6282],
            [9768, 6297],
            [9790, 6300],
            [9788, 6297],
            [9801, 6287]
          ]
        ],
        [
          [
            [9834, 6338],
            [9849, 6344],
            [9850, 6340],
            [9835, 6325],
            [9836, 6322],
            [9851, 6333],
            [9848, 6326],
            [9837, 6321],
            [9828, 6325],
            [9809, 6313],
            [9805, 6322],
            [9818, 6333],
            [9834, 6338]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BB",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.25,
      "hc-middle-y": 0.55,
      "hc-key": "bb",
      "hc-a2": "BB",
      "name": "Barbados",
      "labelrank": "5",
      "country-abbrev": "Barb.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "BRB",
      "iso-a2": "BB",
      "woe-id": "23424754",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2062, 7433],
          [2058, 7435],
          [2059, 7443],
          [2064, 7435],
          [2062, 7433]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.38,
      "hc-middle-y": 0.25,
      "hc-key": "it",
      "hc-a2": "IT",
      "name": "Italy",
      "labelrank": "2",
      "country-abbrev": "Italy",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "ITA",
      "iso-a2": "IT",
      "woe-id": "23424853",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4284, 8408],
            [4274, 8397],
            [4261, 8400],
            [4255, 8408],
            [4264, 8434],
            [4253, 8468],
            [4261, 8466],
            [4276, 8477],
            [4288, 8482],
            [4291, 8469],
            [4302, 8455],
            [4296, 8445],
            [4298, 8438],
            [4296, 8406],
            [4284, 8408]
          ]
        ],
        [
          [
            [4469, 8318],
            [4469, 8312],
            [4450, 8318],
            [4447, 8325],
            [4432, 8329],
            [4402, 8347],
            [4393, 8347],
            [4385, 8356],
            [4387, 8364],
            [4395, 8370],
            [4399, 8365],
            [4405, 8371],
            [4427, 8362],
            [4441, 8364],
            [4461, 8371],
            [4466, 8368],
            [4483, 8374],
            [4471, 8354],
            [4468, 8338],
            [4475, 8326],
            [4469, 8318]
          ]
        ],
        [
          [
            [4405, 8675],
            [4396, 8666],
            [4404, 8662],
            [4399, 8656],
            [4413, 8642],
            [4407, 8641],
            [4405, 8647],
            [4392, 8648],
            [4364, 8631],
            [4374, 8615],
            [4366, 8606],
            [4372, 8588],
            [4410, 8564],
            [4425, 8530],
            [4447, 8511],
            [4460, 8506],
            [4485, 8506],
            [4491, 8501],
            [4484, 8490],
            [4519, 8475],
            [4532, 8466],
            [4549, 8459],
            [4566, 8439],
            [4562, 8431],
            [4553, 8435],
            [4545, 8446],
            [4535, 8447],
            [4520, 8455],
            [4505, 8431],
            [4506, 8427],
            [4526, 8416],
            [4526, 8397],
            [4510, 8394],
            [4511, 8380],
            [4499, 8369],
            [4497, 8362],
            [4486, 8361],
            [4483, 8373],
            [4491, 8384],
            [4488, 8388],
            [4499, 8393],
            [4491, 8418],
            [4481, 8438],
            [4470, 8436],
            [4456, 8444],
            [4458, 8450],
            [4451, 8460],
            [4442, 8459],
            [4436, 8466],
            [4429, 8466],
            [4418, 8481],
            [4398, 8480],
            [4385, 8488],
            [4370, 8504],
            [4359, 8510],
            [4354, 8519],
            [4339, 8527],
            [4326, 8542],
            [4317, 8544],
            [4319, 8550],
            [4311, 8562],
            [4309, 8575],
            [4278, 8593],
            [4264, 8596],
            [4255, 8591],
            [4247, 8579],
            [4227, 8573],
            [4231, 8587],
            [4222, 8585],
            [4211, 8589],
            [4207, 8600],
            [4211, 8610],
            [4203, 8614],
            [4199, 8623],
            [4212, 8627],
            [4215, 8634],
            [4205, 8645],
            [4210, 8653],
            [4226, 8655],
            [4235, 8653],
            [4241, 8665],
            [4251, 8672],
            [4251, 8666],
            [4263, 8658],
            [4266, 8649],
            [4275, 8664],
            [4275, 8673],
            [4284, 8667],
            [4296, 8669],
            [4299, 8678],
            [4310, 8675],
            [4309, 8687],
            [4325, 8684],
            [4330, 8691],
            [4346, 8691],
            [4357, 8695],
            [4367, 8681],
            [4405, 8675]
          ],
          [
            [4378, 8505],
            [4378, 8505],
            [4378, 8505],
            [4378, 8505],
            [4378, 8505]
          ],
          [
            [4374, 8577],
            [4375, 8580],
            [4373, 8579],
            [4372, 8578],
            [4374, 8577]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.53,
      "hc-key": "mt",
      "hc-a2": "MT",
      "name": "Malta",
      "labelrank": "5",
      "country-abbrev": "Malta",
      "subregion": "Southern Europe",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "MLT",
      "iso-a2": "MT",
      "woe-id": "23424897",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4445, 8288],
          [4453, 8285],
          [4454, 8280],
          [4449, 8282],
          [4445, 8288]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.24,
      "hc-middle-y": 0.47,
      "hc-key": "pg",
      "hc-a2": "PG",
      "name": "Papua New Guinea",
      "labelrank": "2",
      "country-abbrev": "P.N.G.",
      "subregion": "Melanesia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "PNG",
      "iso-a2": "PG",
      "woe-id": "23424926",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [9032, 6514],
            [9017, 6517],
            [9016, 6524],
            [9030, 6518],
            [9044, 6525],
            [9032, 6514]
          ]
        ],
        [
          [
            [8929, 6592],
            [8930, 6598],
            [8943, 6597],
            [8949, 6589],
            [8944, 6582],
            [8955, 6567],
            [8947, 6570],
            [8939, 6587],
            [8929, 6592]
          ]
        ],
        [
          [
            [9083, 6743],
            [9097, 6740],
            [9101, 6728],
            [9122, 6704],
            [9121, 6693],
            [9114, 6691],
            [9103, 6695],
            [9100, 6710],
            [9085, 6726],
            [9087, 6740],
            [9083, 6743]
          ]
        ],
        [
          [
            [8835, 6874],
            [8852, 6870],
            [8845, 6865],
            [8824, 6864],
            [8825, 6872],
            [8835, 6874]
          ]
        ],
        [
          [
            [8640, 6850],
            [8673, 6836],
            [8675, 6833],
            [8706, 6822],
            [8722, 6819],
            [8738, 6805],
            [8754, 6804],
            [8771, 6785],
            [8780, 6783],
            [8791, 6769],
            [8801, 6778],
            [8802, 6771],
            [8794, 6766],
            [8790, 6745],
            [8814, 6738],
            [8832, 6725],
            [8845, 6725],
            [8857, 6711],
            [8857, 6697],
            [8827, 6695],
            [8833, 6669],
            [8838, 6667],
            [8849, 6651],
            [8862, 6647],
            [8863, 6628],
            [8870, 6624],
            [8874, 6608],
            [8892, 6612],
            [8898, 6610],
            [8892, 6598],
            [8900, 6589],
            [8918, 6587],
            [8908, 6581],
            [8911, 6574],
            [8935, 6564],
            [8926, 6561],
            [8939, 6554],
            [8920, 6548],
            [8910, 6554],
            [8916, 6557],
            [8897, 6561],
            [8849, 6568],
            [8838, 6575],
            [8830, 6591],
            [8822, 6594],
            [8818, 6608],
            [8808, 6611],
            [8808, 6620],
            [8794, 6645],
            [8785, 6651],
            [8774, 6651],
            [8756, 6657],
            [8749, 6665],
            [8744, 6656],
            [8734, 6656],
            [8720, 6664],
            [8725, 6650],
            [8716, 6645],
            [8715, 6633],
            [8701, 6631],
            [8704, 6613],
            [8678, 6599],
            [8664, 6605],
            [8644, 6603],
            [8628, 6603],
            [8624, 6607],
            [8631, 6690],
            [8627, 6697],
            [8632, 6711],
            [8636, 6775],
            [8640, 6850]
          ]
        ],
        [
          [
            [9007, 6763],
            [8997, 6761],
            [8999, 6743],
            [8980, 6736],
            [8964, 6722],
            [8944, 6713],
            [8916, 6712],
            [8907, 6721],
            [8901, 6718],
            [8889, 6728],
            [8866, 6733],
            [8864, 6728],
            [8859, 6742],
            [8875, 6736],
            [8879, 6744],
            [8905, 6738],
            [8927, 6741],
            [8933, 6759],
            [8938, 6758],
            [8933, 6749],
            [8936, 6740],
            [8944, 6743],
            [8951, 6740],
            [8964, 6745],
            [8967, 6754],
            [8977, 6764],
            [8987, 6764],
            [8984, 6791],
            [8999, 6790],
            [9012, 6785],
            [9007, 6763]
          ]
        ],
        [
          [
            [9010, 6814],
            [8999, 6818],
            [8989, 6829],
            [8970, 6841],
            [8951, 6848],
            [8942, 6847],
            [8935, 6854],
            [8944, 6858],
            [8963, 6851],
            [8991, 6832],
            [8999, 6841],
            [9004, 6837],
            [9003, 6826],
            [9007, 6819],
            [9023, 6833],
            [9023, 6827],
            [9012, 6815],
            [9019, 6804],
            [9031, 6798],
            [9036, 6788],
            [9034, 6775],
            [9027, 6766],
            [9021, 6781],
            [9022, 6791],
            [9010, 6814]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "DE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.35,
      "hc-key": "de",
      "hc-a2": "DE",
      "name": "Germany",
      "labelrank": "2",
      "country-abbrev": "Ger.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "DEU",
      "iso-a2": "DE",
      "woe-id": "23424829",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4366, 8963],
            [4369, 8967],
            [4381, 8965],
            [4385, 8956],
            [4374, 8953],
            [4366, 8963]
          ]
        ],
        [
          [
            [4243, 8976],
            [4247, 8976],
            [4264, 8973],
            [4278, 8971],
            [4284, 8961],
            [4302, 8955],
            [4311, 8963],
            [4311, 8950],
            [4302, 8946],
            [4322, 8941],
            [4328, 8949],
            [4339, 8950],
            [4349, 8961],
            [4378, 8948],
            [4387, 8950],
            [4398, 8942],
            [4397, 8941],
            [4398, 8940],
            [4388, 8939],
            [4401, 8933],
            [4406, 8918],
            [4399, 8903],
            [4415, 8894],
            [4412, 8888],
            [4420, 8876],
            [4416, 8866],
            [4420, 8856],
            [4429, 8847],
            [4425, 8832],
            [4414, 8838],
            [4412, 8833],
            [4390, 8827],
            [4387, 8823],
            [4361, 8815],
            [4354, 8803],
            [4362, 8798],
            [4359, 8792],
            [4367, 8780],
            [4374, 8777],
            [4402, 8756],
            [4400, 8748],
            [4373, 8733],
            [4381, 8723],
            [4383, 8710],
            [4375, 8716],
            [4342, 8714],
            [4324, 8706],
            [4307, 8713],
            [4300, 8702],
            [4293, 8712],
            [4287, 8712],
            [4267, 8722],
            [4271, 8717],
            [4254, 8721],
            [4250, 8713],
            [4225, 8713],
            [4224, 8733],
            [4230, 8751],
            [4240, 8763],
            [4201, 8773],
            [4198, 8771],
            [4186, 8781],
            [4191, 8794],
            [4182, 8797],
            [4179, 8805],
            [4186, 8812],
            [4175, 8828],
            [4180, 8855],
            [4172, 8866],
            [4184, 8867],
            [4202, 8881],
            [4193, 8896],
            [4201, 8895],
            [4205, 8917],
            [4202, 8929],
            [4209, 8934],
            [4234, 8930],
            [4244, 8940],
            [4254, 8940],
            [4242, 8963],
            [4253, 8962],
            [4243, 8976]
          ]
        ],
        [
          [
            [4271, 8716],
            [4271, 8716],
            [4271, 8716],
            [4271, 8716]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "VU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.15,
      "hc-middle-y": 0.10,
      "hc-key": "vu",
      "hc-a2": "VU",
      "name": "Vanuatu",
      "labelrank": "4",
      "country-abbrev": "Van.",
      "subregion": "Melanesia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "VUT",
      "iso-a2": "VU",
      "woe-id": "23424907",
      "continent": "Oceania"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [9482, 6227],
            [9485, 6219],
            [9476, 6221],
            [9483, 6239],
            [9475, 6244],
            [9481, 6253],
            [9485, 6243],
            [9482, 6227]
          ]
        ],
        [
          [
            [9448, 6347],
            [9459, 6334],
            [9446, 6329],
            [9445, 6346],
            [9448, 6347]
          ]
        ],
        [
          [
            [9467, 6370],
            [9461, 6371],
            [9478, 6382],
            [9476, 6340],
            [9468, 6320],
            [9466, 6324],
            [9471, 6338],
            [9463, 6342],
            [9474, 6351],
            [9474, 6362],
            [9467, 6370]
          ]
        ],
        [
          [
            [9446, 6364],
            [9431, 6364],
            [9427, 6374],
            [9428, 6394],
            [9432, 6402],
            [9435, 6382],
            [9445, 6390],
            [9446, 6364]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GQ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.68,
      "hc-middle-y": 0.78,
      "hc-key": "gq",
      "hc-a2": "GQ",
      "name": "Equatorial Guinea",
      "labelrank": "4",
      "country-abbrev": "Eq. G.",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "GNQ",
      "iso-a2": "GQ",
      "woe-id": "23424804",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4293, 7086],
            [4299, 7081],
            [4290, 7066],
            [4282, 7068],
            [4293, 7086]
          ]
        ],
        [
          [
            [4327, 6984],
            [4312, 6991],
            [4327, 7019],
            [4327, 7034],
            [4333, 7027],
            [4377, 7027],
            [4377, 6984],
            [4327, 6984]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.39,
      "hc-middle-y": 0.50,
      "hc-key": "cy",
      "hc-a2": "CY",
      "name": "Cyprus",
      "labelrank": "5",
      "country-abbrev": "Cyp.",
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "CYP",
      "iso-a2": "CY",
      "woe-id": "-90",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5051, 8250],
            [5051, 8250],
            [5051, 8250],
            [5051, 8250],
            [5051, 8250]
          ]
        ],
        [
          [
            [5059, 8252],
            [5062, 8248],
            [5056, 8248],
            [5053, 8251],
            [5055, 8252],
            [5059, 8252],
            [5059, 8252]
          ]
        ],
        [
          [
            [5051, 8249],
            [5052, 8249],
            [5053, 8249],
            [5052, 8249],
            [5051, 8249]
          ]
        ],
        [
          [
            [5050, 8249],
            [5047, 8243],
            [5030, 8236],
            [5024, 8239],
            [5022, 8237],
            [5011, 8241],
            [5005, 8252],
            [5014, 8256],
            [5016, 8256],
            [5017, 8257],
            [5018, 8257],
            [5022, 8252],
            [5040, 8256],
            [5050, 8249],
            [5050, 8249]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.73,
      "hc-middle-y": 0.82,
      "hc-key": "km",
      "hc-a2": "KM",
      "name": "Comoros",
      "labelrank": "6",
      "country-abbrev": "Com.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "COM",
      "iso-a2": "KM",
      "woe-id": "23424786",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5433, 6490],
          [5431, 6487],
          [5425, 6502],
          [5417, 6509],
          [5419, 6521],
          [5433, 6490]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "VA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.61,
      "hc-middle-y": 0.45,
      "hc-key": "va",
      "hc-a2": "VA",
      "name": "Vatican",
      "labelrank": "6",
      "country-abbrev": "Vat.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "VAT",
      "iso-a2": "VA",
      "woe-id": "23424986",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4378, 8505],
          [4378, 8505],
          [4378, 8505],
          [4378, 8505],
          [4378, 8505]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.65,
      "hc-middle-y": 0.39,
      "hc-key": "sm",
      "hc-a2": "SM",
      "name": "San Marino",
      "labelrank": "6",
      "country-abbrev": "S.M.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "SMR",
      "iso-a2": "SM",
      "woe-id": "23424947",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4374, 8577],
          [4372, 8578],
          [4373, 8579],
          [4375, 8580],
          [4374, 8577]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.17,
      "hc-middle-y": 0.18,
      "hc-key": "am",
      "hc-a2": "AM",
      "name": "Armenia",
      "labelrank": "6",
      "country-abbrev": "Arm.",
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "ARM",
      "iso-a2": "AM",
      "woe-id": "23424743",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5379, 8458],
            [5379, 8460],
            [5381, 8459],
            [5380, 8458],
            [5379, 8458]
          ]
        ],
        [
          [
            [5411, 8396],
            [5396, 8422],
            [5385, 8419],
            [5371, 8430],
            [5364, 8427],
            [5353, 8437],
            [5339, 8436],
            [5328, 8439],
            [5322, 8453],
            [5326, 8460],
            [5314, 8476],
            [5335, 8480],
            [5347, 8479],
            [5360, 8483],
            [5363, 8476],
            [5381, 8467],
            [5376, 8459],
            [5384, 8450],
            [5397, 8444],
            [5392, 8436],
            [5391, 8437],
            [5387, 8437],
            [5387, 8437],
            [5387, 8437],
            [5386, 8438],
            [5387, 8437],
            [5387, 8437],
            [5387, 8437],
            [5387, 8437],
            [5387, 8437],
            [5388, 8436],
            [5388, 8436],
            [5392, 8436],
            [5392, 8436],
            [5392, 8436],
            [5408, 8423],
            [5418, 8422],
            [5415, 8415],
            [5422, 8397],
            [5418, 8398],
            [5411, 8396]
          ],
          [
            [5362, 8474],
            [5362, 8475],
            [5360, 8475],
            [5361, 8473],
            [5362, 8474]
          ],
          [
            [5368, 8471],
            [5367, 8472],
            [5367, 8472],
            [5368, 8471],
            [5368, 8471]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.68,
      "hc-middle-y": 0.16,
      "hc-key": "az",
      "hc-a2": "AZ",
      "name": "Azerbaijan",
      "labelrank": "5",
      "country-abbrev": "Aze.",
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "AZE",
      "iso-a2": "AZ",
      "woe-id": "23424741",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5362, 8474],
            [5361, 8473],
            [5360, 8475],
            [5362, 8475],
            [5362, 8474]
          ]
        ],
        [
          [
            [5368, 8471],
            [5368, 8471],
            [5367, 8472],
            [5367, 8472],
            [5368, 8471]
          ]
        ],
        [
          [
            [5392, 8436],
            [5392, 8436],
            [5396, 8436],
            [5397, 8444],
            [5384, 8450],
            [5376, 8459],
            [5381, 8467],
            [5363, 8476],
            [5360, 8483],
            [5366, 8488],
            [5382, 8484],
            [5385, 8480],
            [5397, 8479],
            [5406, 8474],
            [5410, 8482],
            [5392, 8496],
            [5398, 8504],
            [5408, 8503],
            [5428, 8483],
            [5443, 8479],
            [5459, 8493],
            [5463, 8503],
            [5480, 8487],
            [5488, 8474],
            [5503, 8458],
            [5517, 8457],
            [5528, 8446],
            [5514, 8449],
            [5503, 8438],
            [5505, 8428],
            [5503, 8402],
            [5495, 8408],
            [5494, 8396],
            [5498, 8380],
            [5490, 8378],
            [5482, 8387],
            [5469, 8394],
            [5476, 8403],
            [5469, 8413],
            [5475, 8415],
            [5461, 8428],
            [5431, 8407],
            [5422, 8397],
            [5415, 8415],
            [5418, 8422],
            [5408, 8423],
            [5392, 8436]
          ],
          [
            [5379, 8458],
            [5380, 8458],
            [5381, 8459],
            [5379, 8460],
            [5379, 8458]
          ]
        ],
        [
          [
            [5365, 8425],
            [5364, 8427],
            [5371, 8430],
            [5385, 8419],
            [5396, 8422],
            [5411, 8396],
            [5389, 8401],
            [5365, 8425]
          ]
        ],
        [
          [
            [5387, 8437],
            [5387, 8437],
            [5387, 8437],
            [5386, 8438],
            [5387, 8437]
          ]
        ],
        [
          [
            [5387, 8437],
            [5387, 8437],
            [5387, 8437],
            [5392, 8436],
            [5387, 8437]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TJ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.55,
      "hc-middle-y": 0.40,
      "hc-key": "tj",
      "hc-a2": "TJ",
      "name": "Tajikistan",
      "labelrank": "4",
      "country-abbrev": "Tjk.",
      "subregion": "Central Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "TJK",
      "iso-a2": "TJ",
      "woe-id": "23424961",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [6082, 8441],
            [6103, 8443],
            [6096, 8456],
            [6099, 8464],
            [6109, 8459],
            [6125, 8468],
            [6129, 8473],
            [6142, 8461],
            [6133, 8453],
            [6142, 8444],
            [6153, 8444],
            [6149, 8441],
            [6148, 8440],
            [6145, 8437],
            [6145, 8437],
            [6144, 8436],
            [6143, 8436],
            [6143, 8436],
            [6143, 8436],
            [6141, 8437],
            [6141, 8437],
            [6139, 8437],
            [6136, 8438],
            [6123, 8443],
            [6106, 8438],
            [6111, 8420],
            [6121, 8423],
            [6138, 8421],
            [6145, 8424],
            [6157, 8415],
            [6175, 8424],
            [6189, 8411],
            [6196, 8415],
            [6203, 8408],
            [6213, 8416],
            [6230, 8414],
            [6243, 8418],
            [6244, 8410],
            [6254, 8400],
            [6251, 8396],
            [6258, 8386],
            [6266, 8389],
            [6287, 8383],
            [6293, 8367],
            [6302, 8355],
            [6301, 8348],
            [6312, 8341],
            [6305, 8334],
            [6299, 8337],
            [6299, 8337],
            [6299, 8337],
            [6299, 8337],
            [6286, 8342],
            [6269, 8334],
            [6268, 8342],
            [6254, 8343],
            [6241, 8334],
            [6238, 8327],
            [6227, 8324],
            [6216, 8314],
            [6207, 8316],
            [6200, 8328],
            [6197, 8360],
            [6186, 8361],
            [6185, 8374],
            [6173, 8381],
            [6162, 8377],
            [6153, 8361],
            [6159, 8352],
            [6156, 8346],
            [6137, 8348],
            [6138, 8335],
            [6133, 8330],
            [6123, 8338],
            [6113, 8336],
            [6097, 8323],
            [6087, 8333],
            [6086, 8348],
            [6095, 8371],
            [6082, 8384],
            [6079, 8400],
            [6067, 8401],
            [6054, 8409],
            [6054, 8419],
            [6061, 8424],
            [6084, 8421],
            [6089, 8438],
            [6089, 8438],
            [6093, 8434],
            [6093, 8433],
            [6091, 8437],
            [6091, 8437],
            [6095, 8438],
            [6082, 8441]
          ],
          [
            [6093, 8433],
            [6093, 8433],
            [6093, 8433],
            [6093, 8433]
          ]
        ],
        [
          [
            [6136, 8470],
            [6135, 8470],
            [6132, 8473],
            [6133, 8472],
            [6136, 8470]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "UZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.56,
      "hc-middle-y": 0.57,
      "hc-key": "uz",
      "hc-a2": "UZ",
      "name": "Uzbekistan",
      "labelrank": "3",
      "country-abbrev": "Uzb.",
      "subregion": "Central Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "UZB",
      "iso-a2": "UZ",
      "woe-id": "23424980",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [6181, 8435],
            [6179, 8435],
            [6178, 8436],
            [6181, 8438],
            [6181, 8435]
          ]
        ],
        [
          [
            [6162, 8437],
            [6164, 8434],
            [6159, 8434],
            [6155, 8441],
            [6162, 8437]
          ]
        ],
        [
          [
            [5732, 8514],
            [5723, 8521],
            [5718, 8517],
            [5717, 8506],
            [5714, 8504],
            [5722, 8481],
            [5690, 8484],
            [5655, 8616],
            [5657, 8620],
            [5715, 8637],
            [5726, 8639],
            [5722, 8614],
            [5732, 8596],
            [5740, 8608],
            [5733, 8616],
            [5731, 8637],
            [5755, 8625],
            [5752, 8607],
            [5770, 8593],
            [5768, 8587],
            [5779, 8589],
            [5781, 8596],
            [5777, 8611],
            [5811, 8594],
            [5817, 8586],
            [5850, 8562],
            [5883, 8567],
            [5920, 8564],
            [5933, 8570],
            [5955, 8555],
            [5968, 8540],
            [5976, 8544],
            [5984, 8509],
            [5999, 8508],
            [6014, 8479],
            [6018, 8477],
            [6051, 8479],
            [6058, 8475],
            [6057, 8465],
            [6078, 8457],
            [6073, 8469],
            [6084, 8480],
            [6082, 8486],
            [6097, 8496],
            [6105, 8498],
            [6114, 8511],
            [6122, 8509],
            [6130, 8517],
            [6139, 8516],
            [6114, 8493],
            [6125, 8487],
            [6129, 8489],
            [6136, 8481],
            [6157, 8477],
            [6163, 8489],
            [6170, 8479],
            [6179, 8479],
            [6197, 8467],
            [6212, 8464],
            [6199, 8454],
            [6190, 8452],
            [6176, 8441],
            [6161, 8447],
            [6153, 8444],
            [6142, 8444],
            [6133, 8453],
            [6142, 8461],
            [6129, 8473],
            [6125, 8468],
            [6109, 8459],
            [6099, 8464],
            [6096, 8456],
            [6103, 8443],
            [6082, 8441],
            [6089, 8438],
            [6084, 8421],
            [6061, 8424],
            [6054, 8419],
            [6054, 8409],
            [6067, 8401],
            [6079, 8400],
            [6082, 8384],
            [6095, 8371],
            [6086, 8348],
            [6087, 8333],
            [6078, 8336],
            [6070, 8333],
            [6061, 8340],
            [6047, 8339],
            [6042, 8364],
            [6018, 8374],
            [6010, 8372],
            [5965, 8400],
            [5958, 8400],
            [5935, 8416],
            [5903, 8434],
            [5898, 8436],
            [5891, 8451],
            [5885, 8454],
            [5874, 8472],
            [5854, 8483],
            [5851, 8478],
            [5828, 8480],
            [5813, 8486],
            [5809, 8498],
            [5814, 8501],
            [5803, 8507],
            [5804, 8515],
            [5797, 8519],
            [5784, 8519],
            [5773, 8528],
            [5766, 8528],
            [5754, 8537],
            [5745, 8533],
            [5756, 8519],
            [5740, 8526],
            [5738, 8515],
            [5732, 8514]
          ],
          [
            [6136, 8470],
            [6133, 8472],
            [6132, 8473],
            [6135, 8470],
            [6136, 8470]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LS",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.50,
      "hc-key": "ls",
      "hc-a2": "LS",
      "name": "Lesotho",
      "labelrank": "6",
      "country-abbrev": "Les.",
      "subregion": "Southern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "LSO",
      "iso-a2": "LS",
      "woe-id": "23424880",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4859, 5844],
          [4867, 5846],
          [4884, 5870],
          [4897, 5878],
          [4913, 5883],
          [4936, 5854],
          [4926, 5842],
          [4925, 5832],
          [4914, 5826],
          [4900, 5824],
          [4894, 5818],
          [4889, 5805],
          [4879, 5807],
          [4868, 5818],
          [4859, 5844]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.35,
      "hc-middle-y": 0.50,
      "hc-key": "kg",
      "hc-a2": "KG",
      "name": "Kyrgyzstan",
      "labelrank": "4",
      "country-abbrev": "Kgz.",
      "subregion": "Central Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "KGZ",
      "iso-a2": "KG",
      "woe-id": "23424864",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6295, 8446],
          [6287, 8459],
          [6279, 8452],
          [6267, 8454],
          [6257, 8439],
          [6246, 8437],
          [6246, 8437],
          [6246, 8437],
          [6246, 8438],
          [6246, 8437],
          [6246, 8437],
          [6250, 8423],
          [6243, 8418],
          [6230, 8414],
          [6213, 8416],
          [6203, 8408],
          [6196, 8415],
          [6189, 8411],
          [6175, 8424],
          [6157, 8415],
          [6145, 8424],
          [6138, 8421],
          [6121, 8423],
          [6111, 8420],
          [6106, 8438],
          [6123, 8443],
          [6139, 8437],
          [6143, 8436],
          [6143, 8436],
          [6148, 8440],
          [6153, 8444],
          [6161, 8447],
          [6176, 8441],
          [6190, 8452],
          [6199, 8454],
          [6212, 8464],
          [6197, 8467],
          [6179, 8479],
          [6170, 8479],
          [6163, 8489],
          [6157, 8477],
          [6136, 8481],
          [6129, 8489],
          [6125, 8487],
          [6114, 8493],
          [6139, 8516],
          [6130, 8517],
          [6128, 8529],
          [6137, 8537],
          [6150, 8538],
          [6178, 8532],
          [6204, 8523],
          [6199, 8531],
          [6199, 8546],
          [6214, 8554],
          [6249, 8539],
          [6265, 8538],
          [6266, 8542],
          [6345, 8540],
          [6365, 8536],
          [6381, 8525],
          [6396, 8524],
          [6408, 8515],
          [6409, 8509],
          [6385, 8501],
          [6363, 8486],
          [6359, 8474],
          [6342, 8471],
          [6326, 8474],
          [6320, 8470],
          [6320, 8458],
          [6314, 8448],
          [6311, 8452],
          [6295, 8446]
        ],
        [
          [6181, 8435],
          [6181, 8438],
          [6178, 8436],
          [6179, 8435],
          [6181, 8435]
        ],
        [
          [6162, 8437],
          [6155, 8441],
          [6159, 8434],
          [6164, 8434],
          [6162, 8437]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KP",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.67,
      "hc-middle-y": 0.53,
      "hc-key": "kp",
      "hc-a2": "KP",
      "name": "North Korea",
      "labelrank": "3",
      "country-abbrev": "N.K.",
      "subregion": "Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "PRK",
      "iso-a2": "KP",
      "woe-id": "23424865",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7774, 8438],
          [7773, 8439],
          [7781, 8453],
          [7794, 8459],
          [7799, 8468],
          [7807, 8468],
          [7811, 8488],
          [7809, 8496],
          [7816, 8501],
          [7832, 8490],
          [7861, 8486],
          [7862, 8493],
          [7845, 8508],
          [7870, 8509],
          [7874, 8525],
          [7885, 8524],
          [7878, 8543],
          [7886, 8544],
          [7908, 8528],
          [7914, 8523],
          [7918, 8519],
          [7912, 8521],
          [7904, 8511],
          [7903, 8492],
          [7911, 8486],
          [7920, 8466],
          [7908, 8460],
          [7908, 8453],
          [7898, 8446],
          [7894, 8436],
          [7882, 8438],
          [7875, 8429],
          [7878, 8415],
          [7884, 8407],
          [7895, 8406],
          [7922, 8387],
          [7921, 8377],
          [7891, 8375],
          [7885, 8357],
          [7869, 8357],
          [7848, 8365],
          [7854, 8355],
          [7846, 8352],
          [7825, 8368],
          [7818, 8383],
          [7832, 8390],
          [7820, 8394],
          [7820, 8413],
          [7812, 8421],
          [7792, 8429],
          [7791, 8424],
          [7774, 8437],
          [7774, 8438]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.45,
      "hc-middle-y": 0.51,
      "hc-key": "pt",
      "hc-a2": "PT",
      "name": "Portugal",
      "labelrank": "2",
      "country-abbrev": "Port.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "PRT",
      "iso-a2": "PT",
      "woe-id": "23424925",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3792, 8444],
            [3795, 8437],
            [3795, 8437],
            [3791, 8427],
            [3775, 8427],
            [3782, 8418],
            [3787, 8405],
            [3792, 8402],
            [3783, 8391],
            [3780, 8380],
            [3790, 8364],
            [3782, 8363],
            [3774, 8347],
            [3777, 8333],
            [3760, 8325],
            [3741, 8330],
            [3728, 8326],
            [3734, 8341],
            [3736, 8371],
            [3731, 8383],
            [3724, 8379],
            [3722, 8389],
            [3715, 8390],
            [3720, 8415],
            [3727, 8420],
            [3742, 8465],
            [3738, 8503],
            [3742, 8507],
            [3758, 8514],
            [3759, 8502],
            [3773, 8505],
            [3781, 8501],
            [3793, 8506],
            [3807, 8506],
            [3807, 8499],
            [3818, 8493],
            [3795, 8473],
            [3799, 8449],
            [3792, 8444]
          ]
        ],
        [
          [
            [3795, 8437],
            [3795, 8437],
            [3796, 8436],
            [3795, 8437]
          ]
        ],
        [
          [
            [3795, 8437],
            [3795, 8437],
            [3795, 8437],
            [3795, 8437],
            [3795, 8437]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MX",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.58,
      "hc-key": "mx",
      "hc-a2": "MX",
      "name": "Mexico",
      "labelrank": "2",
      "country-abbrev": "Mex.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "MEX",
      "iso-a2": "MX",
      "woe-id": "23424900",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [802, 8050],
          [802, 8045],
          [809, 8044],
          [817, 8031],
          [822, 8000],
          [831, 7982],
          [840, 7974],
          [837, 7954],
          [842, 7945],
          [842, 7936],
          [869, 7918],
          [886, 7916],
          [893, 7909],
          [903, 7913],
          [900, 7904],
          [887, 7884],
          [876, 7859],
          [864, 7813],
          [858, 7793],
          [858, 7752],
          [864, 7737],
          [869, 7715],
          [888, 7686],
          [890, 7666],
          [899, 7656],
          [903, 7645],
          [923, 7643],
          [935, 7636],
          [943, 7622],
          [974, 7633],
          [997, 7634],
          [1003, 7640],
          [1024, 7643],
          [1030, 7640],
          [1063, 7660],
          [1070, 7668],
          [1074, 7683],
          [1081, 7688],
          [1086, 7718],
          [1091, 7730],
          [1110, 7739],
          [1132, 7742],
          [1165, 7751],
          [1193, 7745],
          [1202, 7750],
          [1209, 7736],
          [1195, 7714],
          [1205, 7712],
          [1195, 7701],
          [1189, 7710],
          [1181, 7699],
          [1178, 7687],
          [1168, 7678],
          [1177, 7675],
          [1168, 7663],
          [1175, 7666],
          [1158, 7626],
          [1152, 7635],
          [1155, 7649],
          [1144, 7635],
          [1138, 7635],
          [1123, 7613],
          [1118, 7617],
          [1114, 7610],
          [1055, 7610],
          [1051, 7589],
          [1037, 7589],
          [1048, 7576],
          [1057, 7570],
          [1067, 7556],
          [1063, 7545],
          [1022, 7545],
          [1003, 7515],
          [1007, 7508],
          [999, 7488],
          [981, 7512],
          [952, 7546],
          [936, 7553],
          [949, 7542],
          [922, 7558],
          [901, 7541],
          [874, 7531],
          [863, 7530],
          [841, 7540],
          [825, 7542],
          [801, 7554],
          [795, 7563],
          [769, 7568],
          [758, 7576],
          [725, 7590],
          [708, 7604],
          [704, 7613],
          [692, 7614],
          [651, 7629],
          [647, 7641],
          [630, 7656],
          [609, 7667],
          [596, 7692],
          [592, 7706],
          [608, 7715],
          [600, 7720],
          [611, 7731],
          [615, 7745],
          [607, 7752],
          [603, 7764],
          [602, 7789],
          [586, 7810],
          [575, 7834],
          [542, 7873],
          [540, 7887],
          [525, 7891],
          [508, 7907],
          [510, 7916],
          [520, 7928],
          [516, 7941],
          [505, 7942],
          [502, 7954],
          [493, 7958],
          [487, 7966],
          [492, 7983],
          [481, 7983],
          [471, 7991],
          [467, 8003],
          [451, 8027],
          [445, 8017],
          [437, 8022],
          [444, 8033],
          [451, 8035],
          [446, 8060],
          [446, 8071],
          [442, 8094],
          [448, 8107],
          [434, 8112],
          [426, 8123],
          [418, 8119],
          [408, 8129],
          [396, 8120],
          [390, 8105],
          [393, 8098],
          [386, 8071],
          [390, 8055],
          [395, 8054],
          [408, 8037],
          [413, 8047],
          [423, 8037],
          [422, 8026],
          [415, 8034],
          [408, 8027],
          [415, 8021],
          [417, 8008],
          [424, 8006],
          [421, 7984],
          [431, 7972],
          [434, 7958],
          [441, 7935],
          [442, 7948],
          [448, 7941],
          [451, 7918],
          [459, 7917],
          [449, 7906],
          [457, 7903],
          [454, 7897],
          [456, 7883],
          [465, 7879],
          [457, 7861],
          [464, 7844],
          [469, 7855],
          [478, 7846],
          [484, 7846],
          [484, 7828],
          [491, 7824],
          [489, 7812],
          [472, 7798],
          [467, 7804],
          [464, 7823],
          [456, 7828],
          [444, 7844],
          [429, 7854],
          [415, 7869],
          [423, 7907],
          [421, 7916],
          [394, 7941],
          [384, 7941],
          [379, 7950],
          [360, 7961],
          [361, 7967],
          [348, 7980],
          [342, 7994],
          [354, 7983],
          [365, 7981],
          [372, 7985],
          [376, 7974],
          [377, 7987],
          [382, 7991],
          [387, 8006],
          [367, 8041],
          [348, 8055],
          [351, 8076],
          [346, 8081],
          [349, 8093],
          [343, 8099],
          [346, 8106],
          [339, 8121],
          [345, 8133],
          [339, 8138],
          [338, 8158],
          [416, 8164],
          [410, 8156],
          [513, 8113],
          [602, 8113],
          [608, 8130],
          [661, 8129],
          [686, 8096],
          [698, 8084],
          [701, 8071],
          [700, 8052],
          [712, 8039],
          [737, 8026],
          [748, 8036],
          [759, 8054],
          [773, 8060],
          [778, 8056],
          [800, 8055],
          [802, 8050]
        ],
        [
          [886, 7894],
          [881, 7891],
          [876, 7877],
          [876, 7861],
          [890, 7893],
          [886, 7894]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.71,
      "hc-middle-y": 0.13,
      "hc-key": "ma",
      "hc-a2": "MA",
      "name": "Morocco",
      "labelrank": "3",
      "country-abbrev": "Mor.",
      "subregion": "Northern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "MAR",
      "iso-a2": "MA",
      "woe-id": "23424893",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3913, 8260],
          [3914, 8260],
          [3916, 8255],
          [3936, 8253],
          [3950, 8240],
          [3947, 8235],
          [3953, 8215],
          [3950, 8201],
          [3954, 8194],
          [3952, 8184],
          [3960, 8165],
          [3972, 8157],
          [3966, 8151],
          [3965, 8141],
          [3926, 8143],
          [3912, 8140],
          [3916, 8130],
          [3890, 8125],
          [3885, 8113],
          [3893, 8099],
          [3890, 8090],
          [3867, 8082],
          [3838, 8059],
          [3829, 8046],
          [3823, 8049],
          [3779, 8045],
          [3764, 8041],
          [3729, 8014],
          [3729, 7977],
          [3724, 7977],
          [3725, 7956],
          [3705, 7955],
          [3694, 7947],
          [3678, 7947],
          [3657, 7952],
          [3642, 7948],
          [3643, 7938],
          [3631, 7919],
          [3621, 7916],
          [3607, 7871],
          [3586, 7855],
          [3578, 7839],
          [3563, 7832],
          [3554, 7818],
          [3547, 7777],
          [3533, 7761],
          [3526, 7745],
          [3497, 7747],
          [3456, 7744],
          [3458, 7758],
          [3467, 7776],
          [3479, 7787],
          [3483, 7806],
          [3504, 7841],
          [3528, 7866],
          [3532, 7894],
          [3542, 7920],
          [3552, 7931],
          [3570, 7940],
          [3586, 7978],
          [3593, 7987],
          [3622, 7993],
          [3640, 8001],
          [3654, 8017],
          [3670, 8026],
          [3694, 8058],
          [3702, 8079],
          [3693, 8089],
          [3695, 8116],
          [3714, 8145],
          [3715, 8159],
          [3727, 8171],
          [3738, 8185],
          [3783, 8206],
          [3792, 8214],
          [3809, 8245],
          [3821, 8279],
          [3838, 8285],
          [3838, 8283],
          [3840, 8282],
          [3842, 8272],
          [3857, 8259],
          [3869, 8256],
          [3891, 8261],
          [3899, 8257],
          [3913, 8262],
          [3913, 8262],
          [3913, 8262],
          [3913, 8260]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.53,
      "hc-key": "co",
      "hc-a2": "CO",
      "name": "Colombia",
      "labelrank": "2",
      "country-abbrev": "Col.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "COL",
      "iso-a2": "CO",
      "woe-id": "23424787",
      "continent": "South America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1412, 7000],
          [1407, 7006],
          [1412, 7014],
          [1421, 7013],
          [1417, 7028],
          [1429, 7045],
          [1443, 7045],
          [1452, 7054],
          [1450, 7058],
          [1462, 7073],
          [1468, 7086],
          [1460, 7102],
          [1466, 7123],
          [1463, 7148],
          [1460, 7155],
          [1468, 7162],
          [1461, 7177],
          [1466, 7191],
          [1456, 7203],
          [1449, 7216],
          [1455, 7234],
          [1460, 7227],
          [1474, 7242],
          [1467, 7261],
          [1469, 7269],
          [1488, 7242],
          [1488, 7260],
          [1482, 7265],
          [1506, 7282],
          [1509, 7291],
          [1518, 7298],
          [1528, 7299],
          [1527, 7310],
          [1534, 7341],
          [1542, 7345],
          [1557, 7360],
          [1568, 7355],
          [1572, 7348],
          [1581, 7369],
          [1590, 7366],
          [1608, 7367],
          [1627, 7382],
          [1643, 7389],
          [1649, 7402],
          [1669, 7410],
          [1678, 7405],
          [1681, 7396],
          [1673, 7388],
          [1652, 7381],
          [1641, 7362],
          [1633, 7361],
          [1618, 7335],
          [1615, 7312],
          [1601, 7288],
          [1613, 7293],
          [1619, 7287],
          [1623, 7269],
          [1632, 7256],
          [1627, 7242],
          [1627, 7225],
          [1636, 7221],
          [1639, 7210],
          [1665, 7208],
          [1669, 7206],
          [1689, 7210],
          [1704, 7206],
          [1725, 7175],
          [1738, 7178],
          [1751, 7175],
          [1775, 7179],
          [1789, 7177],
          [1791, 7169],
          [1784, 7162],
          [1784, 7153],
          [1776, 7144],
          [1778, 7135],
          [1775, 7115],
          [1782, 7087],
          [1792, 7074],
          [1774, 7054],
          [1781, 7051],
          [1795, 7036],
          [1805, 6992],
          [1799, 6990],
          [1797, 7010],
          [1790, 7024],
          [1782, 7023],
          [1774, 7013],
          [1763, 7011],
          [1707, 7010],
          [1707, 6986],
          [1724, 6986],
          [1731, 6971],
          [1719, 6974],
          [1700, 6968],
          [1700, 6941],
          [1715, 6927],
          [1714, 6919],
          [1722, 6902],
          [1706, 6789],
          [1694, 6804],
          [1680, 6806],
          [1702, 6845],
          [1673, 6864],
          [1656, 6858],
          [1645, 6867],
          [1639, 6860],
          [1625, 6855],
          [1616, 6860],
          [1606, 6856],
          [1598, 6864],
          [1598, 6880],
          [1586, 6884],
          [1583, 6900],
          [1562, 6910],
          [1557, 6926],
          [1543, 6940],
          [1528, 6943],
          [1506, 6954],
          [1495, 6964],
          [1491, 6956],
          [1476, 6955],
          [1459, 6961],
          [1457, 6971],
          [1420, 6991],
          [1412, 7000]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.45,
      "hc-middle-y": 0.33,
      "hc-key": "ar",
      "hc-a2": "AR",
      "name": "Argentina",
      "labelrank": "2",
      "country-abbrev": "Arg.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "ARG",
      "iso-a2": "AR",
      "woe-id": "23424747",
      "continent": "South America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [2116, 4921],
            [2119, 4918],
            [2117, 4918],
            [2116, 4921]
          ]
        ],
        [
          [
            [2116, 4921],
            [2083, 4997],
            [2099, 4985],
            [2094, 4980],
            [2098, 4974],
            [2108, 4972],
            [2116, 4963],
            [2132, 4952],
            [2159, 4940],
            [2174, 4932],
            [2191, 4926],
            [2205, 4927],
            [2225, 4922],
            [2248, 4923],
            [2226, 4917],
            [2223, 4920],
            [2198, 4917],
            [2178, 4912],
            [2162, 4917],
            [2116, 4921]
          ]
        ],
        [
          [
            [1832, 5457],
            [1832, 5457],
            [1832, 5457],
            [1833, 5458],
            [1827, 5471],
            [1832, 5469],
            [1828, 5494],
            [1842, 5504],
            [1832, 5527],
            [1823, 5541],
            [1815, 5569],
            [1815, 5587],
            [1825, 5590],
            [1824, 5595],
            [1832, 5603],
            [1826, 5624],
            [1819, 5635],
            [1824, 5637],
            [1823, 5659],
            [1826, 5670],
            [1833, 5672],
            [1826, 5693],
            [1827, 5704],
            [1819, 5707],
            [1816, 5723],
            [1787, 5771],
            [1786, 5785],
            [1793, 5791],
            [1790, 5800],
            [1792, 5816],
            [1799, 5817],
            [1796, 5837],
            [1788, 5853],
            [1794, 5863],
            [1795, 5889],
            [1806, 5906],
            [1813, 5937],
            [1821, 5935],
            [1828, 5945],
            [1818, 5958],
            [1821, 5973],
            [1811, 5999],
            [1817, 6012],
            [1809, 6024],
            [1818, 6039],
            [1845, 6053],
            [1851, 6090],
            [1845, 6097],
            [1849, 6108],
            [1856, 6111],
            [1857, 6119],
            [1870, 6124],
            [1871, 6135],
            [1888, 6123],
            [1912, 6124],
            [1926, 6120],
            [1937, 6095],
            [1938, 6107],
            [1946, 6127],
            [1982, 6127],
            [1988, 6119],
            [2001, 6109],
            [2014, 6089],
            [2022, 6081],
            [2043, 6068],
            [2047, 6060],
            [2070, 6052],
            [2079, 6053],
            [2103, 6035],
            [2122, 6024],
            [2141, 6018],
            [2157, 6009],
            [2164, 5999],
            [2150, 5974],
            [2147, 5946],
            [2137, 5935],
            [2140, 5929],
            [2158, 5931],
            [2186, 5923],
            [2206, 5924],
            [2212, 5919],
            [2218, 5930],
            [2231, 5925],
            [2240, 5942],
            [2248, 5943],
            [2258, 5954],
            [2261, 5971],
            [2259, 5994],
            [2275, 5997],
            [2282, 5992],
            [2292, 5969],
            [2293, 5945],
            [2290, 5935],
            [2259, 5918],
            [2256, 5909],
            [2247, 5907],
            [2234, 5895],
            [2218, 5864],
            [2194, 5830],
            [2186, 5823],
            [2181, 5811],
            [2185, 5796],
            [2180, 5775],
            [2184, 5770],
            [2178, 5759],
            [2184, 5745],
            [2182, 5739],
            [2188, 5716],
            [2181, 5715],
            [2180, 5692],
            [2189, 5674],
            [2183, 5670],
            [2188, 5661],
            [2200, 5653],
            [2221, 5643],
            [2236, 5627],
            [2231, 5611],
            [2236, 5602],
            [2249, 5591],
            [2255, 5593],
            [2261, 5573],
            [2254, 5552],
            [2244, 5536],
            [2243, 5524],
            [2228, 5513],
            [2203, 5503],
            [2179, 5498],
            [2142, 5492],
            [2124, 5493],
            [2114, 5487],
            [2109, 5499],
            [2107, 5485],
            [2118, 5479],
            [2120, 5461],
            [2114, 5462],
            [2116, 5450],
            [2126, 5451],
            [2129, 5440],
            [2123, 5426],
            [2105, 5416],
            [2081, 5415],
            [2051, 5427],
            [2045, 5432],
            [2039, 5422],
            [2050, 5402],
            [2052, 5386],
            [2061, 5378],
            [2073, 5374],
            [2071, 5369],
            [2086, 5369],
            [2079, 5375],
            [2091, 5382],
            [2100, 5374],
            [2104, 5358],
            [2091, 5353],
            [2077, 5366],
            [2064, 5361],
            [2064, 5356],
            [2083, 5349],
            [2075, 5343],
            [2064, 5325],
            [2075, 5299],
            [2065, 5287],
            [2072, 5279],
            [2069, 5271],
            [2053, 5277],
            [2051, 5272],
            [2036, 5265],
            [2027, 5251],
            [2025, 5231],
            [2036, 5217],
            [2060, 5201],
            [2084, 5199],
            [2093, 5194],
            [2097, 5182],
            [2096, 5163],
            [2071, 5140],
            [2063, 5128],
            [2068, 5100],
            [2066, 5092],
            [2043, 5080],
            [2040, 5072],
            [2044, 5057],
            [2060, 5033],
            [2082, 5010],
            [2082, 5010],
            [2082, 5010],
            [2037, 5020],
            [1981, 5020],
            [1960, 5036],
            [1960, 5047],
            [1950, 5069],
            [1936, 5070],
            [1927, 5065],
            [1914, 5083],
            [1908, 5087],
            [1904, 5100],
            [1897, 5109],
            [1897, 5117],
            [1906, 5117],
            [1906, 5129],
            [1915, 5136],
            [1911, 5148],
            [1917, 5152],
            [1904, 5168],
            [1910, 5194],
            [1907, 5208],
            [1913, 5212],
            [1905, 5228],
            [1899, 5232],
            [1906, 5238],
            [1897, 5247],
            [1906, 5263],
            [1894, 5277],
            [1879, 5280],
            [1878, 5285],
            [1900, 5284],
            [1898, 5297],
            [1880, 5298],
            [1875, 5309],
            [1879, 5315],
            [1873, 5327],
            [1865, 5332],
            [1867, 5342],
            [1853, 5349],
            [1844, 5375],
            [1854, 5382],
            [1843, 5398],
            [1837, 5423],
            [1831, 5431],
            [1835, 5446],
            [1830, 5450],
            [1832, 5457]
          ]
        ],
        [
          [
            [2084, 5008],
            [2082, 5010],
            [2082, 5010],
            [2082, 5010],
            [2083, 5009],
            [2084, 5008]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.48,
      "hc-key": "sa",
      "hc-a2": "SA",
      "name": "Saudi Arabia",
      "labelrank": "2",
      "country-abbrev": "Saud.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "SAU",
      "iso-a2": "SA",
      "woe-id": "23424938",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5541, 8009],
          [5548, 7995],
          [5558, 7983],
          [5559, 7974],
          [5575, 7960],
          [5581, 7966],
          [5583, 7956],
          [5604, 7940],
          [5598, 7940],
          [5606, 7930],
          [5607, 7905],
          [5618, 7894],
          [5623, 7879],
          [5632, 7868],
          [5638, 7861],
          [5645, 7864],
          [5648, 7859],
          [5650, 7863],
          [5651, 7864],
          [5651, 7864],
          [5648, 7852],
          [5658, 7850],
          [5659, 7843],
          [5694, 7801],
          [5777, 7789],
          [5779, 7792],
          [5796, 7765],
          [5781, 7691],
          [5687, 7654],
          [5596, 7640],
          [5565, 7622],
          [5549, 7597],
          [5544, 7583],
          [5530, 7578],
          [5521, 7590],
          [5508, 7588],
          [5479, 7591],
          [5470, 7596],
          [5453, 7596],
          [5424, 7593],
          [5413, 7599],
          [5405, 7592],
          [5405, 7576],
          [5408, 7572],
          [5395, 7556],
          [5393, 7567],
          [5386, 7575],
          [5368, 7567],
          [5366, 7570],
          [5380, 7580],
          [5377, 7596],
          [5359, 7612],
          [5339, 7643],
          [5329, 7673],
          [5321, 7683],
          [5299, 7702],
          [5284, 7708],
          [5264, 7740],
          [5267, 7744],
          [5260, 7766],
          [5262, 7786],
          [5238, 7832],
          [5212, 7851],
          [5207, 7850],
          [5194, 7872],
          [5196, 7884],
          [5185, 7902],
          [5184, 7894],
          [5171, 7902],
          [5176, 7916],
          [5171, 7918],
          [5160, 7938],
          [5136, 7969],
          [5127, 7985],
          [5118, 7994],
          [5103, 7993],
          [5109, 8009],
          [5110, 8040],
          [5146, 8034],
          [5158, 8045],
          [5165, 8058],
          [5188, 8063],
          [5192, 8076],
          [5202, 8082],
          [5166, 8119],
          [5227, 8138],
          [5232, 8142],
          [5273, 8135],
          [5329, 8104],
          [5356, 8082],
          [5419, 8034],
          [5473, 8029],
          [5478, 8030],
          [5507, 8026],
          [5517, 8009],
          [5541, 8009]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "QA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.50,
      "hc-key": "qa",
      "hc-a2": "QA",
      "name": "Qatar",
      "labelrank": "5",
      "country-abbrev": "Qatar",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "QAT",
      "iso-a2": "QA",
      "woe-id": "23424930",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5650, 7863],
          [5649, 7864],
          [5645, 7864],
          [5638, 7861],
          [5632, 7868],
          [5627, 7896],
          [5630, 7895],
          [5634, 7917],
          [5640, 7921],
          [5652, 7910],
          [5650, 7897],
          [5656, 7876],
          [5651, 7864],
          [5650, 7863]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.98,
      "hc-middle-y": 0.03,
      "hc-key": "nl",
      "hc-a2": "NL",
      "name": "Netherlands",
      "labelrank": "5",
      "country-abbrev": "Neth.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "NLD",
      "iso-a2": "NL",
      "woe-id": "-90",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1962, 7618],
            [1959, 7618],
            [1959, 7619],
            [1962, 7618]
          ]
        ],
        [
          [
            [4099, 8851],
            [4111, 8850],
            [4124, 8850],
            [4112, 8845],
            [4099, 8851]
          ]
        ],
        [
          [
            [4205, 8917],
            [4201, 8895],
            [4193, 8896],
            [4202, 8881],
            [4184, 8867],
            [4172, 8866],
            [4180, 8855],
            [4175, 8828],
            [4166, 8829],
            [4170, 8843],
            [4152, 8846],
            [4146, 8854],
            [4125, 8850],
            [4113, 8851],
            [4102, 8857],
            [4113, 8859],
            [4116, 8868],
            [4131, 8885],
            [4141, 8916],
            [4146, 8907],
            [4162, 8920],
            [4162, 8925],
            [4196, 8924],
            [4205, 8917]
          ],
          [
            [4165, 8888],
            [4157, 8883],
            [4149, 8887],
            [4163, 8895],
            [4165, 8903],
            [4156, 8904],
            [4155, 8911],
            [4146, 8906],
            [4153, 8898],
            [4146, 8895],
            [4144, 8886],
            [4158, 8882],
            [4165, 8888]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.88,
      "hc-middle-y": 0.48,
      "hc-key": "ae",
      "hc-a2": "AE",
      "name": "United Arab Emirates",
      "labelrank": "4",
      "country-abbrev": "U.A.E.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "ARE",
      "iso-a2": "AE",
      "woe-id": "23424738",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5803, 7901],
          [5807, 7897],
          [5809, 7877],
          [5800, 7867],
          [5797, 7876],
          [5791, 7873],
          [5792, 7849],
          [5800, 7843],
          [5783, 7839],
          [5787, 7832],
          [5778, 7803],
          [5779, 7792],
          [5777, 7789],
          [5694, 7801],
          [5659, 7843],
          [5658, 7850],
          [5664, 7851],
          [5666, 7840],
          [5683, 7840],
          [5690, 7846],
          [5723, 7842],
          [5740, 7846],
          [5751, 7855],
          [5754, 7868],
          [5767, 7878],
          [5780, 7897],
          [5794, 7911],
          [5795, 7917],
          [5799, 7902],
          [5803, 7901]
        ],
        [
          [5805, 7886],
          [5807, 7888],
          [5803, 7889],
          [5804, 7885],
          [5805, 7886]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.50,
      "hc-key": "ke",
      "hc-a2": "KE",
      "name": "Kenya",
      "labelrank": "2",
      "country-abbrev": "Ken.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "KEN",
      "iso-a2": "KE",
      "woe-id": "23424863",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5292, 6772],
          [5246, 6810],
          [5240, 6819],
          [5242, 6833],
          [5125, 6907],
          [5124, 6919],
          [5128, 6933],
          [5137, 6927],
          [5138, 6934],
          [5150, 6935],
          [5147, 6943],
          [5131, 6937],
          [5123, 6945],
          [5123, 6956],
          [5128, 6969],
          [5140, 6988],
          [5149, 6992],
          [5155, 7008],
          [5153, 7039],
          [5146, 7053],
          [5137, 7064],
          [5137, 7083],
          [5125, 7091],
          [5121, 7104],
          [5134, 7119],
          [5168, 7134],
          [5175, 7119],
          [5185, 7119],
          [5189, 7112],
          [5215, 7112],
          [5257, 7081],
          [5270, 7081],
          [5304, 7073],
          [5314, 7091],
          [5344, 7106],
          [5357, 7093],
          [5381, 7095],
          [5364, 7066],
          [5351, 7051],
          [5352, 6914],
          [5370, 6888],
          [5371, 6883],
          [5358, 6869],
          [5346, 6861],
          [5340, 6851],
          [5333, 6851],
          [5325, 6844],
          [5323, 6824],
          [5318, 6821],
          [5312, 6801],
          [5299, 6774],
          [5292, 6772]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.93,
      "hc-middle-y": 0.22,
      "hc-key": "my",
      "hc-a2": "MY",
      "name": "Malaysia",
      "labelrank": "3",
      "country-abbrev": "Malay.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "MYS",
      "iso-a2": "MY",
      "woe-id": "23424901",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [7872, 7102],
            [7875, 7105],
            [7879, 7101],
            [7872, 7102]
          ]
        ],
        [
          [
            [7782, 7129],
            [7783, 7130],
            [7783, 7126],
            [7786, 7110],
            [7795, 7107],
            [7787, 7129],
            [7794, 7129],
            [7801, 7141],
            [7788, 7143],
            [7801, 7154],
            [7809, 7154],
            [7816, 7175],
            [7832, 7196],
            [7836, 7208],
            [7839, 7192],
            [7846, 7201],
            [7848, 7213],
            [7854, 7194],
            [7862, 7193],
            [7869, 7184],
            [7865, 7177],
            [7871, 7167],
            [7879, 7172],
            [7885, 7165],
            [7904, 7153],
            [7919, 7150],
            [7922, 7140],
            [7903, 7131],
            [7892, 7134],
            [7885, 7128],
            [7900, 7109],
            [7878, 7105],
            [7871, 7111],
            [7868, 7101],
            [7856, 7109],
            [7829, 7106],
            [7811, 7110],
            [7805, 7102],
            [7800, 7059],
            [7793, 7060],
            [7788, 7052],
            [7792, 7039],
            [7779, 7030],
            [7781, 7017],
            [7770, 7000],
            [7751, 7000],
            [7742, 6992],
            [7724, 7000],
            [7720, 7005],
            [7703, 7005],
            [7693, 7000],
            [7691, 6989],
            [7672, 6982],
            [7662, 6987],
            [7641, 6978],
            [7611, 7006],
            [7607, 7015],
            [7610, 7024],
            [7620, 7010],
            [7639, 7011],
            [7648, 7002],
            [7655, 7004],
            [7661, 7024],
            [7664, 7050],
            [7669, 7046],
            [7676, 7052],
            [7687, 7054],
            [7719, 7064],
            [7733, 7086],
            [7749, 7106],
            [7750, 7118],
            [7758, 7113],
            [7770, 7096],
            [7776, 7100],
            [7778, 7111],
            [7774, 7123],
            [7782, 7129]
          ]
        ],
        [
          [
            [7291, 7186],
            [7292, 7196],
            [7308, 7187],
            [7315, 7179],
            [7323, 7179],
            [7320, 7162],
            [7325, 7156],
            [7339, 7167],
            [7347, 7160],
            [7355, 7180],
            [7366, 7175],
            [7371, 7165],
            [7391, 7147],
            [7403, 7126],
            [7405, 7107],
            [7401, 7086],
            [7406, 7077],
            [7405, 7057],
            [7416, 7045],
            [7431, 7014],
            [7434, 6997],
            [7422, 6999],
            [7420, 7000],
            [7415, 7001],
            [7409, 6994],
            [7404, 7004],
            [7376, 7024],
            [7354, 7036],
            [7351, 7043],
            [7335, 7053],
            [7337, 7061],
            [7326, 7081],
            [7314, 7091],
            [7317, 7095],
            [7309, 7107],
            [7309, 7127],
            [7301, 7136],
            [7299, 7170],
            [7293, 7181],
            [7282, 7181],
            [7291, 7186]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.26,
      "hc-middle-y": 0.50,
      "hc-key": "pa",
      "hc-a2": "PA",
      "name": "Panama",
      "labelrank": "4",
      "country-abbrev": "Pan.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "PAN",
      "iso-a2": "PA",
      "woe-id": "23424924",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1469, 7269],
          [1467, 7261],
          [1474, 7242],
          [1460, 7227],
          [1455, 7234],
          [1449, 7216],
          [1437, 7233],
          [1433, 7247],
          [1443, 7259],
          [1435, 7257],
          [1431, 7266],
          [1419, 7255],
          [1412, 7259],
          [1428, 7269],
          [1413, 7281],
          [1397, 7280],
          [1392, 7269],
          [1366, 7248],
          [1376, 7235],
          [1380, 7224],
          [1366, 7216],
          [1351, 7215],
          [1349, 7229],
          [1338, 7231],
          [1326, 7226],
          [1321, 7216],
          [1319, 7226],
          [1331, 7234],
          [1323, 7249],
          [1295, 7256],
          [1286, 7246],
          [1282, 7257],
          [1289, 7264],
          [1287, 7273],
          [1294, 7279],
          [1287, 7284],
          [1291, 7304],
          [1300, 7303],
          [1315, 7292],
          [1309, 7288],
          [1314, 7279],
          [1325, 7282],
          [1332, 7275],
          [1348, 7274],
          [1370, 7287],
          [1388, 7294],
          [1397, 7304],
          [1415, 7299],
          [1431, 7298],
          [1448, 7290],
          [1465, 7269],
          [1469, 7269]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "HT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.75,
      "hc-middle-y": 0.50,
      "hc-key": "ht",
      "hc-a2": "HT",
      "name": "Haiti",
      "labelrank": "5",
      "country-abbrev": "Haiti",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "HTI",
      "iso-a2": "HT",
      "woe-id": "23424839",
      "continent": "North America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1675, 7635],
            [1675, 7636],
            [1674, 7637],
            [1674, 7637],
            [1675, 7635]
          ]
        ],
        [
          [
            [1673, 7639],
            [1674, 7635],
            [1676, 7635],
            [1681, 7628],
            [1678, 7618],
            [1669, 7626],
            [1642, 7622],
            [1629, 7626],
            [1607, 7623],
            [1592, 7633],
            [1595, 7640],
            [1603, 7641],
            [1614, 7637],
            [1649, 7633],
            [1652, 7637],
            [1635, 7648],
            [1636, 7653],
            [1646, 7648],
            [1653, 7670],
            [1645, 7677],
            [1631, 7678],
            [1632, 7683],
            [1652, 7695],
            [1653, 7689],
            [1677, 7680],
            [1685, 7680],
            [1687, 7662],
            [1681, 7652],
            [1683, 7645],
            [1673, 7639]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "DO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.41,
      "hc-key": "do",
      "hc-a2": "DO",
      "name": "Dominican Republic",
      "labelrank": "5",
      "country-abbrev": "Dom. Rep.",
      "subregion": "Caribbean",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "DOM",
      "iso-a2": "DO",
      "woe-id": "23424800",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1674, 7637],
          [1673, 7639],
          [1683, 7645],
          [1681, 7652],
          [1687, 7662],
          [1685, 7680],
          [1689, 7687],
          [1703, 7685],
          [1711, 7689],
          [1738, 7677],
          [1744, 7679],
          [1748, 7665],
          [1756, 7667],
          [1765, 7662],
          [1753, 7662],
          [1752, 7658],
          [1780, 7653],
          [1791, 7641],
          [1787, 7630],
          [1778, 7621],
          [1772, 7632],
          [1740, 7634],
          [1731, 7625],
          [1718, 7624],
          [1714, 7633],
          [1702, 7622],
          [1688, 7602],
          [1680, 7608],
          [1678, 7618],
          [1681, 7628],
          [1676, 7635],
          [1675, 7635],
          [1674, 7637],
          [1674, 7637]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "HR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.35,
      "hc-middle-y": 0.59,
      "hc-key": "hr",
      "hc-a2": "HR",
      "name": "Croatia",
      "labelrank": "6",
      "country-abbrev": "Cro.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "HRV",
      "iso-a2": "HR",
      "woe-id": "23424843",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4558, 8523],
            [4536, 8538],
            [4531, 8541],
            [4538, 8538],
            [4556, 8529],
            [4556, 8526],
            [4558, 8523]
          ]
        ],
        [
          [
            [4404, 8637],
            [4436, 8639],
            [4455, 8636],
            [4452, 8645],
            [4463, 8649],
            [4462, 8663],
            [4487, 8674],
            [4497, 8670],
            [4513, 8654],
            [4529, 8647],
            [4545, 8646],
            [4559, 8653],
            [4563, 8634],
            [4576, 8626],
            [4566, 8624],
            [4566, 8612],
            [4559, 8613],
            [4555, 8623],
            [4542, 8625],
            [4530, 8622],
            [4503, 8630],
            [4491, 8628],
            [4486, 8620],
            [4476, 8627],
            [4470, 8626],
            [4468, 8609],
            [4481, 8599],
            [4485, 8588],
            [4529, 8547],
            [4529, 8542],
            [4521, 8549],
            [4501, 8549],
            [4493, 8557],
            [4479, 8563],
            [4478, 8569],
            [4463, 8578],
            [4453, 8587],
            [4445, 8605],
            [4445, 8615],
            [4436, 8616],
            [4430, 8623],
            [4433, 8630],
            [4426, 8632],
            [4432, 8603],
            [4422, 8616],
            [4413, 8610],
            [4405, 8625],
            [4404, 8637]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.84,
      "hc-key": "th",
      "hc-a2": "TH",
      "name": "Thailand",
      "labelrank": "3",
      "country-abbrev": "Thai.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "THA",
      "iso-a2": "TH",
      "woe-id": "23424960",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7355, 7180],
          [7347, 7160],
          [7339, 7167],
          [7325, 7156],
          [7320, 7162],
          [7323, 7179],
          [7315, 7179],
          [7308, 7187],
          [7292, 7196],
          [7291, 7186],
          [7281, 7199],
          [7273, 7192],
          [7277, 7202],
          [7269, 7221],
          [7265, 7214],
          [7261, 7230],
          [7248, 7246],
          [7232, 7248],
          [7229, 7236],
          [7223, 7265],
          [7224, 7287],
          [7231, 7306],
          [7227, 7311],
          [7231, 7319],
          [7237, 7332],
          [7236, 7345],
          [7250, 7360],
          [7261, 7387],
          [7251, 7411],
          [7239, 7432],
          [7242, 7439],
          [7239, 7457],
          [7230, 7471],
          [7218, 7480],
          [7205, 7498],
          [7201, 7513],
          [7212, 7517],
          [7209, 7544],
          [7218, 7548],
          [7216, 7559],
          [7212, 7553],
          [7203, 7569],
          [7200, 7581],
          [7188, 7591],
          [7172, 7610],
          [7174, 7616],
          [7160, 7635],
          [7170, 7638],
          [7165, 7651],
          [7169, 7658],
          [7166, 7669],
          [7173, 7684],
          [7190, 7679],
          [7204, 7685],
          [7203, 7693],
          [7219, 7699],
          [7231, 7708],
          [7237, 7703],
          [7244, 7706],
          [7253, 7694],
          [7249, 7682],
          [7253, 7674],
          [7266, 7677],
          [7278, 7674],
          [7277, 7668],
          [7283, 7656],
          [7283, 7641],
          [7277, 7633],
          [7284, 7619],
          [7277, 7602],
          [7286, 7597],
          [7304, 7620],
          [7312, 7625],
          [7330, 7616],
          [7331, 7611],
          [7342, 7617],
          [7354, 7633],
          [7374, 7629],
          [7392, 7604],
          [7406, 7593],
          [7408, 7562],
          [7420, 7547],
          [7433, 7543],
          [7440, 7532],
          [7443, 7505],
          [7440, 7484],
          [7433, 7481],
          [7429, 7476],
          [7419, 7484],
          [7390, 7481],
          [7382, 7484],
          [7365, 7479],
          [7352, 7453],
          [7343, 7452],
          [7344, 7441],
          [7350, 7430],
          [7352, 7418],
          [7362, 7409],
          [7360, 7400],
          [7369, 7380],
          [7358, 7399],
          [7349, 7401],
          [7330, 7418],
          [7306, 7419],
          [7302, 7416],
          [7297, 7434],
          [7299, 7448],
          [7276, 7449],
          [7267, 7440],
          [7272, 7433],
          [7269, 7418],
          [7273, 7401],
          [7268, 7392],
          [7259, 7361],
          [7260, 7351],
          [7254, 7342],
          [7251, 7323],
          [7252, 7310],
          [7264, 7289],
          [7282, 7299],
          [7277, 7290],
          [7281, 7267],
          [7292, 7256],
          [7299, 7225],
          [7294, 7237],
          [7291, 7227],
          [7299, 7214],
          [7305, 7216],
          [7319, 7202],
          [7337, 7201],
          [7345, 7189],
          [7355, 7180]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.43,
      "hc-key": "cd",
      "hc-a2": "CD",
      "name": "Democratic Republic of the Congo",
      "labelrank": "2",
      "country-abbrev": "D.R.C.",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "COD",
      "iso-a2": "CD",
      "woe-id": "23424780",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4965, 6822],
          [4962, 6819],
          [4959, 6786],
          [4964, 6782],
          [4960, 6758],
          [4969, 6738],
          [4963, 6726],
          [4973, 6697],
          [4982, 6684],
          [4993, 6677],
          [4997, 6655],
          [5007, 6640],
          [4952, 6631],
          [4933, 6608],
          [4932, 6592],
          [4939, 6597],
          [4944, 6582],
          [4942, 6555],
          [4935, 6524],
          [4932, 6520],
          [4936, 6504],
          [4944, 6500],
          [4953, 6486],
          [4968, 6483],
          [4968, 6491],
          [4978, 6494],
          [4977, 6447],
          [4968, 6454],
          [4957, 6446],
          [4930, 6483],
          [4908, 6489],
          [4893, 6516],
          [4886, 6505],
          [4877, 6499],
          [4854, 6503],
          [4833, 6513],
          [4832, 6530],
          [4813, 6525],
          [4804, 6520],
          [4799, 6523],
          [4802, 6533],
          [4789, 6542],
          [4785, 6536],
          [4772, 6538],
          [4757, 6533],
          [4742, 6536],
          [4732, 6528],
          [4730, 6542],
          [4735, 6546],
          [4735, 6560],
          [4730, 6577],
          [4720, 6588],
          [4718, 6596],
          [4724, 6632],
          [4718, 6648],
          [4722, 6668],
          [4719, 6675],
          [4678, 6675],
          [4681, 6689],
          [4671, 6686],
          [4645, 6686],
          [4645, 6668],
          [4639, 6665],
          [4639, 6649],
          [4601, 6649],
          [4598, 6645],
          [4582, 6645],
          [4562, 6675],
          [4560, 6691],
          [4555, 6697],
          [4554, 6716],
          [4550, 6726],
          [4540, 6729],
          [4472, 6727],
          [4437, 6728],
          [4413, 6721],
          [4406, 6732],
          [4415, 6733],
          [4416, 6754],
          [4413, 6758],
          [4426, 6771],
          [4434, 6774],
          [4445, 6765],
          [4455, 6772],
          [4455, 6781],
          [4463, 6779],
          [4477, 6787],
          [4478, 6765],
          [4492, 6767],
          [4504, 6785],
          [4515, 6795],
          [4528, 6801],
          [4538, 6823],
          [4536, 6839],
          [4538, 6867],
          [4548, 6876],
          [4558, 6899],
          [4574, 6909],
          [4588, 6927],
          [4587, 6939],
          [4595, 6961],
          [4592, 6984],
          [4599, 7004],
          [4599, 7027],
          [4616, 7063],
          [4617, 7076],
          [4617, 7097],
          [4614, 7108],
          [4621, 7110],
          [4631, 7129],
          [4642, 7138],
          [4652, 7138],
          [4673, 7124],
          [4681, 7111],
          [4690, 7112],
          [4702, 7106],
          [4719, 7106],
          [4734, 7101],
          [4744, 7103],
          [4757, 7126],
          [4775, 7120],
          [4810, 7136],
          [4814, 7130],
          [4836, 7134],
          [4838, 7144],
          [4845, 7147],
          [4856, 7139],
          [4863, 7142],
          [4874, 7135],
          [4887, 7134],
          [4895, 7140],
          [4906, 7135],
          [4917, 7118],
          [4936, 7106],
          [4949, 7116],
          [4964, 7108],
          [4972, 7120],
          [4984, 7116],
          [4997, 7094],
          [5008, 7091],
          [5008, 7081],
          [5018, 7077],
          [5015, 7060],
          [5019, 7053],
          [5014, 7038],
          [5023, 7036],
          [5033, 7027],
          [5008, 7003],
          [5007, 6993],
          [5000, 6990],
          [4996, 6980],
          [4990, 6977],
          [4989, 6965],
          [4981, 6943],
          [4973, 6937],
          [4969, 6924],
          [4980, 6929],
          [4977, 6912],
          [4977, 6895],
          [4970, 6890],
          [4966, 6884],
          [4960, 6887],
          [4956, 6873],
          [4961, 6864],
          [4954, 6854],
          [4955, 6848],
          [4959, 6845],
          [4966, 6833],
          [4965, 6822]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.62,
      "hc-middle-y": 0.53,
      "hc-key": "kw",
      "hc-a2": "KW",
      "name": "Kuwait",
      "labelrank": "6",
      "country-abbrev": "Kwt.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "KWT",
      "iso-a2": "KW",
      "woe-id": "23424870",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5519, 8063],
          [5532, 8056],
          [5528, 8047],
          [5521, 8048],
          [5514, 8040],
          [5527, 8039],
          [5530, 8027],
          [5541, 8009],
          [5517, 8009],
          [5507, 8026],
          [5478, 8030],
          [5487, 8043],
          [5492, 8062],
          [5500, 8067],
          [5519, 8063]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.51,
      "hc-key": "ie",
      "hc-a2": "IE",
      "name": "Ireland",
      "labelrank": "3",
      "country-abbrev": "Ire.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "IRL",
      "iso-a2": "IE",
      "woe-id": "23424803",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3806, 8982],
          [3792, 8965],
          [3779, 8960],
          [3787, 8951],
          [3803, 8948],
          [3811, 8959],
          [3821, 8945],
          [3831, 8947],
          [3829, 8945],
          [3837, 8907],
          [3831, 8897],
          [3826, 8880],
          [3816, 8881],
          [3796, 8877],
          [3791, 8873],
          [3772, 8866],
          [3759, 8858],
          [3727, 8853],
          [3723, 8863],
          [3711, 8869],
          [3725, 8875],
          [3711, 8876],
          [3719, 8883],
          [3727, 8881],
          [3737, 8896],
          [3726, 8893],
          [3743, 8906],
          [3753, 8918],
          [3735, 8917],
          [3722, 8928],
          [3731, 8930],
          [3732, 8942],
          [3728, 8955],
          [3766, 8953],
          [3765, 8957],
          [3781, 8967],
          [3762, 8967],
          [3774, 8974],
          [3778, 8985],
          [3807, 8991],
          [3814, 8987],
          [3806, 8982]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.22,
      "hc-middle-y": 0.47,
      "hc-key": "mm",
      "hc-a2": "MM",
      "name": "Myanmar",
      "labelrank": "3",
      "country-abbrev": "Myan.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "MMR",
      "iso-a2": "MM",
      "woe-id": "23424763",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6980, 7731],
          [6977, 7735],
          [6981, 7745],
          [6991, 7740],
          [6985, 7765],
          [6988, 7771],
          [6995, 7764],
          [7002, 7780],
          [6998, 7803],
          [7005, 7808],
          [7003, 7828],
          [6997, 7840],
          [7007, 7841],
          [7024, 7834],
          [7027, 7853],
          [7036, 7878],
          [7030, 7892],
          [7040, 7905],
          [7040, 7919],
          [7036, 7932],
          [7065, 7962],
          [7082, 7965],
          [7095, 7955],
          [7096, 7959],
          [7085, 7974],
          [7097, 7985],
          [7094, 7997],
          [7099, 8009],
          [7120, 7994],
          [7131, 7972],
          [7133, 7977],
          [7143, 7973],
          [7153, 7938],
          [7150, 7919],
          [7157, 7911],
          [7131, 7880],
          [7135, 7871],
          [7128, 7868],
          [7134, 7856],
          [7137, 7835],
          [7153, 7845],
          [7166, 7843],
          [7180, 7818],
          [7180, 7810],
          [7202, 7805],
          [7197, 7793],
          [7201, 7784],
          [7196, 7771],
          [7222, 7767],
          [7224, 7755],
          [7233, 7744],
          [7250, 7748],
          [7262, 7757],
          [7264, 7749],
          [7251, 7740],
          [7248, 7721],
          [7239, 7718],
          [7237, 7703],
          [7231, 7708],
          [7219, 7699],
          [7203, 7693],
          [7204, 7685],
          [7190, 7679],
          [7173, 7684],
          [7166, 7669],
          [7169, 7658],
          [7165, 7651],
          [7170, 7638],
          [7160, 7635],
          [7174, 7616],
          [7172, 7610],
          [7188, 7591],
          [7200, 7581],
          [7203, 7569],
          [7212, 7553],
          [7216, 7559],
          [7218, 7548],
          [7209, 7544],
          [7212, 7517],
          [7201, 7513],
          [7205, 7498],
          [7218, 7480],
          [7230, 7471],
          [7239, 7457],
          [7242, 7439],
          [7239, 7432],
          [7251, 7411],
          [7261, 7387],
          [7250, 7360],
          [7236, 7345],
          [7237, 7332],
          [7231, 7318],
          [7231, 7319],
          [7229, 7326],
          [7218, 7313],
          [7221, 7325],
          [7230, 7332],
          [7226, 7346],
          [7219, 7345],
          [7215, 7353],
          [7228, 7357],
          [7234, 7353],
          [7232, 7376],
          [7223, 7379],
          [7216, 7374],
          [7217, 7388],
          [7223, 7389],
          [7221, 7398],
          [7231, 7392],
          [7224, 7403],
          [7226, 7409],
          [7210, 7404],
          [7204, 7407],
          [7226, 7414],
          [7227, 7420],
          [7222, 7438],
          [7209, 7457],
          [7198, 7462],
          [7203, 7474],
          [7190, 7501],
          [7189, 7512],
          [7183, 7524],
          [7183, 7538],
          [7177, 7543],
          [7179, 7552],
          [7172, 7554],
          [7160, 7580],
          [7149, 7594],
          [7151, 7582],
          [7144, 7562],
          [7132, 7565],
          [7134, 7556],
          [7122, 7551],
          [7109, 7532],
          [7099, 7536],
          [7098, 7548],
          [7094, 7534],
          [7068, 7544],
          [7068, 7562],
          [7072, 7578],
          [7074, 7600],
          [7064, 7628],
          [7053, 7647],
          [7045, 7649],
          [7036, 7642],
          [7031, 7649],
          [7036, 7655],
          [7028, 7667],
          [7040, 7663],
          [7033, 7672],
          [7044, 7670],
          [7021, 7695],
          [7013, 7695],
          [7014, 7686],
          [6986, 7717],
          [6980, 7731]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "UG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.21,
      "hc-middle-y": 0.67,
      "hc-key": "ug",
      "hc-a2": "UG",
      "name": "Uganda",
      "labelrank": "3",
      "country-abbrev": "Uga.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "UGA",
      "iso-a2": "UG",
      "woe-id": "23424974",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5051, 6909],
            [5051, 6910],
            [5052, 6909],
            [5051, 6909]
          ]
        ],
        [
          [
            [5050, 6909],
            [5019, 6909],
            [5007, 6907],
            [5002, 6907],
            [4989, 6892],
            [4986, 6897],
            [4977, 6895],
            [4977, 6912],
            [4980, 6929],
            [4988, 6941],
            [4981, 6943],
            [4989, 6965],
            [4990, 6977],
            [4996, 6980],
            [5000, 6990],
            [5007, 6993],
            [5010, 6985],
            [5022, 7003],
            [5030, 7007],
            [5037, 7018],
            [5036, 7033],
            [5033, 7027],
            [5023, 7036],
            [5014, 7038],
            [5019, 7053],
            [5015, 7060],
            [5018, 7077],
            [5029, 7088],
            [5041, 7083],
            [5049, 7089],
            [5062, 7078],
            [5069, 7085],
            [5089, 7091],
            [5105, 7086],
            [5121, 7104],
            [5125, 7091],
            [5137, 7083],
            [5137, 7064],
            [5146, 7053],
            [5153, 7039],
            [5155, 7008],
            [5149, 6992],
            [5140, 6988],
            [5128, 6969],
            [5123, 6956],
            [5109, 6953],
            [5098, 6958],
            [5084, 6947],
            [5077, 6952],
            [5055, 6942],
            [5057, 6935],
            [5047, 6917],
            [5050, 6909]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.61,
      "hc-middle-y": 0.49,
      "hc-key": "kz",
      "hc-a2": "KZ",
      "name": "Kazakhstan",
      "labelrank": "3",
      "country-abbrev": "Kaz.",
      "subregion": "Central Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "KAZ",
      "iso-a2": "KZ",
      "woe-id": "-90",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5731, 8637],
            [5738, 8649],
            [5750, 8639],
            [5755, 8625],
            [5731, 8637]
          ]
        ],
        [
          [
            [5726, 8639],
            [5715, 8637],
            [5657, 8620],
            [5655, 8616],
            [5690, 8484],
            [5676, 8482],
            [5666, 8489],
            [5652, 8506],
            [5627, 8520],
            [5604, 8518],
            [5593, 8513],
            [5580, 8499],
            [5576, 8512],
            [5579, 8535],
            [5562, 8540],
            [5555, 8539],
            [5543, 8551],
            [5533, 8550],
            [5531, 8561],
            [5513, 8581],
            [5511, 8587],
            [5495, 8592],
            [5479, 8615],
            [5479, 8622],
            [5488, 8623],
            [5485, 8611],
            [5491, 8604],
            [5508, 8603],
            [5517, 8598],
            [5521, 8602],
            [5509, 8611],
            [5517, 8631],
            [5549, 8634],
            [5560, 8656],
            [5551, 8688],
            [5532, 8692],
            [5524, 8685],
            [5495, 8696],
            [5474, 8688],
            [5459, 8675],
            [5445, 8676],
            [5444, 8668],
            [5419, 8680],
            [5434, 8684],
            [5414, 8707],
            [5397, 8720],
            [5370, 8722],
            [5365, 8738],
            [5346, 8743],
            [5349, 8762],
            [5355, 8772],
            [5346, 8777],
            [5345, 8795],
            [5355, 8803],
            [5352, 8811],
            [5358, 8817],
            [5389, 8794],
            [5400, 8802],
            [5388, 8822],
            [5406, 8831],
            [5405, 8841],
            [5414, 8841],
            [5428, 8849],
            [5432, 8860],
            [5454, 8860],
            [5454, 8854],
            [5467, 8855],
            [5467, 8861],
            [5480, 8865],
            [5487, 8855],
            [5511, 8855],
            [5523, 8845],
            [5537, 8841],
            [5550, 8832],
            [5550, 8823],
            [5559, 8823],
            [5554, 8838],
            [5588, 8820],
            [5605, 8840],
            [5623, 8841],
            [5635, 8832],
            [5641, 8841],
            [5665, 8838],
            [5666, 8832],
            [5679, 8826],
            [5705, 8820],
            [5706, 8831],
            [5730, 8825],
            [5747, 8829],
            [5746, 8845],
            [5742, 8852],
            [5724, 8859],
            [5712, 8859],
            [5698, 8869],
            [5703, 8878],
            [5717, 8885],
            [5703, 8897],
            [5720, 8909],
            [5735, 8906],
            [5735, 8913],
            [5709, 8918],
            [5709, 8928],
            [5699, 8931],
            [5695, 8940],
            [5705, 8946],
            [5711, 8943],
            [5750, 8947],
            [5772, 8955],
            [5796, 8958],
            [5806, 8956],
            [5808, 8966],
            [5823, 8966],
            [5878, 8978],
            [5876, 8986],
            [5913, 8991],
            [5931, 8984],
            [5945, 8990],
            [5959, 8971],
            [5965, 8970],
            [5974, 8948],
            [5976, 8951],
            [5999, 8949],
            [5994, 8957],
            [6010, 8949],
            [6040, 8942],
            [6038, 8932],
            [6047, 8924],
            [6051, 8930],
            [6067, 8930],
            [6086, 8937],
            [6098, 8947],
            [6120, 8959],
            [6127, 8954],
            [6117, 8949],
            [6125, 8943],
            [6174, 8918],
            [6202, 8896],
            [6249, 8855],
            [6274, 8830],
            [6285, 8836],
            [6286, 8848],
            [6302, 8844],
            [6303, 8836],
            [6313, 8836],
            [6318, 8827],
            [6336, 8827],
            [6351, 8830],
            [6352, 8834],
            [6370, 8837],
            [6383, 8832],
            [6400, 8820],
            [6405, 8811],
            [6430, 8804],
            [6446, 8786],
            [6455, 8787],
            [6474, 8782],
            [6481, 8794],
            [6484, 8787],
            [6513, 8768],
            [6500, 8769],
            [6501, 8748],
            [6480, 8743],
            [6480, 8726],
            [6493, 8706],
            [6494, 8694],
            [6486, 8694],
            [6475, 8685],
            [6470, 8691],
            [6448, 8691],
            [6419, 8700],
            [6423, 8652],
            [6423, 8639],
            [6434, 8635],
            [6434, 8624],
            [6426, 8628],
            [6418, 8625],
            [6407, 8632],
            [6386, 8624],
            [6364, 8620],
            [6360, 8613],
            [6381, 8607],
            [6378, 8604],
            [6388, 8582],
            [6412, 8550],
            [6401, 8545],
            [6409, 8540],
            [6400, 8532],
            [6408, 8515],
            [6396, 8524],
            [6381, 8525],
            [6365, 8536],
            [6345, 8540],
            [6266, 8542],
            [6265, 8538],
            [6249, 8539],
            [6214, 8554],
            [6199, 8546],
            [6199, 8531],
            [6204, 8523],
            [6178, 8532],
            [6150, 8538],
            [6137, 8537],
            [6128, 8529],
            [6130, 8517],
            [6122, 8509],
            [6114, 8511],
            [6105, 8498],
            [6097, 8496],
            [6082, 8486],
            [6084, 8480],
            [6073, 8469],
            [6078, 8457],
            [6057, 8465],
            [6058, 8475],
            [6051, 8479],
            [6018, 8477],
            [6014, 8479],
            [5999, 8508],
            [5984, 8509],
            [5976, 8544],
            [5968, 8540],
            [5955, 8555],
            [5933, 8570],
            [5920, 8564],
            [5883, 8567],
            [5850, 8562],
            [5817, 8586],
            [5811, 8594],
            [5777, 8611],
            [5769, 8638],
            [5761, 8640],
            [5759, 8653],
            [5777, 8650],
            [5772, 8659],
            [5755, 8659],
            [5751, 8668],
            [5745, 8667],
            [5754, 8658],
            [5754, 8647],
            [5747, 8644],
            [5744, 8654],
            [5727, 8651],
            [5726, 8639]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.49,
      "hc-key": "tr",
      "hc-a2": "TR",
      "name": "Turkey",
      "labelrank": "2",
      "country-abbrev": "Tur.",
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "TUR",
      "iso-a2": "TR",
      "woe-id": "23424969",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5364, 8427],
          [5365, 8425],
          [5358, 8430],
          [5355, 8417],
          [5343, 8415],
          [5354, 8395],
          [5358, 8378],
          [5363, 8376],
          [5358, 8363],
          [5371, 8353],
          [5372, 8343],
          [5380, 8331],
          [5365, 8325],
          [5363, 8335],
          [5340, 8335],
          [5328, 8340],
          [5316, 8339],
          [5306, 8330],
          [5301, 8338],
          [5295, 8332],
          [5280, 8328],
          [5261, 8330],
          [5247, 8326],
          [5229, 8316],
          [5213, 8313],
          [5195, 8315],
          [5180, 8322],
          [5158, 8312],
          [5144, 8312],
          [5132, 8319],
          [5130, 8306],
          [5136, 8296],
          [5127, 8296],
          [5122, 8281],
          [5114, 8285],
          [5108, 8300],
          [5119, 8311],
          [5111, 8322],
          [5102, 8310],
          [5093, 8309],
          [5075, 8319],
          [5068, 8317],
          [5055, 8303],
          [5040, 8292],
          [5017, 8289],
          [5003, 8294],
          [4991, 8308],
          [4969, 8318],
          [4949, 8321],
          [4942, 8297],
          [4937, 8299],
          [4920, 8292],
          [4903, 8301],
          [4901, 8313],
          [4886, 8314],
          [4884, 8319],
          [4870, 8312],
          [4863, 8318],
          [4875, 8327],
          [4856, 8326],
          [4849, 8329],
          [4853, 8336],
          [4839, 8339],
          [4838, 8363],
          [4818, 8367],
          [4807, 8374],
          [4815, 8380],
          [4828, 8380],
          [4820, 8391],
          [4830, 8397],
          [4814, 8411],
          [4822, 8423],
          [4798, 8418],
          [4797, 8438],
          [4785, 8443],
          [4798, 8448],
          [4815, 8458],
          [4793, 8458],
          [4791, 8463],
          [4800, 8471],
          [4797, 8481],
          [4806, 8487],
          [4796, 8498],
          [4803, 8507],
          [4815, 8511],
          [4831, 8505],
          [4845, 8507],
          [4849, 8495],
          [4859, 8488],
          [4881, 8481],
          [4874, 8471],
          [4854, 8475],
          [4848, 8471],
          [4835, 8472],
          [4826, 8459],
          [4812, 8452],
          [4830, 8453],
          [4835, 8447],
          [4848, 8450],
          [4836, 8459],
          [4852, 8453],
          [4849, 8450],
          [4886, 8451],
          [4875, 8455],
          [4880, 8459],
          [4908, 8462],
          [4892, 8463],
          [4880, 8471],
          [4885, 8481],
          [4905, 8478],
          [4917, 8480],
          [4934, 8475],
          [4946, 8475],
          [4950, 8484],
          [4971, 8494],
          [4974, 8498],
          [5004, 8509],
          [5046, 8506],
          [5052, 8512],
          [5065, 8498],
          [5074, 8495],
          [5085, 8499],
          [5102, 8481],
          [5107, 8486],
          [5136, 8473],
          [5140, 8477],
          [5161, 8469],
          [5193, 8476],
          [5216, 8469],
          [5250, 8486],
          [5253, 8491],
          [5282, 8488],
          [5291, 8493],
          [5314, 8476],
          [5326, 8460],
          [5322, 8453],
          [5328, 8439],
          [5339, 8436],
          [5353, 8437],
          [5364, 8427]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.23,
      "hc-middle-y": 0.44,
      "hc-key": "ga",
      "hc-a2": "GA",
      "name": "Gabon",
      "labelrank": "4",
      "country-abbrev": "Gabon",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "GAB",
      "iso-a2": "GA",
      "woe-id": "23424822",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4327, 6984],
          [4377, 6984],
          [4377, 7027],
          [4378, 7032],
          [4410, 7033],
          [4424, 7030],
          [4440, 7031],
          [4442, 7027],
          [4436, 7006],
          [4440, 6992],
          [4458, 7000],
          [4473, 6996],
          [4480, 6981],
          [4473, 6967],
          [4468, 6967],
          [4461, 6954],
          [4460, 6939],
          [4468, 6936],
          [4481, 6924],
          [4478, 6909],
          [4480, 6901],
          [4478, 6876],
          [4473, 6873],
          [4468, 6853],
          [4461, 6854],
          [4457, 6868],
          [4447, 6856],
          [4433, 6859],
          [4426, 6875],
          [4413, 6876],
          [4414, 6860],
          [4391, 6857],
          [4385, 6860],
          [4389, 6828],
          [4397, 6824],
          [4394, 6808],
          [4382, 6816],
          [4373, 6809],
          [4370, 6800],
          [4355, 6818],
          [4354, 6823],
          [4330, 6846],
          [4309, 6878],
          [4312, 6896],
          [4302, 6898],
          [4291, 6925],
          [4302, 6919],
          [4309, 6931],
          [4312, 6947],
          [4310, 6957],
          [4317, 6957],
          [4311, 6970],
          [4322, 6969],
          [4319, 6982],
          [4327, 6984]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.61,
      "hc-middle-y": 0.33,
      "hc-key": "tl",
      "hc-a2": "TL",
      "name": "East Timor",
      "labelrank": "5",
      "country-abbrev": "T.L.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "TLS",
      "iso-a2": "TL",
      "woe-id": "23424968",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [8068, 6599],
            [8074, 6602],
            [8082, 6605],
            [8075, 6593],
            [8068, 6599]
          ]
        ],
        [
          [
            [8098, 6613],
            [8106, 6625],
            [8149, 6633],
            [8153, 6631],
            [8167, 6637],
            [8178, 6633],
            [8168, 6623],
            [8153, 6619],
            [8149, 6614],
            [8119, 6604],
            [8101, 6593],
            [8099, 6604],
            [8105, 6605],
            [8098, 6613]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.60,
      "hc-middle-y": 0.60,
      "hc-key": "mr",
      "hc-a2": "MR",
      "name": "Mauritania",
      "labelrank": "3",
      "country-abbrev": "Mrt.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "MRT",
      "iso-a2": "MR",
      "woe-id": "23424896",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3728, 7963],
          [3828, 7893],
          [3850, 7877],
          [3794, 7877],
          [3822, 7562],
          [3831, 7554],
          [3825, 7523],
          [3700, 7524],
          [3676, 7519],
          [3656, 7521],
          [3649, 7509],
          [3633, 7528],
          [3623, 7525],
          [3620, 7501],
          [3605, 7497],
          [3598, 7506],
          [3586, 7513],
          [3583, 7524],
          [3574, 7528],
          [3566, 7548],
          [3555, 7547],
          [3539, 7566],
          [3520, 7566],
          [3495, 7560],
          [3474, 7559],
          [3467, 7535],
          [3470, 7566],
          [3480, 7589],
          [3485, 7615],
          [3484, 7635],
          [3480, 7653],
          [3470, 7669],
          [3472, 7680],
          [3481, 7691],
          [3481, 7699],
          [3471, 7719],
          [3467, 7716],
          [3459, 7734],
          [3454, 7720],
          [3458, 7741],
          [3585, 7741],
          [3583, 7784],
          [3581, 7794],
          [3586, 7804],
          [3599, 7813],
          [3619, 7820],
          [3621, 7915],
          [3727, 7915],
          [3728, 7963]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "DZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.50,
      "hc-key": "dz",
      "hc-a2": "DZ",
      "name": "Algeria",
      "labelrank": "3",
      "country-abbrev": "Alg.",
      "subregion": "Northern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "DZA",
      "iso-a2": "DZ",
      "woe-id": "23424740",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3850, 7877],
          [3828, 7893],
          [3728, 7963],
          [3729, 7977],
          [3729, 8014],
          [3764, 8041],
          [3779, 8045],
          [3823, 8049],
          [3829, 8046],
          [3838, 8059],
          [3867, 8082],
          [3890, 8090],
          [3893, 8099],
          [3885, 8113],
          [3890, 8125],
          [3916, 8130],
          [3912, 8140],
          [3926, 8143],
          [3965, 8141],
          [3966, 8151],
          [3972, 8157],
          [3960, 8165],
          [3952, 8184],
          [3954, 8194],
          [3950, 8201],
          [3953, 8215],
          [3947, 8235],
          [3950, 8240],
          [3936, 8253],
          [3950, 8255],
          [3965, 8265],
          [3968, 8272],
          [3990, 8283],
          [4002, 8280],
          [4009, 8290],
          [4037, 8306],
          [4085, 8310],
          [4095, 8318],
          [4112, 8317],
          [4124, 8322],
          [4152, 8322],
          [4166, 8312],
          [4181, 8319],
          [4195, 8322],
          [4203, 8329],
          [4208, 8325],
          [4225, 8322],
          [4232, 8329],
          [4244, 8325],
          [4248, 8320],
          [4258, 8324],
          [4269, 8323],
          [4271, 8319],
          [4256, 8306],
          [4262, 8305],
          [4259, 8281],
          [4262, 8274],
          [4260, 8237],
          [4248, 8228],
          [4239, 8216],
          [4238, 8208],
          [4247, 8183],
          [4257, 8178],
          [4264, 8169],
          [4265, 8157],
          [4288, 8140],
          [4305, 8072],
          [4298, 8068],
          [4310, 8049],
          [4316, 8031],
          [4315, 7999],
          [4320, 7984],
          [4314, 7963],
          [4320, 7946],
          [4318, 7934],
          [4307, 7928],
          [4305, 7919],
          [4323, 7892],
          [4326, 7872],
          [4338, 7858],
          [4347, 7861],
          [4375, 7851],
          [4389, 7822],
          [4246, 7724],
          [4192, 7671],
          [4141, 7659],
          [4113, 7653],
          [4105, 7659],
          [4110, 7668],
          [4109, 7684],
          [4100, 7689],
          [4082, 7693],
          [4076, 7701],
          [4066, 7700],
          [4055, 7714],
          [4042, 7719],
          [4042, 7732],
          [3850, 7877]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.70,
      "hc-middle-y": 0.71,
      "hc-key": "pe",
      "hc-a2": "PE",
      "name": "Peru",
      "labelrank": "2",
      "country-abbrev": "Peru",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "PER",
      "iso-a2": "PE",
      "woe-id": "23424919",
      "continent": "South America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1747, 6369],
          [1735, 6377],
          [1728, 6373],
          [1727, 6356],
          [1733, 6359],
          [1747, 6350],
          [1745, 6344],
          [1758, 6342],
          [1760, 6343],
          [1763, 6343],
          [1759, 6332],
          [1762, 6330],
          [1751, 6310],
          [1744, 6303],
          [1750, 6295],
          [1739, 6286],
          [1742, 6277],
          [1737, 6267],
          [1724, 6264],
          [1696, 6285],
          [1689, 6288],
          [1684, 6302],
          [1663, 6313],
          [1653, 6323],
          [1643, 6326],
          [1621, 6338],
          [1609, 6343],
          [1582, 6361],
          [1557, 6375],
          [1546, 6391],
          [1531, 6401],
          [1517, 6422],
          [1517, 6449],
          [1496, 6482],
          [1496, 6486],
          [1483, 6495],
          [1480, 6513],
          [1465, 6526],
          [1464, 6540],
          [1450, 6561],
          [1433, 6604],
          [1428, 6609],
          [1423, 6626],
          [1415, 6641],
          [1398, 6659],
          [1389, 6682],
          [1381, 6694],
          [1342, 6720],
          [1340, 6727],
          [1350, 6736],
          [1338, 6753],
          [1342, 6760],
          [1333, 6772],
          [1335, 6789],
          [1349, 6807],
          [1364, 6820],
          [1370, 6802],
          [1359, 6794],
          [1365, 6790],
          [1364, 6780],
          [1371, 6787],
          [1382, 6780],
          [1392, 6778],
          [1395, 6767],
          [1408, 6760],
          [1420, 6777],
          [1419, 6785],
          [1427, 6805],
          [1429, 6820],
          [1434, 6821],
          [1445, 6835],
          [1483, 6851],
          [1502, 6867],
          [1519, 6889],
          [1524, 6912],
          [1530, 6911],
          [1529, 6926],
          [1517, 6943],
          [1528, 6943],
          [1543, 6940],
          [1557, 6926],
          [1562, 6910],
          [1583, 6900],
          [1586, 6884],
          [1598, 6880],
          [1598, 6864],
          [1606, 6856],
          [1616, 6860],
          [1625, 6855],
          [1639, 6860],
          [1645, 6867],
          [1656, 6858],
          [1673, 6864],
          [1702, 6845],
          [1680, 6806],
          [1694, 6804],
          [1706, 6789],
          [1698, 6785],
          [1694, 6791],
          [1679, 6792],
          [1673, 6783],
          [1642, 6778],
          [1619, 6760],
          [1610, 6755],
          [1608, 6734],
          [1600, 6720],
          [1604, 6709],
          [1584, 6690],
          [1586, 6675],
          [1577, 6666],
          [1587, 6657],
          [1594, 6635],
          [1600, 6631],
          [1614, 6608],
          [1606, 6596],
          [1619, 6596],
          [1636, 6592],
          [1641, 6574],
          [1667, 6574],
          [1673, 6576],
          [1694, 6595],
          [1692, 6580],
          [1694, 6537],
          [1705, 6535],
          [1716, 6540],
          [1728, 6539],
          [1761, 6481],
          [1752, 6467],
          [1754, 6444],
          [1751, 6438],
          [1760, 6418],
          [1748, 6403],
          [1745, 6389],
          [1754, 6379],
          [1747, 6369]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.64,
      "hc-key": "ao",
      "hc-a2": "AO",
      "name": "Angola",
      "labelrank": "3",
      "country-abbrev": "Ang.",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "AGO",
      "iso-a2": "AO",
      "woe-id": "23424745",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4406, 6732],
            [4406, 6743],
            [4399, 6760],
            [4412, 6775],
            [4424, 6783],
            [4434, 6774],
            [4426, 6771],
            [4413, 6758],
            [4416, 6754],
            [4415, 6733],
            [4406, 6732]
          ]
        ],
        [
          [
            [4386, 6304],
            [4389, 6333],
            [4387, 6358],
            [4395, 6365],
            [4397, 6379],
            [4404, 6397],
            [4407, 6422],
            [4412, 6431],
            [4413, 6447],
            [4427, 6463],
            [4435, 6477],
            [4441, 6478],
            [4450, 6490],
            [4455, 6507],
            [4458, 6533],
            [4455, 6549],
            [4437, 6586],
            [4436, 6597],
            [4430, 6608],
            [4443, 6621],
            [4443, 6636],
            [4426, 6676],
            [4426, 6689],
            [4419, 6696],
            [4408, 6719],
            [4423, 6721],
            [4437, 6728],
            [4472, 6727],
            [4540, 6729],
            [4550, 6726],
            [4554, 6716],
            [4555, 6697],
            [4560, 6691],
            [4562, 6675],
            [4582, 6645],
            [4598, 6645],
            [4601, 6649],
            [4639, 6649],
            [4639, 6665],
            [4645, 6668],
            [4645, 6686],
            [4671, 6686],
            [4681, 6689],
            [4678, 6675],
            [4719, 6675],
            [4722, 6668],
            [4718, 6648],
            [4724, 6632],
            [4718, 6596],
            [4720, 6588],
            [4730, 6577],
            [4735, 6560],
            [4735, 6546],
            [4730, 6542],
            [4732, 6528],
            [4742, 6536],
            [4757, 6533],
            [4772, 6538],
            [4785, 6536],
            [4789, 6542],
            [4791, 6522],
            [4788, 6513],
            [4790, 6485],
            [4784, 6470],
            [4788, 6462],
            [4722, 6462],
            [4719, 6345],
            [4723, 6331],
            [4730, 6326],
            [4744, 6307],
            [4763, 6290],
            [4698, 6276],
            [4693, 6279],
            [4679, 6275],
            [4664, 6282],
            [4654, 6280],
            [4621, 6283],
            [4613, 6286],
            [4603, 6299],
            [4466, 6299],
            [4457, 6298],
            [4432, 6315],
            [4413, 6305],
            [4400, 6308],
            [4386, 6304]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.61,
      "hc-middle-y": 0.39,
      "hc-key": "mz",
      "hc-a2": "MZ",
      "name": "Mozambique",
      "labelrank": "3",
      "country-abbrev": "Moz.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "MOZ",
      "iso-a2": "MZ",
      "woe-id": "23424902",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5142, 6443],
          [5139, 6465],
          [5142, 6473],
          [5138, 6493],
          [5144, 6498],
          [5148, 6516],
          [5168, 6514],
          [5176, 6522],
          [5188, 6511],
          [5206, 6512],
          [5215, 6516],
          [5230, 6510],
          [5241, 6517],
          [5243, 6525],
          [5251, 6528],
          [5263, 6522],
          [5277, 6531],
          [5289, 6531],
          [5297, 6537],
          [5314, 6544],
          [5328, 6556],
          [5334, 6543],
          [5326, 6525],
          [5329, 6500],
          [5328, 6490],
          [5332, 6472],
          [5327, 6439],
          [5331, 6418],
          [5330, 6409],
          [5335, 6409],
          [5335, 6396],
          [5325, 6370],
          [5311, 6354],
          [5301, 6335],
          [5275, 6318],
          [5274, 6314],
          [5258, 6310],
          [5235, 6300],
          [5207, 6281],
          [5200, 6269],
          [5178, 6243],
          [5174, 6246],
          [5158, 6234],
          [5151, 6223],
          [5132, 6207],
          [5124, 6186],
          [5137, 6166],
          [5134, 6161],
          [5142, 6131],
          [5140, 6113],
          [5147, 6124],
          [5146, 6094],
          [5138, 6054],
          [5143, 6061],
          [5143, 6049],
          [5129, 6031],
          [5114, 6023],
          [5084, 6012],
          [5055, 5995],
          [5049, 5983],
          [5043, 5980],
          [5053, 5968],
          [5058, 5980],
          [5053, 5947],
          [5035, 5946],
          [5028, 5947],
          [5027, 5968],
          [5025, 5980],
          [5027, 5992],
          [5030, 6037],
          [5017, 6073],
          [5018, 6084],
          [5011, 6113],
          [5016, 6116],
          [5049, 6154],
          [5054, 6181],
          [5058, 6181],
          [5071, 6201],
          [5072, 6210],
          [5064, 6222],
          [5068, 6235],
          [5063, 6245],
          [5069, 6247],
          [5069, 6256],
          [5075, 6263],
          [5072, 6277],
          [5076, 6299],
          [5071, 6316],
          [5076, 6325],
          [5054, 6334],
          [5042, 6335],
          [5035, 6343],
          [5021, 6350],
          [4993, 6351],
          [4994, 6364],
          [4989, 6389],
          [5087, 6425],
          [5101, 6403],
          [5103, 6407],
          [5124, 6411],
          [5129, 6404],
          [5130, 6377],
          [5118, 6355],
          [5122, 6344],
          [5141, 6320],
          [5143, 6309],
          [5150, 6309],
          [5151, 6325],
          [5146, 6331],
          [5155, 6346],
          [5168, 6349],
          [5171, 6372],
          [5170, 6382],
          [5174, 6392],
          [5172, 6401],
          [5149, 6436],
          [5142, 6443]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.25,
      "hc-middle-y": 0.14,
      "hc-key": "cr",
      "hc-a2": "CR",
      "name": "Costa Rica",
      "labelrank": "5",
      "country-abbrev": "C.R.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "CRI",
      "iso-a2": "CR",
      "woe-id": "23424791",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1268, 7353],
          [1273, 7337],
          [1293, 7307],
          [1300, 7303],
          [1291, 7304],
          [1287, 7284],
          [1294, 7279],
          [1287, 7273],
          [1289, 7264],
          [1282, 7257],
          [1286, 7246],
          [1279, 7258],
          [1279, 7268],
          [1269, 7271],
          [1274, 7258],
          [1265, 7261],
          [1256, 7271],
          [1263, 7270],
          [1264, 7283],
          [1246, 7299],
          [1231, 7306],
          [1230, 7318],
          [1219, 7325],
          [1217, 7319],
          [1226, 7313],
          [1217, 7302],
          [1211, 7312],
          [1200, 7315],
          [1194, 7332],
          [1202, 7348],
          [1193, 7352],
          [1201, 7359],
          [1205, 7364],
          [1227, 7354],
          [1234, 7358],
          [1245, 7356],
          [1250, 7348],
          [1259, 7345],
          [1268, 7353]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SV",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.51,
      "hc-key": "sv",
      "hc-a2": "SV",
      "name": "El Salvador",
      "labelrank": "6",
      "country-abbrev": "El. S.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "SLV",
      "iso-a2": "SV",
      "woe-id": "23424807",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1139, 7446],
          [1135, 7437],
          [1107, 7440],
          [1093, 7448],
          [1075, 7450],
          [1066, 7458],
          [1066, 7461],
          [1081, 7474],
          [1085, 7482],
          [1092, 7483],
          [1119, 7467],
          [1119, 7462],
          [1132, 7467],
          [1144, 7461],
          [1139, 7446]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.28,
      "hc-middle-y": 0.70,
      "hc-key": "gt",
      "hc-a2": "GT",
      "name": "Guatemala",
      "labelrank": "3",
      "country-abbrev": "Guat.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "GTM",
      "iso-a2": "GT",
      "woe-id": "23424834",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1113, 7538],
          [1123, 7532],
          [1127, 7537],
          [1135, 7532],
          [1108, 7510],
          [1101, 7507],
          [1101, 7494],
          [1092, 7483],
          [1085, 7482],
          [1081, 7474],
          [1066, 7461],
          [1066, 7458],
          [1047, 7465],
          [1027, 7466],
          [1013, 7475],
          [999, 7488],
          [1007, 7508],
          [1003, 7515],
          [1022, 7545],
          [1063, 7545],
          [1067, 7556],
          [1057, 7570],
          [1048, 7576],
          [1037, 7589],
          [1051, 7589],
          [1055, 7610],
          [1114, 7610],
          [1110, 7581],
          [1102, 7538],
          [1113, 7538]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.50,
      "hc-key": "bz",
      "hc-a2": "BZ",
      "name": "Belize",
      "labelrank": "6",
      "country-abbrev": "Belize",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "BLZ",
      "iso-a2": "BZ",
      "woe-id": "23424760",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1114, 7610],
          [1118, 7617],
          [1123, 7613],
          [1138, 7635],
          [1144, 7635],
          [1151, 7631],
          [1143, 7605],
          [1140, 7578],
          [1127, 7552],
          [1120, 7551],
          [1113, 7538],
          [1102, 7538],
          [1110, 7581],
          [1114, 7610]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.70,
      "hc-middle-y": 0.27,
      "hc-key": "gy",
      "hc-a2": "GY",
      "name": "Guyana",
      "labelrank": "4",
      "country-abbrev": "Guy.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "GUY",
      "iso-a2": "GY",
      "woe-id": "23424836",
      "continent": "South America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2010, 7140],
          [1989, 7166],
          [1998, 7177],
          [1996, 7190],
          [1999, 7197],
          [2012, 7198],
          [2023, 7205],
          [2026, 7212],
          [2016, 7214],
          [2013, 7227],
          [2020, 7237],
          [2036, 7246],
          [2044, 7255],
          [2037, 7265],
          [2067, 7245],
          [2087, 7219],
          [2081, 7189],
          [2088, 7206],
          [2101, 7199],
          [2128, 7173],
          [2125, 7151],
          [2123, 7134],
          [2109, 7132],
          [2102, 7126],
          [2105, 7120],
          [2097, 7102],
          [2098, 7095],
          [2110, 7073],
          [2121, 7073],
          [2125, 7052],
          [2140, 7022],
          [2147, 7019],
          [2137, 7016],
          [2127, 7022],
          [2116, 7017],
          [2112, 7010],
          [2087, 7006],
          [2080, 6994],
          [2070, 6991],
          [2056, 6998],
          [2040, 7015],
          [2040, 7031],
          [2032, 7047],
          [2038, 7081],
          [2048, 7093],
          [2040, 7113],
          [2029, 7114],
          [2034, 7136],
          [2027, 7143],
          [2010, 7140]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "HN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.98,
      "hc-middle-y": 0.31,
      "hc-key": "hn",
      "hc-a2": "HN",
      "name": "Honduras",
      "labelrank": "5",
      "country-abbrev": "Hond.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "HND",
      "iso-a2": "HN",
      "woe-id": "23424841",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1092, 7483],
          [1101, 7494],
          [1101, 7507],
          [1108, 7510],
          [1135, 7532],
          [1152, 7539],
          [1177, 7533],
          [1196, 7534],
          [1211, 7542],
          [1224, 7537],
          [1241, 7542],
          [1263, 7535],
          [1271, 7525],
          [1267, 7519],
          [1278, 7513],
          [1291, 7514],
          [1298, 7505],
          [1289, 7506],
          [1281, 7500],
          [1252, 7491],
          [1243, 7498],
          [1235, 7495],
          [1229, 7480],
          [1209, 7467],
          [1208, 7461],
          [1197, 7469],
          [1186, 7458],
          [1176, 7459],
          [1175, 7441],
          [1163, 7430],
          [1154, 7430],
          [1149, 7441],
          [1139, 7446],
          [1144, 7461],
          [1132, 7467],
          [1119, 7462],
          [1119, 7467],
          [1092, 7483]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.70,
      "hc-middle-y": 0.77,
      "hc-key": "ni",
      "hc-a2": "NI",
      "name": "Nicaragua",
      "labelrank": "5",
      "country-abbrev": "Nic.",
      "subregion": "Central America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "NIC",
      "iso-a2": "NI",
      "woe-id": "23424915",
      "continent": "North America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1201, 7359],
          [1177, 7384],
          [1169, 7401],
          [1143, 7426],
          [1147, 7433],
          [1154, 7430],
          [1163, 7430],
          [1175, 7441],
          [1176, 7459],
          [1186, 7458],
          [1197, 7469],
          [1208, 7461],
          [1209, 7467],
          [1229, 7480],
          [1235, 7495],
          [1243, 7498],
          [1252, 7491],
          [1281, 7500],
          [1289, 7506],
          [1298, 7505],
          [1291, 7497],
          [1293, 7481],
          [1284, 7466],
          [1278, 7446],
          [1276, 7408],
          [1275, 7417],
          [1269, 7414],
          [1273, 7406],
          [1269, 7388],
          [1270, 7379],
          [1262, 7371],
          [1268, 7353],
          [1259, 7345],
          [1250, 7348],
          [1245, 7356],
          [1234, 7358],
          [1227, 7354],
          [1205, 7364],
          [1201, 7359]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.27,
      "hc-middle-y": 0.35,
      "hc-key": "mw",
      "hc-a2": "MW",
      "name": "Malawi",
      "labelrank": "6",
      "country-abbrev": "Mal.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "MWI",
      "iso-a2": "MW",
      "woe-id": "23424889",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5146, 6521],
            [5146, 6522],
            [5146, 6522],
            [5146, 6521]
          ]
        ],
        [
          [
            [5141, 6527],
            [5140, 6527],
            [5140, 6528],
            [5141, 6527],
            [5141, 6527]
          ]
        ],
        [
          [
            [5128, 6585],
            [5124, 6589],
            [5124, 6589],
            [5128, 6585]
          ]
        ],
        [
          [
            [5121, 6592],
            [5121, 6592],
            [5121, 6592],
            [5121, 6592]
          ]
        ],
        [
          [
            [5083, 6596],
            [5099, 6589],
            [5110, 6590],
            [5115, 6585],
            [5117, 6574],
            [5126, 6558],
            [5123, 6553],
            [5127, 6512],
            [5118, 6500],
            [5117, 6487],
            [5125, 6467],
            [5124, 6449],
            [5134, 6436],
            [5131, 6426],
            [5136, 6415],
            [5141, 6425],
            [5153, 6410],
            [5148, 6435],
            [5142, 6443],
            [5149, 6436],
            [5172, 6401],
            [5174, 6392],
            [5170, 6382],
            [5171, 6372],
            [5168, 6349],
            [5155, 6346],
            [5146, 6331],
            [5151, 6325],
            [5150, 6309],
            [5143, 6309],
            [5141, 6320],
            [5122, 6344],
            [5118, 6355],
            [5130, 6377],
            [5129, 6404],
            [5124, 6411],
            [5103, 6407],
            [5101, 6403],
            [5087, 6425],
            [5081, 6424],
            [5075, 6436],
            [5082, 6466],
            [5083, 6477],
            [5094, 6480],
            [5091, 6521],
            [5097, 6531],
            [5092, 6542],
            [5107, 6553],
            [5102, 6566],
            [5095, 6571],
            [5097, 6578],
            [5083, 6596]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.40,
      "hc-middle-y": 0.41,
      "hc-key": "tm",
      "hc-a2": "TM",
      "name": "Turkmenistan",
      "labelrank": "4",
      "country-abbrev": "Turkm.",
      "subregion": "Central Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "TKM",
      "iso-a2": "TM",
      "woe-id": "23424972",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5717, 8506],
          [5729, 8492],
          [5743, 8497],
          [5732, 8514],
          [5738, 8515],
          [5740, 8526],
          [5756, 8519],
          [5745, 8533],
          [5754, 8537],
          [5766, 8528],
          [5773, 8528],
          [5784, 8519],
          [5797, 8519],
          [5804, 8515],
          [5803, 8507],
          [5814, 8501],
          [5809, 8498],
          [5813, 8486],
          [5828, 8480],
          [5851, 8478],
          [5854, 8483],
          [5874, 8472],
          [5885, 8454],
          [5891, 8451],
          [5898, 8436],
          [5903, 8434],
          [5935, 8416],
          [5958, 8400],
          [5965, 8400],
          [6010, 8372],
          [6018, 8374],
          [6042, 8364],
          [6047, 8339],
          [6040, 8338],
          [6021, 8348],
          [6016, 8335],
          [6003, 8334],
          [5995, 8329],
          [5997, 8323],
          [5993, 8298],
          [5962, 8282],
          [5957, 8266],
          [5935, 8255],
          [5924, 8266],
          [5909, 8267],
          [5900, 8273],
          [5890, 8309],
          [5885, 8312],
          [5863, 8312],
          [5850, 8327],
          [5827, 8338],
          [5826, 8344],
          [5807, 8352],
          [5794, 8350],
          [5787, 8355],
          [5760, 8362],
          [5754, 8373],
          [5749, 8371],
          [5730, 8373],
          [5728, 8367],
          [5701, 8367],
          [5686, 8354],
          [5685, 8345],
          [5669, 8338],
          [5660, 8339],
          [5651, 8365],
          [5648, 8388],
          [5650, 8398],
          [5639, 8404],
          [5634, 8413],
          [5623, 8413],
          [5622, 8421],
          [5637, 8421],
          [5626, 8430],
          [5629, 8437],
          [5608, 8438],
          [5600, 8445],
          [5601, 8471],
          [5608, 8464],
          [5620, 8463],
          [5622, 8468],
          [5628, 8458],
          [5645, 8462],
          [5656, 8471],
          [5654, 8476],
          [5631, 8490],
          [5621, 8511],
          [5613, 8514],
          [5598, 8512],
          [5591, 8500],
          [5594, 8486],
          [5580, 8499],
          [5593, 8513],
          [5604, 8518],
          [5627, 8520],
          [5652, 8506],
          [5666, 8489],
          [5676, 8482],
          [5690, 8484],
          [5722, 8481],
          [5714, 8504],
          [5717, 8506]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ZM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.31,
      "hc-middle-y": 0.68,
      "hc-key": "zm",
      "hc-a2": "ZM",
      "name": "Zambia",
      "labelrank": "3",
      "country-abbrev": "Zambia",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "ZMB",
      "iso-a2": "ZM",
      "woe-id": "23425003",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4939, 6597],
          [4955, 6612],
          [4960, 6623],
          [4952, 6631],
          [5007, 6640],
          [5003, 6633],
          [5014, 6628],
          [5021, 6619],
          [5026, 6627],
          [5038, 6622],
          [5052, 6609],
          [5066, 6606],
          [5083, 6596],
          [5097, 6578],
          [5095, 6571],
          [5102, 6566],
          [5107, 6553],
          [5092, 6542],
          [5097, 6531],
          [5091, 6521],
          [5094, 6480],
          [5083, 6477],
          [5082, 6466],
          [5075, 6436],
          [5081, 6424],
          [5087, 6425],
          [4989, 6389],
          [4994, 6364],
          [4975, 6365],
          [4954, 6358],
          [4943, 6349],
          [4939, 6331],
          [4929, 6331],
          [4899, 6309],
          [4881, 6278],
          [4870, 6274],
          [4854, 6281],
          [4847, 6276],
          [4837, 6283],
          [4824, 6284],
          [4814, 6293],
          [4790, 6296],
          [4763, 6290],
          [4744, 6307],
          [4730, 6326],
          [4723, 6331],
          [4719, 6345],
          [4722, 6462],
          [4788, 6462],
          [4784, 6470],
          [4790, 6485],
          [4788, 6513],
          [4791, 6522],
          [4789, 6542],
          [4802, 6533],
          [4799, 6523],
          [4804, 6520],
          [4813, 6525],
          [4832, 6530],
          [4833, 6513],
          [4854, 6503],
          [4877, 6499],
          [4886, 6505],
          [4893, 6516],
          [4908, 6489],
          [4930, 6483],
          [4957, 6446],
          [4968, 6454],
          [4977, 6447],
          [4978, 6494],
          [4968, 6491],
          [4968, 6483],
          [4953, 6486],
          [4944, 6500],
          [4936, 6504],
          [4932, 6520],
          [4935, 6524],
          [4942, 6555],
          [4944, 6582],
          [4939, 6597]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NC",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.55,
      "hc-middle-y": 0.64,
      "hc-key": "nc",
      "hc-a2": "NC",
      "name": "Northern Cyprus",
      "labelrank": "6",
      "country-abbrev": "N. Cy.",
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "-99",
      "iso-a2": "NC",
      "woe-id": "-90",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5056, 8252],
            [5052, 8251],
            [5049, 8251],
            [5040, 8257],
            [5023, 8253],
            [5018, 8257],
            [5024, 8265],
            [5040, 8262],
            [5058, 8268],
            [5074, 8276],
            [5056, 8262],
            [5059, 8252],
            [5057, 8252],
            [5056, 8252]
          ]
        ],
        [
          [
            [5015, 8257],
            [5016, 8257],
            [5016, 8256],
            [5015, 8257]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ZA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.40,
      "hc-middle-y": 0.66,
      "hc-key": "za",
      "hc-a2": "ZA",
      "name": "South Africa",
      "labelrank": "2",
      "country-abbrev": "S.Af.",
      "subregion": "Southern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "ZAF",
      "iso-a2": "ZA",
      "woe-id": "23424942",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5028, 5947],
          [5035, 5946],
          [5053, 5947],
          [5044, 5922],
          [5038, 5897],
          [5032, 5883],
          [5010, 5868],
          [4991, 5846],
          [4962, 5798],
          [4948, 5782],
          [4928, 5767],
          [4909, 5745],
          [4891, 5729],
          [4850, 5699],
          [4831, 5690],
          [4811, 5691],
          [4804, 5687],
          [4805, 5680],
          [4783, 5682],
          [4778, 5674],
          [4766, 5675],
          [4740, 5682],
          [4733, 5677],
          [4708, 5681],
          [4695, 5678],
          [4685, 5668],
          [4665, 5665],
          [4655, 5667],
          [4642, 5664],
          [4625, 5650],
          [4614, 5652],
          [4604, 5665],
          [4590, 5667],
          [4591, 5675],
          [4574, 5675],
          [4581, 5686],
          [4575, 5702],
          [4564, 5717],
          [4563, 5725],
          [4576, 5731],
          [4580, 5746],
          [4576, 5767],
          [4567, 5780],
          [4550, 5817],
          [4537, 5863],
          [4527, 5882],
          [4538, 5890],
          [4541, 5901],
          [4548, 5903],
          [4555, 5895],
          [4556, 5878],
          [4580, 5870],
          [4599, 5873],
          [4610, 5868],
          [4625, 5884],
          [4639, 5888],
          [4644, 6025],
          [4656, 6014],
          [4669, 5982],
          [4670, 5973],
          [4662, 5962],
          [4664, 5945],
          [4669, 5948],
          [4695, 5946],
          [4706, 5954],
          [4714, 5965],
          [4730, 5979],
          [4735, 5998],
          [4741, 6004],
          [4755, 6005],
          [4769, 5992],
          [4798, 5985],
          [4816, 5988],
          [4822, 5993],
          [4833, 6020],
          [4833, 6025],
          [4850, 6029],
          [4865, 6043],
          [4872, 6066],
          [4896, 6082],
          [4911, 6102],
          [4935, 6110],
          [4939, 6119],
          [4949, 6120],
          [4962, 6122],
          [4980, 6115],
          [4997, 6117],
          [5011, 6113],
          [5018, 6084],
          [5017, 6073],
          [5030, 6037],
          [5027, 5992],
          [5025, 5980],
          [5009, 5988],
          [4999, 5982],
          [4987, 5964],
          [4986, 5949],
          [4996, 5934],
          [5008, 5929],
          [5022, 5929],
          [5024, 5948],
          [5028, 5947]
        ],
        [
          [4859, 5844],
          [4868, 5818],
          [4879, 5807],
          [4889, 5805],
          [4894, 5818],
          [4900, 5824],
          [4914, 5826],
          [4925, 5832],
          [4926, 5842],
          [4936, 5854],
          [4913, 5883],
          [4897, 5878],
          [4884, 5870],
          [4867, 5846],
          [4859, 5844]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.23,
      "hc-middle-y": 0.08,
      "hc-key": "lt",
      "hc-a2": "LT",
      "name": "Lithuania",
      "labelrank": "5",
      "country-abbrev": "Lith.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "LTU",
      "iso-a2": "LT",
      "woe-id": "23424875",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4588, 8988],
            [4582, 9003],
            [4578, 9017],
            [4584, 9022],
            [4604, 9029],
            [4632, 9025],
            [4648, 9027],
            [4671, 9024],
            [4679, 9030],
            [4687, 9021],
            [4703, 9019],
            [4722, 9005],
            [4731, 9003],
            [4729, 8991],
            [4738, 8990],
            [4734, 8983],
            [4725, 8984],
            [4716, 8977],
            [4714, 8964],
            [4708, 8955],
            [4690, 8947],
            [4680, 8940],
            [4655, 8942],
            [4653, 8949],
            [4639, 8957],
            [4633, 8957],
            [4632, 8975],
            [4624, 8982],
            [4611, 8980],
            [4588, 8988]
          ]
        ],
        [
          [
            [4578, 8989],
            [4581, 8997],
            [4580, 8989],
            [4578, 8989]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ET",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.43,
      "hc-middle-y": 0.56,
      "hc-key": "et",
      "hc-a2": "ET",
      "name": "Ethiopia",
      "labelrank": "2",
      "country-abbrev": "Eth.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "ETH",
      "iso-a2": "ET",
      "woe-id": "23424808",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5371, 7367],
          [5368, 7363],
          [5371, 7359],
          [5377, 7354],
          [5399, 7359],
          [5409, 7356],
          [5400, 7342],
          [5407, 7327],
          [5419, 7315],
          [5427, 7297],
          [5447, 7281],
          [5545, 7244],
          [5578, 7244],
          [5528, 7188],
          [5481, 7129],
          [5449, 7131],
          [5421, 7120],
          [5411, 7106],
          [5388, 7103],
          [5381, 7095],
          [5357, 7093],
          [5344, 7106],
          [5314, 7091],
          [5304, 7073],
          [5270, 7081],
          [5257, 7081],
          [5215, 7112],
          [5189, 7112],
          [5185, 7119],
          [5180, 7124],
          [5180, 7145],
          [5165, 7146],
          [5153, 7165],
          [5145, 7194],
          [5129, 7206],
          [5120, 7222],
          [5110, 7232],
          [5089, 7237],
          [5086, 7241],
          [5093, 7254],
          [5092, 7259],
          [5118, 7261],
          [5123, 7268],
          [5121, 7299],
          [5128, 7327],
          [5126, 7340],
          [5136, 7352],
          [5145, 7346],
          [5156, 7390],
          [5168, 7415],
          [5184, 7420],
          [5187, 7444],
          [5192, 7453],
          [5195, 7478],
          [5214, 7480],
          [5220, 7485],
          [5229, 7472],
          [5239, 7501],
          [5250, 7493],
          [5257, 7483],
          [5271, 7486],
          [5276, 7492],
          [5282, 7484],
          [5292, 7489],
          [5311, 7485],
          [5336, 7472],
          [5348, 7454],
          [5368, 7437],
          [5374, 7426],
          [5389, 7411],
          [5370, 7376],
          [5371, 7367]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.69,
      "hc-key": "so",
      "hc-a2": "SO",
      "name": "Somalia",
      "labelrank": "6",
      "country-abbrev": "Som.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SOM",
      "iso-a2": "SO",
      "woe-id": "-90",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5381, 7095],
          [5388, 7103],
          [5411, 7106],
          [5421, 7120],
          [5449, 7131],
          [5481, 7129],
          [5528, 7188],
          [5578, 7244],
          [5608, 7298],
          [5605, 7365],
          [5648, 7378],
          [5657, 7390],
          [5665, 7393],
          [5681, 7387],
          [5675, 7363],
          [5679, 7340],
          [5687, 7337],
          [5672, 7331],
          [5669, 7305],
          [5670, 7299],
          [5658, 7278],
          [5647, 7250],
          [5638, 7242],
          [5639, 7235],
          [5624, 7208],
          [5615, 7185],
          [5614, 7175],
          [5580, 7113],
          [5537, 7059],
          [5518, 7037],
          [5470, 7005],
          [5445, 6981],
          [5405, 6935],
          [5382, 6903],
          [5371, 6883],
          [5370, 6888],
          [5352, 6914],
          [5351, 7051],
          [5364, 7066],
          [5381, 7095]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.19,
      "hc-middle-y": 0.90,
      "hc-key": "gh",
      "hc-a2": "GH",
      "name": "Ghana",
      "labelrank": "3",
      "country-abbrev": "Ghana",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "GHA",
      "iso-a2": "GH",
      "woe-id": "23424824",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4044, 7174],
          [4037, 7164],
          [4013, 7161],
          [3992, 7151],
          [3978, 7141],
          [3953, 7133],
          [3936, 7123],
          [3931, 7128],
          [3902, 7136],
          [3902, 7137],
          [3907, 7136],
          [3911, 7138],
          [3915, 7147],
          [3908, 7155],
          [3900, 7180],
          [3899, 7202],
          [3905, 7210],
          [3908, 7229],
          [3914, 7242],
          [3922, 7252],
          [3919, 7279],
          [3914, 7284],
          [3917, 7300],
          [3909, 7343],
          [3915, 7356],
          [3974, 7356],
          [3985, 7355],
          [3999, 7361],
          [4005, 7358],
          [4002, 7342],
          [4016, 7327],
          [4012, 7303],
          [4022, 7297],
          [4017, 7273],
          [4028, 7255],
          [4023, 7252],
          [4025, 7233],
          [4022, 7222],
          [4026, 7219],
          [4022, 7201],
          [4029, 7186],
          [4044, 7174]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.57,
      "hc-key": "si",
      "hc-a2": "SI",
      "name": "Slovenia",
      "labelrank": "6",
      "country-abbrev": "Slo.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "SVN",
      "iso-a2": "SI",
      "woe-id": "23424945",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4404, 8637],
          [4403, 8639],
          [4407, 8641],
          [4413, 8642],
          [4399, 8656],
          [4404, 8662],
          [4396, 8666],
          [4405, 8675],
          [4430, 8669],
          [4438, 8678],
          [4472, 8681],
          [4474, 8687],
          [4479, 8687],
          [4487, 8674],
          [4462, 8663],
          [4463, 8649],
          [4452, 8645],
          [4455, 8636],
          [4436, 8639],
          [4404, 8637]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.82,
      "hc-middle-y": 0.66,
      "hc-key": "ba",
      "hc-a2": "BA",
      "name": "Bosnia and Herzegovina",
      "labelrank": "5",
      "country-abbrev": "B.H.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "BIH",
      "iso-a2": "BA",
      "woe-id": "23424761",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4531, 8541],
          [4528, 8542],
          [4529, 8542],
          [4529, 8547],
          [4485, 8588],
          [4481, 8599],
          [4468, 8609],
          [4470, 8626],
          [4476, 8627],
          [4486, 8620],
          [4491, 8628],
          [4503, 8630],
          [4530, 8622],
          [4542, 8625],
          [4555, 8623],
          [4559, 8613],
          [4566, 8612],
          [4576, 8612],
          [4570, 8599],
          [4572, 8591],
          [4586, 8582],
          [4575, 8579],
          [4584, 8565],
          [4575, 8564],
          [4555, 8544],
          [4556, 8529],
          [4538, 8538],
          [4531, 8541]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "JO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.13,
      "hc-middle-y": 0.48,
      "hc-key": "jo",
      "hc-a2": "JO",
      "name": "Jordan",
      "labelrank": "4",
      "country-abbrev": "Jord.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "JOR",
      "iso-a2": "JO",
      "woe-id": "23424860",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5119, 8104],
          [5122, 8108],
          [5118, 8109],
          [5118, 8110],
          [5118, 8113],
          [5122, 8113],
          [5121, 8129],
          [5117, 8162],
          [5123, 8165],
          [5144, 8152],
          [5158, 8149],
          [5215, 8189],
          [5227, 8156],
          [5234, 8151],
          [5232, 8142],
          [5227, 8138],
          [5166, 8119],
          [5202, 8082],
          [5192, 8076],
          [5188, 8063],
          [5165, 8058],
          [5158, 8045],
          [5146, 8034],
          [5110, 8040],
          [5111, 8046],
          [5110, 8047],
          [5114, 8068],
          [5113, 8080],
          [5119, 8104]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.30,
      "hc-middle-y": 0.53,
      "hc-key": "sy",
      "hc-a2": "SY",
      "name": "Syria",
      "labelrank": "3",
      "country-abbrev": "Syria",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "SYR",
      "iso-a2": "SY",
      "woe-id": "23424956",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5215, 8189],
          [5158, 8149],
          [5144, 8152],
          [5123, 8165],
          [5126, 8173],
          [5122, 8190],
          [5128, 8205],
          [5143, 8220],
          [5135, 8235],
          [5122, 8237],
          [5117, 8247],
          [5116, 8266],
          [5110, 8272],
          [5114, 8285],
          [5122, 8281],
          [5127, 8296],
          [5136, 8296],
          [5130, 8306],
          [5132, 8319],
          [5144, 8312],
          [5158, 8312],
          [5180, 8322],
          [5195, 8315],
          [5213, 8313],
          [5229, 8316],
          [5247, 8326],
          [5261, 8330],
          [5280, 8328],
          [5295, 8332],
          [5301, 8338],
          [5306, 8330],
          [5293, 8311],
          [5280, 8307],
          [5278, 8290],
          [5284, 8275],
          [5281, 8257],
          [5283, 8242],
          [5278, 8227],
          [5270, 8225],
          [5215, 8189]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MC",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.67,
      "hc-key": "mc",
      "hc-a2": "MC",
      "name": "Monaco",
      "labelrank": "6",
      "country-abbrev": "Mco.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "MCO",
      "iso-a2": "MC",
      "woe-id": "23424892",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4225, 8571],
          [4225, 8570],
          [4223, 8570],
          [4225, 8572],
          [4225, 8571]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.39,
      "hc-middle-y": 0.49,
      "hc-key": "al",
      "hc-a2": "AL",
      "name": "Albania",
      "labelrank": "6",
      "country-abbrev": "Alb.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "ALB",
      "iso-a2": "AL",
      "woe-id": "23424742",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4637, 8468],
            [4637, 8468],
            [4636, 8469],
            [4637, 8468]
          ]
        ],
        [
          [
            [4585, 8512],
            [4585, 8517],
            [4585, 8520],
            [4593, 8532],
            [4595, 8526],
            [4605, 8528],
            [4619, 8516],
            [4622, 8504],
            [4621, 8485],
            [4627, 8475],
            [4628, 8469],
            [4630, 8469],
            [4633, 8469],
            [4636, 8469],
            [4636, 8468],
            [4637, 8467],
            [4637, 8467],
            [4636, 8464],
            [4638, 8465],
            [4637, 8464],
            [4639, 8461],
            [4639, 8460],
            [4640, 8461],
            [4630, 8439],
            [4620, 8438],
            [4624, 8432],
            [4612, 8427],
            [4609, 8436],
            [4594, 8443],
            [4588, 8459],
            [4592, 8481],
            [4589, 8487],
            [4593, 8502],
            [4586, 8503],
            [4585, 8507],
            [4585, 8512]
          ]
        ],
        [
          [
            [4585, 8519],
            [4585, 8519],
            [4584, 8519],
            [4585, 8519]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "UY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.89,
      "hc-middle-y": 0.86,
      "hc-key": "uy",
      "hc-a2": "UY",
      "name": "Uruguay",
      "labelrank": "4",
      "country-abbrev": "Ury.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "URY",
      "iso-a2": "UY",
      "woe-id": "23424979",
      "continent": "South America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2341, 5731],
          [2338, 5720],
          [2329, 5714],
          [2335, 5697],
          [2336, 5694],
          [2341, 5691],
          [2333, 5666],
          [2323, 5656],
          [2301, 5645],
          [2286, 5651],
          [2270, 5651],
          [2263, 5645],
          [2255, 5651],
          [2239, 5656],
          [2229, 5664],
          [2207, 5663],
          [2186, 5683],
          [2182, 5698],
          [2182, 5712],
          [2190, 5716],
          [2182, 5739],
          [2184, 5745],
          [2178, 5759],
          [2184, 5770],
          [2180, 5775],
          [2185, 5796],
          [2181, 5811],
          [2186, 5823],
          [2200, 5820],
          [2211, 5826],
          [2233, 5808],
          [2242, 5798],
          [2242, 5789],
          [2254, 5798],
          [2267, 5783],
          [2289, 5775],
          [2306, 5759],
          [2319, 5753],
          [2324, 5742],
          [2341, 5731]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CNM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.69,
      "hc-middle-y": 0.51,
      "hc-key": "cnm",
      "hc-a2": "CN",
      "name": "Cyprus No Mans Area",
      "labelrank": "9",
      "country-abbrev": null,
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "-99",
      "iso-a2": null,
      "woe-id": "-99",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5059, 8252],
            [5059, 8252],
            [5059, 8252],
            [5055, 8252],
            [5056, 8252],
            [5057, 8252],
            [5059, 8252]
          ]
        ],
        [
          [
            [5014, 8256],
            [5015, 8257],
            [5016, 8256],
            [5016, 8257],
            [5017, 8257],
            [5016, 8256],
            [5014, 8256]
          ]
        ],
        [
          [
            [5018, 8257],
            [5018, 8257],
            [5023, 8253],
            [5040, 8257],
            [5049, 8251],
            [5050, 8250],
            [5050, 8249],
            [5040, 8256],
            [5022, 8252],
            [5018, 8257]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.51,
      "hc-key": "mn",
      "hc-a2": "MN",
      "name": "Mongolia",
      "labelrank": "3",
      "country-abbrev": "Mong.",
      "subregion": "Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "MNG",
      "iso-a2": "MN",
      "woe-id": "23424887",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7410, 8720],
          [7416, 8716],
          [7418, 8724],
          [7412, 8728],
          [7435, 8727],
          [7447, 8720],
          [7484, 8700],
          [7498, 8688],
          [7499, 8677],
          [7455, 8682],
          [7442, 8674],
          [7432, 8676],
          [7435, 8669],
          [7415, 8667],
          [7412, 8652],
          [7415, 8645],
          [7405, 8636],
          [7373, 8633],
          [7369, 8615],
          [7359, 8607],
          [7326, 8613],
          [7317, 8622],
          [7300, 8620],
          [7300, 8597],
          [7330, 8570],
          [7308, 8555],
          [7302, 8536],
          [7280, 8525],
          [7261, 8523],
          [7241, 8525],
          [7202, 8519],
          [7164, 8499],
          [7161, 8494],
          [7145, 8496],
          [7141, 8504],
          [7120, 8500],
          [7096, 8509],
          [7062, 8515],
          [7044, 8527],
          [6993, 8533],
          [6979, 8529],
          [6907, 8537],
          [6883, 8535],
          [6879, 8541],
          [6860, 8553],
          [6838, 8579],
          [6831, 8581],
          [6828, 8591],
          [6819, 8590],
          [6779, 8605],
          [6768, 8613],
          [6751, 8620],
          [6702, 8622],
          [6680, 8626],
          [6669, 8637],
          [6667, 8647],
          [6671, 8656],
          [6663, 8667],
          [6663, 8676],
          [6652, 8690],
          [6634, 8703],
          [6625, 8716],
          [6612, 8724],
          [6605, 8722],
          [6596, 8729],
          [6581, 8728],
          [6565, 8736],
          [6562, 8741],
          [6541, 8749],
          [6529, 8760],
          [6526, 8771],
          [6532, 8781],
          [6552, 8781],
          [6570, 8791],
          [6565, 8798],
          [6589, 8809],
          [6594, 8816],
          [6606, 8818],
          [6611, 8826],
          [6623, 8826],
          [6625, 8832],
          [6637, 8825],
          [6685, 8821],
          [6694, 8809],
          [6705, 8802],
          [6714, 8803],
          [6733, 8797],
          [6741, 8802],
          [6757, 8797],
          [6775, 8797],
          [6789, 8792],
          [6792, 8798],
          [6804, 8803],
          [6800, 8820],
          [6791, 8824],
          [6777, 8837],
          [6774, 8854],
          [6777, 8863],
          [6785, 8867],
          [6784, 8878],
          [6824, 8863],
          [6838, 8863],
          [6868, 8853],
          [6895, 8848],
          [6911, 8824],
          [6926, 8816],
          [6961, 8806],
          [6976, 8807],
          [6979, 8812],
          [7001, 8818],
          [7031, 8812],
          [7042, 8813],
          [7066, 8801],
          [7088, 8799],
          [7093, 8789],
          [7118, 8777],
          [7135, 8777],
          [7168, 8771],
          [7185, 8770],
          [7197, 8778],
          [7216, 8780],
          [7241, 8787],
          [7240, 8794],
          [7261, 8811],
          [7275, 8810],
          [7301, 8797],
          [7322, 8802],
          [7340, 8795],
          [7344, 8747],
          [7350, 8737],
          [7344, 8733],
          [7363, 8718],
          [7371, 8724],
          [7389, 8724],
          [7407, 8716],
          [7410, 8720]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "RW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.55,
      "hc-key": "rw",
      "hc-a2": "RW",
      "name": "Rwanda",
      "labelrank": "3",
      "country-abbrev": "Rwa.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "RWA",
      "iso-a2": "RW",
      "woe-id": "23424937",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5007, 6907],
          [5010, 6897],
          [5019, 6887],
          [5018, 6859],
          [5009, 6857],
          [5004, 6861],
          [4995, 6856],
          [4989, 6860],
          [4988, 6847],
          [4982, 6842],
          [4969, 6841],
          [4967, 6848],
          [4959, 6845],
          [4955, 6848],
          [4954, 6854],
          [4970, 6870],
          [4966, 6884],
          [4970, 6890],
          [4977, 6895],
          [4986, 6897],
          [4989, 6892],
          [5002, 6907],
          [5007, 6907]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.57,
      "hc-key": "bo",
      "hc-a2": "BO",
      "name": "Bolivia",
      "labelrank": "3",
      "country-abbrev": "Bolivia",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "BOL",
      "iso-a2": "BO",
      "woe-id": "23424762",
      "continent": "South America"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [1758, 6342],
            [1757, 6349],
            [1763, 6343],
            [1760, 6343],
            [1758, 6342]
          ]
        ],
        [
          [
            [1750, 6295],
            [1744, 6303],
            [1751, 6310],
            [1762, 6330],
            [1776, 6339],
            [1767, 6343],
            [1768, 6352],
            [1747, 6369],
            [1754, 6379],
            [1745, 6389],
            [1748, 6403],
            [1760, 6418],
            [1751, 6438],
            [1754, 6444],
            [1752, 6467],
            [1761, 6481],
            [1728, 6539],
            [1755, 6536],
            [1755, 6532],
            [1771, 6538],
            [1776, 6548],
            [1789, 6548],
            [1800, 6562],
            [1805, 6562],
            [1822, 6578],
            [1861, 6586],
            [1866, 6580],
            [1867, 6566],
            [1863, 6557],
            [1868, 6537],
            [1866, 6531],
            [1873, 6509],
            [1880, 6500],
            [1898, 6491],
            [1901, 6483],
            [1917, 6479],
            [1925, 6482],
            [1937, 6474],
            [1945, 6475],
            [1955, 6462],
            [1975, 6458],
            [1987, 6442],
            [2013, 6445],
            [2032, 6433],
            [2033, 6421],
            [2040, 6402],
            [2042, 6384],
            [2032, 6384],
            [2044, 6370],
            [2049, 6341],
            [2104, 6338],
            [2110, 6304],
            [2130, 6294],
            [2140, 6269],
            [2135, 6237],
            [2126, 6212],
            [2135, 6203],
            [2126, 6196],
            [2125, 6208],
            [2093, 6228],
            [2064, 6228],
            [2008, 6215],
            [2004, 6198],
            [1995, 6181],
            [1996, 6162],
            [1988, 6119],
            [1982, 6127],
            [1946, 6127],
            [1938, 6107],
            [1937, 6095],
            [1926, 6120],
            [1912, 6124],
            [1888, 6123],
            [1871, 6135],
            [1870, 6124],
            [1857, 6119],
            [1856, 6111],
            [1849, 6108],
            [1845, 6097],
            [1833, 6094],
            [1822, 6097],
            [1822, 6107],
            [1812, 6129],
            [1806, 6154],
            [1793, 6169],
            [1795, 6179],
            [1785, 6186],
            [1783, 6198],
            [1789, 6200],
            [1784, 6211],
            [1791, 6223],
            [1772, 6241],
            [1763, 6271],
            [1750, 6295]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.74,
      "hc-key": "cm",
      "hc-a2": "CM",
      "name": "Cameroon",
      "labelrank": "3",
      "country-abbrev": "Cam.",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "CMR",
      "iso-a2": "CM",
      "woe-id": "23424785",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4442, 7027],
            [4440, 7031],
            [4424, 7030],
            [4410, 7033],
            [4378, 7032],
            [4377, 7027],
            [4333, 7027],
            [4327, 7034],
            [4332, 7061],
            [4322, 7078],
            [4321, 7091],
            [4326, 7094],
            [4315, 7098],
            [4316, 7092],
            [4299, 7099],
            [4297, 7117],
            [4284, 7115],
            [4287, 7126],
            [4294, 7139],
            [4295, 7164],
            [4311, 7182],
            [4323, 7190],
            [4325, 7199],
            [4337, 7207],
            [4349, 7203],
            [4352, 7212],
            [4367, 7196],
            [4369, 7187],
            [4376, 7186],
            [4384, 7203],
            [4394, 7212],
            [4390, 7217],
            [4399, 7229],
            [4404, 7243],
            [4405, 7257],
            [4424, 7274],
            [4426, 7296],
            [4437, 7302],
            [4438, 7322],
            [4444, 7325],
            [4448, 7342],
            [4462, 7366],
            [4468, 7365],
            [4482, 7375],
            [4480, 7383],
            [4484, 7400],
            [4468, 7407],
            [4464, 7434],
            [4472, 7434],
            [4470, 7426],
            [4478, 7430],
            [4481, 7421],
            [4489, 7417],
            [4491, 7399],
            [4496, 7397],
            [4499, 7376],
            [4496, 7363],
            [4498, 7348],
            [4505, 7331],
            [4518, 7319],
            [4488, 7316],
            [4469, 7318],
            [4461, 7305],
            [4475, 7288],
            [4502, 7262],
            [4511, 7238],
            [4512, 7227],
            [4504, 7216],
            [4498, 7199],
            [4488, 7180],
            [4477, 7171],
            [4485, 7160],
            [4482, 7142],
            [4486, 7139],
            [4488, 7119],
            [4497, 7111],
            [4498, 7096],
            [4503, 7087],
            [4534, 7052],
            [4537, 7030],
            [4533, 7020],
            [4536, 7011],
            [4523, 7018],
            [4506, 7022],
            [4494, 7021],
            [4484, 7029],
            [4474, 7027],
            [4442, 7027]
          ]
        ],
        [
          [
            [4474, 7434],
            [4474, 7433],
            [4473, 7434],
            [4474, 7434]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.15,
      "hc-middle-y": 0.85,
      "hc-key": "cg",
      "hc-a2": "CG",
      "name": "Republic of Congo",
      "labelrank": "4",
      "country-abbrev": "Rep. Congo",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "COG",
      "iso-a2": "CG",
      "woe-id": "23424779",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4434, 6774],
          [4424, 6783],
          [4412, 6775],
          [4399, 6760],
          [4393, 6776],
          [4370, 6800],
          [4373, 6809],
          [4382, 6816],
          [4394, 6808],
          [4397, 6824],
          [4389, 6828],
          [4385, 6860],
          [4391, 6857],
          [4414, 6860],
          [4413, 6876],
          [4426, 6875],
          [4433, 6859],
          [4447, 6856],
          [4457, 6868],
          [4461, 6854],
          [4468, 6853],
          [4473, 6873],
          [4478, 6876],
          [4480, 6901],
          [4478, 6909],
          [4481, 6924],
          [4468, 6936],
          [4460, 6939],
          [4461, 6954],
          [4468, 6967],
          [4473, 6967],
          [4480, 6981],
          [4473, 6996],
          [4458, 7000],
          [4440, 6992],
          [4436, 7006],
          [4442, 7027],
          [4474, 7027],
          [4484, 7029],
          [4494, 7021],
          [4506, 7022],
          [4523, 7018],
          [4536, 7011],
          [4533, 7020],
          [4537, 7030],
          [4546, 7052],
          [4549, 7076],
          [4574, 7081],
          [4578, 7085],
          [4591, 7078],
          [4612, 7082],
          [4617, 7076],
          [4616, 7063],
          [4599, 7027],
          [4599, 7004],
          [4592, 6984],
          [4595, 6961],
          [4587, 6939],
          [4588, 6927],
          [4574, 6909],
          [4558, 6899],
          [4548, 6876],
          [4538, 6867],
          [4536, 6839],
          [4538, 6823],
          [4528, 6801],
          [4515, 6795],
          [4504, 6785],
          [4492, 6767],
          [4478, 6765],
          [4477, 6787],
          [4463, 6779],
          [4455, 6781],
          [4455, 6772],
          [4445, 6765],
          [4434, 6774]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "EH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.68,
      "hc-key": "eh",
      "hc-a2": "EH",
      "name": "Western Sahara",
      "labelrank": "7",
      "country-abbrev": "W. Sah.",
      "subregion": "Northern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "ESH",
      "iso-a2": "EH",
      "woe-id": "23424990",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3454, 7720],
          [3453, 7723],
          [3456, 7744],
          [3497, 7747],
          [3526, 7745],
          [3533, 7761],
          [3547, 7777],
          [3554, 7818],
          [3563, 7832],
          [3578, 7839],
          [3586, 7855],
          [3607, 7871],
          [3621, 7916],
          [3631, 7919],
          [3643, 7938],
          [3642, 7948],
          [3657, 7952],
          [3678, 7947],
          [3694, 7947],
          [3705, 7955],
          [3725, 7956],
          [3724, 7977],
          [3729, 7977],
          [3728, 7963],
          [3727, 7915],
          [3621, 7915],
          [3619, 7820],
          [3599, 7813],
          [3586, 7804],
          [3581, 7794],
          [3583, 7784],
          [3585, 7741],
          [3458, 7741],
          [3454, 7720]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "RS",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.16,
      "hc-middle-y": 0.33,
      "hc-key": "rs",
      "hc-a2": "RS",
      "name": "Republic of Serbia",
      "labelrank": "5",
      "country-abbrev": "Serb.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "SRB",
      "iso-a2": "RS",
      "woe-id": "-90",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4566, 8612],
          [4566, 8624],
          [4576, 8626],
          [4563, 8634],
          [4559, 8653],
          [4569, 8655],
          [4577, 8662],
          [4597, 8660],
          [4615, 8647],
          [4615, 8637],
          [4638, 8625],
          [4635, 8612],
          [4659, 8599],
          [4667, 8607],
          [4677, 8601],
          [4669, 8597],
          [4677, 8589],
          [4668, 8574],
          [4674, 8562],
          [4689, 8552],
          [4683, 8540],
          [4674, 8538],
          [4678, 8523],
          [4674, 8520],
          [4661, 8521],
          [4651, 8517],
          [4655, 8533],
          [4643, 8535],
          [4633, 8548],
          [4623, 8554],
          [4612, 8538],
          [4599, 8549],
          [4589, 8551],
          [4575, 8564],
          [4584, 8565],
          [4575, 8579],
          [4586, 8582],
          [4572, 8591],
          [4570, 8599],
          [4576, 8612],
          [4566, 8612]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ME",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.47,
      "hc-key": "me",
      "hc-a2": "ME",
      "name": "Montenegro",
      "labelrank": "6",
      "country-abbrev": "Mont.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "MNE",
      "iso-a2": "ME",
      "woe-id": "20069817",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4575, 8564],
          [4589, 8551],
          [4599, 8549],
          [4612, 8538],
          [4603, 8535],
          [4605, 8528],
          [4595, 8526],
          [4593, 8532],
          [4585, 8520],
          [4585, 8519],
          [4584, 8519],
          [4578, 8518],
          [4585, 8512],
          [4585, 8507],
          [4586, 8503],
          [4567, 8518],
          [4558, 8523],
          [4556, 8526],
          [4556, 8529],
          [4555, 8544],
          [4575, 8564]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BJ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.28,
      "hc-middle-y": 0.93,
      "hc-key": "bj",
      "hc-a2": "BJ",
      "name": "Benin",
      "labelrank": "5",
      "country-abbrev": "Benin",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "BEN",
      "iso-a2": "BJ",
      "woe-id": "23424764",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4093, 7184],
          [4066, 7180],
          [4058, 7178],
          [4063, 7180],
          [4056, 7195],
          [4058, 7207],
          [4057, 7284],
          [4048, 7301],
          [4048, 7319],
          [4030, 7333],
          [4034, 7356],
          [4041, 7358],
          [4042, 7366],
          [4052, 7374],
          [4070, 7372],
          [4083, 7390],
          [4082, 7402],
          [4098, 7408],
          [4122, 7382],
          [4118, 7372],
          [4124, 7361],
          [4130, 7341],
          [4122, 7330],
          [4120, 7313],
          [4107, 7299],
          [4105, 7285],
          [4095, 7284],
          [4094, 7252],
          [4092, 7241],
          [4096, 7209],
          [4093, 7184]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.77,
      "hc-middle-y": 0.98,
      "hc-key": "tg",
      "hc-a2": "TG",
      "name": "Togo",
      "labelrank": "6",
      "country-abbrev": "Togo",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "TGO",
      "iso-a2": "TG",
      "woe-id": "23424965",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4034, 7356],
          [4030, 7333],
          [4048, 7319],
          [4048, 7301],
          [4057, 7284],
          [4058, 7207],
          [4056, 7195],
          [4063, 7180],
          [4058, 7178],
          [4052, 7177],
          [4044, 7174],
          [4029, 7186],
          [4022, 7201],
          [4026, 7219],
          [4022, 7222],
          [4025, 7233],
          [4023, 7252],
          [4028, 7255],
          [4017, 7273],
          [4022, 7297],
          [4012, 7303],
          [4016, 7327],
          [4002, 7342],
          [4005, 7358],
          [3999, 7361],
          [4021, 7356],
          [4034, 7356]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.32,
      "hc-key": "la",
      "hc-a2": "LA",
      "name": "Laos",
      "labelrank": "4",
      "country-abbrev": "Laos",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "LAO",
      "iso-a2": "LA",
      "woe-id": "23424872",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7264, 7749],
          [7269, 7735],
          [7284, 7734],
          [7282, 7759],
          [7271, 7775],
          [7275, 7782],
          [7290, 7781],
          [7308, 7762],
          [7311, 7753],
          [7316, 7759],
          [7322, 7750],
          [7321, 7740],
          [7332, 7723],
          [7350, 7716],
          [7361, 7727],
          [7381, 7715],
          [7374, 7708],
          [7385, 7704],
          [7395, 7694],
          [7387, 7677],
          [7366, 7679],
          [7370, 7672],
          [7364, 7665],
          [7394, 7646],
          [7408, 7643],
          [7408, 7634],
          [7428, 7615],
          [7434, 7605],
          [7463, 7579],
          [7466, 7567],
          [7475, 7562],
          [7497, 7539],
          [7490, 7534],
          [7509, 7515],
          [7507, 7494],
          [7494, 7483],
          [7486, 7479],
          [7475, 7490],
          [7458, 7481],
          [7466, 7470],
          [7458, 7465],
          [7445, 7474],
          [7439, 7472],
          [7433, 7481],
          [7440, 7484],
          [7443, 7505],
          [7440, 7532],
          [7433, 7543],
          [7420, 7547],
          [7408, 7562],
          [7406, 7593],
          [7392, 7604],
          [7374, 7629],
          [7354, 7633],
          [7342, 7617],
          [7331, 7611],
          [7330, 7616],
          [7312, 7625],
          [7304, 7620],
          [7286, 7597],
          [7277, 7602],
          [7284, 7619],
          [7277, 7633],
          [7283, 7641],
          [7283, 7656],
          [7277, 7668],
          [7278, 7674],
          [7266, 7677],
          [7253, 7674],
          [7249, 7682],
          [7253, 7694],
          [7244, 7706],
          [7237, 7703],
          [7239, 7718],
          [7248, 7721],
          [7251, 7740],
          [7264, 7749]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AF",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.42,
      "hc-middle-y": 0.52,
      "hc-key": "af",
      "hc-a2": "AF",
      "name": "Afghanistan",
      "labelrank": "3",
      "country-abbrev": "Afg.",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "AFG",
      "iso-a2": "AF",
      "woe-id": "23424739",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [6047, 8339],
            [6061, 8340],
            [6070, 8333],
            [6078, 8336],
            [6087, 8333],
            [6097, 8323],
            [6113, 8336],
            [6123, 8338],
            [6133, 8330],
            [6138, 8335],
            [6137, 8348],
            [6156, 8346],
            [6159, 8352],
            [6153, 8361],
            [6162, 8377],
            [6173, 8381],
            [6185, 8374],
            [6186, 8361],
            [6197, 8360],
            [6200, 8328],
            [6207, 8316],
            [6216, 8314],
            [6227, 8324],
            [6238, 8327],
            [6241, 8334],
            [6254, 8343],
            [6268, 8342],
            [6269, 8334],
            [6286, 8342],
            [6299, 8337],
            [6299, 8337],
            [6290, 8330],
            [6296, 8326],
            [6284, 8319],
            [6276, 8321],
            [6238, 8319],
            [6216, 8303],
            [6212, 8305],
            [6202, 8289],
            [6219, 8271],
            [6224, 8257],
            [6210, 8231],
            [6216, 8226],
            [6216, 8214],
            [6201, 8210],
            [6184, 8214],
            [6179, 8210],
            [6190, 8202],
            [6199, 8187],
            [6188, 8178],
            [6177, 8178],
            [6177, 8162],
            [6173, 8153],
            [6179, 8135],
            [6166, 8123],
            [6160, 8129],
            [6143, 8131],
            [6131, 8120],
            [6135, 8113],
            [6123, 8108],
            [6109, 8112],
            [6094, 8098],
            [6093, 8086],
            [6097, 8073],
            [6096, 8058],
            [6061, 8047],
            [6043, 8048],
            [6032, 8041],
            [6015, 8045],
            [5981, 8042],
            [5927, 8058],
            [5951, 8095],
            [5944, 8115],
            [5916, 8119],
            [5911, 8147],
            [5897, 8177],
            [5902, 8196],
            [5891, 8199],
            [5887, 8216],
            [5890, 8224],
            [5898, 8224],
            [5890, 8232],
            [5897, 8236],
            [5900, 8254],
            [5900, 8273],
            [5909, 8267],
            [5924, 8266],
            [5935, 8255],
            [5957, 8266],
            [5962, 8282],
            [5993, 8298],
            [5997, 8323],
            [5995, 8329],
            [6003, 8334],
            [6016, 8335],
            [6021, 8348],
            [6040, 8338],
            [6047, 8339]
          ]
        ],
        [
          [
            [6305, 8334],
            [6299, 8337],
            [6299, 8337],
            [6300, 8337],
            [6305, 8334]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "UA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.33,
      "hc-middle-y": 0.30,
      "hc-key": "ua",
      "hc-a2": "UA",
      "name": "Ukraine",
      "labelrank": "3",
      "country-abbrev": "Ukr.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "UKR",
      "iso-a2": "UA",
      "woe-id": "23424976",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4643, 8743],
          [4647, 8753],
          [4652, 8768],
          [4662, 8765],
          [4653, 8784],
          [4664, 8800],
          [4681, 8815],
          [4690, 8821],
          [4685, 8830],
          [4690, 8832],
          [4673, 8849],
          [4671, 8856],
          [4681, 8858],
          [4691, 8869],
          [4712, 8871],
          [4730, 8870],
          [4762, 8864],
          [4774, 8858],
          [4801, 8860],
          [4817, 8855],
          [4825, 8860],
          [4833, 8850],
          [4842, 8855],
          [4856, 8855],
          [4869, 8846],
          [4866, 8857],
          [4874, 8875],
          [4898, 8877],
          [4911, 8876],
          [4913, 8884],
          [4929, 8882],
          [4936, 8886],
          [4953, 8886],
          [4964, 8871],
          [4975, 8864],
          [4966, 8861],
          [4972, 8846],
          [4997, 8845],
          [5021, 8814],
          [5032, 8816],
          [5049, 8809],
          [5070, 8816],
          [5090, 8798],
          [5094, 8803],
          [5118, 8794],
          [5124, 8796],
          [5152, 8783],
          [5156, 8773],
          [5145, 8766],
          [5156, 8761],
          [5148, 8756],
          [5160, 8737],
          [5156, 8722],
          [5129, 8723],
          [5128, 8717],
          [5117, 8714],
          [5117, 8696],
          [5098, 8695],
          [5089, 8690],
          [5061, 8680],
          [5052, 8679],
          [5038, 8668],
          [5034, 8670],
          [5024, 8662],
          [5027, 8653],
          [5049, 8630],
          [5066, 8636],
          [5080, 8635],
          [5079, 8623],
          [5063, 8620],
          [5054, 8624],
          [5038, 8611],
          [5022, 8607],
          [5009, 8594],
          [4991, 8601],
          [4995, 8603],
          [4994, 8621],
          [4972, 8632],
          [4961, 8632],
          [4970, 8642],
          [4995, 8653],
          [4980, 8660],
          [4973, 8656],
          [4933, 8664],
          [4934, 8668],
          [4949, 8673],
          [4936, 8685],
          [4936, 8679],
          [4914, 8679],
          [4905, 8672],
          [4898, 8659],
          [4880, 8642],
          [4875, 8648],
          [4878, 8627],
          [4867, 8636],
          [4852, 8628],
          [4838, 8631],
          [4834, 8636],
          [4853, 8656],
          [4850, 8672],
          [4858, 8669],
          [4884, 8669],
          [4878, 8675],
          [4877, 8685],
          [4866, 8690],
          [4864, 8704],
          [4860, 8702],
          [4850, 8712],
          [4851, 8724],
          [4837, 8733],
          [4816, 8737],
          [4805, 8745],
          [4790, 8742],
          [4779, 8743],
          [4774, 8738],
          [4765, 8736],
          [4762, 8728],
          [4736, 8725],
          [4726, 8718],
          [4718, 8725],
          [4681, 8728],
          [4674, 8732],
          [4667, 8727],
          [4658, 8732],
          [4643, 8743]
        ],
        [
          [4996, 8660],
          [5010, 8656],
          [5031, 8644],
          [5038, 8631],
          [5047, 8629],
          [5032, 8644],
          [5024, 8657],
          [5004, 8666],
          [4990, 8664],
          [4996, 8660]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SK",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.21,
      "hc-middle-y": 0.56,
      "hc-key": "sk",
      "hc-a2": "SK",
      "name": "Slovakia",
      "labelrank": "6",
      "country-abbrev": "Svk.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "SVK",
      "iso-a2": "SK",
      "woe-id": "23424877",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4652, 8768],
          [4647, 8753],
          [4643, 8743],
          [4633, 8741],
          [4622, 8749],
          [4613, 8746],
          [4595, 8748],
          [4590, 8738],
          [4581, 8733],
          [4550, 8730],
          [4550, 8722],
          [4521, 8719],
          [4501, 8729],
          [4491, 8742],
          [4493, 8751],
          [4497, 8759],
          [4509, 8758],
          [4525, 8768],
          [4536, 8782],
          [4544, 8783],
          [4554, 8779],
          [4561, 8787],
          [4580, 8771],
          [4587, 8779],
          [4605, 8775],
          [4614, 8781],
          [4630, 8779],
          [4636, 8773],
          [4652, 8768]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "JK",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.22,
      "hc-middle-y": 0.49,
      "hc-key": "jk",
      "hc-a2": "JK",
      "name": "Siachen Glacier",
      "labelrank": "5",
      "country-abbrev": "Siachen",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "-99",
      "iso-a2": "JK",
      "woe-id": "23424928",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6412, 8269],
          [6393, 8254],
          [6379, 8274],
          [6400, 8268],
          [6412, 8269]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PK",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.53,
      "hc-middle-y": 0.56,
      "hc-key": "pk",
      "hc-a2": "PK",
      "name": "Pakistan",
      "labelrank": "2",
      "country-abbrev": "Pak.",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "PAK",
      "iso-a2": "PK",
      "woe-id": "23424922",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6379, 8274],
          [6393, 8254],
          [6384, 8240],
          [6365, 8238],
          [6359, 8231],
          [6312, 8241],
          [6300, 8236],
          [6298, 8226],
          [6304, 8224],
          [6307, 8213],
          [6315, 8213],
          [6311, 8199],
          [6317, 8195],
          [6316, 8182],
          [6327, 8175],
          [6330, 8166],
          [6340, 8169],
          [6344, 8155],
          [6354, 8155],
          [6366, 8148],
          [6365, 8143],
          [6351, 8139],
          [6343, 8127],
          [6349, 8118],
          [6350, 8105],
          [6334, 8077],
          [6338, 8071],
          [6322, 8061],
          [6320, 8046],
          [6314, 8027],
          [6298, 8018],
          [6288, 7988],
          [6257, 7978],
          [6242, 7991],
          [6233, 7982],
          [6231, 7974],
          [6220, 7959],
          [6218, 7945],
          [6231, 7936],
          [6242, 7934],
          [6242, 7914],
          [6249, 7904],
          [6262, 7903],
          [6264, 7892],
          [6281, 7866],
          [6282, 7856],
          [6273, 7849],
          [6266, 7856],
          [6251, 7851],
          [6248, 7846],
          [6234, 7850],
          [6211, 7849],
          [6209, 7839],
          [6192, 7834],
          [6192, 7829],
          [6181, 7837],
          [6177, 7832],
          [6165, 7843],
          [6156, 7866],
          [6149, 7872],
          [6139, 7871],
          [6139, 7886],
          [6123, 7895],
          [6104, 7890],
          [6068, 7888],
          [6043, 7892],
          [6036, 7885],
          [6003, 7887],
          [5999, 7883],
          [5980, 7879],
          [5975, 7885],
          [5975, 7906],
          [5979, 7924],
          [5990, 7928],
          [5991, 7933],
          [6005, 7939],
          [6016, 7939],
          [6021, 7956],
          [6016, 7962],
          [6002, 7962],
          [6003, 7970],
          [5997, 7998],
          [5968, 8009],
          [5955, 8022],
          [5943, 8042],
          [5927, 8058],
          [5981, 8042],
          [6015, 8045],
          [6032, 8041],
          [6043, 8048],
          [6061, 8047],
          [6096, 8058],
          [6097, 8073],
          [6093, 8086],
          [6094, 8098],
          [6109, 8112],
          [6123, 8108],
          [6135, 8113],
          [6131, 8120],
          [6143, 8131],
          [6160, 8129],
          [6166, 8123],
          [6179, 8135],
          [6173, 8153],
          [6177, 8162],
          [6177, 8178],
          [6188, 8178],
          [6199, 8187],
          [6190, 8202],
          [6179, 8210],
          [6184, 8214],
          [6201, 8210],
          [6216, 8214],
          [6216, 8226],
          [6210, 8231],
          [6224, 8257],
          [6219, 8271],
          [6202, 8289],
          [6212, 8305],
          [6216, 8303],
          [6238, 8319],
          [6276, 8321],
          [6284, 8319],
          [6296, 8326],
          [6308, 8322],
          [6314, 8325],
          [6326, 8316],
          [6338, 8314],
          [6346, 8305],
          [6347, 8292],
          [6359, 8280],
          [6369, 8284],
          [6379, 8274]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.75,
      "hc-middle-y": 0.51,
      "hc-key": "bg",
      "hc-a2": "BG",
      "name": "Bulgaria",
      "labelrank": "4",
      "country-abbrev": "Bulg.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "BGR",
      "iso-a2": "BG",
      "woe-id": "23424771",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4853, 8571],
          [4852, 8558],
          [4842, 8559],
          [4836, 8545],
          [4838, 8534],
          [4831, 8525],
          [4845, 8507],
          [4831, 8505],
          [4815, 8511],
          [4803, 8507],
          [4796, 8498],
          [4787, 8498],
          [4791, 8485],
          [4765, 8481],
          [4750, 8485],
          [4742, 8493],
          [4728, 8491],
          [4715, 8486],
          [4694, 8484],
          [4696, 8499],
          [4690, 8509],
          [4674, 8520],
          [4678, 8523],
          [4674, 8538],
          [4683, 8540],
          [4689, 8552],
          [4674, 8562],
          [4668, 8574],
          [4677, 8589],
          [4687, 8584],
          [4685, 8574],
          [4697, 8576],
          [4722, 8572],
          [4731, 8573],
          [4758, 8568],
          [4770, 8571],
          [4780, 8581],
          [4805, 8587],
          [4817, 8581],
          [4832, 8580],
          [4835, 8575],
          [4853, 8571]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.51,
      "hc-key": "li",
      "hc-a2": "LI",
      "name": "Liechtenstein",
      "labelrank": "6",
      "country-abbrev": "Liech.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "LIE",
      "iso-a2": "LI",
      "woe-id": "23424879",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4281, 8702],
          [4284, 8696],
          [4284, 8694],
          [4280, 8694],
          [4281, 8702]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.61,
      "hc-key": "at",
      "hc-a2": "AT",
      "name": "Austria",
      "labelrank": "4",
      "country-abbrev": "Aust.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "AUT",
      "iso-a2": "AT",
      "woe-id": "23424750",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4284, 8694],
          [4284, 8696],
          [4281, 8702],
          [4285, 8707],
          [4282, 8711],
          [4286, 8710],
          [4287, 8712],
          [4293, 8712],
          [4300, 8702],
          [4307, 8713],
          [4324, 8706],
          [4342, 8714],
          [4375, 8716],
          [4383, 8710],
          [4381, 8723],
          [4373, 8733],
          [4400, 8748],
          [4402, 8756],
          [4410, 8750],
          [4428, 8749],
          [4435, 8764],
          [4444, 8764],
          [4468, 8756],
          [4478, 8757],
          [4493, 8751],
          [4491, 8742],
          [4501, 8729],
          [4500, 8718],
          [4485, 8720],
          [4488, 8709],
          [4482, 8705],
          [4483, 8693],
          [4474, 8687],
          [4472, 8681],
          [4438, 8678],
          [4430, 8669],
          [4405, 8675],
          [4367, 8681],
          [4357, 8695],
          [4346, 8691],
          [4330, 8691],
          [4325, 8684],
          [4309, 8687],
          [4299, 8687],
          [4284, 8694]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.50,
      "hc-key": "sz",
      "hc-a2": "SZ",
      "name": "Swaziland",
      "labelrank": "4",
      "country-abbrev": "Swz.",
      "subregion": "Southern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SWZ",
      "iso-a2": "SZ",
      "woe-id": "23424993",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5025, 5980],
          [5027, 5968],
          [5028, 5947],
          [5024, 5948],
          [5022, 5929],
          [5008, 5929],
          [4996, 5934],
          [4986, 5949],
          [4987, 5964],
          [4999, 5982],
          [5009, 5988],
          [5025, 5980]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "HU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.27,
      "hc-middle-y": 0.59,
      "hc-key": "hu",
      "hc-a2": "HU",
      "name": "Hungary",
      "labelrank": "5",
      "country-abbrev": "Hun.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "HUN",
      "iso-a2": "HU",
      "woe-id": "23424844",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4559, 8653],
          [4545, 8646],
          [4529, 8647],
          [4513, 8654],
          [4497, 8670],
          [4487, 8674],
          [4479, 8687],
          [4474, 8687],
          [4483, 8693],
          [4482, 8705],
          [4488, 8709],
          [4485, 8720],
          [4500, 8718],
          [4501, 8729],
          [4521, 8719],
          [4550, 8722],
          [4550, 8730],
          [4581, 8733],
          [4590, 8738],
          [4595, 8748],
          [4613, 8746],
          [4622, 8749],
          [4633, 8741],
          [4643, 8743],
          [4658, 8732],
          [4667, 8727],
          [4650, 8718],
          [4643, 8710],
          [4632, 8682],
          [4623, 8666],
          [4597, 8660],
          [4577, 8662],
          [4569, 8655],
          [4559, 8653]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.59,
      "hc-middle-y": 0.45,
      "hc-key": "ne",
      "hc-a2": "NE",
      "name": "Niger",
      "labelrank": "3",
      "country-abbrev": "Niger",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "NER",
      "iso-a2": "NE",
      "woe-id": "23424906",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4122, 7382],
          [4098, 7408],
          [4082, 7402],
          [4083, 7390],
          [4072, 7406],
          [4076, 7416],
          [4069, 7420],
          [4056, 7417],
          [4037, 7432],
          [4037, 7444],
          [4043, 7444],
          [4034, 7454],
          [4025, 7456],
          [4016, 7473],
          [4017, 7477],
          [4010, 7488],
          [4012, 7502],
          [4012, 7505],
          [4036, 7504],
          [4048, 7516],
          [4119, 7518],
          [4130, 7531],
          [4137, 7553],
          [4141, 7558],
          [4142, 7579],
          [4141, 7659],
          [4192, 7671],
          [4246, 7724],
          [4389, 7822],
          [4438, 7810],
          [4462, 7789],
          [4486, 7803],
          [4493, 7765],
          [4494, 7747],
          [4508, 7727],
          [4507, 7719],
          [4520, 7704],
          [4513, 7688],
          [4507, 7576],
          [4472, 7533],
          [4455, 7506],
          [4453, 7495],
          [4443, 7482],
          [4448, 7457],
          [4439, 7457],
          [4415, 7440],
          [4412, 7433],
          [4398, 7435],
          [4378, 7444],
          [4353, 7445],
          [4335, 7440],
          [4319, 7424],
          [4307, 7424],
          [4288, 7428],
          [4269, 7442],
          [4260, 7443],
          [4246, 7435],
          [4231, 7430],
          [4212, 7454],
          [4205, 7454],
          [4185, 7463],
          [4175, 7458],
          [4162, 7459],
          [4139, 7448],
          [4138, 7430],
          [4124, 7413],
          [4122, 7382]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LU",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.60,
      "hc-key": "lu",
      "hc-a2": "LU",
      "name": "Luxembourg",
      "labelrank": "6",
      "country-abbrev": "Lux.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "LUX",
      "iso-a2": "LU",
      "woe-id": "23424881",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4186, 8781],
          [4175, 8781],
          [4170, 8784],
          [4168, 8797],
          [4179, 8805],
          [4182, 8797],
          [4191, 8794],
          [4186, 8781]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "AD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.28,
      "hc-key": "ad",
      "hc-a2": "AD",
      "name": "Andorra",
      "labelrank": "6",
      "country-abbrev": "And.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "AND",
      "iso-a2": "AD",
      "woe-id": "23424744",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4047, 8530],
          [4056, 8530],
          [4056, 8527],
          [4050, 8524],
          [4047, 8530]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.51,
      "hc-key": "ci",
      "hc-a2": "CI",
      "name": "Ivory Coast",
      "labelrank": "3",
      "country-abbrev": "I.C.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "CIV",
      "iso-a2": "CI",
      "woe-id": "23424854",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [3902, 7136],
            [3897, 7137],
            [3902, 7137],
            [3902, 7136]
          ]
        ],
        [
          [
            [3757, 7109],
            [3756, 7135],
            [3762, 7146],
            [3760, 7164],
            [3747, 7173],
            [3747, 7177],
            [3722, 7188],
            [3731, 7198],
            [3732, 7212],
            [3726, 7228],
            [3735, 7227],
            [3740, 7250],
            [3734, 7254],
            [3736, 7263],
            [3753, 7258],
            [3752, 7268],
            [3744, 7274],
            [3747, 7297],
            [3740, 7297],
            [3737, 7317],
            [3743, 7325],
            [3754, 7335],
            [3764, 7328],
            [3776, 7325],
            [3777, 7332],
            [3785, 7332],
            [3800, 7346],
            [3800, 7328],
            [3808, 7326],
            [3812, 7332],
            [3824, 7335],
            [3837, 7330],
            [3842, 7315],
            [3851, 7307],
            [3864, 7309],
            [3885, 7317],
            [3899, 7316],
            [3914, 7296],
            [3917, 7300],
            [3914, 7284],
            [3919, 7279],
            [3922, 7252],
            [3914, 7242],
            [3908, 7229],
            [3905, 7210],
            [3899, 7202],
            [3900, 7180],
            [3908, 7155],
            [3915, 7147],
            [3911, 7138],
            [3896, 7137],
            [3873, 7141],
            [3824, 7136],
            [3812, 7134],
            [3778, 7120],
            [3757, 7109]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.89,
      "hc-middle-y": 0.71,
      "hc-key": "lr",
      "hc-a2": "LR",
      "name": "Liberia",
      "labelrank": "4",
      "country-abbrev": "Liberia",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "LBR",
      "iso-a2": "LR",
      "woe-id": "23424876",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3726, 7228],
          [3732, 7212],
          [3731, 7198],
          [3722, 7188],
          [3747, 7177],
          [3747, 7173],
          [3760, 7164],
          [3762, 7146],
          [3756, 7135],
          [3757, 7109],
          [3733, 7117],
          [3700, 7138],
          [3665, 7175],
          [3650, 7181],
          [3649, 7186],
          [3632, 7196],
          [3628, 7204],
          [3631, 7212],
          [3656, 7236],
          [3657, 7246],
          [3666, 7251],
          [3668, 7262],
          [3683, 7263],
          [3693, 7257],
          [3692, 7251],
          [3698, 7230],
          [3694, 7223],
          [3705, 7214],
          [3714, 7220],
          [3720, 7233],
          [3726, 7228]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.47,
      "hc-key": "sl",
      "hc-a2": "SL",
      "name": "Sierra Leone",
      "labelrank": "4",
      "country-abbrev": "S.L.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SLE",
      "iso-a2": "SL",
      "woe-id": "23424946",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3668, 7262],
          [3666, 7251],
          [3657, 7246],
          [3656, 7236],
          [3631, 7212],
          [3628, 7204],
          [3616, 7213],
          [3580, 7228],
          [3593, 7232],
          [3580, 7241],
          [3579, 7254],
          [3573, 7251],
          [3573, 7264],
          [3569, 7283],
          [3578, 7285],
          [3589, 7297],
          [3595, 7313],
          [3615, 7319],
          [3636, 7319],
          [3655, 7293],
          [3661, 7269],
          [3653, 7255],
          [3668, 7262]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.54,
      "hc-key": "bn",
      "hc-a2": "BN",
      "name": "Brunei",
      "labelrank": "6",
      "country-abbrev": "Brunei",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "BRN",
      "iso-a2": "BN",
      "woe-id": "23424773",
      "continent": "Asia"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [7783, 7126],
            [7787, 7127],
            [7787, 7129],
            [7795, 7107],
            [7786, 7110],
            [7783, 7126]
          ]
        ],
        [
          [
            [7750, 7118],
            [7767, 7121],
            [7784, 7135],
            [7782, 7129],
            [7774, 7123],
            [7778, 7111],
            [7776, 7100],
            [7770, 7096],
            [7758, 7113],
            [7750, 7118]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.36,
      "hc-key": "be",
      "hc-a2": "BE",
      "name": "Belgium",
      "labelrank": "2",
      "country-abbrev": "Belg.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "BEL",
      "iso-a2": "BE",
      "woe-id": "23424757",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4179, 8805],
          [4168, 8797],
          [4170, 8784],
          [4161, 8783],
          [4141, 8800],
          [4143, 8806],
          [4131, 8799],
          [4123, 8800],
          [4124, 8810],
          [4109, 8813],
          [4098, 8820],
          [4093, 8829],
          [4087, 8826],
          [4078, 8832],
          [4076, 8840],
          [4093, 8849],
          [4099, 8851],
          [4112, 8845],
          [4124, 8850],
          [4126, 8848],
          [4125, 8850],
          [4146, 8854],
          [4152, 8846],
          [4170, 8843],
          [4166, 8829],
          [4175, 8828],
          [4186, 8812],
          [4179, 8805]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IQ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.39,
      "hc-middle-y": 0.57,
      "hc-key": "iq",
      "hc-a2": "IQ",
      "name": "Iraq",
      "labelrank": "3",
      "country-abbrev": "Iraq",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "IRQ",
      "iso-a2": "IQ",
      "woe-id": "23424855",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5537, 8062],
          [5524, 8065],
          [5519, 8063],
          [5500, 8067],
          [5492, 8062],
          [5487, 8043],
          [5478, 8030],
          [5473, 8029],
          [5419, 8034],
          [5356, 8082],
          [5329, 8104],
          [5273, 8135],
          [5232, 8142],
          [5234, 8151],
          [5227, 8156],
          [5215, 8189],
          [5270, 8225],
          [5278, 8227],
          [5283, 8242],
          [5281, 8257],
          [5284, 8275],
          [5278, 8290],
          [5280, 8307],
          [5293, 8311],
          [5306, 8330],
          [5316, 8339],
          [5328, 8340],
          [5340, 8335],
          [5363, 8335],
          [5365, 8325],
          [5380, 8331],
          [5391, 8308],
          [5399, 8304],
          [5404, 8287],
          [5417, 8281],
          [5436, 8280],
          [5428, 8276],
          [5427, 8268],
          [5435, 8258],
          [5428, 8253],
          [5416, 8229],
          [5422, 8222],
          [5418, 8211],
          [5431, 8197],
          [5435, 8198],
          [5451, 8173],
          [5466, 8166],
          [5479, 8155],
          [5490, 8152],
          [5493, 8143],
          [5506, 8129],
          [5503, 8116],
          [5505, 8101],
          [5516, 8100],
          [5518, 8081],
          [5532, 8071],
          [5537, 8062]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GE",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.28,
      "hc-middle-y": 0.45,
      "hc-key": "ge",
      "hc-a2": "GE",
      "name": "Georgia",
      "labelrank": "5",
      "country-abbrev": "Geo.",
      "subregion": "Western Asia",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "GEO",
      "iso-a2": "GE",
      "woe-id": "23424823",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5360, 8483],
          [5347, 8479],
          [5335, 8480],
          [5314, 8476],
          [5291, 8493],
          [5282, 8488],
          [5253, 8491],
          [5259, 8502],
          [5245, 8532],
          [5228, 8544],
          [5207, 8550],
          [5195, 8558],
          [5196, 8564],
          [5213, 8564],
          [5243, 8552],
          [5281, 8551],
          [5292, 8542],
          [5313, 8535],
          [5318, 8528],
          [5327, 8534],
          [5344, 8535],
          [5361, 8527],
          [5373, 8525],
          [5371, 8517],
          [5398, 8504],
          [5392, 8496],
          [5410, 8482],
          [5406, 8474],
          [5397, 8479],
          [5385, 8480],
          [5382, 8484],
          [5366, 8488],
          [5360, 8483]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GM",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.02,
      "hc-middle-y": 0.59,
      "hc-key": "gm",
      "hc-a2": "GM",
      "name": "Gambia",
      "labelrank": "6",
      "country-abbrev": "Gambia",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "GMB",
      "iso-a2": "GM",
      "woe-id": "23424821",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3458, 7433],
          [3455, 7443],
          [3464, 7452],
          [3498, 7452],
          [3503, 7459],
          [3519, 7460],
          [3536, 7448],
          [3548, 7452],
          [3553, 7443],
          [3536, 7439],
          [3511, 7453],
          [3508, 7446],
          [3488, 7443],
          [3488, 7436],
          [3460, 7437],
          [3458, 7433]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.87,
      "hc-middle-y": 0.53,
      "hc-key": "ch",
      "hc-a2": "CH",
      "name": "Switzerland",
      "labelrank": "4",
      "country-abbrev": "Switz.",
      "subregion": "Western Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "CHE",
      "iso-a2": "CH",
      "woe-id": "23424957",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4271, 8717],
          [4271, 8716],
          [4271, 8716],
          [4271, 8716],
          [4280, 8710],
          [4282, 8711],
          [4285, 8707],
          [4281, 8702],
          [4280, 8694],
          [4284, 8694],
          [4299, 8687],
          [4309, 8687],
          [4310, 8675],
          [4299, 8678],
          [4296, 8669],
          [4284, 8667],
          [4275, 8673],
          [4275, 8664],
          [4266, 8649],
          [4263, 8658],
          [4251, 8666],
          [4251, 8672],
          [4241, 8665],
          [4235, 8653],
          [4226, 8655],
          [4210, 8653],
          [4203, 8661],
          [4203, 8671],
          [4198, 8675],
          [4191, 8670],
          [4187, 8666],
          [4183, 8677],
          [4192, 8683],
          [4209, 8704],
          [4208, 8710],
          [4219, 8708],
          [4225, 8713],
          [4250, 8713],
          [4254, 8721],
          [4271, 8717]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.46,
      "hc-middle-y": 0.68,
      "hc-key": "td",
      "hc-a2": "TD",
      "name": "Chad",
      "labelrank": "3",
      "country-abbrev": "Chad",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "TCD",
      "iso-a2": "TD",
      "woe-id": "23424777",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4478, 7430],
          [4487, 7433],
          [4479, 7440],
          [4474, 7434],
          [4473, 7434],
          [4471, 7436],
          [4472, 7434],
          [4464, 7434],
          [4448, 7457],
          [4443, 7482],
          [4453, 7495],
          [4455, 7506],
          [4472, 7533],
          [4507, 7576],
          [4513, 7688],
          [4520, 7704],
          [4507, 7719],
          [4508, 7727],
          [4494, 7747],
          [4493, 7765],
          [4486, 7803],
          [4518, 7820],
          [4780, 7673],
          [4785, 7532],
          [4756, 7531],
          [4750, 7525],
          [4750, 7509],
          [4743, 7493],
          [4733, 7488],
          [4740, 7473],
          [4725, 7460],
          [4731, 7443],
          [4722, 7434],
          [4717, 7423],
          [4724, 7417],
          [4730, 7421],
          [4738, 7416],
          [4735, 7411],
          [4744, 7396],
          [4741, 7381],
          [4753, 7371],
          [4753, 7353],
          [4739, 7356],
          [4715, 7343],
          [4717, 7334],
          [4693, 7310],
          [4687, 7297],
          [4674, 7287],
          [4656, 7283],
          [4630, 7282],
          [4623, 7276],
          [4631, 7270],
          [4614, 7246],
          [4583, 7244],
          [4555, 7228],
          [4547, 7240],
          [4542, 7232],
          [4522, 7224],
          [4512, 7227],
          [4511, 7238],
          [4502, 7262],
          [4475, 7288],
          [4461, 7305],
          [4469, 7318],
          [4488, 7316],
          [4518, 7319],
          [4505, 7331],
          [4498, 7348],
          [4496, 7363],
          [4499, 7376],
          [4496, 7397],
          [4491, 7399],
          [4489, 7417],
          [4481, 7421],
          [4478, 7430]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.38,
      "hc-middle-y": 0.37,
      "hc-key": "ng",
      "hc-a2": "NG",
      "name": "Nigeria",
      "labelrank": "2",
      "country-abbrev": "Nigeria",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "NGA",
      "iso-a2": "NG",
      "woe-id": "23424908",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4448, 7457],
          [4464, 7434],
          [4468, 7407],
          [4484, 7400],
          [4480, 7383],
          [4482, 7375],
          [4468, 7365],
          [4462, 7366],
          [4448, 7342],
          [4444, 7325],
          [4438, 7322],
          [4437, 7302],
          [4426, 7296],
          [4424, 7274],
          [4405, 7257],
          [4404, 7243],
          [4399, 7229],
          [4390, 7217],
          [4394, 7212],
          [4384, 7203],
          [4376, 7186],
          [4369, 7187],
          [4367, 7196],
          [4352, 7212],
          [4349, 7203],
          [4337, 7207],
          [4325, 7199],
          [4323, 7190],
          [4311, 7182],
          [4295, 7164],
          [4294, 7139],
          [4287, 7126],
          [4281, 7123],
          [4275, 7131],
          [4277, 7116],
          [4258, 7114],
          [4244, 7118],
          [4241, 7110],
          [4230, 7110],
          [4208, 7106],
          [4198, 7109],
          [4188, 7119],
          [4177, 7149],
          [4165, 7170],
          [4149, 7183],
          [4132, 7186],
          [4093, 7184],
          [4096, 7209],
          [4092, 7241],
          [4094, 7252],
          [4095, 7284],
          [4105, 7285],
          [4107, 7299],
          [4120, 7313],
          [4122, 7330],
          [4130, 7341],
          [4124, 7361],
          [4118, 7372],
          [4122, 7382],
          [4124, 7413],
          [4138, 7430],
          [4139, 7448],
          [4162, 7459],
          [4175, 7458],
          [4185, 7463],
          [4205, 7454],
          [4212, 7454],
          [4231, 7430],
          [4246, 7435],
          [4260, 7443],
          [4269, 7442],
          [4288, 7428],
          [4307, 7424],
          [4319, 7424],
          [4335, 7440],
          [4353, 7445],
          [4378, 7444],
          [4398, 7435],
          [4412, 7433],
          [4415, 7440],
          [4439, 7457],
          [4448, 7457]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KV",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.51,
      "hc-key": "kv",
      "hc-a2": "KV",
      "name": "Kosovo",
      "labelrank": "6",
      "country-abbrev": "Kos.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "-99",
      "iso-a2": "KV",
      "woe-id": "-90",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4622, 8504],
          [4619, 8516],
          [4605, 8528],
          [4603, 8535],
          [4612, 8538],
          [4623, 8554],
          [4633, 8548],
          [4643, 8535],
          [4655, 8533],
          [4651, 8517],
          [4641, 8512],
          [4637, 8516],
          [4622, 8504]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LB",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.41,
      "hc-middle-y": 0.52,
      "hc-key": "lb",
      "hc-a2": "LB",
      "name": "Lebanon",
      "labelrank": "5",
      "country-abbrev": "Leb.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "LBN",
      "iso-a2": "LB",
      "woe-id": "23424873",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5101, 8178],
          [5112, 8209],
          [5114, 8224],
          [5122, 8237],
          [5135, 8235],
          [5143, 8220],
          [5128, 8205],
          [5122, 8190],
          [5113, 8178],
          [5101, 8178]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SX",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.95,
      "hc-middle-y": 0.17,
      "hc-key": "sx",
      "hc-a2": "SX",
      "name": "Somaliland",
      "labelrank": "5",
      "country-abbrev": "Solnd.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "-99",
      "iso-a2": "SX",
      "woe-id": "-99",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5578, 7244],
          [5545, 7244],
          [5447, 7281],
          [5427, 7297],
          [5419, 7315],
          [5407, 7327],
          [5400, 7342],
          [5409, 7356],
          [5418, 7374],
          [5426, 7369],
          [5433, 7356],
          [5454, 7336],
          [5476, 7334],
          [5502, 7352],
          [5524, 7345],
          [5531, 7347],
          [5555, 7363],
          [5580, 7362],
          [5596, 7368],
          [5605, 7365],
          [5608, 7298],
          [5578, 7244]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "DJ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.54,
      "hc-key": "dj",
      "hc-a2": "DJ",
      "name": "Djibouti",
      "labelrank": "5",
      "country-abbrev": "Dji.",
      "subregion": "Eastern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "DJI",
      "iso-a2": "DJ",
      "woe-id": "23424797",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5409, 7356],
          [5399, 7359],
          [5377, 7354],
          [5371, 7359],
          [5374, 7364],
          [5371, 7367],
          [5370, 7376],
          [5389, 7411],
          [5399, 7407],
          [5413, 7420],
          [5420, 7412],
          [5421, 7393],
          [5403, 7383],
          [5396, 7375],
          [5415, 7379],
          [5418, 7374],
          [5409, 7356]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ER",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.31,
      "hc-middle-y": 0.18,
      "hc-key": "er",
      "hc-a2": "ER",
      "name": "Eritrea",
      "labelrank": "4",
      "country-abbrev": "Erit.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "ERI",
      "iso-a2": "ER",
      "woe-id": "23424806",
      "continent": "Africa"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [5413, 7420],
            [5399, 7407],
            [5389, 7411],
            [5374, 7426],
            [5368, 7437],
            [5348, 7454],
            [5336, 7472],
            [5311, 7485],
            [5292, 7489],
            [5282, 7484],
            [5276, 7492],
            [5271, 7486],
            [5257, 7483],
            [5250, 7493],
            [5239, 7501],
            [5229, 7472],
            [5220, 7485],
            [5214, 7480],
            [5195, 7478],
            [5191, 7510],
            [5206, 7553],
            [5203, 7561],
            [5206, 7582],
            [5221, 7583],
            [5221, 7591],
            [5244, 7599],
            [5256, 7617],
            [5268, 7594],
            [5276, 7569],
            [5283, 7538],
            [5289, 7525],
            [5294, 7524],
            [5297, 7510],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524],
            [5309, 7517],
            [5312, 7504],
            [5327, 7503],
            [5333, 7494],
            [5346, 7492],
            [5364, 7466],
            [5373, 7462],
            [5384, 7452],
            [5388, 7439],
            [5392, 7439],
            [5401, 7425],
            [5413, 7420]
          ]
        ],
        [
          [
            [5302, 7524],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524]
          ]
        ],
        [
          [
            [5302, 7524],
            [5307, 7536],
            [5311, 7529],
            [5302, 7524],
            [5302, 7524],
            [5302, 7524]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BI",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.56,
      "hc-middle-y": 0.48,
      "hc-key": "bi",
      "hc-a2": "BI",
      "name": "Burundi",
      "labelrank": "6",
      "country-abbrev": "Bur.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "BDI",
      "iso-a2": "BI",
      "woe-id": "23424774",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4979, 6781],
          [4970, 6802],
          [4969, 6820],
          [4965, 6822],
          [4966, 6833],
          [4959, 6845],
          [4967, 6848],
          [4969, 6841],
          [4982, 6842],
          [4988, 6847],
          [4989, 6860],
          [4995, 6856],
          [5004, 6861],
          [5009, 6857],
          [5005, 6841],
          [5015, 6835],
          [5018, 6826],
          [5005, 6814],
          [4990, 6787],
          [4979, 6781]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SR",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.85,
      "hc-middle-y": 0.21,
      "hc-key": "sr",
      "hc-a2": "SR",
      "name": "Suriname",
      "labelrank": "4",
      "country-abbrev": "Sur.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "SUR",
      "iso-a2": "SR",
      "woe-id": "23424913",
      "continent": "South America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2125, 7151],
          [2135, 7170],
          [2168, 7163],
          [2170, 7169],
          [2216, 7168],
          [2231, 7164],
          [2226, 7146],
          [2215, 7129],
          [2218, 7097],
          [2230, 7075],
          [2224, 7066],
          [2224, 7053],
          [2217, 7039],
          [2209, 7033],
          [2197, 7041],
          [2172, 7036],
          [2164, 7041],
          [2161, 7030],
          [2166, 7023],
          [2162, 7015],
          [2147, 7019],
          [2140, 7022],
          [2125, 7052],
          [2121, 7073],
          [2110, 7073],
          [2098, 7095],
          [2097, 7102],
          [2105, 7120],
          [2102, 7126],
          [2109, 7132],
          [2123, 7134],
          [2125, 7151]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.55,
      "hc-middle-y": 0.17,
      "hc-key": "il",
      "hc-a2": "IL",
      "name": "Israel",
      "labelrank": "4",
      "country-abbrev": "Isr.",
      "subregion": "Western Asia",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "ISR",
      "iso-a2": "IL",
      "woe-id": "23424852",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5080, 8112],
          [5088, 8122],
          [5096, 8148],
          [5098, 8168],
          [5101, 8178],
          [5113, 8178],
          [5122, 8190],
          [5126, 8173],
          [5123, 8165],
          [5117, 8162],
          [5121, 8129],
          [5117, 8120],
          [5118, 8113],
          [5118, 8110],
          [5118, 8109],
          [5117, 8107],
          [5119, 8104],
          [5113, 8080],
          [5114, 8068],
          [5110, 8047],
          [5109, 8045],
          [5108, 8045],
          [5105, 8054],
          [5080, 8112]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.27,
      "hc-middle-y": 0.50,
      "hc-key": "sn",
      "hc-a2": "SN",
      "name": "Senegal",
      "labelrank": "3",
      "country-abbrev": "Sen.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SEN",
      "iso-a2": "SN",
      "woe-id": "23424943",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3556, 7418],
          [3508, 7419],
          [3493, 7410],
          [3475, 7410],
          [3458, 7406],
          [3456, 7424],
          [3458, 7433],
          [3460, 7437],
          [3488, 7436],
          [3488, 7443],
          [3508, 7446],
          [3511, 7453],
          [3536, 7439],
          [3553, 7443],
          [3548, 7452],
          [3536, 7448],
          [3519, 7460],
          [3503, 7459],
          [3498, 7452],
          [3464, 7452],
          [3453, 7481],
          [3444, 7494],
          [3433, 7496],
          [3446, 7502],
          [3455, 7514],
          [3467, 7535],
          [3474, 7559],
          [3495, 7560],
          [3520, 7566],
          [3539, 7566],
          [3555, 7547],
          [3566, 7548],
          [3574, 7528],
          [3583, 7524],
          [3586, 7513],
          [3598, 7506],
          [3605, 7497],
          [3606, 7482],
          [3614, 7474],
          [3610, 7457],
          [3619, 7442],
          [3628, 7440],
          [3633, 7428],
          [3633, 7408],
          [3609, 7409],
          [3601, 7405],
          [3577, 7413],
          [3578, 7417],
          [3556, 7418]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "GN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.38,
      "hc-key": "gn",
      "hc-a2": "GN",
      "name": "Guinea",
      "labelrank": "3",
      "country-abbrev": "Gin.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "GIN",
      "iso-a2": "GN",
      "woe-id": "23424835",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3556, 7418],
          [3578, 7417],
          [3577, 7413],
          [3601, 7405],
          [3609, 7409],
          [3633, 7408],
          [3629, 7399],
          [3636, 7393],
          [3643, 7401],
          [3655, 7389],
          [3669, 7401],
          [3687, 7394],
          [3704, 7411],
          [3711, 7408],
          [3717, 7391],
          [3715, 7381],
          [3731, 7370],
          [3720, 7356],
          [3733, 7355],
          [3735, 7335],
          [3743, 7325],
          [3737, 7317],
          [3740, 7297],
          [3747, 7297],
          [3744, 7274],
          [3752, 7268],
          [3753, 7258],
          [3736, 7263],
          [3734, 7254],
          [3740, 7250],
          [3735, 7227],
          [3726, 7228],
          [3720, 7233],
          [3714, 7220],
          [3705, 7214],
          [3694, 7223],
          [3698, 7230],
          [3692, 7251],
          [3693, 7257],
          [3683, 7263],
          [3668, 7262],
          [3653, 7255],
          [3661, 7269],
          [3655, 7293],
          [3636, 7319],
          [3615, 7319],
          [3595, 7313],
          [3589, 7297],
          [3578, 7285],
          [3569, 7283],
          [3560, 7310],
          [3554, 7311],
          [3525, 7337],
          [3517, 7357],
          [3513, 7355],
          [3524, 7375],
          [3537, 7381],
          [3556, 7383],
          [3556, 7393],
          [3548, 7399],
          [3557, 7404],
          [3556, 7418]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PL",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.48,
      "hc-key": "pl",
      "hc-a2": "PL",
      "name": "Poland",
      "labelrank": "3",
      "country-abbrev": "Pol.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "POL",
      "iso-a2": "PL",
      "woe-id": "23424923",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4546, 8960],
          [4540, 8954],
          [4550, 8959],
          [4631, 8956],
          [4633, 8957],
          [4639, 8957],
          [4653, 8949],
          [4655, 8942],
          [4671, 8914],
          [4673, 8897],
          [4660, 8891],
          [4655, 8883],
          [4669, 8876],
          [4671, 8856],
          [4673, 8849],
          [4690, 8832],
          [4685, 8830],
          [4690, 8821],
          [4681, 8815],
          [4664, 8800],
          [4653, 8784],
          [4662, 8765],
          [4652, 8768],
          [4636, 8773],
          [4630, 8779],
          [4614, 8781],
          [4605, 8775],
          [4587, 8779],
          [4580, 8771],
          [4561, 8787],
          [4554, 8779],
          [4544, 8783],
          [4535, 8798],
          [4514, 8800],
          [4494, 8815],
          [4485, 8816],
          [4490, 8809],
          [4481, 8805],
          [4465, 8816],
          [4471, 8822],
          [4441, 8829],
          [4430, 8838],
          [4425, 8832],
          [4429, 8847],
          [4420, 8856],
          [4416, 8866],
          [4420, 8876],
          [4412, 8888],
          [4415, 8894],
          [4399, 8903],
          [4406, 8918],
          [4401, 8933],
          [4408, 8932],
          [4410, 8939],
          [4398, 8940],
          [4397, 8941],
          [4398, 8942],
          [4450, 8954],
          [4461, 8964],
          [4482, 8970],
          [4508, 8974],
          [4518, 8959],
          [4529, 8956],
          [4546, 8960],
          [4546, 8960]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MK",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.49,
      "hc-key": "mk",
      "hc-a2": "MK",
      "name": "Macedonia",
      "labelrank": "6",
      "country-abbrev": "Mkd.",
      "subregion": "Southern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "MKD",
      "iso-a2": "MK",
      "woe-id": "23424890",
      "continent": "Europe"
    },
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [
        [
          [
            [4637, 8467],
            [4637, 8467],
            [4637, 8467],
            [4637, 8467]
          ]
        ],
        [
          [
            [4694, 8484],
            [4689, 8478],
            [4665, 8476],
            [4661, 8469],
            [4642, 8467],
            [4637, 8473],
            [4637, 8468],
            [4636, 8469],
            [4636, 8469],
            [4633, 8469],
            [4630, 8469],
            [4632, 8476],
            [4627, 8475],
            [4621, 8485],
            [4622, 8504],
            [4637, 8516],
            [4641, 8512],
            [4651, 8517],
            [4661, 8521],
            [4674, 8520],
            [4690, 8509],
            [4696, 8499],
            [4694, 8484]
          ]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "PY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.41,
      "hc-middle-y": 0.37,
      "hc-key": "py",
      "hc-a2": "PY",
      "name": "Paraguay",
      "labelrank": "4",
      "country-abbrev": "Para.",
      "subregion": "South America",
      "region-wb": "Latin America & Caribbean",
      "iso-a3": "PRY",
      "iso-a2": "PY",
      "woe-id": "23424917",
      "continent": "South America"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2264, 6050],
          [2265, 6040],
          [2259, 6000],
          [2259, 5996],
          [2259, 5994],
          [2261, 5971],
          [2258, 5954],
          [2248, 5943],
          [2240, 5942],
          [2231, 5925],
          [2218, 5930],
          [2212, 5919],
          [2206, 5924],
          [2186, 5923],
          [2158, 5931],
          [2140, 5929],
          [2137, 5935],
          [2147, 5946],
          [2150, 5974],
          [2164, 5999],
          [2157, 6009],
          [2141, 6018],
          [2122, 6024],
          [2103, 6035],
          [2079, 6053],
          [2070, 6052],
          [2047, 6060],
          [2043, 6068],
          [2022, 6081],
          [2014, 6089],
          [2001, 6109],
          [1988, 6119],
          [1996, 6162],
          [1995, 6181],
          [2004, 6198],
          [2008, 6215],
          [2064, 6228],
          [2093, 6228],
          [2125, 6208],
          [2126, 6196],
          [2140, 6166],
          [2138, 6125],
          [2150, 6121],
          [2181, 6119],
          [2189, 6125],
          [2196, 6117],
          [2207, 6116],
          [2216, 6104],
          [2217, 6090],
          [2227, 6055],
          [2235, 6052],
          [2251, 6060],
          [2264, 6050]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.49,
      "hc-key": "by",
      "hc-a2": "BY",
      "name": "Belarus",
      "labelrank": "4",
      "country-abbrev": "Bela.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "BLR",
      "iso-a2": "BY",
      "woe-id": "23424765",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4671, 8856],
          [4669, 8876],
          [4655, 8883],
          [4660, 8891],
          [4673, 8897],
          [4671, 8914],
          [4655, 8942],
          [4680, 8940],
          [4690, 8947],
          [4708, 8955],
          [4714, 8964],
          [4716, 8977],
          [4725, 8984],
          [4734, 8983],
          [4738, 8990],
          [4729, 8991],
          [4731, 9003],
          [4741, 9008],
          [4757, 9007],
          [4764, 9018],
          [4770, 9019],
          [4790, 9012],
          [4806, 9012],
          [4810, 9003],
          [4819, 9008],
          [4836, 9007],
          [4849, 9000],
          [4848, 8989],
          [4856, 8980],
          [4851, 8972],
          [4863, 8966],
          [4870, 8952],
          [4887, 8944],
          [4885, 8937],
          [4907, 8933],
          [4915, 8924],
          [4901, 8911],
          [4879, 8915],
          [4877, 8909],
          [4898, 8877],
          [4874, 8875],
          [4866, 8857],
          [4869, 8846],
          [4856, 8855],
          [4842, 8855],
          [4833, 8850],
          [4825, 8860],
          [4817, 8855],
          [4801, 8860],
          [4774, 8858],
          [4762, 8864],
          [4730, 8870],
          [4712, 8871],
          [4691, 8869],
          [4681, 8858],
          [4671, 8856]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LV",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.27,
      "hc-middle-y": 0.42,
      "hc-key": "lv",
      "hc-a2": "LV",
      "name": "Latvia",
      "labelrank": "5",
      "country-abbrev": "Lat.",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "LVA",
      "iso-a2": "LV",
      "woe-id": "23424874",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4770, 9019],
          [4764, 9018],
          [4757, 9007],
          [4741, 9008],
          [4731, 9003],
          [4722, 9005],
          [4703, 9019],
          [4687, 9021],
          [4679, 9030],
          [4671, 9024],
          [4648, 9027],
          [4632, 9025],
          [4604, 9029],
          [4584, 9022],
          [4578, 9017],
          [4575, 9022],
          [4574, 9044],
          [4582, 9049],
          [4581, 9059],
          [4588, 9069],
          [4611, 9075],
          [4613, 9069],
          [4627, 9062],
          [4632, 9053],
          [4645, 9048],
          [4661, 9057],
          [4656, 9079],
          [4681, 9086],
          [4717, 9067],
          [4726, 9071],
          [4740, 9067],
          [4754, 9059],
          [4752, 9044],
          [4767, 9033],
          [4770, 9019]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BF",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.61,
      "hc-middle-y": 0.43,
      "hc-key": "bf",
      "hc-a2": "BF",
      "name": "Burkina Faso",
      "labelrank": "3",
      "country-abbrev": "B.F.",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "BFA",
      "iso-a2": "BF",
      "woe-id": "23424978",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4034, 7356],
          [4021, 7356],
          [3999, 7361],
          [3985, 7355],
          [3974, 7356],
          [3915, 7356],
          [3909, 7343],
          [3917, 7300],
          [3914, 7296],
          [3899, 7316],
          [3885, 7317],
          [3864, 7309],
          [3851, 7307],
          [3842, 7315],
          [3837, 7330],
          [3824, 7335],
          [3834, 7372],
          [3831, 7379],
          [3836, 7391],
          [3849, 7394],
          [3856, 7399],
          [3861, 7413],
          [3858, 7420],
          [3866, 7421],
          [3863, 7435],
          [3871, 7445],
          [3887, 7438],
          [3899, 7442],
          [3898, 7457],
          [3910, 7455],
          [3912, 7469],
          [3924, 7478],
          [3936, 7473],
          [3940, 7485],
          [3949, 7486],
          [3969, 7497],
          [3981, 7508],
          [3997, 7508],
          [4012, 7502],
          [4010, 7488],
          [4017, 7477],
          [4016, 7473],
          [4025, 7456],
          [4034, 7454],
          [4043, 7444],
          [4037, 7444],
          [4037, 7432],
          [4056, 7417],
          [4069, 7420],
          [4076, 7416],
          [4072, 7406],
          [4083, 7390],
          [4070, 7372],
          [4052, 7374],
          [4042, 7366],
          [4041, 7358],
          [4034, 7356]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SS",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.48,
      "hc-middle-y": 0.58,
      "hc-key": "ss",
      "hc-a2": "SS",
      "name": "South Sudan",
      "labelrank": "3",
      "country-abbrev": "S. Sud.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SSD",
      "iso-a2": "SS",
      "woe-id": "-99",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5121, 7104],
          [5105, 7086],
          [5089, 7091],
          [5069, 7085],
          [5062, 7078],
          [5049, 7089],
          [5041, 7083],
          [5029, 7088],
          [5018, 7077],
          [5008, 7081],
          [5008, 7091],
          [4997, 7094],
          [4984, 7116],
          [4972, 7120],
          [4964, 7108],
          [4949, 7116],
          [4936, 7106],
          [4917, 7118],
          [4906, 7135],
          [4895, 7161],
          [4872, 7173],
          [4875, 7178],
          [4868, 7184],
          [4870, 7194],
          [4859, 7207],
          [4836, 7220],
          [4834, 7232],
          [4819, 7251],
          [4798, 7255],
          [4797, 7270],
          [4809, 7277],
          [4817, 7312],
          [4825, 7330],
          [4850, 7334],
          [4853, 7326],
          [4874, 7301],
          [4892, 7304],
          [4918, 7304],
          [4923, 7294],
          [4950, 7294],
          [4955, 7304],
          [4970, 7310],
          [4974, 7321],
          [4987, 7329],
          [5012, 7309],
          [5027, 7311],
          [5041, 7327],
          [5050, 7343],
          [5065, 7358],
          [5062, 7382],
          [5053, 7393],
          [5075, 7393],
          [5074, 7401],
          [5090, 7401],
          [5086, 7378],
          [5090, 7350],
          [5115, 7325],
          [5117, 7313],
          [5115, 7299],
          [5121, 7299],
          [5123, 7268],
          [5118, 7261],
          [5092, 7259],
          [5093, 7254],
          [5086, 7241],
          [5089, 7237],
          [5110, 7232],
          [5120, 7222],
          [5129, 7206],
          [5145, 7194],
          [5153, 7165],
          [5165, 7146],
          [5180, 7145],
          [5180, 7124],
          [5185, 7119],
          [5175, 7119],
          [5168, 7134],
          [5134, 7119],
          [5121, 7104]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NA",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.33,
      "hc-middle-y": 0.40,
      "hc-key": "na",
      "hc-a2": "NA",
      "name": "Namibia",
      "labelrank": "3",
      "country-abbrev": "Nam.",
      "subregion": "Southern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "NAM",
      "iso-a2": "NA",
      "woe-id": "23424987",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4763, 6290],
          [4790, 6296],
          [4814, 6293],
          [4824, 6284],
          [4813, 6283],
          [4801, 6274],
          [4790, 6276],
          [4768, 6259],
          [4760, 6276],
          [4750, 6276],
          [4700, 6265],
          [4684, 6264],
          [4680, 6129],
          [4648, 6127],
          [4644, 6025],
          [4639, 5888],
          [4625, 5884],
          [4610, 5868],
          [4599, 5873],
          [4580, 5870],
          [4556, 5878],
          [4555, 5895],
          [4548, 5903],
          [4541, 5901],
          [4538, 5890],
          [4527, 5882],
          [4523, 5883],
          [4503, 5906],
          [4491, 5929],
          [4482, 5966],
          [4479, 5988],
          [4478, 6023],
          [4472, 6032],
          [4468, 6053],
          [4470, 6057],
          [4468, 6087],
          [4472, 6094],
          [4468, 6117],
          [4454, 6135],
          [4450, 6148],
          [4437, 6170],
          [4430, 6196],
          [4402, 6250],
          [4394, 6257],
          [4389, 6271],
          [4385, 6293],
          [4386, 6304],
          [4400, 6308],
          [4413, 6305],
          [4432, 6315],
          [4457, 6298],
          [4466, 6299],
          [4603, 6299],
          [4613, 6286],
          [4621, 6283],
          [4654, 6280],
          [4664, 6282],
          [4679, 6275],
          [4693, 6279],
          [4698, 6276],
          [4763, 6290]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "RO",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.51,
      "hc-key": "ro",
      "hc-a2": "RO",
      "name": "Romania",
      "labelrank": "3",
      "country-abbrev": "Rom.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "ROU",
      "iso-a2": "RO",
      "woe-id": "23424933",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4834, 8636],
          [4838, 8631],
          [4852, 8628],
          [4867, 8636],
          [4878, 8627],
          [4878, 8611],
          [4860, 8607],
          [4859, 8620],
          [4855, 8606],
          [4859, 8602],
          [4852, 8592],
          [4853, 8571],
          [4835, 8575],
          [4832, 8580],
          [4817, 8581],
          [4805, 8587],
          [4780, 8581],
          [4770, 8571],
          [4758, 8568],
          [4731, 8573],
          [4722, 8572],
          [4697, 8576],
          [4685, 8574],
          [4687, 8584],
          [4677, 8589],
          [4669, 8597],
          [4677, 8601],
          [4667, 8607],
          [4659, 8599],
          [4635, 8612],
          [4638, 8625],
          [4615, 8637],
          [4615, 8647],
          [4597, 8660],
          [4623, 8666],
          [4632, 8682],
          [4643, 8710],
          [4650, 8718],
          [4667, 8727],
          [4674, 8732],
          [4681, 8728],
          [4718, 8725],
          [4726, 8718],
          [4736, 8725],
          [4762, 8728],
          [4765, 8736],
          [4774, 8738],
          [4785, 8735],
          [4796, 8716],
          [4814, 8697],
          [4821, 8693],
          [4829, 8678],
          [4827, 8656],
          [4834, 8636]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ZW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.54,
      "hc-middle-y": 0.35,
      "hc-key": "zw",
      "hc-a2": "ZW",
      "name": "Zimbabwe",
      "labelrank": "3",
      "country-abbrev": "Zimb.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "ZWE",
      "iso-a2": "ZW",
      "woe-id": "23425004",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4824, 6284],
          [4837, 6283],
          [4847, 6276],
          [4854, 6281],
          [4870, 6274],
          [4881, 6278],
          [4899, 6296],
          [4904, 6306],
          [4915, 6311],
          [4918, 6319],
          [4931, 6324],
          [4941, 6322],
          [4947, 6328],
          [4939, 6331],
          [4943, 6349],
          [4954, 6358],
          [4975, 6365],
          [4994, 6364],
          [4993, 6351],
          [5021, 6350],
          [5035, 6343],
          [5042, 6335],
          [5054, 6334],
          [5076, 6325],
          [5071, 6316],
          [5076, 6299],
          [5072, 6277],
          [5075, 6263],
          [5069, 6256],
          [5069, 6247],
          [5063, 6245],
          [5068, 6235],
          [5064, 6222],
          [5072, 6210],
          [5071, 6201],
          [5058, 6181],
          [5054, 6181],
          [5049, 6154],
          [5016, 6116],
          [5011, 6113],
          [4997, 6117],
          [4980, 6115],
          [4962, 6122],
          [4949, 6120],
          [4942, 6125],
          [4940, 6134],
          [4925, 6141],
          [4908, 6143],
          [4897, 6162],
          [4899, 6183],
          [4885, 6183],
          [4883, 6198],
          [4868, 6205],
          [4850, 6220],
          [4844, 6242],
          [4831, 6261],
          [4822, 6281],
          [4824, 6284]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "KH",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.25,
      "hc-middle-y": 0.54,
      "hc-key": "kh",
      "hc-a2": "KH",
      "name": "Cambodia",
      "labelrank": "3",
      "country-abbrev": "Camb.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "KHM",
      "iso-a2": "KH",
      "woe-id": "23424776",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7423, 7335],
          [7416, 7340],
          [7402, 7338],
          [7392, 7342],
          [7398, 7352],
          [7391, 7362],
          [7388, 7352],
          [7377, 7354],
          [7377, 7368],
          [7369, 7380],
          [7360, 7400],
          [7362, 7409],
          [7352, 7418],
          [7350, 7430],
          [7344, 7441],
          [7343, 7452],
          [7352, 7453],
          [7365, 7479],
          [7382, 7484],
          [7390, 7481],
          [7419, 7484],
          [7429, 7476],
          [7433, 7481],
          [7439, 7472],
          [7445, 7474],
          [7458, 7465],
          [7466, 7470],
          [7458, 7481],
          [7475, 7490],
          [7486, 7479],
          [7494, 7483],
          [7507, 7494],
          [7503, 7472],
          [7515, 7449],
          [7513, 7431],
          [7518, 7416],
          [7517, 7406],
          [7505, 7404],
          [7492, 7392],
          [7482, 7392],
          [7484, 7381],
          [7470, 7385],
          [7464, 7379],
          [7466, 7367],
          [7478, 7355],
          [7479, 7347],
          [7464, 7357],
          [7450, 7350],
          [7441, 7353],
          [7443, 7345],
          [7436, 7339],
          [7423, 7335]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.50,
      "hc-key": "sd",
      "hc-a2": "SD",
      "name": "Sudan",
      "labelrank": "3",
      "country-abbrev": "Sudan",
      "subregion": "Northern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "SDN",
      "iso-a2": "SD",
      "woe-id": "-90",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5192, 7766],
          [5193, 7753],
          [5205, 7734],
          [5201, 7730],
          [5207, 7722],
          [5206, 7692],
          [5212, 7660],
          [5220, 7643],
          [5224, 7644],
          [5238, 7630],
          [5256, 7617],
          [5244, 7599],
          [5221, 7591],
          [5221, 7583],
          [5206, 7582],
          [5203, 7561],
          [5206, 7553],
          [5191, 7510],
          [5195, 7478],
          [5192, 7453],
          [5187, 7444],
          [5184, 7420],
          [5168, 7415],
          [5156, 7390],
          [5145, 7346],
          [5136, 7352],
          [5126, 7340],
          [5128, 7327],
          [5121, 7299],
          [5115, 7299],
          [5117, 7313],
          [5115, 7325],
          [5090, 7350],
          [5086, 7378],
          [5090, 7401],
          [5074, 7401],
          [5075, 7393],
          [5053, 7393],
          [5062, 7382],
          [5065, 7358],
          [5050, 7343],
          [5041, 7327],
          [5027, 7311],
          [5012, 7309],
          [4987, 7329],
          [4974, 7321],
          [4970, 7310],
          [4955, 7304],
          [4950, 7294],
          [4923, 7294],
          [4918, 7304],
          [4892, 7304],
          [4874, 7301],
          [4853, 7326],
          [4850, 7334],
          [4825, 7330],
          [4817, 7312],
          [4809, 7277],
          [4797, 7270],
          [4774, 7274],
          [4774, 7288],
          [4779, 7292],
          [4779, 7314],
          [4767, 7335],
          [4753, 7353],
          [4753, 7371],
          [4741, 7381],
          [4744, 7396],
          [4735, 7411],
          [4738, 7416],
          [4730, 7421],
          [4724, 7417],
          [4717, 7423],
          [4722, 7434],
          [4731, 7443],
          [4725, 7460],
          [4740, 7473],
          [4733, 7488],
          [4743, 7493],
          [4750, 7509],
          [4750, 7525],
          [4756, 7531],
          [4785, 7532],
          [4780, 7673],
          [4779, 7691],
          [4812, 7691],
          [4809, 7766],
          [5011, 7766],
          [5192, 7766]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CZ",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.71,
      "hc-middle-y": 0.78,
      "hc-key": "cz",
      "hc-a2": "CZ",
      "name": "Czech Republic",
      "labelrank": "5",
      "country-abbrev": "Cz. Rep.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "CZE",
      "iso-a2": "CZ",
      "woe-id": "23424810",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4544, 8783],
          [4536, 8782],
          [4525, 8768],
          [4509, 8758],
          [4497, 8759],
          [4493, 8751],
          [4478, 8757],
          [4468, 8756],
          [4444, 8764],
          [4435, 8764],
          [4428, 8749],
          [4410, 8750],
          [4402, 8756],
          [4374, 8777],
          [4367, 8780],
          [4359, 8792],
          [4362, 8798],
          [4354, 8803],
          [4361, 8815],
          [4387, 8823],
          [4390, 8827],
          [4412, 8833],
          [4414, 8838],
          [4425, 8832],
          [4430, 8838],
          [4441, 8829],
          [4471, 8822],
          [4465, 8816],
          [4481, 8805],
          [4490, 8809],
          [4485, 8816],
          [4494, 8815],
          [4514, 8800],
          [4535, 8798],
          [4544, 8783]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LY",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.53,
      "hc-middle-y": 0.49,
      "hc-key": "ly",
      "hc-a2": "LY",
      "name": "Libya",
      "labelrank": "3",
      "country-abbrev": "Libya",
      "subregion": "Northern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "LBY",
      "iso-a2": "LY",
      "woe-id": "23424882",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4809, 7766],
          [4812, 7691],
          [4779, 7691],
          [4780, 7673],
          [4518, 7820],
          [4486, 7803],
          [4462, 7789],
          [4438, 7810],
          [4389, 7822],
          [4375, 7851],
          [4347, 7861],
          [4338, 7858],
          [4326, 7872],
          [4323, 7892],
          [4305, 7919],
          [4307, 7928],
          [4318, 7934],
          [4320, 7946],
          [4314, 7963],
          [4320, 7984],
          [4315, 7999],
          [4316, 8031],
          [4310, 8049],
          [4298, 8068],
          [4305, 8072],
          [4316, 8077],
          [4328, 8098],
          [4322, 8117],
          [4328, 8127],
          [4345, 8143],
          [4367, 8155],
          [4363, 8161],
          [4364, 8182],
          [4391, 8169],
          [4403, 8167],
          [4422, 8171],
          [4448, 8164],
          [4458, 8157],
          [4480, 8152],
          [4486, 8144],
          [4491, 8125],
          [4500, 8115],
          [4509, 8111],
          [4531, 8109],
          [4551, 8104],
          [4578, 8092],
          [4593, 8079],
          [4606, 8074],
          [4615, 8075],
          [4627, 8083],
          [4636, 8094],
          [4638, 8109],
          [4630, 8129],
          [4634, 8144],
          [4648, 8159],
          [4681, 8173],
          [4697, 8173],
          [4728, 8162],
          [4728, 8150],
          [4760, 8138],
          [4788, 8137],
          [4794, 8125],
          [4786, 8115],
          [4792, 8093],
          [4784, 8070],
          [4795, 8033],
          [4803, 7907],
          [4809, 7766]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MD",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.38,
      "hc-key": "md",
      "hc-a2": "MD",
      "name": "Moldova",
      "labelrank": "6",
      "country-abbrev": "Mda.",
      "subregion": "Eastern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "MDA",
      "iso-a2": "MD",
      "woe-id": "23424885",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4834, 8636],
          [4827, 8656],
          [4829, 8678],
          [4821, 8693],
          [4814, 8697],
          [4796, 8716],
          [4785, 8735],
          [4774, 8738],
          [4779, 8743],
          [4790, 8742],
          [4805, 8745],
          [4816, 8737],
          [4837, 8733],
          [4851, 8724],
          [4850, 8712],
          [4860, 8702],
          [4864, 8704],
          [4866, 8690],
          [4877, 8685],
          [4878, 8675],
          [4884, 8669],
          [4858, 8669],
          [4850, 8672],
          [4853, 8656],
          [4834, 8636]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "CF",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.56,
      "hc-middle-y": 0.52,
      "hc-key": "cf",
      "hc-a2": "CF",
      "name": "Central African Republic",
      "labelrank": "4",
      "country-abbrev": "C.A.R.",
      "subregion": "Middle Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "CAF",
      "iso-a2": "CF",
      "woe-id": "23424792",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4617, 7076],
          [4612, 7082],
          [4591, 7078],
          [4578, 7085],
          [4574, 7081],
          [4549, 7076],
          [4546, 7052],
          [4537, 7030],
          [4534, 7052],
          [4503, 7087],
          [4498, 7096],
          [4497, 7111],
          [4488, 7119],
          [4486, 7139],
          [4482, 7142],
          [4485, 7160],
          [4477, 7171],
          [4488, 7180],
          [4498, 7199],
          [4504, 7216],
          [4512, 7227],
          [4522, 7224],
          [4542, 7232],
          [4547, 7240],
          [4555, 7228],
          [4583, 7244],
          [4614, 7246],
          [4631, 7270],
          [4623, 7276],
          [4630, 7282],
          [4656, 7283],
          [4674, 7287],
          [4687, 7297],
          [4693, 7310],
          [4717, 7334],
          [4715, 7343],
          [4739, 7356],
          [4753, 7353],
          [4767, 7335],
          [4779, 7314],
          [4779, 7292],
          [4774, 7288],
          [4774, 7274],
          [4797, 7270],
          [4798, 7255],
          [4819, 7251],
          [4834, 7232],
          [4836, 7220],
          [4859, 7207],
          [4870, 7194],
          [4868, 7184],
          [4875, 7178],
          [4872, 7173],
          [4895, 7161],
          [4906, 7135],
          [4895, 7140],
          [4887, 7134],
          [4874, 7135],
          [4863, 7142],
          [4856, 7139],
          [4845, 7147],
          [4838, 7144],
          [4836, 7134],
          [4814, 7130],
          [4810, 7136],
          [4775, 7120],
          [4757, 7126],
          [4744, 7103],
          [4734, 7101],
          [4719, 7106],
          [4702, 7106],
          [4690, 7112],
          [4681, 7111],
          [4673, 7124],
          [4652, 7138],
          [4642, 7138],
          [4631, 7129],
          [4621, 7110],
          [4614, 7108],
          [4617, 7097],
          [4617, 7076]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "SG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.55,
      "hc-key": "sg",
      "hc-a2": "SG",
      "name": "Singapore",
      "labelrank": "6",
      "country-abbrev": "Sing.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "SGP",
      "iso-a2": "SG",
      "woe-id": "23424948",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7422, 6999],
          [7425, 6998],
          [7419, 6994],
          [7414, 6995],
          [7420, 7000],
          [7420, 7000],
          [7422, 6999]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "VN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.60,
      "hc-middle-y": 0.92,
      "hc-key": "vn",
      "hc-a2": "VN",
      "name": "Vietnam",
      "labelrank": "2",
      "country-abbrev": "Viet.",
      "subregion": "South-Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "VNM",
      "iso-a2": "VN",
      "woe-id": "23424984",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7485, 7747],
          [7474, 7737],
          [7472, 7729],
          [7461, 7726],
          [7451, 7728],
          [7460, 7719],
          [7450, 7718],
          [7443, 7711],
          [7446, 7700],
          [7430, 7691],
          [7426, 7678],
          [7426, 7658],
          [7423, 7654],
          [7432, 7639],
          [7442, 7628],
          [7454, 7621],
          [7456, 7611],
          [7464, 7597],
          [7482, 7583],
          [7486, 7576],
          [7512, 7553],
          [7522, 7550],
          [7533, 7533],
          [7545, 7519],
          [7558, 7495],
          [7569, 7463],
          [7569, 7445],
          [7579, 7427],
          [7579, 7415],
          [7571, 7417],
          [7570, 7410],
          [7576, 7392],
          [7570, 7369],
          [7541, 7353],
          [7535, 7346],
          [7516, 7333],
          [7501, 7342],
          [7501, 7325],
          [7493, 7313],
          [7492, 7302],
          [7484, 7305],
          [7483, 7295],
          [7463, 7286],
          [7449, 7268],
          [7439, 7279],
          [7439, 7313],
          [7445, 7319],
          [7436, 7327],
          [7412, 7328],
          [7410, 7320],
          [7404, 7333],
          [7423, 7335],
          [7436, 7339],
          [7443, 7345],
          [7441, 7353],
          [7450, 7350],
          [7464, 7357],
          [7479, 7347],
          [7478, 7355],
          [7466, 7367],
          [7464, 7379],
          [7470, 7385],
          [7484, 7381],
          [7482, 7392],
          [7492, 7392],
          [7505, 7404],
          [7517, 7406],
          [7518, 7416],
          [7513, 7431],
          [7515, 7449],
          [7503, 7472],
          [7507, 7494],
          [7509, 7515],
          [7490, 7534],
          [7497, 7539],
          [7475, 7562],
          [7466, 7567],
          [7463, 7579],
          [7434, 7605],
          [7428, 7615],
          [7408, 7634],
          [7408, 7643],
          [7394, 7646],
          [7364, 7665],
          [7370, 7672],
          [7366, 7679],
          [7387, 7677],
          [7395, 7694],
          [7385, 7704],
          [7374, 7708],
          [7381, 7715],
          [7361, 7727],
          [7350, 7716],
          [7332, 7723],
          [7321, 7740],
          [7322, 7750],
          [7316, 7759],
          [7311, 7753],
          [7308, 7762],
          [7290, 7781],
          [7299, 7794],
          [7318, 7782],
          [7326, 7795],
          [7333, 7787],
          [7337, 7795],
          [7349, 7785],
          [7351, 7795],
          [7360, 7791],
          [7374, 7800],
          [7372, 7806],
          [7387, 7817],
          [7407, 7799],
          [7427, 7800],
          [7437, 7793],
          [7432, 7788],
          [7441, 7766],
          [7463, 7751],
          [7479, 7752],
          [7485, 7747]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TN",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.39,
      "hc-middle-y": 0.16,
      "hc-key": "tn",
      "hc-a2": "TN",
      "name": "Tunisia",
      "labelrank": "3",
      "country-abbrev": "Tun.",
      "subregion": "Northern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "TUN",
      "iso-a2": "TN",
      "woe-id": "23424967",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4269, 8323],
          [4282, 8331],
          [4304, 8339],
          [4317, 8332],
          [4322, 8316],
          [4329, 8317],
          [4344, 8329],
          [4347, 8320],
          [4337, 8305],
          [4329, 8300],
          [4328, 8292],
          [4333, 8282],
          [4345, 8273],
          [4350, 8259],
          [4346, 8251],
          [4355, 8240],
          [4350, 8237],
          [4343, 8245],
          [4334, 8233],
          [4319, 8224],
          [4318, 8210],
          [4332, 8199],
          [4339, 8208],
          [4349, 8205],
          [4344, 8199],
          [4351, 8195],
          [4354, 8183],
          [4364, 8182],
          [4363, 8161],
          [4367, 8155],
          [4345, 8143],
          [4328, 8127],
          [4322, 8117],
          [4328, 8098],
          [4316, 8077],
          [4305, 8072],
          [4288, 8140],
          [4265, 8157],
          [4264, 8169],
          [4257, 8178],
          [4247, 8183],
          [4238, 8208],
          [4239, 8216],
          [4248, 8228],
          [4260, 8237],
          [4262, 8274],
          [4259, 8281],
          [4262, 8305],
          [4256, 8306],
          [4271, 8319],
          [4269, 8323]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "TW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.47,
      "hc-key": "tw",
      "hc-a2": "TW",
      "name": "Taiwan",
      "labelrank": "3",
      "country-abbrev": "Taiwan",
      "subregion": "Eastern Asia",
      "region-wb": "East Asia & Pacific",
      "iso-a3": "TWN",
      "iso-a2": "TW",
      "woe-id": "23424971",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7862, 7806],
          [7860, 7822],
          [7844, 7822],
          [7861, 7832],
          [7871, 7863],
          [7879, 7879],
          [7894, 7888],
          [7905, 7881],
          [7908, 7858],
          [7905, 7847],
          [7905, 7808],
          [7896, 7790],
          [7895, 7763],
          [7882, 7782],
          [7875, 7785],
          [7862, 7806]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.39,
      "hc-middle-y": 0.57,
      "hc-key": "mg",
      "hc-a2": "MG",
      "name": "Madagascar",
      "labelrank": "3",
      "country-abbrev": "Mad.",
      "subregion": "Eastern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "MDG",
      "iso-a2": "MG",
      "woe-id": "23424883",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5620, 6368],
          [5620, 6350],
          [5625, 6342],
          [5624, 6331],
          [5630, 6325],
          [5623, 6311],
          [5623, 6320],
          [5616, 6317],
          [5609, 6303],
          [5610, 6286],
          [5604, 6260],
          [5593, 6237],
          [5582, 6205],
          [5572, 6180],
          [5563, 6151],
          [5545, 6109],
          [5542, 6094],
          [5531, 6058],
          [5512, 6017],
          [5501, 6010],
          [5484, 6008],
          [5459, 5994],
          [5447, 5994],
          [5438, 6003],
          [5423, 6006],
          [5414, 6016],
          [5409, 6034],
          [5405, 6038],
          [5405, 6066],
          [5410, 6073],
          [5405, 6087],
          [5398, 6096],
          [5396, 6118],
          [5400, 6136],
          [5405, 6140],
          [5407, 6153],
          [5417, 6156],
          [5421, 6169],
          [5441, 6202],
          [5439, 6210],
          [5443, 6220],
          [5436, 6236],
          [5437, 6246],
          [5432, 6260],
          [5433, 6285],
          [5430, 6297],
          [5448, 6325],
          [5449, 6343],
          [5463, 6343],
          [5477, 6354],
          [5488, 6351],
          [5491, 6359],
          [5508, 6362],
          [5534, 6381],
          [5533, 6370],
          [5542, 6372],
          [5537, 6381],
          [5550, 6400],
          [5551, 6385],
          [5560, 6403],
          [5562, 6417],
          [5570, 6427],
          [5567, 6440],
          [5578, 6448],
          [5594, 6446],
          [5603, 6469],
          [5597, 6485],
          [5603, 6482],
          [5614, 6501],
          [5624, 6484],
          [5623, 6476],
          [5635, 6461],
          [5640, 6433],
          [5640, 6409],
          [5648, 6371],
          [5638, 6352],
          [5632, 6356],
          [5629, 6372],
          [5620, 6368]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "IS",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.50,
      "hc-key": "is",
      "hc-a2": "IS",
      "name": "Iceland",
      "labelrank": "3",
      "country-abbrev": "Iceland",
      "subregion": "Northern Europe",
      "region-wb": "Europe & Central Asia",
      "iso-a3": "ISL",
      "iso-a2": "IS",
      "woe-id": "23424845",
      "continent": "Europe"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3407, 9341],
          [3408, 9346],
          [3419, 9343],
          [3416, 9353],
          [3426, 9359],
          [3444, 9354],
          [3435, 9366],
          [3449, 9367],
          [3477, 9352],
          [3468, 9341],
          [3484, 9331],
          [3492, 9342],
          [3494, 9336],
          [3502, 9345],
          [3499, 9353],
          [3509, 9357],
          [3518, 9345],
          [3523, 9344],
          [3526, 9355],
          [3540, 9359],
          [3552, 9353],
          [3553, 9358],
          [3570, 9352],
          [3582, 9360],
          [3598, 9359],
          [3597, 9368],
          [3607, 9370],
          [3618, 9365],
          [3625, 9357],
          [3639, 9365],
          [3630, 9356],
          [3642, 9354],
          [3637, 9344],
          [3666, 9337],
          [3667, 9325],
          [3654, 9311],
          [3643, 9309],
          [3639, 9300],
          [3628, 9295],
          [3617, 9296],
          [3585, 9283],
          [3555, 9277],
          [3549, 9271],
          [3527, 9267],
          [3493, 9272],
          [3484, 9278],
          [3470, 9282],
          [3430, 9281],
          [3431, 9289],
          [3439, 9286],
          [3450, 9289],
          [3459, 9300],
          [3444, 9305],
          [3443, 9313],
          [3414, 9313],
          [3413, 9316],
          [3446, 9322],
          [3442, 9325],
          [3457, 9333],
          [3445, 9338],
          [3427, 9336],
          [3395, 9336],
          [3407, 9341]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "LK",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.57,
      "hc-middle-y": 0.80,
      "hc-key": "lk",
      "hc-a2": "LK",
      "name": "Sri Lanka",
      "labelrank": "3",
      "country-abbrev": "Sri L.",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "LKA",
      "iso-a2": "LK",
      "woe-id": "23424778",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6621, 7247],
          [6628, 7283],
          [6627, 7296],
          [6637, 7301],
          [6620, 7310],
          [6629, 7311],
          [6650, 7295],
          [6672, 7262],
          [6682, 7235],
          [6688, 7229],
          [6691, 7206],
          [6688, 7193],
          [6675, 7178],
          [6651, 7167],
          [6634, 7175],
          [6625, 7200],
          [6618, 7248],
          [6621, 7247]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "EG",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.27,
      "hc-middle-y": 0.50,
      "hc-key": "eg",
      "hc-a2": "EG",
      "name": "Egypt",
      "labelrank": "2",
      "country-abbrev": "Egypt",
      "subregion": "Northern Africa",
      "region-wb": "Middle East & North Africa",
      "iso-a3": "EGY",
      "iso-a2": "EG",
      "woe-id": "23424802",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5108, 8045],
          [5104, 8038],
          [5102, 8017],
          [5097, 8001],
          [5100, 7989],
          [5093, 7979],
          [5075, 7992],
          [5058, 8010],
          [5054, 8028],
          [5039, 8043],
          [5031, 8062],
          [5027, 8049],
          [5036, 8039],
          [5038, 8025],
          [5072, 7981],
          [5070, 7976],
          [5088, 7948],
          [5089, 7938],
          [5131, 7862],
          [5140, 7847],
          [5151, 7840],
          [5144, 7839],
          [5144, 7821],
          [5152, 7800],
          [5158, 7793],
          [5170, 7789],
          [5177, 7779],
          [5192, 7766],
          [5011, 7766],
          [4809, 7766],
          [4803, 7907],
          [4795, 8033],
          [4784, 8070],
          [4792, 8093],
          [4786, 8115],
          [4794, 8125],
          [4803, 8119],
          [4816, 8124],
          [4864, 8114],
          [4868, 8109],
          [4881, 8110],
          [4883, 8104],
          [4899, 8104],
          [4919, 8094],
          [4933, 8099],
          [4959, 8120],
          [4978, 8117],
          [4979, 8122],
          [4996, 8117],
          [5006, 8121],
          [5004, 8112],
          [5015, 8103],
          [5021, 8111],
          [5031, 8103],
          [5046, 8110],
          [5063, 8105],
          [5080, 8112],
          [5105, 8054],
          [5108, 8045]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "ML",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.61,
      "hc-middle-y": 0.47,
      "hc-key": "ml",
      "hc-a2": "ML",
      "name": "Mali",
      "labelrank": "3",
      "country-abbrev": "Mali",
      "subregion": "Western Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "MLI",
      "iso-a2": "ML",
      "woe-id": "23424891",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3605, 7497],
          [3620, 7501],
          [3623, 7525],
          [3633, 7528],
          [3649, 7509],
          [3656, 7521],
          [3676, 7519],
          [3700, 7524],
          [3825, 7523],
          [3831, 7554],
          [3822, 7562],
          [3794, 7877],
          [3850, 7877],
          [4042, 7732],
          [4042, 7719],
          [4055, 7714],
          [4066, 7700],
          [4076, 7701],
          [4082, 7693],
          [4100, 7689],
          [4109, 7684],
          [4110, 7668],
          [4105, 7659],
          [4113, 7653],
          [4141, 7659],
          [4142, 7579],
          [4141, 7558],
          [4137, 7553],
          [4130, 7531],
          [4119, 7518],
          [4048, 7516],
          [4036, 7504],
          [4012, 7505],
          [4012, 7502],
          [3997, 7508],
          [3981, 7508],
          [3969, 7497],
          [3949, 7486],
          [3940, 7485],
          [3936, 7473],
          [3924, 7478],
          [3912, 7469],
          [3910, 7455],
          [3898, 7457],
          [3899, 7442],
          [3887, 7438],
          [3871, 7445],
          [3863, 7435],
          [3866, 7421],
          [3858, 7420],
          [3861, 7413],
          [3856, 7399],
          [3849, 7394],
          [3836, 7391],
          [3831, 7379],
          [3834, 7372],
          [3824, 7335],
          [3812, 7332],
          [3808, 7326],
          [3800, 7328],
          [3800, 7346],
          [3785, 7332],
          [3777, 7332],
          [3776, 7325],
          [3764, 7328],
          [3754, 7335],
          [3743, 7325],
          [3735, 7335],
          [3733, 7355],
          [3720, 7356],
          [3731, 7370],
          [3715, 7381],
          [3717, 7391],
          [3711, 7408],
          [3704, 7411],
          [3687, 7394],
          [3669, 7401],
          [3655, 7389],
          [3643, 7401],
          [3636, 7393],
          [3629, 7399],
          [3633, 7408],
          [3633, 7428],
          [3628, 7440],
          [3619, 7442],
          [3610, 7457],
          [3614, 7474],
          [3606, 7482],
          [3605, 7497]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BW",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.45,
      "hc-middle-y": 0.46,
      "hc-key": "bw",
      "hc-a2": "BW",
      "name": "Botswana",
      "labelrank": "4",
      "country-abbrev": "Bwa.",
      "subregion": "Southern Africa",
      "region-wb": "Sub-Saharan Africa",
      "iso-a3": "BWA",
      "iso-a2": "BW",
      "woe-id": "23424755",
      "continent": "Africa"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4644, 6025],
          [4648, 6127],
          [4680, 6129],
          [4684, 6264],
          [4700, 6265],
          [4750, 6276],
          [4760, 6276],
          [4768, 6259],
          [4790, 6276],
          [4801, 6274],
          [4813, 6283],
          [4824, 6284],
          [4822, 6281],
          [4831, 6261],
          [4844, 6242],
          [4850, 6220],
          [4868, 6205],
          [4883, 6198],
          [4885, 6183],
          [4899, 6183],
          [4897, 6162],
          [4908, 6143],
          [4925, 6141],
          [4940, 6134],
          [4942, 6125],
          [4949, 6120],
          [4939, 6119],
          [4935, 6110],
          [4911, 6102],
          [4896, 6082],
          [4872, 6066],
          [4865, 6043],
          [4850, 6029],
          [4833, 6025],
          [4833, 6020],
          [4822, 5993],
          [4816, 5988],
          [4798, 5985],
          [4769, 5992],
          [4755, 6005],
          [4741, 6004],
          [4735, 5998],
          [4730, 5979],
          [4714, 5965],
          [4706, 5954],
          [4695, 5946],
          [4669, 5948],
          [4664, 5945],
          [4662, 5962],
          [4670, 5973],
          [4669, 5982],
          [4656, 6014],
          [4644, 6025]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "NP",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.66,
      "hc-middle-y": 0.67,
      "hc-key": "np",
      "hc-a2": "NP",
      "name": "Nepal",
      "labelrank": "3",
      "country-abbrev": "Nepal",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "NPL",
      "iso-a2": "NP",
      "woe-id": "23424911",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6805, 7984],
          [6806, 7956],
          [6815, 7942],
          [6812, 7929],
          [6807, 7932],
          [6791, 7928],
          [6780, 7936],
          [6771, 7930],
          [6756, 7938],
          [6741, 7936],
          [6732, 7946],
          [6723, 7942],
          [6700, 7953],
          [6696, 7964],
          [6679, 7971],
          [6673, 7965],
          [6657, 7970],
          [6637, 7970],
          [6632, 7978],
          [6626, 7977],
          [6611, 7986],
          [6607, 7984],
          [6586, 7995],
          [6559, 8015],
          [6557, 8010],
          [6541, 8020],
          [6545, 8038],
          [6544, 8055],
          [6561, 8071],
          [6568, 8064],
          [6572, 8077],
          [6594, 8076],
          [6598, 8066],
          [6612, 8061],
          [6623, 8051],
          [6634, 8050],
          [6649, 8033],
          [6666, 8036],
          [6674, 8023],
          [6690, 8012],
          [6705, 8011],
          [6705, 8001],
          [6722, 7999],
          [6724, 8002],
          [6737, 7985],
          [6751, 7986],
          [6753, 7993],
          [6775, 7983],
          [6805, 7984]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "BT",
    "properties": {
      "hc-group": "admin0",
      "hc-middle-x": 0.95,
      "hc-middle-y": 0.70,
      "hc-key": "bt",
      "hc-a2": "BT",
      "name": "Bhutan",
      "labelrank": "5",
      "country-abbrev": "Bhutan",
      "subregion": "Southern Asia",
      "region-wb": "South Asia",
      "iso-a3": "BTN",
      "iso-a2": "BT",
      "woe-id": "23424770",
      "continent": "Asia"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [6834, 7964],
          [6849, 7995],
          [6868, 8003],
          [6884, 7993],
          [6898, 7988],
          [6904, 7993],
          [6917, 7986],
          [6917, 7980],
          [6924, 7968],
          [6931, 7970],
          [6938, 7950],
          [6927, 7945],
          [6892, 7944],
          [6884, 7948],
          [6868, 7941],
          [6851, 7947],
          [6844, 7945],
          [6830, 7958],
          [6834, 7964]
        ]
      ]
    }
  }]
};

export default mapData;
